const $e4b50d36b79545e2$var$methods$1 = {};
const $e4b50d36b79545e2$var$names = [];
function $e4b50d36b79545e2$var$registerMethods(name, m) {
    if (Array.isArray(name)) {
        for (const _name of name)$e4b50d36b79545e2$var$registerMethods(_name, m);
        return;
    }
    if (typeof name === "object") {
        for(const _name in name)$e4b50d36b79545e2$var$registerMethods(_name, name[_name]);
        return;
    }
    $e4b50d36b79545e2$var$addMethodNames(Object.getOwnPropertyNames(m));
    $e4b50d36b79545e2$var$methods$1[name] = Object.assign($e4b50d36b79545e2$var$methods$1[name] || {}, m);
}
function $e4b50d36b79545e2$var$getMethodsFor(name) {
    return $e4b50d36b79545e2$var$methods$1[name] || {};
}
function $e4b50d36b79545e2$var$getMethodNames() {
    return [
        ...new Set($e4b50d36b79545e2$var$names)
    ];
}
function $e4b50d36b79545e2$var$addMethodNames(_names) {
    $e4b50d36b79545e2$var$names.push(..._names);
}
// Map function
function $e4b50d36b79545e2$var$map(array, block) {
    let i;
    const il = array.length;
    const result = [];
    for(i = 0; i < il; i++)result.push(block(array[i]));
    return result;
} // Filter function
function $e4b50d36b79545e2$var$filter(array, block) {
    let i;
    const il = array.length;
    const result = [];
    for(i = 0; i < il; i++)if (block(array[i])) result.push(array[i]);
    return result;
} // Degrees to radians
function $e4b50d36b79545e2$var$radians(d) {
    return d % 360 * Math.PI / 180;
} // Radians to degrees
function $e4b50d36b79545e2$var$degrees(r) {
    return r * 180 / Math.PI % 360;
} // Convert dash-separated-string to camelCase
function $e4b50d36b79545e2$var$camelCase(s) {
    return s.toLowerCase().replace(/-(.)/g, function(m, g) {
        return g.toUpperCase();
    });
} // Convert camel cased string to dash separated
function $e4b50d36b79545e2$var$unCamelCase(s) {
    return s.replace(/([A-Z])/g, function(m, g) {
        return "-" + g.toLowerCase();
    });
} // Capitalize first letter of a string
function $e4b50d36b79545e2$var$capitalize(s) {
    return s.charAt(0).toUpperCase() + s.slice(1);
} // Calculate proportional width and height values when necessary
function $e4b50d36b79545e2$var$proportionalSize(element, width, height, box) {
    if (width == null || height == null) {
        box = box || element.bbox();
        if (width == null) width = box.width / box.height * height;
        else if (height == null) height = box.height / box.width * width;
    }
    return {
        width: width,
        height: height
    };
}
/**
 * This function adds support for string origins.
 * It searches for an origin in o.origin o.ox and o.originX.
 * This way, origin: {x: 'center', y: 50} can be passed as well as ox: 'center', oy: 50
**/ function $e4b50d36b79545e2$var$getOrigin(o, element) {
    const origin = o.origin; // First check if origin is in ox or originX
    let ox = o.ox != null ? o.ox : o.originX != null ? o.originX : "center";
    let oy = o.oy != null ? o.oy : o.originY != null ? o.originY : "center"; // Then check if origin was used and overwrite in that case
    if (origin != null) [ox, oy] = Array.isArray(origin) ? origin : typeof origin === "object" ? [
        origin.x,
        origin.y
    ] : [
        origin,
        origin
    ];
     // Make sure to only call bbox when actually needed
    const condX = typeof ox === "string";
    const condY = typeof oy === "string";
    if (condX || condY) {
        const { height: height, width: width, x: x, y: y } = element.bbox(); // And only overwrite if string was passed for this specific axis
        if (condX) ox = ox.includes("left") ? x : ox.includes("right") ? x + width : x + width / 2;
        if (condY) oy = oy.includes("top") ? y : oy.includes("bottom") ? y + height : y + height / 2;
    } // Return the origin as it is if it wasn't a string
    return [
        ox,
        oy
    ];
}
var $e4b50d36b79545e2$export$eab97d15b1788b8d = {
    __proto__: null,
    map: $e4b50d36b79545e2$var$map,
    filter: $e4b50d36b79545e2$var$filter,
    radians: $e4b50d36b79545e2$var$radians,
    degrees: $e4b50d36b79545e2$var$degrees,
    camelCase: $e4b50d36b79545e2$var$camelCase,
    unCamelCase: $e4b50d36b79545e2$var$unCamelCase,
    capitalize: $e4b50d36b79545e2$var$capitalize,
    proportionalSize: $e4b50d36b79545e2$var$proportionalSize,
    getOrigin: $e4b50d36b79545e2$var$getOrigin
};
// Default namespaces
const $e4b50d36b79545e2$var$svg = "http://www.w3.org/2000/svg";
const $e4b50d36b79545e2$var$html = "http://www.w3.org/1999/xhtml";
const $e4b50d36b79545e2$var$xmlns = "http://www.w3.org/2000/xmlns/";
const $e4b50d36b79545e2$var$xlink = "http://www.w3.org/1999/xlink";
const $e4b50d36b79545e2$var$svgjs = "http://svgjs.dev/svgjs";
var $e4b50d36b79545e2$export$41fc20bb625e8618 = {
    __proto__: null,
    svg: $e4b50d36b79545e2$var$svg,
    html: $e4b50d36b79545e2$var$html,
    xmlns: $e4b50d36b79545e2$var$xmlns,
    xlink: $e4b50d36b79545e2$var$xlink,
    svgjs: $e4b50d36b79545e2$var$svgjs
};
const $e4b50d36b79545e2$var$globals = {
    window: typeof window === "undefined" ? null : window,
    document: typeof document === "undefined" ? null : document
};
function $e4b50d36b79545e2$export$f6278c69e3ee2bda(win = null, doc = null) {
    $e4b50d36b79545e2$var$globals.window = win;
    $e4b50d36b79545e2$var$globals.document = doc;
}
const $e4b50d36b79545e2$var$save = {};
function $e4b50d36b79545e2$export$9a9d6a4544bb1669() {
    $e4b50d36b79545e2$var$save.window = $e4b50d36b79545e2$var$globals.window;
    $e4b50d36b79545e2$var$save.document = $e4b50d36b79545e2$var$globals.document;
}
function $e4b50d36b79545e2$export$69199fcb7ae81e7e() {
    $e4b50d36b79545e2$var$globals.window = $e4b50d36b79545e2$var$save.window;
    $e4b50d36b79545e2$var$globals.document = $e4b50d36b79545e2$var$save.document;
}
function $e4b50d36b79545e2$export$bcba7c7bfbcde5ae(win, fn) {
    $e4b50d36b79545e2$export$9a9d6a4544bb1669();
    $e4b50d36b79545e2$export$f6278c69e3ee2bda(win, win.document);
    fn(win, win.document);
    $e4b50d36b79545e2$export$69199fcb7ae81e7e();
}
function $e4b50d36b79545e2$export$38b2d434cce3ea22() {
    return $e4b50d36b79545e2$var$globals.window;
}
class $e4b50d36b79545e2$var$Base {
}
const $e4b50d36b79545e2$var$elements = {};
const $e4b50d36b79545e2$export$e8e78c978b129247 = "___SYMBOL___ROOT___"; // Method for element creation
function $e4b50d36b79545e2$export$185802fd694ee1f5(name, ns = $e4b50d36b79545e2$var$svg) {
    // create element
    return $e4b50d36b79545e2$var$globals.document.createElementNS(ns, name);
}
function $e4b50d36b79545e2$export$60fbc25e7b928117(element, isHTML = false) {
    if (element instanceof $e4b50d36b79545e2$var$Base) return element;
    if (typeof element === "object") return $e4b50d36b79545e2$var$adopter(element);
    if (element == null) return new $e4b50d36b79545e2$var$elements[$e4b50d36b79545e2$export$e8e78c978b129247]();
    if (typeof element === "string" && element.charAt(0) !== "<") return $e4b50d36b79545e2$var$adopter($e4b50d36b79545e2$var$globals.document.querySelector(element));
     // Make sure, that HTML elements are created with the correct namespace
    const wrapper = isHTML ? $e4b50d36b79545e2$var$globals.document.createElement("div") : $e4b50d36b79545e2$export$185802fd694ee1f5("svg");
    wrapper.innerHTML = element; // We can use firstChild here because we know,
    // that the first char is < and thus an element
    element = $e4b50d36b79545e2$var$adopter(wrapper.firstChild); // make sure, that element doesn't have its wrapper attached
    wrapper.removeChild(wrapper.firstChild);
    return element;
}
function $e4b50d36b79545e2$export$5b825b8c91fb12a7(name, node) {
    return node && node.ownerDocument && node instanceof node.ownerDocument.defaultView.Node ? node : $e4b50d36b79545e2$export$185802fd694ee1f5(name);
} // Adopt existing svg elements
function $e4b50d36b79545e2$export$62c9251e71806cd(node) {
    // check for presence of node
    if (!node) return null; // make sure a node isn't already adopted
    if (node.instance instanceof $e4b50d36b79545e2$var$Base) return node.instance;
    if (node.nodeName === "#document-fragment") return new $e4b50d36b79545e2$var$elements.Fragment(node);
     // initialize variables
    let className = $e4b50d36b79545e2$var$capitalize(node.nodeName || "Dom"); // Make sure that gradients are adopted correctly
    if (className === "LinearGradient" || className === "RadialGradient") className = "Gradient"; // Fallback to Dom if element is not known
    else if (!$e4b50d36b79545e2$var$elements[className]) className = "Dom";
    return new $e4b50d36b79545e2$var$elements[className](node);
}
let $e4b50d36b79545e2$var$adopter = $e4b50d36b79545e2$export$62c9251e71806cd;
function $e4b50d36b79545e2$export$f53871d05bb02902(mock = $e4b50d36b79545e2$export$62c9251e71806cd) {
    $e4b50d36b79545e2$var$adopter = mock;
}
function $e4b50d36b79545e2$export$6503ec6e8aabbaf(element, name = element.name, asRoot = false) {
    $e4b50d36b79545e2$var$elements[name] = element;
    if (asRoot) $e4b50d36b79545e2$var$elements[$e4b50d36b79545e2$export$e8e78c978b129247] = element;
    $e4b50d36b79545e2$var$addMethodNames(Object.getOwnPropertyNames(element.prototype));
    return element;
}
function $e4b50d36b79545e2$export$d39d7c22acbe0a14(name) {
    return $e4b50d36b79545e2$var$elements[name];
} // Element id sequence
let $e4b50d36b79545e2$var$did = 1000; // Get next named element id
function $e4b50d36b79545e2$export$ff39fbab45dc7cd0(name) {
    return "Svgjs" + $e4b50d36b79545e2$var$capitalize(name) + $e4b50d36b79545e2$var$did++;
} // Deep new id assignment
function $e4b50d36b79545e2$export$14fdd2dab64e28f0(node) {
    // do the same for SVG child nodes as well
    for(let i = node.children.length - 1; i >= 0; i--)$e4b50d36b79545e2$export$14fdd2dab64e28f0(node.children[i]);
    if (node.id) {
        node.id = $e4b50d36b79545e2$export$ff39fbab45dc7cd0(node.nodeName);
        return node;
    }
    return node;
} // Method for extending objects
function $e4b50d36b79545e2$export$8b58be045bf06082(modules, methods) {
    let key, i;
    modules = Array.isArray(modules) ? modules : [
        modules
    ];
    for(i = modules.length - 1; i >= 0; i--)for(key in methods)modules[i].prototype[key] = methods[key];
}
function $e4b50d36b79545e2$export$26f3b51f2e19e8f9(fn) {
    return function(...args) {
        const o = args[args.length - 1];
        if (o && o.constructor === Object && !(o instanceof Array)) return fn.apply(this, args.slice(0, -1)).attr(o);
        else return fn.apply(this, args);
    };
}
function $e4b50d36b79545e2$var$siblings() {
    return this.parent().children();
} // Get the current position siblings
function $e4b50d36b79545e2$var$position() {
    return this.parent().index(this);
} // Get the next element (will return null if there is none)
function $e4b50d36b79545e2$var$next() {
    return this.siblings()[this.position() + 1];
} // Get the next element (will return null if there is none)
function $e4b50d36b79545e2$var$prev() {
    return this.siblings()[this.position() - 1];
} // Send given element one step forward
function $e4b50d36b79545e2$var$forward() {
    const i = this.position();
    const p = this.parent(); // move node one step forward
    p.add(this.remove(), i + 1);
    return this;
} // Send given element one step backward
function $e4b50d36b79545e2$var$backward() {
    const i = this.position();
    const p = this.parent();
    p.add(this.remove(), i ? i - 1 : 0);
    return this;
} // Send given element all the way to the front
function $e4b50d36b79545e2$var$front() {
    const p = this.parent(); // Move node forward
    p.add(this.remove());
    return this;
} // Send given element all the way to the back
function $e4b50d36b79545e2$var$back() {
    const p = this.parent(); // Move node back
    p.add(this.remove(), 0);
    return this;
} // Inserts a given element before the targeted element
function $e4b50d36b79545e2$var$before(element) {
    element = $e4b50d36b79545e2$export$60fbc25e7b928117(element);
    element.remove();
    const i = this.position();
    this.parent().add(element, i);
    return this;
} // Inserts a given element after the targeted element
function $e4b50d36b79545e2$var$after(element) {
    element = $e4b50d36b79545e2$export$60fbc25e7b928117(element);
    element.remove();
    const i = this.position();
    this.parent().add(element, i + 1);
    return this;
}
function $e4b50d36b79545e2$var$insertBefore(element) {
    element = $e4b50d36b79545e2$export$60fbc25e7b928117(element);
    element.before(this);
    return this;
}
function $e4b50d36b79545e2$var$insertAfter(element) {
    element = $e4b50d36b79545e2$export$60fbc25e7b928117(element);
    element.after(this);
    return this;
}
$e4b50d36b79545e2$var$registerMethods("Dom", {
    siblings: $e4b50d36b79545e2$var$siblings,
    position: $e4b50d36b79545e2$var$position,
    next: $e4b50d36b79545e2$var$next,
    prev: $e4b50d36b79545e2$var$prev,
    forward: $e4b50d36b79545e2$var$forward,
    backward: $e4b50d36b79545e2$var$backward,
    front: $e4b50d36b79545e2$var$front,
    back: $e4b50d36b79545e2$var$back,
    before: $e4b50d36b79545e2$var$before,
    after: $e4b50d36b79545e2$var$after,
    insertBefore: $e4b50d36b79545e2$var$insertBefore,
    insertAfter: $e4b50d36b79545e2$var$insertAfter
});
// Parse unit value
const $e4b50d36b79545e2$var$numberAndUnit = /^([+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?)([a-z%]*)$/i; // Parse hex value
const $e4b50d36b79545e2$var$hex = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i; // Parse rgb value
const $e4b50d36b79545e2$var$rgb = /rgb\((\d+),(\d+),(\d+)\)/; // Parse reference id
const $e4b50d36b79545e2$var$reference = /(#[a-z_][a-z0-9\-_]*)/i; // splits a transformation chain
const $e4b50d36b79545e2$var$transforms = /\)\s*,?\s*/; // Whitespace
const $e4b50d36b79545e2$var$whitespace = /\s/g; // Test hex value
const $e4b50d36b79545e2$var$isHex = /^#[a-f0-9]{3}$|^#[a-f0-9]{6}$/i; // Test rgb value
const $e4b50d36b79545e2$var$isRgb = /^rgb\(/; // Test for blank string
const $e4b50d36b79545e2$var$isBlank = /^(\s+)?$/; // Test for numeric string
const $e4b50d36b79545e2$var$isNumber = /^[+-]?(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i; // Test for image url
const $e4b50d36b79545e2$var$isImage = /\.(jpg|jpeg|png|gif|svg)(\?[^=]+.*)?/i; // split at whitespace and comma
const $e4b50d36b79545e2$var$delimiter = /[\s,]+/; // Test for path letter
const $e4b50d36b79545e2$var$isPathLetter = /[MLHVCSQTAZ]/i;
var $e4b50d36b79545e2$export$17b0f4d84dbfeedf = {
    __proto__: null,
    numberAndUnit: $e4b50d36b79545e2$var$numberAndUnit,
    hex: $e4b50d36b79545e2$var$hex,
    rgb: $e4b50d36b79545e2$var$rgb,
    reference: $e4b50d36b79545e2$var$reference,
    transforms: $e4b50d36b79545e2$var$transforms,
    whitespace: $e4b50d36b79545e2$var$whitespace,
    isHex: $e4b50d36b79545e2$var$isHex,
    isRgb: $e4b50d36b79545e2$var$isRgb,
    isBlank: $e4b50d36b79545e2$var$isBlank,
    isNumber: $e4b50d36b79545e2$var$isNumber,
    isImage: $e4b50d36b79545e2$var$isImage,
    delimiter: $e4b50d36b79545e2$var$delimiter,
    isPathLetter: $e4b50d36b79545e2$var$isPathLetter
};
function $e4b50d36b79545e2$var$classes() {
    const attr = this.attr("class");
    return attr == null ? [] : attr.trim().split($e4b50d36b79545e2$var$delimiter);
} // Return true if class exists on the node, false otherwise
function $e4b50d36b79545e2$var$hasClass(name) {
    return this.classes().indexOf(name) !== -1;
} // Add class to the node
function $e4b50d36b79545e2$var$addClass(name) {
    if (!this.hasClass(name)) {
        const array = this.classes();
        array.push(name);
        this.attr("class", array.join(" "));
    }
    return this;
} // Remove class from the node
function $e4b50d36b79545e2$var$removeClass(name) {
    if (this.hasClass(name)) this.attr("class", this.classes().filter(function(c) {
        return c !== name;
    }).join(" "));
    return this;
} // Toggle the presence of a class on the node
function $e4b50d36b79545e2$var$toggleClass(name) {
    return this.hasClass(name) ? this.removeClass(name) : this.addClass(name);
}
$e4b50d36b79545e2$var$registerMethods("Dom", {
    classes: $e4b50d36b79545e2$var$classes,
    hasClass: $e4b50d36b79545e2$var$hasClass,
    addClass: $e4b50d36b79545e2$var$addClass,
    removeClass: $e4b50d36b79545e2$var$removeClass,
    toggleClass: $e4b50d36b79545e2$var$toggleClass
});
function $e4b50d36b79545e2$var$css(style, val) {
    const ret = {};
    if (arguments.length === 0) {
        // get full style as object
        this.node.style.cssText.split(/\s*;\s*/).filter(function(el) {
            return !!el.length;
        }).forEach(function(el) {
            const t = el.split(/\s*:\s*/);
            ret[t[0]] = t[1];
        });
        return ret;
    }
    if (arguments.length < 2) {
        // get style properties as array
        if (Array.isArray(style)) {
            for (const name of style){
                const cased = $e4b50d36b79545e2$var$camelCase(name);
                ret[name] = this.node.style[cased];
            }
            return ret;
        } // get style for property
        if (typeof style === "string") return this.node.style[$e4b50d36b79545e2$var$camelCase(style)];
         // set styles in object
        if (typeof style === "object") for(const name in style)// set empty string if null/undefined/'' was given
        this.node.style[$e4b50d36b79545e2$var$camelCase(name)] = style[name] == null || $e4b50d36b79545e2$var$isBlank.test(style[name]) ? "" : style[name];
    } // set style for property
    if (arguments.length === 2) this.node.style[$e4b50d36b79545e2$var$camelCase(style)] = val == null || $e4b50d36b79545e2$var$isBlank.test(val) ? "" : val;
    return this;
} // Show element
function $e4b50d36b79545e2$var$show() {
    return this.css("display", "");
} // Hide element
function $e4b50d36b79545e2$var$hide() {
    return this.css("display", "none");
} // Is element visible?
function $e4b50d36b79545e2$var$visible() {
    return this.css("display") !== "none";
}
$e4b50d36b79545e2$var$registerMethods("Dom", {
    css: $e4b50d36b79545e2$var$css,
    show: $e4b50d36b79545e2$var$show,
    hide: $e4b50d36b79545e2$var$hide,
    visible: $e4b50d36b79545e2$var$visible
});
function $e4b50d36b79545e2$var$data(a, v, r) {
    if (a == null) // get an object of attributes
    return this.data($e4b50d36b79545e2$var$map($e4b50d36b79545e2$var$filter(this.node.attributes, (el)=>el.nodeName.indexOf("data-") === 0), (el)=>el.nodeName.slice(5)));
    else if (a instanceof Array) {
        const data = {};
        for (const key of a)data[key] = this.data(key);
        return data;
    } else if (typeof a === "object") for(v in a)this.data(v, a[v]);
    else if (arguments.length < 2) try {
        return JSON.parse(this.attr("data-" + a));
    } catch (e) {
        return this.attr("data-" + a);
    }
    else this.attr("data-" + a, v === null ? null : r === true || typeof v === "string" || typeof v === "number" ? v : JSON.stringify(v));
    return this;
}
$e4b50d36b79545e2$var$registerMethods("Dom", {
    data: $e4b50d36b79545e2$var$data
});
function $e4b50d36b79545e2$var$remember(k, v) {
    // remember every item in an object individually
    if (typeof arguments[0] === "object") for(const key in k)this.remember(key, k[key]);
    else if (arguments.length === 1) // retrieve memory
    return this.memory()[k];
    else // store memory
    this.memory()[k] = v;
    return this;
} // Erase a given memory
function $e4b50d36b79545e2$var$forget() {
    if (arguments.length === 0) this._memory = {};
    else for(let i = arguments.length - 1; i >= 0; i--)delete this.memory()[arguments[i]];
    return this;
} // This triggers creation of a new hidden class which is not performant
// However, this function is not rarely used so it will not happen frequently
// Return local memory object
function $e4b50d36b79545e2$var$memory() {
    return this._memory = this._memory || {};
}
$e4b50d36b79545e2$var$registerMethods("Dom", {
    remember: $e4b50d36b79545e2$var$remember,
    forget: $e4b50d36b79545e2$var$forget,
    memory: $e4b50d36b79545e2$var$memory
});
function $e4b50d36b79545e2$var$sixDigitHex(hex) {
    return hex.length === 4 ? [
        "#",
        hex.substring(1, 2),
        hex.substring(1, 2),
        hex.substring(2, 3),
        hex.substring(2, 3),
        hex.substring(3, 4),
        hex.substring(3, 4)
    ].join("") : hex;
}
function $e4b50d36b79545e2$var$componentHex(component) {
    const integer = Math.round(component);
    const bounded = Math.max(0, Math.min(255, integer));
    const hex = bounded.toString(16);
    return hex.length === 1 ? "0" + hex : hex;
}
function $e4b50d36b79545e2$var$is(object, space) {
    for(let i = space.length; i--;){
        if (object[space[i]] == null) return false;
    }
    return true;
}
function $e4b50d36b79545e2$var$getParameters(a, b) {
    const params = $e4b50d36b79545e2$var$is(a, "rgb") ? {
        _a: a.r,
        _b: a.g,
        _c: a.b,
        _d: 0,
        space: "rgb"
    } : $e4b50d36b79545e2$var$is(a, "xyz") ? {
        _a: a.x,
        _b: a.y,
        _c: a.z,
        _d: 0,
        space: "xyz"
    } : $e4b50d36b79545e2$var$is(a, "hsl") ? {
        _a: a.h,
        _b: a.s,
        _c: a.l,
        _d: 0,
        space: "hsl"
    } : $e4b50d36b79545e2$var$is(a, "lab") ? {
        _a: a.l,
        _b: a.a,
        _c: a.b,
        _d: 0,
        space: "lab"
    } : $e4b50d36b79545e2$var$is(a, "lch") ? {
        _a: a.l,
        _b: a.c,
        _c: a.h,
        _d: 0,
        space: "lch"
    } : $e4b50d36b79545e2$var$is(a, "cmyk") ? {
        _a: a.c,
        _b: a.m,
        _c: a.y,
        _d: a.k,
        space: "cmyk"
    } : {
        _a: 0,
        _b: 0,
        _c: 0,
        space: "rgb"
    };
    params.space = b || params.space;
    return params;
}
function $e4b50d36b79545e2$var$cieSpace(space) {
    if (space === "lab" || space === "xyz" || space === "lch") return true;
    else return false;
}
function $e4b50d36b79545e2$var$hueToRgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
    return p;
}
class $e4b50d36b79545e2$export$892596cec99bc70e {
    constructor(...inputs){
        this.init(...inputs);
    }
    static isColor(color) {
        return color && (color instanceof $e4b50d36b79545e2$export$892596cec99bc70e || this.isRgb(color) || this.test(color));
    }
    static isRgb(color) {
        return color && typeof color.r === "number" && typeof color.g === "number" && typeof color.b === "number";
    }
    /*
  Generating random colors
  */ static random(mode = "vibrant", t, u) {
        // Get the math modules
        const { random: random, round: round, sin: sin, PI: pi } = Math; // Run the correct generator
        if (mode === "vibrant") {
            const l = 24 * random() + 57;
            const c = 38 * random() + 45;
            const h = 360 * random();
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(l, c, h, "lch");
            return color;
        } else if (mode === "sine") {
            t = t == null ? random() : t;
            const r = round(80 * sin(2 * pi * t / 0.5 + 0.01) + 150);
            const g = round(50 * sin(2 * pi * t / 0.5 + 4.6) + 200);
            const b = round(100 * sin(2 * pi * t / 0.5 + 2.3) + 150);
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(r, g, b);
            return color;
        } else if (mode === "pastel") {
            const l = 8 * random() + 86;
            const c = 17 * random() + 9;
            const h = 360 * random();
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(l, c, h, "lch");
            return color;
        } else if (mode === "dark") {
            const l = 10 + 10 * random();
            const c = 50 * random() + 86;
            const h = 360 * random();
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(l, c, h, "lch");
            return color;
        } else if (mode === "rgb") {
            const r = 255 * random();
            const g = 255 * random();
            const b = 255 * random();
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(r, g, b);
            return color;
        } else if (mode === "lab") {
            const l = 100 * random();
            const a = 256 * random() - 128;
            const b = 256 * random() - 128;
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(l, a, b, "lab");
            return color;
        } else if (mode === "grey") {
            const grey = 255 * random();
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(grey, grey, grey);
            return color;
        } else throw new Error("Unsupported random color mode");
    }
    static test(color) {
        return typeof color === "string" && ($e4b50d36b79545e2$var$isHex.test(color) || $e4b50d36b79545e2$var$isRgb.test(color));
    }
    cmyk() {
        // Get the rgb values for the current color
        const { _a: _a, _b: _b, _c: _c } = this.rgb();
        const [r, g, b] = [
            _a,
            _b,
            _c
        ].map((v)=>v / 255); // Get the cmyk values in an unbounded format
        const k = Math.min(1 - r, 1 - g, 1 - b);
        if (k === 1) // Catch the black case
        return new $e4b50d36b79545e2$export$892596cec99bc70e(0, 0, 0, 1, "cmyk");
        const c = (1 - r - k) / (1 - k);
        const m = (1 - g - k) / (1 - k);
        const y = (1 - b - k) / (1 - k); // Construct the new color
        const color = new $e4b50d36b79545e2$export$892596cec99bc70e(c, m, y, k, "cmyk");
        return color;
    }
    hsl() {
        // Get the rgb values
        const { _a: _a, _b: _b, _c: _c } = this.rgb();
        const [r, g, b] = [
            _a,
            _b,
            _c
        ].map((v)=>v / 255); // Find the maximum and minimum values to get the lightness
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        const l = (max + min) / 2; // If the r, g, v values are identical then we are grey
        const isGrey = max === min; // Calculate the hue and saturation
        const delta = max - min;
        const s = isGrey ? 0 : l > 0.5 ? delta / (2 - max - min) : delta / (max + min);
        const h = isGrey ? 0 : max === r ? ((g - b) / delta + (g < b ? 6 : 0)) / 6 : max === g ? ((b - r) / delta + 2) / 6 : max === b ? ((r - g) / delta + 4) / 6 : 0; // Construct and return the new color
        const color = new $e4b50d36b79545e2$export$892596cec99bc70e(360 * h, 100 * s, 100 * l, "hsl");
        return color;
    }
    init(a = 0, b = 0, c = 0, d = 0, space = "rgb") {
        // This catches the case when a falsy value is passed like ''
        a = !a ? 0 : a; // Reset all values in case the init function is rerun with new color space
        if (this.space) for(const component in this.space)delete this[this.space[component]];
        if (typeof a === "number") {
            // Allow for the case that we don't need d...
            space = typeof d === "string" ? d : space;
            d = typeof d === "string" ? 0 : d; // Assign the values straight to the color
            Object.assign(this, {
                _a: a,
                _b: b,
                _c: c,
                _d: d,
                space: space
            }); // If the user gave us an array, make the color from it
        } else if (a instanceof Array) {
            this.space = b || (typeof a[3] === "string" ? a[3] : a[4]) || "rgb";
            Object.assign(this, {
                _a: a[0],
                _b: a[1],
                _c: a[2],
                _d: a[3] || 0
            });
        } else if (a instanceof Object) {
            // Set the object up and assign its values directly
            const values = $e4b50d36b79545e2$var$getParameters(a, b);
            Object.assign(this, values);
        } else if (typeof a === "string") {
            if ($e4b50d36b79545e2$var$isRgb.test(a)) {
                const noWhitespace = a.replace($e4b50d36b79545e2$var$whitespace, "");
                const [_a, _b, _c] = $e4b50d36b79545e2$var$rgb.exec(noWhitespace).slice(1, 4).map((v)=>parseInt(v));
                Object.assign(this, {
                    _a: _a,
                    _b: _b,
                    _c: _c,
                    _d: 0,
                    space: "rgb"
                });
            } else if ($e4b50d36b79545e2$var$isHex.test(a)) {
                const hexParse = (v)=>parseInt(v, 16);
                const [, _a, _b, _c] = $e4b50d36b79545e2$var$hex.exec($e4b50d36b79545e2$var$sixDigitHex(a)).map(hexParse);
                Object.assign(this, {
                    _a: _a,
                    _b: _b,
                    _c: _c,
                    _d: 0,
                    space: "rgb"
                });
            } else throw Error("Unsupported string format, can't construct Color");
        } // Now add the components as a convenience
        const { _a: _a, _b: _b, _c: _c, _d: _d } = this;
        const components = this.space === "rgb" ? {
            r: _a,
            g: _b,
            b: _c
        } : this.space === "xyz" ? {
            x: _a,
            y: _b,
            z: _c
        } : this.space === "hsl" ? {
            h: _a,
            s: _b,
            l: _c
        } : this.space === "lab" ? {
            l: _a,
            a: _b,
            b: _c
        } : this.space === "lch" ? {
            l: _a,
            c: _b,
            h: _c
        } : this.space === "cmyk" ? {
            c: _a,
            m: _b,
            y: _c,
            k: _d
        } : {};
        Object.assign(this, components);
    }
    lab() {
        // Get the xyz color
        const { x: x, y: y, z: z } = this.xyz(); // Get the lab components
        const l = 116 * y - 16;
        const a = 500 * (x - y);
        const b = 200 * (y - z); // Construct and return a new color
        const color = new $e4b50d36b79545e2$export$892596cec99bc70e(l, a, b, "lab");
        return color;
    }
    lch() {
        // Get the lab color directly
        const { l: l, a: a, b: b } = this.lab(); // Get the chromaticity and the hue using polar coordinates
        const c = Math.sqrt(a ** 2 + b ** 2);
        let h = 180 * Math.atan2(b, a) / Math.PI;
        if (h < 0) {
            h *= -1;
            h = 360 - h;
        } // Make a new color and return it
        const color = new $e4b50d36b79545e2$export$892596cec99bc70e(l, c, h, "lch");
        return color;
    }
    /*
  Conversion Methods
  */ rgb() {
        if (this.space === "rgb") return this;
        else if ($e4b50d36b79545e2$var$cieSpace(this.space)) {
            // Convert to the xyz color space
            let { x: x, y: y, z: z } = this;
            if (this.space === "lab" || this.space === "lch") {
                // Get the values in the lab space
                let { l: l, a: a, b: b } = this;
                if (this.space === "lch") {
                    const { c: c, h: h } = this;
                    const dToR = Math.PI / 180;
                    a = c * Math.cos(dToR * h);
                    b = c * Math.sin(dToR * h);
                } // Undo the nonlinear function
                const yL = (l + 16) / 116;
                const xL = a / 500 + yL;
                const zL = yL - b / 200; // Get the xyz values
                const ct = 16 / 116;
                const mx = 0.008856;
                const nm = 7.787;
                x = 0.95047 * (xL ** 3 > mx ? xL ** 3 : (xL - ct) / nm);
                y = 1.00000 * (yL ** 3 > mx ? yL ** 3 : (yL - ct) / nm);
                z = 1.08883 * (zL ** 3 > mx ? zL ** 3 : (zL - ct) / nm);
            } // Convert xyz to unbounded rgb values
            const rU = x * 3.2406 + y * -1.5372 + z * -0.4986;
            const gU = x * -0.9689 + y * 1.8758 + z * 0.0415;
            const bU = x * 0.0557 + y * -0.204 + z * 1.0570; // Convert the values to true rgb values
            const pow = Math.pow;
            const bd = 0.0031308;
            const r = rU > bd ? 1.055 * pow(rU, 1 / 2.4) - 0.055 : 12.92 * rU;
            const g = gU > bd ? 1.055 * pow(gU, 1 / 2.4) - 0.055 : 12.92 * gU;
            const b = bU > bd ? 1.055 * pow(bU, 1 / 2.4) - 0.055 : 12.92 * bU; // Make and return the color
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(255 * r, 255 * g, 255 * b);
            return color;
        } else if (this.space === "hsl") {
            // https://bgrins.github.io/TinyColor/docs/tinycolor.html
            // Get the current hsl values
            let { h: h, s: s, l: l } = this;
            h /= 360;
            s /= 100;
            l /= 100; // If we are grey, then just make the color directly
            if (s === 0) {
                l *= 255;
                const color = new $e4b50d36b79545e2$export$892596cec99bc70e(l, l, l);
                return color;
            } // TODO I have no idea what this does :D If you figure it out, tell me!
            const q = l < 0.5 ? l * (1 + s) : l + s - l * s;
            const p = 2 * l - q; // Get the rgb values
            const r = 255 * $e4b50d36b79545e2$var$hueToRgb(p, q, h + 1 / 3);
            const g = 255 * $e4b50d36b79545e2$var$hueToRgb(p, q, h);
            const b = 255 * $e4b50d36b79545e2$var$hueToRgb(p, q, h - 1 / 3); // Make a new color
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(r, g, b);
            return color;
        } else if (this.space === "cmyk") {
            // https://gist.github.com/felipesabino/5066336
            // Get the normalised cmyk values
            const { c: c, m: m, y: y, k: k } = this; // Get the rgb values
            const r = 255 * (1 - Math.min(1, c * (1 - k) + k));
            const g = 255 * (1 - Math.min(1, m * (1 - k) + k));
            const b = 255 * (1 - Math.min(1, y * (1 - k) + k)); // Form the color and return it
            const color = new $e4b50d36b79545e2$export$892596cec99bc70e(r, g, b);
            return color;
        } else return this;
    }
    toArray() {
        const { _a: _a, _b: _b, _c: _c, _d: _d, space: space } = this;
        return [
            _a,
            _b,
            _c,
            _d,
            space
        ];
    }
    toHex() {
        const [r, g, b] = this._clamped().map($e4b50d36b79545e2$var$componentHex);
        return `#${r}${g}${b}`;
    }
    toRgb() {
        const [rV, gV, bV] = this._clamped();
        const string = `rgb(${rV},${gV},${bV})`;
        return string;
    }
    toString() {
        return this.toHex();
    }
    xyz() {
        // Normalise the red, green and blue values
        const { _a: r255, _b: g255, _c: b255 } = this.rgb();
        const [r, g, b] = [
            r255,
            g255,
            b255
        ].map((v)=>v / 255); // Convert to the lab rgb space
        const rL = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
        const gL = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
        const bL = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92; // Convert to the xyz color space without bounding the values
        const xU = (rL * 0.4124 + gL * 0.3576 + bL * 0.1805) / 0.95047;
        const yU = (rL * 0.2126 + gL * 0.7152 + bL * 0.0722) / 1.00000;
        const zU = (rL * 0.0193 + gL * 0.1192 + bL * 0.9505) / 1.08883; // Get the proper xyz values by applying the bounding
        const x = xU > 0.008856 ? Math.pow(xU, 1 / 3) : 7.787 * xU + 16 / 116;
        const y = yU > 0.008856 ? Math.pow(yU, 1 / 3) : 7.787 * yU + 16 / 116;
        const z = zU > 0.008856 ? Math.pow(zU, 1 / 3) : 7.787 * zU + 16 / 116; // Make and return the color
        const color = new $e4b50d36b79545e2$export$892596cec99bc70e(x, y, z, "xyz");
        return color;
    }
    /*
  Input and Output methods
  */ _clamped() {
        const { _a: _a, _b: _b, _c: _c } = this.rgb();
        const { max: max, min: min, round: round } = Math;
        const format = (v)=>max(0, min(round(v), 255));
        return [
            _a,
            _b,
            _c
        ].map(format);
    }
}
class $e4b50d36b79545e2$export$baf26146a414f24a {
    // Initialize
    constructor(...args){
        this.init(...args);
    }
    clone() {
        return new $e4b50d36b79545e2$export$baf26146a414f24a(this);
    }
    init(x, y) {
        const base = {
            x: 0,
            y: 0
        }; // ensure source as object
        const source = Array.isArray(x) ? {
            x: x[0],
            y: x[1]
        } : typeof x === "object" ? {
            x: x.x,
            y: x.y
        } : {
            x: x,
            y: y
        }; // merge source
        this.x = source.x == null ? base.x : source.x;
        this.y = source.y == null ? base.y : source.y;
        return this;
    }
    toArray() {
        return [
            this.x,
            this.y
        ];
    }
    transform(m) {
        return this.clone().transformO(m);
    }
    transformO(m) {
        if (!$e4b50d36b79545e2$export$5b12bf1653c0dd85.isMatrixLike(m)) m = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(m);
        const { x: x, y: y } = this; // Perform the matrix multiplication
        this.x = m.a * x + m.c * y + m.e;
        this.y = m.b * x + m.d * y + m.f;
        return this;
    }
}
function $e4b50d36b79545e2$var$point(x, y) {
    return new $e4b50d36b79545e2$export$baf26146a414f24a(x, y).transformO(this.screenCTM().inverseO());
}
function $e4b50d36b79545e2$var$closeEnough(a, b, threshold) {
    return Math.abs(b - a) < (threshold || 1e-6);
}
class $e4b50d36b79545e2$export$5b12bf1653c0dd85 {
    constructor(...args){
        this.init(...args);
    }
    static formatTransforms(o) {
        // Get all of the parameters required to form the matrix
        const flipBoth = o.flip === "both" || o.flip === true;
        const flipX = o.flip && (flipBoth || o.flip === "x") ? -1 : 1;
        const flipY = o.flip && (flipBoth || o.flip === "y") ? -1 : 1;
        const skewX = o.skew && o.skew.length ? o.skew[0] : isFinite(o.skew) ? o.skew : isFinite(o.skewX) ? o.skewX : 0;
        const skewY = o.skew && o.skew.length ? o.skew[1] : isFinite(o.skew) ? o.skew : isFinite(o.skewY) ? o.skewY : 0;
        const scaleX = o.scale && o.scale.length ? o.scale[0] * flipX : isFinite(o.scale) ? o.scale * flipX : isFinite(o.scaleX) ? o.scaleX * flipX : flipX;
        const scaleY = o.scale && o.scale.length ? o.scale[1] * flipY : isFinite(o.scale) ? o.scale * flipY : isFinite(o.scaleY) ? o.scaleY * flipY : flipY;
        const shear = o.shear || 0;
        const theta = o.rotate || o.theta || 0;
        const origin = new $e4b50d36b79545e2$export$baf26146a414f24a(o.origin || o.around || o.ox || o.originX, o.oy || o.originY);
        const ox = origin.x;
        const oy = origin.y; // We need Point to be invalid if nothing was passed because we cannot default to 0 here. That is why NaN
        const position = new $e4b50d36b79545e2$export$baf26146a414f24a(o.position || o.px || o.positionX || NaN, o.py || o.positionY || NaN);
        const px = position.x;
        const py = position.y;
        const translate = new $e4b50d36b79545e2$export$baf26146a414f24a(o.translate || o.tx || o.translateX, o.ty || o.translateY);
        const tx = translate.x;
        const ty = translate.y;
        const relative = new $e4b50d36b79545e2$export$baf26146a414f24a(o.relative || o.rx || o.relativeX, o.ry || o.relativeY);
        const rx = relative.x;
        const ry = relative.y; // Populate all of the values
        return {
            scaleX: scaleX,
            scaleY: scaleY,
            skewX: skewX,
            skewY: skewY,
            shear: shear,
            theta: theta,
            rx: rx,
            ry: ry,
            tx: tx,
            ty: ty,
            ox: ox,
            oy: oy,
            px: px,
            py: py
        };
    }
    static fromArray(a) {
        return {
            a: a[0],
            b: a[1],
            c: a[2],
            d: a[3],
            e: a[4],
            f: a[5]
        };
    }
    static isMatrixLike(o) {
        return o.a != null || o.b != null || o.c != null || o.d != null || o.e != null || o.f != null;
    }
    static matrixMultiply(l, r, o) {
        // Work out the product directly
        const a = l.a * r.a + l.c * r.b;
        const b = l.b * r.a + l.d * r.b;
        const c = l.a * r.c + l.c * r.d;
        const d = l.b * r.c + l.d * r.d;
        const e = l.e + l.a * r.e + l.c * r.f;
        const f = l.f + l.b * r.e + l.d * r.f; // make sure to use local variables because l/r and o could be the same
        o.a = a;
        o.b = b;
        o.c = c;
        o.d = d;
        o.e = e;
        o.f = f;
        return o;
    }
    around(cx, cy, matrix) {
        return this.clone().aroundO(cx, cy, matrix);
    }
    aroundO(cx, cy, matrix) {
        const dx = cx || 0;
        const dy = cy || 0;
        return this.translateO(-dx, -dy).lmultiplyO(matrix).translateO(dx, dy);
    }
    clone() {
        return new $e4b50d36b79545e2$export$5b12bf1653c0dd85(this);
    }
    decompose(cx = 0, cy = 0) {
        // Get the parameters from the matrix
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const e = this.e;
        const f = this.f; // Figure out if the winding direction is clockwise or counterclockwise
        const determinant = a * d - b * c;
        const ccw = determinant > 0 ? 1 : -1; // Since we only shear in x, we can use the x basis to get the x scale
        // and the rotation of the resulting matrix
        const sx = ccw * Math.sqrt(a * a + b * b);
        const thetaRad = Math.atan2(ccw * b, ccw * a);
        const theta = 180 / Math.PI * thetaRad;
        const ct = Math.cos(thetaRad);
        const st = Math.sin(thetaRad); // We can then solve the y basis vector simultaneously to get the other
        // two affine parameters directly from these parameters
        const lam = (a * c + b * d) / determinant;
        const sy = c * sx / (lam * a - b) || d * sx / (lam * b + a); // Use the translations
        const tx = e - cx + cx * ct * sx + cy * (lam * ct * sx - st * sy);
        const ty = f - cy + cx * st * sx + cy * (lam * st * sx + ct * sy); // Construct the decomposition and return it
        return {
            // Return the affine parameters
            scaleX: sx,
            scaleY: sy,
            shear: lam,
            rotate: theta,
            translateX: tx,
            translateY: ty,
            originX: cx,
            originY: cy,
            // Return the matrix parameters
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
    equals(other) {
        if (other === this) return true;
        const comp = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(other);
        return $e4b50d36b79545e2$var$closeEnough(this.a, comp.a) && $e4b50d36b79545e2$var$closeEnough(this.b, comp.b) && $e4b50d36b79545e2$var$closeEnough(this.c, comp.c) && $e4b50d36b79545e2$var$closeEnough(this.d, comp.d) && $e4b50d36b79545e2$var$closeEnough(this.e, comp.e) && $e4b50d36b79545e2$var$closeEnough(this.f, comp.f);
    }
    flip(axis, around) {
        return this.clone().flipO(axis, around);
    }
    flipO(axis, around) {
        return axis === "x" ? this.scaleO(-1, 1, around, 0) : axis === "y" ? this.scaleO(1, -1, 0, around) : this.scaleO(-1, -1, axis, around || axis); // Define an x, y flip point
    }
    init(source) {
        const base = $e4b50d36b79545e2$export$5b12bf1653c0dd85.fromArray([
            1,
            0,
            0,
            1,
            0,
            0
        ]); // ensure source as object
        source = source instanceof $e4b50d36b79545e2$export$db77ccec0bb4ccac ? source.matrixify() : typeof source === "string" ? $e4b50d36b79545e2$export$5b12bf1653c0dd85.fromArray(source.split($e4b50d36b79545e2$var$delimiter).map(parseFloat)) : Array.isArray(source) ? $e4b50d36b79545e2$export$5b12bf1653c0dd85.fromArray(source) : typeof source === "object" && $e4b50d36b79545e2$export$5b12bf1653c0dd85.isMatrixLike(source) ? source : typeof source === "object" ? new $e4b50d36b79545e2$export$5b12bf1653c0dd85().transform(source) : arguments.length === 6 ? $e4b50d36b79545e2$export$5b12bf1653c0dd85.fromArray([].slice.call(arguments)) : base; // Merge the source matrix with the base matrix
        this.a = source.a != null ? source.a : base.a;
        this.b = source.b != null ? source.b : base.b;
        this.c = source.c != null ? source.c : base.c;
        this.d = source.d != null ? source.d : base.d;
        this.e = source.e != null ? source.e : base.e;
        this.f = source.f != null ? source.f : base.f;
        return this;
    }
    inverse() {
        return this.clone().inverseO();
    }
    inverseO() {
        // Get the current parameters out of the matrix
        const a = this.a;
        const b = this.b;
        const c = this.c;
        const d = this.d;
        const e = this.e;
        const f = this.f; // Invert the 2x2 matrix in the top left
        const det = a * d - b * c;
        if (!det) throw new Error("Cannot invert " + this); // Calculate the top 2x2 matrix
        const na = d / det;
        const nb = -b / det;
        const nc = -c / det;
        const nd = a / det; // Apply the inverted matrix to the top right
        const ne = -(na * e + nc * f);
        const nf = -(nb * e + nd * f); // Construct the inverted matrix
        this.a = na;
        this.b = nb;
        this.c = nc;
        this.d = nd;
        this.e = ne;
        this.f = nf;
        return this;
    }
    lmultiply(matrix) {
        return this.clone().lmultiplyO(matrix);
    }
    lmultiplyO(matrix) {
        const r = this;
        const l = matrix instanceof $e4b50d36b79545e2$export$5b12bf1653c0dd85 ? matrix : new $e4b50d36b79545e2$export$5b12bf1653c0dd85(matrix);
        return $e4b50d36b79545e2$export$5b12bf1653c0dd85.matrixMultiply(l, r, this);
    }
    multiply(matrix) {
        return this.clone().multiplyO(matrix);
    }
    multiplyO(matrix) {
        // Get the matrices
        const l = this;
        const r = matrix instanceof $e4b50d36b79545e2$export$5b12bf1653c0dd85 ? matrix : new $e4b50d36b79545e2$export$5b12bf1653c0dd85(matrix);
        return $e4b50d36b79545e2$export$5b12bf1653c0dd85.matrixMultiply(l, r, this);
    }
    rotate(r, cx, cy) {
        return this.clone().rotateO(r, cx, cy);
    }
    rotateO(r, cx = 0, cy = 0) {
        // Convert degrees to radians
        r = $e4b50d36b79545e2$var$radians(r);
        const cos = Math.cos(r);
        const sin = Math.sin(r);
        const { a: a, b: b, c: c, d: d, e: e, f: f } = this;
        this.a = a * cos - b * sin;
        this.b = b * cos + a * sin;
        this.c = c * cos - d * sin;
        this.d = d * cos + c * sin;
        this.e = e * cos - f * sin + cy * sin - cx * cos + cx;
        this.f = f * cos + e * sin - cx * sin - cy * cos + cy;
        return this;
    }
    scale(x, y, cx, cy) {
        return this.clone().scaleO(...arguments);
    }
    scaleO(x, y = x, cx = 0, cy = 0) {
        // Support uniform scaling
        if (arguments.length === 3) {
            cy = cx;
            cx = y;
            y = x;
        }
        const { a: a, b: b, c: c, d: d, e: e, f: f } = this;
        this.a = a * x;
        this.b = b * y;
        this.c = c * x;
        this.d = d * y;
        this.e = e * x - cx * x + cx;
        this.f = f * y - cy * y + cy;
        return this;
    }
    shear(a, cx, cy) {
        return this.clone().shearO(a, cx, cy);
    }
    shearO(lx, cx = 0, cy = 0) {
        const { a: a, b: b, c: c, d: d, e: e, f: f } = this;
        this.a = a + b * lx;
        this.c = c + d * lx;
        this.e = e + f * lx - cy * lx;
        return this;
    }
    skew(x, y, cx, cy) {
        return this.clone().skewO(...arguments);
    }
    skewO(x, y = x, cx = 0, cy = 0) {
        // support uniformal skew
        if (arguments.length === 3) {
            cy = cx;
            cx = y;
            y = x;
        } // Convert degrees to radians
        x = $e4b50d36b79545e2$var$radians(x);
        y = $e4b50d36b79545e2$var$radians(y);
        const lx = Math.tan(x);
        const ly = Math.tan(y);
        const { a: a, b: b, c: c, d: d, e: e, f: f } = this;
        this.a = a + b * lx;
        this.b = b + a * ly;
        this.c = c + d * lx;
        this.d = d + c * ly;
        this.e = e + f * lx - cy * lx;
        this.f = f + e * ly - cx * ly;
        return this;
    }
    skewX(x, cx, cy) {
        return this.skew(x, 0, cx, cy);
    }
    skewY(y, cx, cy) {
        return this.skew(0, y, cx, cy);
    }
    toArray() {
        return [
            this.a,
            this.b,
            this.c,
            this.d,
            this.e,
            this.f
        ];
    }
    toString() {
        return "matrix(" + this.a + "," + this.b + "," + this.c + "," + this.d + "," + this.e + "," + this.f + ")";
    }
    transform(o) {
        // Check if o is a matrix and then left multiply it directly
        if ($e4b50d36b79545e2$export$5b12bf1653c0dd85.isMatrixLike(o)) {
            const matrix = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(o);
            return matrix.multiplyO(this);
        } // Get the proposed transformations and the current transformations
        const t = $e4b50d36b79545e2$export$5b12bf1653c0dd85.formatTransforms(o);
        const current = this;
        const { x: ox, y: oy } = new $e4b50d36b79545e2$export$baf26146a414f24a(t.ox, t.oy).transform(current); // Construct the resulting matrix
        const transformer = new $e4b50d36b79545e2$export$5b12bf1653c0dd85().translateO(t.rx, t.ry).lmultiplyO(current).translateO(-ox, -oy).scaleO(t.scaleX, t.scaleY).skewO(t.skewX, t.skewY).shearO(t.shear).rotateO(t.theta).translateO(ox, oy); // If we want the origin at a particular place, we force it there
        if (isFinite(t.px) || isFinite(t.py)) {
            const origin = new $e4b50d36b79545e2$export$baf26146a414f24a(ox, oy).transform(transformer); // TODO: Replace t.px with isFinite(t.px)
            // Doesn't work because t.px is also 0 if it wasn't passed
            const dx = isFinite(t.px) ? t.px - origin.x : 0;
            const dy = isFinite(t.py) ? t.py - origin.y : 0;
            transformer.translateO(dx, dy);
        } // Translate now after positioning
        transformer.translateO(t.tx, t.ty);
        return transformer;
    }
    translate(x, y) {
        return this.clone().translateO(x, y);
    }
    translateO(x, y) {
        this.e += x || 0;
        this.f += y || 0;
        return this;
    }
    valueOf() {
        return {
            a: this.a,
            b: this.b,
            c: this.c,
            d: this.d,
            e: this.e,
            f: this.f
        };
    }
}
function $e4b50d36b79545e2$var$ctm() {
    return new $e4b50d36b79545e2$export$5b12bf1653c0dd85(this.node.getCTM());
}
function $e4b50d36b79545e2$var$screenCTM() {
    /* https://bugzilla.mozilla.org/show_bug.cgi?id=1344537
     This is needed because FF does not return the transformation matrix
     for the inner coordinate system when getScreenCTM() is called on nested svgs.
     However all other Browsers do that */ if (typeof this.isRoot === "function" && !this.isRoot()) {
        const rect = this.rect(1, 1);
        const m = rect.node.getScreenCTM();
        rect.remove();
        return new $e4b50d36b79545e2$export$5b12bf1653c0dd85(m);
    }
    return new $e4b50d36b79545e2$export$5b12bf1653c0dd85(this.node.getScreenCTM());
}
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$5b12bf1653c0dd85, "Matrix");
function $e4b50d36b79545e2$export$8f49e4af10703ce3() {
    // Reuse cached element if possible
    if (!$e4b50d36b79545e2$export$8f49e4af10703ce3.nodes) {
        const svg = $e4b50d36b79545e2$export$60fbc25e7b928117().size(2, 0);
        svg.node.style.cssText = [
            "opacity: 0",
            "position: absolute",
            "left: -100%",
            "top: -100%",
            "overflow: hidden"
        ].join(";");
        svg.attr("focusable", "false");
        svg.attr("aria-hidden", "true");
        const path = svg.path().node;
        $e4b50d36b79545e2$export$8f49e4af10703ce3.nodes = {
            svg: svg,
            path: path
        };
    }
    if (!$e4b50d36b79545e2$export$8f49e4af10703ce3.nodes.svg.node.parentNode) {
        const b = $e4b50d36b79545e2$var$globals.document.body || $e4b50d36b79545e2$var$globals.document.documentElement;
        $e4b50d36b79545e2$export$8f49e4af10703ce3.nodes.svg.addTo(b);
    }
    return $e4b50d36b79545e2$export$8f49e4af10703ce3.nodes;
}
function $e4b50d36b79545e2$var$isNulledBox(box) {
    return !box.width && !box.height && !box.x && !box.y;
}
function $e4b50d36b79545e2$var$domContains(node) {
    return node === $e4b50d36b79545e2$var$globals.document || ($e4b50d36b79545e2$var$globals.document.documentElement.contains || function(node) {
        // This is IE - it does not support contains() for top-level SVGs
        while(node.parentNode)node = node.parentNode;
        return node === $e4b50d36b79545e2$var$globals.document;
    }).call($e4b50d36b79545e2$var$globals.document.documentElement, node);
}
class $e4b50d36b79545e2$export$e71c4d32a2263218 {
    constructor(...args){
        this.init(...args);
    }
    addOffset() {
        // offset by window scroll position, because getBoundingClientRect changes when window is scrolled
        this.x += $e4b50d36b79545e2$var$globals.window.pageXOffset;
        this.y += $e4b50d36b79545e2$var$globals.window.pageYOffset;
        return new $e4b50d36b79545e2$export$e71c4d32a2263218(this);
    }
    init(source) {
        const base = [
            0,
            0,
            0,
            0
        ];
        source = typeof source === "string" ? source.split($e4b50d36b79545e2$var$delimiter).map(parseFloat) : Array.isArray(source) ? source : typeof source === "object" ? [
            source.left != null ? source.left : source.x,
            source.top != null ? source.top : source.y,
            source.width,
            source.height
        ] : arguments.length === 4 ? [].slice.call(arguments) : base;
        this.x = source[0] || 0;
        this.y = source[1] || 0;
        this.width = this.w = source[2] || 0;
        this.height = this.h = source[3] || 0; // Add more bounding box properties
        this.x2 = this.x + this.w;
        this.y2 = this.y + this.h;
        this.cx = this.x + this.w / 2;
        this.cy = this.y + this.h / 2;
        return this;
    }
    isNulled() {
        return $e4b50d36b79545e2$var$isNulledBox(this);
    }
    merge(box) {
        const x = Math.min(this.x, box.x);
        const y = Math.min(this.y, box.y);
        const width = Math.max(this.x + this.width, box.x + box.width) - x;
        const height = Math.max(this.y + this.height, box.y + box.height) - y;
        return new $e4b50d36b79545e2$export$e71c4d32a2263218(x, y, width, height);
    }
    toArray() {
        return [
            this.x,
            this.y,
            this.width,
            this.height
        ];
    }
    toString() {
        return this.x + " " + this.y + " " + this.width + " " + this.height;
    }
    transform(m) {
        if (!(m instanceof $e4b50d36b79545e2$export$5b12bf1653c0dd85)) m = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(m);
        let xMin = Infinity;
        let xMax = -Infinity;
        let yMin = Infinity;
        let yMax = -Infinity;
        const pts = [
            new $e4b50d36b79545e2$export$baf26146a414f24a(this.x, this.y),
            new $e4b50d36b79545e2$export$baf26146a414f24a(this.x2, this.y),
            new $e4b50d36b79545e2$export$baf26146a414f24a(this.x, this.y2),
            new $e4b50d36b79545e2$export$baf26146a414f24a(this.x2, this.y2)
        ];
        pts.forEach(function(p) {
            p = p.transform(m);
            xMin = Math.min(xMin, p.x);
            xMax = Math.max(xMax, p.x);
            yMin = Math.min(yMin, p.y);
            yMax = Math.max(yMax, p.y);
        });
        return new $e4b50d36b79545e2$export$e71c4d32a2263218(xMin, yMin, xMax - xMin, yMax - yMin);
    }
}
function $e4b50d36b79545e2$var$getBox(el, getBBoxFn, retry) {
    let box;
    try {
        // Try to get the box with the provided function
        box = getBBoxFn(el.node); // If the box is worthless and not even in the dom, retry
        // by throwing an error here...
        if ($e4b50d36b79545e2$var$isNulledBox(box) && !$e4b50d36b79545e2$var$domContains(el.node)) throw new Error("Element not in the dom");
    } catch (e) {
        // ... and calling the retry handler here
        box = retry(el);
    }
    return box;
}
function $e4b50d36b79545e2$var$bbox() {
    // Function to get bbox is getBBox()
    const getBBox = (node)=>node.getBBox(); // Take all measures so that a stupid browser renders the element
    // so we can get the bbox from it when we try again
    const retry = (el)=>{
        try {
            const clone = el.clone().addTo($e4b50d36b79545e2$export$8f49e4af10703ce3().svg).show();
            const box = clone.node.getBBox();
            clone.remove();
            return box;
        } catch (e) {
            // We give up...
            throw new Error(`Getting bbox of element "${el.node.nodeName}" is not possible: ${e.toString()}`);
        }
    };
    const box = $e4b50d36b79545e2$var$getBox(this, getBBox, retry);
    const bbox = new $e4b50d36b79545e2$export$e71c4d32a2263218(box);
    return bbox;
}
function $e4b50d36b79545e2$var$rbox(el) {
    const getRBox = (node)=>node.getBoundingClientRect();
    const retry = (el)=>{
        // There is no point in trying tricks here because if we insert the element into the dom ourselves
        // it obviously will be at the wrong position
        throw new Error(`Getting rbox of element "${el.node.nodeName}" is not possible`);
    };
    const box = $e4b50d36b79545e2$var$getBox(this, getRBox, retry);
    const rbox = new $e4b50d36b79545e2$export$e71c4d32a2263218(box); // If an element was passed, we want the bbox in the coordinate system of that element
    if (el) return rbox.transform(el.screenCTM().inverseO());
     // Else we want it in absolute screen coordinates
    // Therefore we need to add the scrollOffset
    return rbox.addOffset();
} // Checks whether the given point is inside the bounding box
function $e4b50d36b79545e2$var$inside(x, y) {
    const box = this.bbox();
    return x > box.x && y > box.y && x < box.x + box.width && y < box.y + box.height;
}
$e4b50d36b79545e2$var$registerMethods({
    viewbox: {
        viewbox (x, y, width, height) {
            // act as getter
            if (x == null) return new $e4b50d36b79545e2$export$e71c4d32a2263218(this.attr("viewBox")); // act as setter
            return this.attr("viewBox", new $e4b50d36b79545e2$export$e71c4d32a2263218(x, y, width, height));
        },
        zoom (level, point) {
            // Its best to rely on the attributes here and here is why:
            // clientXYZ: Doesn't work on non-root svgs because they dont have a CSSBox (silly!)
            // getBoundingClientRect: Doesn't work because Chrome just ignores width and height of nested svgs completely
            //                        that means, their clientRect is always as big as the content.
            //                        Furthermore this size is incorrect if the element is further transformed by its parents
            // computedStyle: Only returns meaningful values if css was used with px. We dont go this route here!
            // getBBox: returns the bounding box of its content - that doesn't help!
            let { width: width, height: height } = this.attr([
                "width",
                "height"
            ]); // Width and height is a string when a number with a unit is present which we can't use
            // So we try clientXYZ
            if (!width && !height || typeof width === "string" || typeof height === "string") {
                width = this.node.clientWidth;
                height = this.node.clientHeight;
            } // Giving up...
            if (!width || !height) throw new Error("Impossible to get absolute width and height. Please provide an absolute width and height attribute on the zooming element");
            const v = this.viewbox();
            const zoomX = width / v.width;
            const zoomY = height / v.height;
            const zoom = Math.min(zoomX, zoomY);
            if (level == null) return zoom;
            let zoomAmount = zoom / level; // Set the zoomAmount to the highest value which is safe to process and recover from
            // The * 100 is a bit of wiggle room for the matrix transformation
            if (zoomAmount === Infinity) zoomAmount = Number.MAX_SAFE_INTEGER / 100;
            point = point || new $e4b50d36b79545e2$export$baf26146a414f24a(width / 2 / zoomX + v.x, height / 2 / zoomY + v.y);
            const box = new $e4b50d36b79545e2$export$e71c4d32a2263218(v).transform(new $e4b50d36b79545e2$export$5b12bf1653c0dd85({
                scale: zoomAmount,
                origin: point
            }));
            return this.viewbox(box);
        }
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$e71c4d32a2263218, "Box");
class $e4b50d36b79545e2$export$54c2e3dc7acea9f5 extends Array {
    constructor(arr = [], ...args){
        super(arr, ...args);
        if (typeof arr === "number") return this;
        this.length = 0;
        this.push(...arr);
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082([
    $e4b50d36b79545e2$export$54c2e3dc7acea9f5
], {
    each (fnOrMethodName, ...args) {
        if (typeof fnOrMethodName === "function") return this.map((el, i, arr)=>{
            return fnOrMethodName.call(el, el, i, arr);
        });
        else return this.map((el)=>{
            return el[fnOrMethodName](...args);
        });
    },
    toArray () {
        return Array.prototype.concat.apply([], this);
    }
});
const $e4b50d36b79545e2$var$reserved = [
    "toArray",
    "constructor",
    "each"
];
$e4b50d36b79545e2$export$54c2e3dc7acea9f5.extend = function(methods) {
    methods = methods.reduce((obj, name)=>{
        // Don't overwrite own methods
        if ($e4b50d36b79545e2$var$reserved.includes(name)) return obj; // Don't add private methods
        if (name[0] === "_") return obj; // Relay every call to each()
        obj[name] = function(...attrs) {
            return this.each(name, ...attrs);
        };
        return obj;
    }, {});
    $e4b50d36b79545e2$export$8b58be045bf06082([
        $e4b50d36b79545e2$export$54c2e3dc7acea9f5
    ], methods);
};
function $e4b50d36b79545e2$export$71aa6c912b956294(query, parent) {
    return new $e4b50d36b79545e2$export$54c2e3dc7acea9f5($e4b50d36b79545e2$var$map((parent || $e4b50d36b79545e2$var$globals.document).querySelectorAll(query), function(node) {
        return $e4b50d36b79545e2$export$62c9251e71806cd(node);
    }));
} // Scoped find method
function $e4b50d36b79545e2$var$find(query) {
    return $e4b50d36b79545e2$export$71aa6c912b956294(query, this.node);
}
function $e4b50d36b79545e2$var$findOne(query) {
    return $e4b50d36b79545e2$export$62c9251e71806cd(this.node.querySelector(query));
}
let $e4b50d36b79545e2$var$listenerId = 0;
const $e4b50d36b79545e2$export$e7a44b381aecfc4 = {};
function $e4b50d36b79545e2$export$3f41ece7d7128238(instance) {
    let n = instance.getEventHolder(); // We dont want to save events in global space
    if (n === $e4b50d36b79545e2$var$globals.window) n = $e4b50d36b79545e2$export$e7a44b381aecfc4;
    if (!n.events) n.events = {};
    return n.events;
}
function $e4b50d36b79545e2$export$e58f029f0fbfdb29(instance) {
    return instance.getEventTarget();
}
function $e4b50d36b79545e2$export$75a1b449cd535063(instance) {
    let n = instance.getEventHolder();
    if (n === $e4b50d36b79545e2$var$globals.window) n = $e4b50d36b79545e2$export$e7a44b381aecfc4;
    if (n.events) n.events = {};
} // Add event binder in the SVG namespace
function $e4b50d36b79545e2$export$af631764ddc44097(node, events, listener, binding, options) {
    const l = listener.bind(binding || node);
    const instance = $e4b50d36b79545e2$export$60fbc25e7b928117(node);
    const bag = $e4b50d36b79545e2$export$3f41ece7d7128238(instance);
    const n = $e4b50d36b79545e2$export$e58f029f0fbfdb29(instance); // events can be an array of events or a string of events
    events = Array.isArray(events) ? events : events.split($e4b50d36b79545e2$var$delimiter); // add id to listener
    if (!listener._svgjsListenerId) listener._svgjsListenerId = ++$e4b50d36b79545e2$var$listenerId;
    events.forEach(function(event) {
        const ev = event.split(".")[0];
        const ns = event.split(".")[1] || "*"; // ensure valid object
        bag[ev] = bag[ev] || {};
        bag[ev][ns] = bag[ev][ns] || {}; // reference listener
        bag[ev][ns][listener._svgjsListenerId] = l; // add listener
        n.addEventListener(ev, l, options || false);
    });
} // Add event unbinder in the SVG namespace
function $e4b50d36b79545e2$export$8c8705df4a2dcec9(node, events, listener, options) {
    const instance = $e4b50d36b79545e2$export$60fbc25e7b928117(node);
    const bag = $e4b50d36b79545e2$export$3f41ece7d7128238(instance);
    const n = $e4b50d36b79545e2$export$e58f029f0fbfdb29(instance); // listener can be a function or a number
    if (typeof listener === "function") {
        listener = listener._svgjsListenerId;
        if (!listener) return;
    } // events can be an array of events or a string or undefined
    events = Array.isArray(events) ? events : (events || "").split($e4b50d36b79545e2$var$delimiter);
    events.forEach(function(event) {
        const ev = event && event.split(".")[0];
        const ns = event && event.split(".")[1];
        let namespace, l;
        if (listener) // remove listener reference
        {
            if (bag[ev] && bag[ev][ns || "*"]) {
                // removeListener
                n.removeEventListener(ev, bag[ev][ns || "*"][listener], options || false);
                delete bag[ev][ns || "*"][listener];
            }
        } else if (ev && ns) // remove all listeners for a namespaced event
        {
            if (bag[ev] && bag[ev][ns]) {
                for(l in bag[ev][ns])$e4b50d36b79545e2$export$8c8705df4a2dcec9(n, [
                    ev,
                    ns
                ].join("."), l);
                delete bag[ev][ns];
            }
        } else if (ns) // remove all listeners for a specific namespace
        for(event in bag){
            for(namespace in bag[event])if (ns === namespace) $e4b50d36b79545e2$export$8c8705df4a2dcec9(n, [
                event,
                ns
            ].join("."));
        }
        else if (ev) // remove all listeners for the event
        {
            if (bag[ev]) {
                for(namespace in bag[ev])$e4b50d36b79545e2$export$8c8705df4a2dcec9(n, [
                    ev,
                    namespace
                ].join("."));
                delete bag[ev];
            }
        } else {
            // remove all listeners on a given node
            for(event in bag)$e4b50d36b79545e2$export$8c8705df4a2dcec9(n, event);
            $e4b50d36b79545e2$export$75a1b449cd535063(instance);
        }
    });
}
function $e4b50d36b79545e2$export$635e15bbd66f01ea(node, event, data, options) {
    const n = $e4b50d36b79545e2$export$e58f029f0fbfdb29(node); // Dispatch event
    if (event instanceof $e4b50d36b79545e2$var$globals.window.Event) n.dispatchEvent(event);
    else {
        event = new $e4b50d36b79545e2$var$globals.window.CustomEvent(event, {
            detail: data,
            cancelable: true,
            ...options
        });
        n.dispatchEvent(event);
    }
    return event;
}
class $e4b50d36b79545e2$export$648eec84020a2b10 extends $e4b50d36b79545e2$var$Base {
    addEventListener() {}
    dispatch(event, data, options) {
        return $e4b50d36b79545e2$export$635e15bbd66f01ea(this, event, data, options);
    }
    dispatchEvent(event) {
        const bag = this.getEventHolder().events;
        if (!bag) return true;
        const events = bag[event.type];
        for(const i in events)for(const j in events[i])events[i][j](event);
        return !event.defaultPrevented;
    }
    fire(event, data, options) {
        this.dispatch(event, data, options);
        return this;
    }
    getEventHolder() {
        return this;
    }
    getEventTarget() {
        return this;
    }
    off(event, listener, options) {
        $e4b50d36b79545e2$export$8c8705df4a2dcec9(this, event, listener, options);
        return this;
    }
    on(event, listener, binding, options) {
        $e4b50d36b79545e2$export$af631764ddc44097(this, event, listener, binding, options);
        return this;
    }
    removeEventListener() {}
}
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$648eec84020a2b10, "EventTarget");
function $e4b50d36b79545e2$var$noop() {} // Default animation values
const $e4b50d36b79545e2$var$timeline = {
    duration: 400,
    ease: ">",
    delay: 0
}; // Default attribute values
const $e4b50d36b79545e2$var$attrs = {
    // fill and stroke
    "fill-opacity": 1,
    "stroke-opacity": 1,
    "stroke-width": 0,
    "stroke-linejoin": "miter",
    "stroke-linecap": "butt",
    fill: "#000000",
    stroke: "#000000",
    opacity: 1,
    // position
    x: 0,
    y: 0,
    cx: 0,
    cy: 0,
    // size
    width: 0,
    height: 0,
    // radius
    r: 0,
    rx: 0,
    ry: 0,
    // gradient
    offset: 0,
    "stop-opacity": 1,
    "stop-color": "#000000",
    // text
    "text-anchor": "start"
};
var $e4b50d36b79545e2$export$ebe90cb607ad99e = {
    __proto__: null,
    noop: $e4b50d36b79545e2$var$noop,
    timeline: $e4b50d36b79545e2$var$timeline,
    attrs: $e4b50d36b79545e2$var$attrs
};
class $e4b50d36b79545e2$export$c4be6576ca6fe4aa extends Array {
    constructor(...args){
        super(...args);
        this.init(...args);
    }
    clone() {
        return new this.constructor(this);
    }
    init(arr) {
        // This catches the case, that native map tries to create an array with new Array(1)
        if (typeof arr === "number") return this;
        this.length = 0;
        this.push(...this.parse(arr));
        return this;
    }
    parse(array = []) {
        // If already is an array, no need to parse it
        if (array instanceof Array) return array;
        return array.trim().split($e4b50d36b79545e2$var$delimiter).map(parseFloat);
    }
    toArray() {
        return Array.prototype.concat.apply([], this);
    }
    toSet() {
        return new Set(this);
    }
    toString() {
        return this.join(" ");
    }
    valueOf() {
        const ret = [];
        ret.push(...this);
        return ret;
    }
}
class $e4b50d36b79545e2$export$fffa67e515d04022 {
    // Initialize
    constructor(...args){
        this.init(...args);
    }
    convert(unit) {
        return new $e4b50d36b79545e2$export$fffa67e515d04022(this.value, unit);
    }
    divide(number) {
        number = new $e4b50d36b79545e2$export$fffa67e515d04022(number);
        return new $e4b50d36b79545e2$export$fffa67e515d04022(this / number, this.unit || number.unit);
    }
    init(value, unit) {
        unit = Array.isArray(value) ? value[1] : unit;
        value = Array.isArray(value) ? value[0] : value; // initialize defaults
        this.value = 0;
        this.unit = unit || ""; // parse value
        if (typeof value === "number") // ensure a valid numeric value
        this.value = isNaN(value) ? 0 : !isFinite(value) ? value < 0 ? -340000000000000000000000000000000000000 : 340000000000000000000000000000000000000 : value;
        else if (typeof value === "string") {
            unit = value.match($e4b50d36b79545e2$var$numberAndUnit);
            if (unit) {
                // make value numeric
                this.value = parseFloat(unit[1]); // normalize
                if (unit[5] === "%") this.value /= 100;
                else if (unit[5] === "s") this.value *= 1000;
                 // store unit
                this.unit = unit[5];
            }
        } else if (value instanceof $e4b50d36b79545e2$export$fffa67e515d04022) {
            this.value = value.valueOf();
            this.unit = value.unit;
        }
        return this;
    }
    minus(number) {
        number = new $e4b50d36b79545e2$export$fffa67e515d04022(number);
        return new $e4b50d36b79545e2$export$fffa67e515d04022(this - number, this.unit || number.unit);
    }
    plus(number) {
        number = new $e4b50d36b79545e2$export$fffa67e515d04022(number);
        return new $e4b50d36b79545e2$export$fffa67e515d04022(this + number, this.unit || number.unit);
    }
    times(number) {
        number = new $e4b50d36b79545e2$export$fffa67e515d04022(number);
        return new $e4b50d36b79545e2$export$fffa67e515d04022(this * number, this.unit || number.unit);
    }
    toArray() {
        return [
            this.value,
            this.unit
        ];
    }
    toJSON() {
        return this.toString();
    }
    toString() {
        return (this.unit === "%" ? ~~(this.value * 1e8) / 1e6 : this.unit === "s" ? this.value / 1e3 : this.value) + this.unit;
    }
    valueOf() {
        return this.value;
    }
}
const $e4b50d36b79545e2$var$hooks = [];
function $e4b50d36b79545e2$var$registerAttrHook(fn) {
    $e4b50d36b79545e2$var$hooks.push(fn);
} // Set svg element attribute
function $e4b50d36b79545e2$var$attr(attr, val, ns) {
    // act as full getter
    if (attr == null) {
        // get an object of attributes
        attr = {};
        val = this.node.attributes;
        for (const node of val)attr[node.nodeName] = $e4b50d36b79545e2$var$isNumber.test(node.nodeValue) ? parseFloat(node.nodeValue) : node.nodeValue;
        return attr;
    } else if (attr instanceof Array) // loop through array and get all values
    return attr.reduce((last, curr)=>{
        last[curr] = this.attr(curr);
        return last;
    }, {});
    else if (typeof attr === "object" && attr.constructor === Object) // apply every attribute individually if an object is passed
    for(val in attr)this.attr(val, attr[val]);
    else if (val === null) // remove value
    this.node.removeAttribute(attr);
    else if (val == null) {
        // act as a getter if the first and only argument is not an object
        val = this.node.getAttribute(attr);
        return val == null ? $e4b50d36b79545e2$var$attrs[attr] : $e4b50d36b79545e2$var$isNumber.test(val) ? parseFloat(val) : val;
    } else {
        // Loop through hooks and execute them to convert value
        val = $e4b50d36b79545e2$var$hooks.reduce((_val, hook)=>{
            return hook(attr, _val, this);
        }, val); // ensure correct numeric values (also accepts NaN and Infinity)
        if (typeof val === "number") val = new $e4b50d36b79545e2$export$fffa67e515d04022(val);
        else if ($e4b50d36b79545e2$export$892596cec99bc70e.isColor(val)) // ensure full hex color
        val = new $e4b50d36b79545e2$export$892596cec99bc70e(val);
        else if (val.constructor === Array) // Check for plain arrays and parse array values
        val = new $e4b50d36b79545e2$export$c4be6576ca6fe4aa(val);
         // if the passed attribute is leading...
        if (attr === "leading") // ... call the leading method instead
        {
            if (this.leading) this.leading(val);
        } else // set given attribute on node
        typeof ns === "string" ? this.node.setAttributeNS(ns, attr, val.toString()) : this.node.setAttribute(attr, val.toString());
         // rebuild if required
        if (this.rebuild && (attr === "font-size" || attr === "x")) this.rebuild();
    }
    return this;
}
class $e4b50d36b79545e2$export$1e2eb70c93855705 extends $e4b50d36b79545e2$export$648eec84020a2b10 {
    constructor(node, attrs){
        super();
        this.node = node;
        this.type = node.nodeName;
        if (attrs && node !== attrs) this.attr(attrs);
    }
    add(element, i) {
        element = $e4b50d36b79545e2$export$60fbc25e7b928117(element); // If non-root svg nodes are added we have to remove their namespaces
        if (element.removeNamespace && this.node instanceof $e4b50d36b79545e2$var$globals.window.SVGElement) element.removeNamespace();
        if (i == null) this.node.appendChild(element.node);
        else if (element.node !== this.node.childNodes[i]) this.node.insertBefore(element.node, this.node.childNodes[i]);
        return this;
    }
    addTo(parent, i) {
        return $e4b50d36b79545e2$export$60fbc25e7b928117(parent).put(this, i);
    }
    children() {
        return new $e4b50d36b79545e2$export$54c2e3dc7acea9f5($e4b50d36b79545e2$var$map(this.node.children, function(node) {
            return $e4b50d36b79545e2$export$62c9251e71806cd(node);
        }));
    }
    clear() {
        // remove children
        while(this.node.hasChildNodes())this.node.removeChild(this.node.lastChild);
        return this;
    }
    clone(deep = true, assignNewIds = true) {
        // write dom data to the dom so the clone can pickup the data
        this.writeDataToDom(); // clone element
        let nodeClone = this.node.cloneNode(deep);
        if (assignNewIds) // assign new id
        nodeClone = $e4b50d36b79545e2$export$14fdd2dab64e28f0(nodeClone);
        return new this.constructor(nodeClone);
    }
    each(block, deep) {
        const children = this.children();
        let i, il;
        for(i = 0, il = children.length; i < il; i++){
            block.apply(children[i], [
                i,
                children
            ]);
            if (deep) children[i].each(block, deep);
        }
        return this;
    }
    element(nodeName, attrs) {
        return this.put(new $e4b50d36b79545e2$export$1e2eb70c93855705($e4b50d36b79545e2$export$185802fd694ee1f5(nodeName), attrs));
    }
    first() {
        return $e4b50d36b79545e2$export$62c9251e71806cd(this.node.firstChild);
    }
    get(i) {
        return $e4b50d36b79545e2$export$62c9251e71806cd(this.node.childNodes[i]);
    }
    getEventHolder() {
        return this.node;
    }
    getEventTarget() {
        return this.node;
    }
    has(element) {
        return this.index(element) >= 0;
    }
    html(htmlOrFn, outerHTML) {
        return this.xml(htmlOrFn, outerHTML, $e4b50d36b79545e2$var$html);
    }
    id(id) {
        // generate new id if no id set
        if (typeof id === "undefined" && !this.node.id) this.node.id = $e4b50d36b79545e2$export$ff39fbab45dc7cd0(this.type);
         // don't set directly with this.node.id to make `null` work correctly
        return this.attr("id", id);
    }
    index(element) {
        return [].slice.call(this.node.childNodes).indexOf(element.node);
    }
    last() {
        return $e4b50d36b79545e2$export$62c9251e71806cd(this.node.lastChild);
    }
    matches(selector) {
        const el = this.node;
        const matcher = el.matches || el.matchesSelector || el.msMatchesSelector || el.mozMatchesSelector || el.webkitMatchesSelector || el.oMatchesSelector || null;
        return matcher && matcher.call(el, selector);
    }
    parent(type) {
        let parent = this; // check for parent
        if (!parent.node.parentNode) return null; // get parent element
        parent = $e4b50d36b79545e2$export$62c9251e71806cd(parent.node.parentNode);
        if (!type) return parent; // loop through ancestors if type is given
        do {
            if (typeof type === "string" ? parent.matches(type) : parent instanceof type) return parent;
        }while (parent = $e4b50d36b79545e2$export$62c9251e71806cd(parent.node.parentNode));
        return parent;
    }
    put(element, i) {
        element = $e4b50d36b79545e2$export$60fbc25e7b928117(element);
        this.add(element, i);
        return element;
    }
    putIn(parent, i) {
        return $e4b50d36b79545e2$export$60fbc25e7b928117(parent).add(this, i);
    }
    remove() {
        if (this.parent()) this.parent().removeElement(this);
        return this;
    }
    removeElement(element) {
        this.node.removeChild(element.node);
        return this;
    }
    replace(element) {
        element = $e4b50d36b79545e2$export$60fbc25e7b928117(element);
        if (this.node.parentNode) this.node.parentNode.replaceChild(element.node, this.node);
        return element;
    }
    round(precision = 2, map = null) {
        const factor = 10 ** precision;
        const attrs = this.attr(map);
        for(const i in attrs)if (typeof attrs[i] === "number") attrs[i] = Math.round(attrs[i] * factor) / factor;
        this.attr(attrs);
        return this;
    }
    svg(svgOrFn, outerSVG) {
        return this.xml(svgOrFn, outerSVG, $e4b50d36b79545e2$var$svg);
    }
    toString() {
        return this.id();
    }
    words(text) {
        // This is faster than removing all children and adding a new one
        this.node.textContent = text;
        return this;
    }
    wrap(node) {
        const parent = this.parent();
        if (!parent) return this.addTo(node);
        const position = parent.index(this);
        return parent.put(node, position).put(this);
    }
    writeDataToDom() {
        // dump variables recursively
        this.each(function() {
            this.writeDataToDom();
        });
        return this;
    }
    xml(xmlOrFn, outerXML, ns) {
        if (typeof xmlOrFn === "boolean") {
            ns = outerXML;
            outerXML = xmlOrFn;
            xmlOrFn = null;
        } // act as getter if no svg string is given
        if (xmlOrFn == null || typeof xmlOrFn === "function") {
            // The default for exports is, that the outerNode is included
            outerXML = outerXML == null ? true : outerXML; // write svgjs data to the dom
            this.writeDataToDom();
            let current = this; // An export modifier was passed
            if (xmlOrFn != null) {
                current = $e4b50d36b79545e2$export$62c9251e71806cd(current.node.cloneNode(true)); // If the user wants outerHTML we need to process this node, too
                if (outerXML) {
                    const result = xmlOrFn(current);
                    current = result || current; // The user does not want this node? Well, then he gets nothing
                    if (result === false) return "";
                } // Deep loop through all children and apply modifier
                current.each(function() {
                    const result = xmlOrFn(this);
                    const _this = result || this; // If modifier returns false, discard node
                    if (result === false) this.remove(); // If modifier returns new node, use it
                    else if (result && this !== _this) this.replace(_this);
                }, true);
            } // Return outer or inner content
            return outerXML ? current.node.outerHTML : current.node.innerHTML;
        } // Act as setter if we got a string
        // The default for import is, that the current node is not replaced
        outerXML = outerXML == null ? false : outerXML; // Create temporary holder
        const well = $e4b50d36b79545e2$export$185802fd694ee1f5("wrapper", ns);
        const fragment = $e4b50d36b79545e2$var$globals.document.createDocumentFragment(); // Dump raw svg
        well.innerHTML = xmlOrFn; // Transplant nodes into the fragment
        for(let len = well.children.length; len--;)fragment.appendChild(well.firstElementChild);
        const parent = this.parent(); // Add the whole fragment at once
        return outerXML ? this.replace(fragment) && parent : this.add(fragment);
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$1e2eb70c93855705, {
    attr: $e4b50d36b79545e2$var$attr,
    find: $e4b50d36b79545e2$var$find,
    findOne: $e4b50d36b79545e2$var$findOne
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$1e2eb70c93855705, "Dom");
class $e4b50d36b79545e2$export$db77ccec0bb4ccac extends $e4b50d36b79545e2$export$1e2eb70c93855705 {
    constructor(node, attrs){
        super(node, attrs); // initialize data object
        this.dom = {}; // create circular reference
        this.node.instance = this;
        if (node.hasAttribute("svgjs:data")) // pull svgjs data from the dom (getAttributeNS doesn't work in html5)
        this.setData(JSON.parse(node.getAttribute("svgjs:data")) || {});
    }
    center(x, y) {
        return this.cx(x).cy(y);
    }
    cx(x) {
        return x == null ? this.x() + this.width() / 2 : this.x(x - this.width() / 2);
    }
    cy(y) {
        return y == null ? this.y() + this.height() / 2 : this.y(y - this.height() / 2);
    }
    defs() {
        const root = this.root();
        return root && root.defs();
    }
    dmove(x, y) {
        return this.dx(x).dy(y);
    }
    dx(x = 0) {
        return this.x(new $e4b50d36b79545e2$export$fffa67e515d04022(x).plus(this.x()));
    }
    dy(y = 0) {
        return this.y(new $e4b50d36b79545e2$export$fffa67e515d04022(y).plus(this.y()));
    }
    getEventHolder() {
        return this;
    }
    height(height) {
        return this.attr("height", height);
    }
    move(x, y) {
        return this.x(x).y(y);
    }
    parents(until = this.root()) {
        const isSelector = typeof until === "string";
        if (!isSelector) until = $e4b50d36b79545e2$export$60fbc25e7b928117(until);
        const parents = new $e4b50d36b79545e2$export$54c2e3dc7acea9f5();
        let parent = this;
        while((parent = parent.parent()) && parent.node !== $e4b50d36b79545e2$var$globals.document && parent.nodeName !== "#document-fragment"){
            parents.push(parent);
            if (!isSelector && parent.node === until.node) break;
            if (isSelector && parent.matches(until)) break;
            if (parent.node === this.root().node) // We worked our way to the root and didn't match `until`
            return null;
        }
        return parents;
    }
    reference(attr) {
        attr = this.attr(attr);
        if (!attr) return null;
        const m = (attr + "").match($e4b50d36b79545e2$var$reference);
        return m ? $e4b50d36b79545e2$export$60fbc25e7b928117(m[1]) : null;
    }
    root() {
        const p = this.parent($e4b50d36b79545e2$export$d39d7c22acbe0a14($e4b50d36b79545e2$export$e8e78c978b129247));
        return p && p.root();
    }
    setData(o) {
        this.dom = o;
        return this;
    }
    size(width, height) {
        const p = $e4b50d36b79545e2$var$proportionalSize(this, width, height);
        return this.width(new $e4b50d36b79545e2$export$fffa67e515d04022(p.width)).height(new $e4b50d36b79545e2$export$fffa67e515d04022(p.height));
    }
    width(width) {
        return this.attr("width", width);
    }
    writeDataToDom() {
        // remove previously set data
        this.node.removeAttribute("svgjs:data");
        if (Object.keys(this.dom).length) this.node.setAttribute("svgjs:data", JSON.stringify(this.dom)); // see #428
        return super.writeDataToDom();
    }
    x(x) {
        return this.attr("x", x);
    }
    y(y) {
        return this.attr("y", y);
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$db77ccec0bb4ccac, {
    bbox: $e4b50d36b79545e2$var$bbox,
    rbox: $e4b50d36b79545e2$var$rbox,
    inside: $e4b50d36b79545e2$var$inside,
    point: $e4b50d36b79545e2$var$point,
    ctm: $e4b50d36b79545e2$var$ctm,
    screenCTM: $e4b50d36b79545e2$var$screenCTM
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$db77ccec0bb4ccac, "Element");
const $e4b50d36b79545e2$var$sugar = {
    stroke: [
        "color",
        "width",
        "opacity",
        "linecap",
        "linejoin",
        "miterlimit",
        "dasharray",
        "dashoffset"
    ],
    fill: [
        "color",
        "opacity",
        "rule"
    ],
    prefix: function(t, a) {
        return a === "color" ? t : t + "-" + a;
    }
} // Add sugar for fill and stroke
;
[
    "fill",
    "stroke"
].forEach(function(m) {
    const extension = {};
    let i;
    extension[m] = function(o) {
        if (typeof o === "undefined") return this.attr(m);
        if (typeof o === "string" || o instanceof $e4b50d36b79545e2$export$892596cec99bc70e || $e4b50d36b79545e2$export$892596cec99bc70e.isRgb(o) || o instanceof $e4b50d36b79545e2$export$db77ccec0bb4ccac) this.attr(m, o);
        else {
            // set all attributes from sugar.fill and sugar.stroke list
            for(i = $e4b50d36b79545e2$var$sugar[m].length - 1; i >= 0; i--)if (o[$e4b50d36b79545e2$var$sugar[m][i]] != null) this.attr($e4b50d36b79545e2$var$sugar.prefix(m, $e4b50d36b79545e2$var$sugar[m][i]), o[$e4b50d36b79545e2$var$sugar[m][i]]);
        }
        return this;
    };
    $e4b50d36b79545e2$var$registerMethods([
        "Element",
        "Runner"
    ], extension);
});
$e4b50d36b79545e2$var$registerMethods([
    "Element",
    "Runner"
], {
    // Let the user set the matrix directly
    matrix: function(mat, b, c, d, e, f) {
        // Act as a getter
        if (mat == null) return new $e4b50d36b79545e2$export$5b12bf1653c0dd85(this);
         // Act as a setter, the user can pass a matrix or a set of numbers
        return this.attr("transform", new $e4b50d36b79545e2$export$5b12bf1653c0dd85(mat, b, c, d, e, f));
    },
    // Map rotation to transform
    rotate: function(angle, cx, cy) {
        return this.transform({
            rotate: angle,
            ox: cx,
            oy: cy
        }, true);
    },
    // Map skew to transform
    skew: function(x, y, cx, cy) {
        return arguments.length === 1 || arguments.length === 3 ? this.transform({
            skew: x,
            ox: y,
            oy: cx
        }, true) : this.transform({
            skew: [
                x,
                y
            ],
            ox: cx,
            oy: cy
        }, true);
    },
    shear: function(lam, cx, cy) {
        return this.transform({
            shear: lam,
            ox: cx,
            oy: cy
        }, true);
    },
    // Map scale to transform
    scale: function(x, y, cx, cy) {
        return arguments.length === 1 || arguments.length === 3 ? this.transform({
            scale: x,
            ox: y,
            oy: cx
        }, true) : this.transform({
            scale: [
                x,
                y
            ],
            ox: cx,
            oy: cy
        }, true);
    },
    // Map translate to transform
    translate: function(x, y) {
        return this.transform({
            translate: [
                x,
                y
            ]
        }, true);
    },
    // Map relative translations to transform
    relative: function(x, y) {
        return this.transform({
            relative: [
                x,
                y
            ]
        }, true);
    },
    // Map flip to transform
    flip: function(direction = "both", origin = "center") {
        if ("xybothtrue".indexOf(direction) === -1) {
            origin = direction;
            direction = "both";
        }
        return this.transform({
            flip: direction,
            origin: origin
        }, true);
    },
    // Opacity
    opacity: function(value) {
        return this.attr("opacity", value);
    }
});
$e4b50d36b79545e2$var$registerMethods("radius", {
    // Add x and y radius
    radius: function(x, y = x) {
        const type = (this._element || this).type;
        return type === "radialGradient" ? this.attr("r", new $e4b50d36b79545e2$export$fffa67e515d04022(x)) : this.rx(x).ry(y);
    }
});
$e4b50d36b79545e2$var$registerMethods("Path", {
    // Get path length
    length: function() {
        return this.node.getTotalLength();
    },
    // Get point at length
    pointAt: function(length) {
        return new $e4b50d36b79545e2$export$baf26146a414f24a(this.node.getPointAtLength(length));
    }
});
$e4b50d36b79545e2$var$registerMethods([
    "Element",
    "Runner"
], {
    // Set font
    font: function(a, v) {
        if (typeof a === "object") {
            for(v in a)this.font(v, a[v]);
            return this;
        }
        return a === "leading" ? this.leading(v) : a === "anchor" ? this.attr("text-anchor", v) : a === "size" || a === "family" || a === "weight" || a === "stretch" || a === "variant" || a === "style" ? this.attr("font-" + a, v) : this.attr(a, v);
    }
}); // Add events to elements
const $e4b50d36b79545e2$var$methods = [
    "click",
    "dblclick",
    "mousedown",
    "mouseup",
    "mouseover",
    "mouseout",
    "mousemove",
    "mouseenter",
    "mouseleave",
    "touchstart",
    "touchmove",
    "touchleave",
    "touchend",
    "touchcancel"
].reduce(function(last, event) {
    // add event to Element
    const fn = function(f) {
        if (f === null) this.off(event);
        else this.on(event, f);
        return this;
    };
    last[event] = fn;
    return last;
}, {});
$e4b50d36b79545e2$var$registerMethods("Element", $e4b50d36b79545e2$var$methods);
function $e4b50d36b79545e2$var$untransform() {
    return this.attr("transform", null);
} // merge the whole transformation chain into one matrix and returns it
function $e4b50d36b79545e2$var$matrixify() {
    const matrix = (this.attr("transform") || "" // split transformations
    ).split($e4b50d36b79545e2$var$transforms).slice(0, -1).map(function(str) {
        // generate key => value pairs
        const kv = str.trim().split("(");
        return [
            kv[0],
            kv[1].split($e4b50d36b79545e2$var$delimiter).map(function(str) {
                return parseFloat(str);
            })
        ];
    }).reverse() // merge every transformation into one matrix
    .reduce(function(matrix, transform) {
        if (transform[0] === "matrix") return matrix.lmultiply($e4b50d36b79545e2$export$5b12bf1653c0dd85.fromArray(transform[1]));
        return matrix[transform[0]].apply(matrix, transform[1]);
    }, new $e4b50d36b79545e2$export$5b12bf1653c0dd85());
    return matrix;
} // add an element to another parent without changing the visual representation on the screen
function $e4b50d36b79545e2$var$toParent(parent, i) {
    if (this === parent) return this;
    const ctm = this.screenCTM();
    const pCtm = parent.screenCTM().inverse();
    this.addTo(parent, i).untransform().transform(pCtm.multiply(ctm));
    return this;
} // same as above with parent equals root-svg
function $e4b50d36b79545e2$var$toRoot(i) {
    return this.toParent(this.root(), i);
} // Add transformations
function $e4b50d36b79545e2$var$transform(o, relative) {
    // Act as a getter if no object was passed
    if (o == null || typeof o === "string") {
        const decomposed = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(this).decompose();
        return o == null ? decomposed : decomposed[o];
    }
    if (!$e4b50d36b79545e2$export$5b12bf1653c0dd85.isMatrixLike(o)) // Set the origin according to the defined transform
    o = {
        ...o,
        origin: $e4b50d36b79545e2$var$getOrigin(o, this)
    };
     // The user can pass a boolean, an Element or an Matrix or nothing
    const cleanRelative = relative === true ? this : relative || false;
    const result = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(cleanRelative).transform(o);
    return this.attr("transform", result);
}
$e4b50d36b79545e2$var$registerMethods("Element", {
    untransform: $e4b50d36b79545e2$var$untransform,
    matrixify: $e4b50d36b79545e2$var$matrixify,
    toParent: $e4b50d36b79545e2$var$toParent,
    toRoot: $e4b50d36b79545e2$var$toRoot,
    transform: $e4b50d36b79545e2$var$transform
});
class $e4b50d36b79545e2$export$42a852a2b6b56249 extends $e4b50d36b79545e2$export$db77ccec0bb4ccac {
    flatten(parent = this, index) {
        this.each(function() {
            if (this instanceof $e4b50d36b79545e2$export$42a852a2b6b56249) return this.flatten().ungroup();
        });
        return this;
    }
    ungroup(parent = this.parent(), index = parent.index(this)) {
        // when parent != this, we want append all elements to the end
        index = index === -1 ? parent.children().length : index;
        this.each(function(i, children) {
            // reverse each
            return children[children.length - i - 1].toParent(parent, index);
        });
        return this.remove();
    }
}
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$42a852a2b6b56249, "Container");
class $e4b50d36b79545e2$export$b2bdceae9588b42d extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("defs", node), attrs);
    }
    flatten() {
        return this;
    }
    ungroup() {
        return this;
    }
}
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$b2bdceae9588b42d, "Defs");
class $e4b50d36b79545e2$export$6428a7f2611ef1fa extends $e4b50d36b79545e2$export$db77ccec0bb4ccac {
}
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$6428a7f2611ef1fa, "Shape");
function $e4b50d36b79545e2$var$rx(rx) {
    return this.attr("rx", rx);
} // Radius y value
function $e4b50d36b79545e2$var$ry(ry) {
    return this.attr("ry", ry);
} // Move over x-axis
function $e4b50d36b79545e2$var$x$3(x) {
    return x == null ? this.cx() - this.rx() : this.cx(x + this.rx());
} // Move over y-axis
function $e4b50d36b79545e2$var$y$3(y) {
    return y == null ? this.cy() - this.ry() : this.cy(y + this.ry());
} // Move by center over x-axis
function $e4b50d36b79545e2$var$cx$1(x) {
    return this.attr("cx", x);
} // Move by center over y-axis
function $e4b50d36b79545e2$var$cy$1(y) {
    return this.attr("cy", y);
} // Set width of element
function $e4b50d36b79545e2$var$width$2(width) {
    return width == null ? this.rx() * 2 : this.rx(new $e4b50d36b79545e2$export$fffa67e515d04022(width).divide(2));
} // Set height of element
function $e4b50d36b79545e2$var$height$2(height) {
    return height == null ? this.ry() * 2 : this.ry(new $e4b50d36b79545e2$export$fffa67e515d04022(height).divide(2));
}
var $e4b50d36b79545e2$var$circled = {
    __proto__: null,
    rx: $e4b50d36b79545e2$var$rx,
    ry: $e4b50d36b79545e2$var$ry,
    x: $e4b50d36b79545e2$var$x$3,
    y: $e4b50d36b79545e2$var$y$3,
    cx: $e4b50d36b79545e2$var$cx$1,
    cy: $e4b50d36b79545e2$var$cy$1,
    width: $e4b50d36b79545e2$var$width$2,
    height: $e4b50d36b79545e2$var$height$2
};
class $e4b50d36b79545e2$export$80b0269ab108fa11 extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("ellipse", node), attrs);
    }
    size(width, height) {
        const p = $e4b50d36b79545e2$var$proportionalSize(this, width, height);
        return this.rx(new $e4b50d36b79545e2$export$fffa67e515d04022(p.width).divide(2)).ry(new $e4b50d36b79545e2$export$fffa67e515d04022(p.height).divide(2));
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$80b0269ab108fa11, $e4b50d36b79545e2$var$circled);
$e4b50d36b79545e2$var$registerMethods("Container", {
    // Create an ellipse
    ellipse: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(width = 0, height = width) {
        return this.put(new $e4b50d36b79545e2$export$80b0269ab108fa11()).size(width, height).move(0, 0);
    })
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$80b0269ab108fa11, "Ellipse");
class $e4b50d36b79545e2$export$ffb0004e005737fa extends $e4b50d36b79545e2$export$1e2eb70c93855705 {
    constructor(node = $e4b50d36b79545e2$var$globals.document.createDocumentFragment()){
        super(node);
    }
    xml(xmlOrFn, outerXML, ns) {
        if (typeof xmlOrFn === "boolean") {
            ns = outerXML;
            outerXML = xmlOrFn;
            xmlOrFn = null;
        } // because this is a fragment we have to put all elements into a wrapper first
        // before we can get the innerXML from it
        if (xmlOrFn == null || typeof xmlOrFn === "function") {
            const wrapper = new $e4b50d36b79545e2$export$1e2eb70c93855705($e4b50d36b79545e2$export$185802fd694ee1f5("wrapper", ns));
            wrapper.add(this.node.cloneNode(true));
            return wrapper.xml(false, ns);
        } // Act as setter if we got a string
        return super.xml(xmlOrFn, false, ns);
    }
}
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$ffb0004e005737fa, "Fragment");
function $e4b50d36b79545e2$var$from(x, y) {
    return (this._element || this).type === "radialGradient" ? this.attr({
        fx: new $e4b50d36b79545e2$export$fffa67e515d04022(x),
        fy: new $e4b50d36b79545e2$export$fffa67e515d04022(y)
    }) : this.attr({
        x1: new $e4b50d36b79545e2$export$fffa67e515d04022(x),
        y1: new $e4b50d36b79545e2$export$fffa67e515d04022(y)
    });
}
function $e4b50d36b79545e2$var$to(x, y) {
    return (this._element || this).type === "radialGradient" ? this.attr({
        cx: new $e4b50d36b79545e2$export$fffa67e515d04022(x),
        cy: new $e4b50d36b79545e2$export$fffa67e515d04022(y)
    }) : this.attr({
        x2: new $e4b50d36b79545e2$export$fffa67e515d04022(x),
        y2: new $e4b50d36b79545e2$export$fffa67e515d04022(y)
    });
}
var $e4b50d36b79545e2$var$gradiented = {
    __proto__: null,
    from: $e4b50d36b79545e2$var$from,
    to: $e4b50d36b79545e2$var$to
};
class $e4b50d36b79545e2$export$3d3dd8f63ff0f876 extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    constructor(type, attrs){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7(type + "Gradient", typeof type === "string" ? null : type), attrs);
    }
    attr(a, b, c) {
        if (a === "transform") a = "gradientTransform";
        return super.attr(a, b, c);
    }
    bbox() {
        return new $e4b50d36b79545e2$export$e71c4d32a2263218();
    }
    targets() {
        return $e4b50d36b79545e2$export$71aa6c912b956294("svg [fill*=" + this.id() + "]");
    }
    toString() {
        return this.url();
    }
    update(block) {
        // remove all stops
        this.clear(); // invoke passed block
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    url() {
        return "url(#" + this.id() + ")";
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$3d3dd8f63ff0f876, $e4b50d36b79545e2$var$gradiented);
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create gradient element in defs
        gradient (...args) {
            return this.defs().gradient(...args);
        }
    },
    // define gradient
    Defs: {
        gradient: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(type, block) {
            return this.put(new $e4b50d36b79545e2$export$3d3dd8f63ff0f876(type)).update(block);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$3d3dd8f63ff0f876, "Gradient");
class $e4b50d36b79545e2$export$47606a6ae3eaed8e extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("pattern", node), attrs);
    }
    attr(a, b, c) {
        if (a === "transform") a = "patternTransform";
        return super.attr(a, b, c);
    }
    bbox() {
        return new $e4b50d36b79545e2$export$e71c4d32a2263218();
    }
    targets() {
        return $e4b50d36b79545e2$export$71aa6c912b956294("svg [fill*=" + this.id() + "]");
    }
    toString() {
        return this.url();
    }
    update(block) {
        // remove content
        this.clear(); // invoke passed block
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    url() {
        return "url(#" + this.id() + ")";
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create pattern element in defs
        pattern (...args) {
            return this.defs().pattern(...args);
        }
    },
    Defs: {
        pattern: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(width, height, block) {
            return this.put(new $e4b50d36b79545e2$export$47606a6ae3eaed8e()).update(block).attr({
                x: 0,
                y: 0,
                width: width,
                height: height,
                patternUnits: "userSpaceOnUse"
            });
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$47606a6ae3eaed8e, "Pattern");
class $e4b50d36b79545e2$export$3e431a229df88919 extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("image", node), attrs);
    }
    load(url, callback) {
        if (!url) return this;
        const img = new $e4b50d36b79545e2$var$globals.window.Image();
        $e4b50d36b79545e2$export$af631764ddc44097(img, "load", function(e) {
            const p = this.parent($e4b50d36b79545e2$export$47606a6ae3eaed8e); // ensure image size
            if (this.width() === 0 && this.height() === 0) this.size(img.width, img.height);
            if (p instanceof $e4b50d36b79545e2$export$47606a6ae3eaed8e) // ensure pattern size if not set
            {
                if (p.width() === 0 && p.height() === 0) p.size(this.width(), this.height());
            }
            if (typeof callback === "function") callback.call(this, e);
        }, this);
        $e4b50d36b79545e2$export$af631764ddc44097(img, "load error", function() {
            // dont forget to unbind memory leaking events
            $e4b50d36b79545e2$export$8c8705df4a2dcec9(img);
        });
        return this.attr("href", img.src = url, $e4b50d36b79545e2$var$xlink);
    }
}
$e4b50d36b79545e2$var$registerAttrHook(function(attr, val, _this) {
    // convert image fill and stroke to patterns
    if (attr === "fill" || attr === "stroke") {
        if ($e4b50d36b79545e2$var$isImage.test(val)) val = _this.root().defs().image(val);
    }
    if (val instanceof $e4b50d36b79545e2$export$3e431a229df88919) val = _this.root().defs().pattern(0, 0, (pattern)=>{
        pattern.add(val);
    });
    return val;
});
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // create image element, load image and set its size
        image: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(source, callback) {
            return this.put(new $e4b50d36b79545e2$export$3e431a229df88919()).size(0, 0).load(source, callback);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$3e431a229df88919, "Image");
class $e4b50d36b79545e2$export$e834181a854d3988 extends $e4b50d36b79545e2$export$c4be6576ca6fe4aa {
    // Get bounding box of points
    bbox() {
        let maxX = -Infinity;
        let maxY = -Infinity;
        let minX = Infinity;
        let minY = Infinity;
        this.forEach(function(el) {
            maxX = Math.max(el[0], maxX);
            maxY = Math.max(el[1], maxY);
            minX = Math.min(el[0], minX);
            minY = Math.min(el[1], minY);
        });
        return new $e4b50d36b79545e2$export$e71c4d32a2263218(minX, minY, maxX - minX, maxY - minY);
    }
    move(x, y) {
        const box = this.bbox(); // get relative offset
        x -= box.x;
        y -= box.y; // move every point
        if (!isNaN(x) && !isNaN(y)) for(let i = this.length - 1; i >= 0; i--)this[i] = [
            this[i][0] + x,
            this[i][1] + y
        ];
        return this;
    }
    parse(array = [
        0,
        0
    ]) {
        const points = []; // if it is an array, we flatten it and therefore clone it to 1 depths
        if (array instanceof Array) array = Array.prototype.concat.apply([], array);
        else // Else, it is considered as a string
        // parse points
        array = array.trim().split($e4b50d36b79545e2$var$delimiter).map(parseFloat);
         // validate points - https://svgwg.org/svg2-draft/shapes.html#DataTypePoints
        // Odd number of coordinates is an error. In such cases, drop the last odd coordinate.
        if (array.length % 2 !== 0) array.pop(); // wrap points in two-tuples
        for(let i = 0, len = array.length; i < len; i = i + 2)points.push([
            array[i],
            array[i + 1]
        ]);
        return points;
    }
    size(width, height) {
        let i;
        const box = this.bbox(); // recalculate position of all points according to new size
        for(i = this.length - 1; i >= 0; i--){
            if (box.width) this[i][0] = (this[i][0] - box.x) * width / box.width + box.x;
            if (box.height) this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
        }
        return this;
    }
    toLine() {
        return {
            x1: this[0][0],
            y1: this[0][1],
            x2: this[1][0],
            y2: this[1][1]
        };
    }
    toString() {
        const array = []; // convert to a poly point string
        for(let i = 0, il = this.length; i < il; i++)array.push(this[i].join(","));
        return array.join(" ");
    }
    transform(m) {
        return this.clone().transformO(m);
    }
    transformO(m) {
        if (!$e4b50d36b79545e2$export$5b12bf1653c0dd85.isMatrixLike(m)) m = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(m);
        for(let i = this.length; i--;){
            // Perform the matrix multiplication
            const [x, y] = this[i];
            this[i][0] = m.a * x + m.c * y + m.e;
            this[i][1] = m.b * x + m.d * y + m.f;
        }
        return this;
    }
}
const $e4b50d36b79545e2$var$MorphArray = $e4b50d36b79545e2$export$e834181a854d3988; // Move by left top corner over x-axis
function $e4b50d36b79545e2$var$x$2(x) {
    return x == null ? this.bbox().x : this.move(x, this.bbox().y);
} // Move by left top corner over y-axis
function $e4b50d36b79545e2$var$y$2(y) {
    return y == null ? this.bbox().y : this.move(this.bbox().x, y);
} // Set width of element
function $e4b50d36b79545e2$var$width$1(width) {
    const b = this.bbox();
    return width == null ? b.width : this.size(width, b.height);
} // Set height of element
function $e4b50d36b79545e2$var$height$1(height) {
    const b = this.bbox();
    return height == null ? b.height : this.size(b.width, height);
}
var $e4b50d36b79545e2$var$pointed = {
    __proto__: null,
    MorphArray: $e4b50d36b79545e2$var$MorphArray,
    x: $e4b50d36b79545e2$var$x$2,
    y: $e4b50d36b79545e2$var$y$2,
    width: $e4b50d36b79545e2$var$width$1,
    height: $e4b50d36b79545e2$var$height$1
};
class $e4b50d36b79545e2$export$17d680238e50603e extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("line", node), attrs);
    }
    array() {
        return new $e4b50d36b79545e2$export$e834181a854d3988([
            [
                this.attr("x1"),
                this.attr("y1")
            ],
            [
                this.attr("x2"),
                this.attr("y2")
            ]
        ]);
    }
    move(x, y) {
        return this.attr(this.array().move(x, y).toLine());
    }
    plot(x1, y1, x2, y2) {
        if (x1 == null) return this.array();
        else if (typeof y1 !== "undefined") x1 = {
            x1: x1,
            y1: y1,
            x2: x2,
            y2: y2
        };
        else x1 = new $e4b50d36b79545e2$export$e834181a854d3988(x1).toLine();
        return this.attr(x1);
    }
    size(width, height) {
        const p = $e4b50d36b79545e2$var$proportionalSize(this, width, height);
        return this.attr(this.array().size(p.width, p.height).toLine());
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$17d680238e50603e, $e4b50d36b79545e2$var$pointed);
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a line element
        line: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(...args) {
            // make sure plot is called as a setter
            // x1 is not necessarily a number, it can also be an array, a string and a PointArray
            return $e4b50d36b79545e2$export$17d680238e50603e.prototype.plot.apply(this.put(new $e4b50d36b79545e2$export$17d680238e50603e()), args[0] != null ? args : [
                0,
                0,
                0,
                0
            ]);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$17d680238e50603e, "Line");
class $e4b50d36b79545e2$export$e98856a975cab58e extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("marker", node), attrs);
    }
    height(height) {
        return this.attr("markerHeight", height);
    }
    orient(orient) {
        return this.attr("orient", orient);
    }
    ref(x, y) {
        return this.attr("refX", x).attr("refY", y);
    }
    toString() {
        return "url(#" + this.id() + ")";
    }
    update(block) {
        // remove all content
        this.clear(); // invoke passed block
        if (typeof block === "function") block.call(this, this);
        return this;
    }
    width(width) {
        return this.attr("markerWidth", width);
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        marker (...args) {
            // Create marker element in defs
            return this.defs().marker(...args);
        }
    },
    Defs: {
        // Create marker
        marker: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(width, height, block) {
            // Set default viewbox to match the width and height, set ref to cx and cy and set orient to auto
            return this.put(new $e4b50d36b79545e2$export$e98856a975cab58e()).size(width, height).ref(width / 2, height / 2).viewbox(0, 0, width, height).attr("orient", "auto").update(block);
        })
    },
    marker: {
        // Create and attach markers
        marker (marker, width, height, block) {
            let attr = [
                "marker"
            ]; // Build attribute name
            if (marker !== "all") attr.push(marker);
            attr = attr.join("-"); // Set marker attribute
            marker = arguments[1] instanceof $e4b50d36b79545e2$export$e98856a975cab58e ? arguments[1] : this.defs().marker(width, height, block);
            return this.attr(attr, marker);
        }
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$e98856a975cab58e, "Marker");
/***
Base Class
==========
The base stepper class that will be
***/ function $e4b50d36b79545e2$var$makeSetterGetter(k, f) {
    return function(v) {
        if (v == null) return this[k];
        this[k] = v;
        if (f) f.call(this);
        return this;
    };
}
const $e4b50d36b79545e2$export$24c5ac7c37452e7d = {
    "-": function(pos) {
        return pos;
    },
    "<>": function(pos) {
        return -Math.cos(pos * Math.PI) / 2 + 0.5;
    },
    ">": function(pos) {
        return Math.sin(pos * Math.PI / 2);
    },
    "<": function(pos) {
        return -Math.cos(pos * Math.PI / 2) + 1;
    },
    bezier: function(x1, y1, x2, y2) {
        // see https://www.w3.org/TR/css-easing-1/#cubic-bezier-algo
        return function(t) {
            if (t < 0) {
                if (x1 > 0) return y1 / x1 * t;
                else if (x2 > 0) return y2 / x2 * t;
                else return 0;
            } else if (t > 1) {
                if (x2 < 1) return (1 - y2) / (1 - x2) * t + (y2 - x2) / (1 - x2);
                else if (x1 < 1) return (1 - y1) / (1 - x1) * t + (y1 - x1) / (1 - x1);
                else return 1;
            } else return 3 * t * (1 - t) ** 2 * y1 + 3 * t ** 2 * (1 - t) * y2 + t ** 3;
        };
    },
    // see https://www.w3.org/TR/css-easing-1/#step-timing-function-algo
    steps: function(steps, stepPosition = "end") {
        // deal with "jump-" prefix
        stepPosition = stepPosition.split("-").reverse()[0];
        let jumps = steps;
        if (stepPosition === "none") --jumps;
        else if (stepPosition === "both") ++jumps;
         // The beforeFlag is essentially useless
        return (t, beforeFlag = false)=>{
            // Step is called currentStep in referenced url
            let step = Math.floor(t * steps);
            const jumping = t * step % 1 === 0;
            if (stepPosition === "start" || stepPosition === "both") ++step;
            if (beforeFlag && jumping) --step;
            if (t >= 0 && step < 0) step = 0;
            if (t <= 1 && step > jumps) step = jumps;
            return step / jumps;
        };
    }
};
class $e4b50d36b79545e2$var$Stepper {
    done() {
        return false;
    }
}
/***
Easing Functions
================
***/ class $e4b50d36b79545e2$export$e60daad661aebae6 extends $e4b50d36b79545e2$var$Stepper {
    constructor(fn = $e4b50d36b79545e2$var$timeline.ease){
        super();
        this.ease = $e4b50d36b79545e2$export$24c5ac7c37452e7d[fn] || fn;
    }
    step(from, to, pos) {
        if (typeof from !== "number") return pos < 1 ? from : to;
        return from + (to - from) * this.ease(pos);
    }
}
/***
Controller Types
================
***/ class $e4b50d36b79545e2$export$bd0bf19f25da8474 extends $e4b50d36b79545e2$var$Stepper {
    constructor(fn){
        super();
        this.stepper = fn;
    }
    done(c) {
        return c.done;
    }
    step(current, target, dt, c) {
        return this.stepper(current, target, dt, c);
    }
}
function $e4b50d36b79545e2$var$recalculate() {
    // Apply the default parameters
    const duration = (this._duration || 500) / 1000;
    const overshoot = this._overshoot || 0; // Calculate the PID natural response
    const eps = 1e-10;
    const pi = Math.PI;
    const os = Math.log(overshoot / 100 + eps);
    const zeta = -os / Math.sqrt(pi * pi + os * os);
    const wn = 3.9 / (zeta * duration); // Calculate the Spring values
    this.d = 2 * zeta * wn;
    this.k = wn * wn;
}
class $e4b50d36b79545e2$export$a500e5b516cedfc extends $e4b50d36b79545e2$export$bd0bf19f25da8474 {
    constructor(duration = 500, overshoot = 0){
        super();
        this.duration(duration).overshoot(overshoot);
    }
    step(current, target, dt, c) {
        if (typeof current === "string") return current;
        c.done = dt === Infinity;
        if (dt === Infinity) return target;
        if (dt === 0) return current;
        if (dt > 100) dt = 16;
        dt /= 1000; // Get the previous velocity
        const velocity = c.velocity || 0; // Apply the control to get the new position and store it
        const acceleration = -this.d * velocity - this.k * (current - target);
        const newPosition = current + velocity * dt + acceleration * dt * dt / 2; // Store the velocity
        c.velocity = velocity + acceleration * dt; // Figure out if we have converged, and if so, pass the value
        c.done = Math.abs(target - newPosition) + Math.abs(velocity) < 0.002;
        return c.done ? target : newPosition;
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$a500e5b516cedfc, {
    duration: $e4b50d36b79545e2$var$makeSetterGetter("_duration", $e4b50d36b79545e2$var$recalculate),
    overshoot: $e4b50d36b79545e2$var$makeSetterGetter("_overshoot", $e4b50d36b79545e2$var$recalculate)
});
class $e4b50d36b79545e2$export$9eeba9ddf20e6890 extends $e4b50d36b79545e2$export$bd0bf19f25da8474 {
    constructor(p = 0.1, i = 0.01, d = 0, windup = 1000){
        super();
        this.p(p).i(i).d(d).windup(windup);
    }
    step(current, target, dt, c) {
        if (typeof current === "string") return current;
        c.done = dt === Infinity;
        if (dt === Infinity) return target;
        if (dt === 0) return current;
        const p = target - current;
        let i = (c.integral || 0) + p * dt;
        const d = (p - (c.error || 0)) / dt;
        const windup = this._windup; // antiwindup
        if (windup !== false) i = Math.max(-windup, Math.min(i, windup));
        c.error = p;
        c.integral = i;
        c.done = Math.abs(p) < 0.001;
        return c.done ? target : current + (this.P * p + this.I * i + this.D * d);
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$9eeba9ddf20e6890, {
    windup: $e4b50d36b79545e2$var$makeSetterGetter("_windup"),
    p: $e4b50d36b79545e2$var$makeSetterGetter("P"),
    i: $e4b50d36b79545e2$var$makeSetterGetter("I"),
    d: $e4b50d36b79545e2$var$makeSetterGetter("D")
});
const $e4b50d36b79545e2$var$segmentParameters = {
    M: 2,
    L: 2,
    H: 1,
    V: 1,
    C: 6,
    S: 4,
    Q: 4,
    T: 2,
    A: 7,
    Z: 0
};
const $e4b50d36b79545e2$var$pathHandlers = {
    M: function(c, p, p0) {
        p.x = p0.x = c[0];
        p.y = p0.y = c[1];
        return [
            "M",
            p.x,
            p.y
        ];
    },
    L: function(c, p) {
        p.x = c[0];
        p.y = c[1];
        return [
            "L",
            c[0],
            c[1]
        ];
    },
    H: function(c, p) {
        p.x = c[0];
        return [
            "H",
            c[0]
        ];
    },
    V: function(c, p) {
        p.y = c[0];
        return [
            "V",
            c[0]
        ];
    },
    C: function(c, p) {
        p.x = c[4];
        p.y = c[5];
        return [
            "C",
            c[0],
            c[1],
            c[2],
            c[3],
            c[4],
            c[5]
        ];
    },
    S: function(c, p) {
        p.x = c[2];
        p.y = c[3];
        return [
            "S",
            c[0],
            c[1],
            c[2],
            c[3]
        ];
    },
    Q: function(c, p) {
        p.x = c[2];
        p.y = c[3];
        return [
            "Q",
            c[0],
            c[1],
            c[2],
            c[3]
        ];
    },
    T: function(c, p) {
        p.x = c[0];
        p.y = c[1];
        return [
            "T",
            c[0],
            c[1]
        ];
    },
    Z: function(c, p, p0) {
        p.x = p0.x;
        p.y = p0.y;
        return [
            "Z"
        ];
    },
    A: function(c, p) {
        p.x = c[5];
        p.y = c[6];
        return [
            "A",
            c[0],
            c[1],
            c[2],
            c[3],
            c[4],
            c[5],
            c[6]
        ];
    }
};
const $e4b50d36b79545e2$var$mlhvqtcsaz = "mlhvqtcsaz".split("");
for(let i = 0, il = $e4b50d36b79545e2$var$mlhvqtcsaz.length; i < il; ++i)$e4b50d36b79545e2$var$pathHandlers[$e4b50d36b79545e2$var$mlhvqtcsaz[i]] = function(i) {
    return function(c, p, p0) {
        if (i === "H") c[0] = c[0] + p.x;
        else if (i === "V") c[0] = c[0] + p.y;
        else if (i === "A") {
            c[5] = c[5] + p.x;
            c[6] = c[6] + p.y;
        } else for(let j = 0, jl = c.length; j < jl; ++j)c[j] = c[j] + (j % 2 ? p.y : p.x);
        return $e4b50d36b79545e2$var$pathHandlers[i](c, p, p0);
    };
}($e4b50d36b79545e2$var$mlhvqtcsaz[i].toUpperCase());
function $e4b50d36b79545e2$var$makeAbsolut(parser) {
    const command = parser.segment[0];
    return $e4b50d36b79545e2$var$pathHandlers[command](parser.segment.slice(1), parser.p, parser.p0);
}
function $e4b50d36b79545e2$var$segmentComplete(parser) {
    return parser.segment.length && parser.segment.length - 1 === $e4b50d36b79545e2$var$segmentParameters[parser.segment[0].toUpperCase()];
}
function $e4b50d36b79545e2$var$startNewSegment(parser, token) {
    parser.inNumber && $e4b50d36b79545e2$var$finalizeNumber(parser, false);
    const pathLetter = $e4b50d36b79545e2$var$isPathLetter.test(token);
    if (pathLetter) parser.segment = [
        token
    ];
    else {
        const lastCommand = parser.lastCommand;
        const small = lastCommand.toLowerCase();
        const isSmall = lastCommand === small;
        parser.segment = [
            small === "m" ? isSmall ? "l" : "L" : lastCommand
        ];
    }
    parser.inSegment = true;
    parser.lastCommand = parser.segment[0];
    return pathLetter;
}
function $e4b50d36b79545e2$var$finalizeNumber(parser, inNumber) {
    if (!parser.inNumber) throw new Error("Parser Error");
    parser.number && parser.segment.push(parseFloat(parser.number));
    parser.inNumber = inNumber;
    parser.number = "";
    parser.pointSeen = false;
    parser.hasExponent = false;
    if ($e4b50d36b79545e2$var$segmentComplete(parser)) $e4b50d36b79545e2$var$finalizeSegment(parser);
}
function $e4b50d36b79545e2$var$finalizeSegment(parser) {
    parser.inSegment = false;
    if (parser.absolute) parser.segment = $e4b50d36b79545e2$var$makeAbsolut(parser);
    parser.segments.push(parser.segment);
}
function $e4b50d36b79545e2$var$isArcFlag(parser) {
    if (!parser.segment.length) return false;
    const isArc = parser.segment[0].toUpperCase() === "A";
    const length = parser.segment.length;
    return isArc && (length === 4 || length === 5);
}
function $e4b50d36b79545e2$var$isExponential(parser) {
    return parser.lastToken.toUpperCase() === "E";
}
function $e4b50d36b79545e2$var$pathParser(d, toAbsolute = true) {
    let index = 0;
    let token = "";
    const parser = {
        segment: [],
        inNumber: false,
        number: "",
        lastToken: "",
        inSegment: false,
        segments: [],
        pointSeen: false,
        hasExponent: false,
        absolute: toAbsolute,
        p0: new $e4b50d36b79545e2$export$baf26146a414f24a(),
        p: new $e4b50d36b79545e2$export$baf26146a414f24a()
    };
    while(parser.lastToken = token, token = d.charAt(index++)){
        if (!parser.inSegment) {
            if ($e4b50d36b79545e2$var$startNewSegment(parser, token)) continue;
        }
        if (token === ".") {
            if (parser.pointSeen || parser.hasExponent) {
                $e4b50d36b79545e2$var$finalizeNumber(parser, false);
                --index;
                continue;
            }
            parser.inNumber = true;
            parser.pointSeen = true;
            parser.number += token;
            continue;
        }
        if (!isNaN(parseInt(token))) {
            if (parser.number === "0" || $e4b50d36b79545e2$var$isArcFlag(parser)) {
                parser.inNumber = true;
                parser.number = token;
                $e4b50d36b79545e2$var$finalizeNumber(parser, true);
                continue;
            }
            parser.inNumber = true;
            parser.number += token;
            continue;
        }
        if (token === " " || token === ",") {
            if (parser.inNumber) $e4b50d36b79545e2$var$finalizeNumber(parser, false);
            continue;
        }
        if (token === "-") {
            if (parser.inNumber && !$e4b50d36b79545e2$var$isExponential(parser)) {
                $e4b50d36b79545e2$var$finalizeNumber(parser, false);
                --index;
                continue;
            }
            parser.number += token;
            parser.inNumber = true;
            continue;
        }
        if (token.toUpperCase() === "E") {
            parser.number += token;
            parser.hasExponent = true;
            continue;
        }
        if ($e4b50d36b79545e2$var$isPathLetter.test(token)) {
            if (parser.inNumber) $e4b50d36b79545e2$var$finalizeNumber(parser, false);
            else if (!$e4b50d36b79545e2$var$segmentComplete(parser)) throw new Error("parser Error");
            else $e4b50d36b79545e2$var$finalizeSegment(parser);
            --index;
        }
    }
    if (parser.inNumber) $e4b50d36b79545e2$var$finalizeNumber(parser, false);
    if (parser.inSegment && $e4b50d36b79545e2$var$segmentComplete(parser)) $e4b50d36b79545e2$var$finalizeSegment(parser);
    return parser.segments;
}
function $e4b50d36b79545e2$var$arrayToString(a) {
    let s = "";
    for(let i = 0, il = a.length; i < il; i++){
        s += a[i][0];
        if (a[i][1] != null) {
            s += a[i][1];
            if (a[i][2] != null) {
                s += " ";
                s += a[i][2];
                if (a[i][3] != null) {
                    s += " ";
                    s += a[i][3];
                    s += " ";
                    s += a[i][4];
                    if (a[i][5] != null) {
                        s += " ";
                        s += a[i][5];
                        s += " ";
                        s += a[i][6];
                        if (a[i][7] != null) {
                            s += " ";
                            s += a[i][7];
                        }
                    }
                }
            }
        }
    }
    return s + " ";
}
class $e4b50d36b79545e2$export$dbd6a88fc4ee1d79 extends $e4b50d36b79545e2$export$c4be6576ca6fe4aa {
    // Get bounding box of path
    bbox() {
        $e4b50d36b79545e2$export$8f49e4af10703ce3().path.setAttribute("d", this.toString());
        return new $e4b50d36b79545e2$export$e71c4d32a2263218($e4b50d36b79545e2$export$8f49e4af10703ce3.nodes.path.getBBox());
    }
    move(x, y) {
        // get bounding box of current situation
        const box = this.bbox(); // get relative offset
        x -= box.x;
        y -= box.y;
        if (!isNaN(x) && !isNaN(y)) // move every point
        for(let l, i = this.length - 1; i >= 0; i--){
            l = this[i][0];
            if (l === "M" || l === "L" || l === "T") {
                this[i][1] += x;
                this[i][2] += y;
            } else if (l === "H") this[i][1] += x;
            else if (l === "V") this[i][1] += y;
            else if (l === "C" || l === "S" || l === "Q") {
                this[i][1] += x;
                this[i][2] += y;
                this[i][3] += x;
                this[i][4] += y;
                if (l === "C") {
                    this[i][5] += x;
                    this[i][6] += y;
                }
            } else if (l === "A") {
                this[i][6] += x;
                this[i][7] += y;
            }
        }
        return this;
    }
    parse(d = "M0 0") {
        if (Array.isArray(d)) d = Array.prototype.concat.apply([], d).toString();
        return $e4b50d36b79545e2$var$pathParser(d);
    }
    size(width, height) {
        // get bounding box of current situation
        const box = this.bbox();
        let i, l; // If the box width or height is 0 then we ignore
        // transformations on the respective axis
        box.width = box.width === 0 ? 1 : box.width;
        box.height = box.height === 0 ? 1 : box.height; // recalculate position of all points according to new size
        for(i = this.length - 1; i >= 0; i--){
            l = this[i][0];
            if (l === "M" || l === "L" || l === "T") {
                this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
            } else if (l === "H") this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
            else if (l === "V") this[i][1] = (this[i][1] - box.y) * height / box.height + box.y;
            else if (l === "C" || l === "S" || l === "Q") {
                this[i][1] = (this[i][1] - box.x) * width / box.width + box.x;
                this[i][2] = (this[i][2] - box.y) * height / box.height + box.y;
                this[i][3] = (this[i][3] - box.x) * width / box.width + box.x;
                this[i][4] = (this[i][4] - box.y) * height / box.height + box.y;
                if (l === "C") {
                    this[i][5] = (this[i][5] - box.x) * width / box.width + box.x;
                    this[i][6] = (this[i][6] - box.y) * height / box.height + box.y;
                }
            } else if (l === "A") {
                // resize radii
                this[i][1] = this[i][1] * width / box.width;
                this[i][2] = this[i][2] * height / box.height; // move position values
                this[i][6] = (this[i][6] - box.x) * width / box.width + box.x;
                this[i][7] = (this[i][7] - box.y) * height / box.height + box.y;
            }
        }
        return this;
    }
    toString() {
        return $e4b50d36b79545e2$var$arrayToString(this);
    }
}
const $e4b50d36b79545e2$var$getClassForType = (value)=>{
    const type = typeof value;
    if (type === "number") return $e4b50d36b79545e2$export$fffa67e515d04022;
    else if (type === "string") {
        if ($e4b50d36b79545e2$export$892596cec99bc70e.isColor(value)) return $e4b50d36b79545e2$export$892596cec99bc70e;
        else if ($e4b50d36b79545e2$var$delimiter.test(value)) return $e4b50d36b79545e2$var$isPathLetter.test(value) ? $e4b50d36b79545e2$export$dbd6a88fc4ee1d79 : $e4b50d36b79545e2$export$c4be6576ca6fe4aa;
        else if ($e4b50d36b79545e2$var$numberAndUnit.test(value)) return $e4b50d36b79545e2$export$fffa67e515d04022;
        else return $e4b50d36b79545e2$export$886991c84a4f013a;
    } else if ($e4b50d36b79545e2$var$morphableTypes.indexOf(value.constructor) > -1) return value.constructor;
    else if (Array.isArray(value)) return $e4b50d36b79545e2$export$c4be6576ca6fe4aa;
    else if (type === "object") return $e4b50d36b79545e2$export$2b088fc80407dd4c;
    else return $e4b50d36b79545e2$export$886991c84a4f013a;
};
class $e4b50d36b79545e2$export$c8711ee424a4a619 {
    constructor(stepper){
        this._stepper = stepper || new $e4b50d36b79545e2$export$e60daad661aebae6("-");
        this._from = null;
        this._to = null;
        this._type = null;
        this._context = null;
        this._morphObj = null;
    }
    at(pos) {
        return this._morphObj.morph(this._from, this._to, pos, this._stepper, this._context);
    }
    done() {
        const complete = this._context.map(this._stepper.done).reduce(function(last, curr) {
            return last && curr;
        }, true);
        return complete;
    }
    from(val) {
        if (val == null) return this._from;
        this._from = this._set(val);
        return this;
    }
    stepper(stepper) {
        if (stepper == null) return this._stepper;
        this._stepper = stepper;
        return this;
    }
    to(val) {
        if (val == null) return this._to;
        this._to = this._set(val);
        return this;
    }
    type(type) {
        // getter
        if (type == null) return this._type;
         // setter
        this._type = type;
        return this;
    }
    _set(value) {
        if (!this._type) this.type($e4b50d36b79545e2$var$getClassForType(value));
        let result = new this._type(value);
        if (this._type === $e4b50d36b79545e2$export$892596cec99bc70e) result = this._to ? result[this._to[4]]() : this._from ? result[this._from[4]]() : result;
        if (this._type === $e4b50d36b79545e2$export$2b088fc80407dd4c) result = this._to ? result.align(this._to) : this._from ? result.align(this._from) : result;
        result = result.toConsumable();
        this._morphObj = this._morphObj || new this._type();
        this._context = this._context || Array.apply(null, Array(result.length)).map(Object).map(function(o) {
            o.done = true;
            return o;
        });
        return result;
    }
}
class $e4b50d36b79545e2$export$886991c84a4f013a {
    constructor(...args){
        this.init(...args);
    }
    init(val) {
        val = Array.isArray(val) ? val[0] : val;
        this.value = val;
        return this;
    }
    toArray() {
        return [
            this.value
        ];
    }
    valueOf() {
        return this.value;
    }
}
class $e4b50d36b79545e2$export$9c52af6a49a79065 {
    constructor(...args){
        this.init(...args);
    }
    init(obj) {
        if (Array.isArray(obj)) obj = {
            scaleX: obj[0],
            scaleY: obj[1],
            shear: obj[2],
            rotate: obj[3],
            translateX: obj[4],
            translateY: obj[5],
            originX: obj[6],
            originY: obj[7]
        };
        Object.assign(this, $e4b50d36b79545e2$export$9c52af6a49a79065.defaults, obj);
        return this;
    }
    toArray() {
        const v = this;
        return [
            v.scaleX,
            v.scaleY,
            v.shear,
            v.rotate,
            v.translateX,
            v.translateY,
            v.originX,
            v.originY
        ];
    }
}
$e4b50d36b79545e2$export$9c52af6a49a79065.defaults = {
    scaleX: 1,
    scaleY: 1,
    shear: 0,
    rotate: 0,
    translateX: 0,
    translateY: 0,
    originX: 0,
    originY: 0
};
const $e4b50d36b79545e2$var$sortByKey = (a, b)=>{
    return a[0] < b[0] ? -1 : a[0] > b[0] ? 1 : 0;
};
class $e4b50d36b79545e2$export$2b088fc80407dd4c {
    constructor(...args){
        this.init(...args);
    }
    align(other) {
        const values = this.values;
        for(let i = 0, il = values.length; i < il; ++i){
            // If the type is the same we only need to check if the color is in the correct format
            if (values[i + 1] === other[i + 1]) {
                if (values[i + 1] === $e4b50d36b79545e2$export$892596cec99bc70e && other[i + 7] !== values[i + 7]) {
                    const space = other[i + 7];
                    const color = new $e4b50d36b79545e2$export$892596cec99bc70e(this.values.splice(i + 3, 5))[space]().toArray();
                    this.values.splice(i + 3, 0, ...color);
                }
                i += values[i + 2] + 2;
                continue;
            }
            if (!other[i + 1]) return this;
             // The types differ, so we overwrite the new type with the old one
            // And initialize it with the types default (e.g. black for color or 0 for number)
            const defaultObject = new other[i + 1]().toArray(); // Than we fix the values array
            const toDelete = values[i + 2] + 3;
            values.splice(i, toDelete, other[i], other[i + 1], other[i + 2], ...defaultObject);
            i += values[i + 2] + 2;
        }
        return this;
    }
    init(objOrArr) {
        this.values = [];
        if (Array.isArray(objOrArr)) {
            this.values = objOrArr.slice();
            return;
        }
        objOrArr = objOrArr || {};
        const entries = [];
        for(const i in objOrArr){
            const Type = $e4b50d36b79545e2$var$getClassForType(objOrArr[i]);
            const val = new Type(objOrArr[i]).toArray();
            entries.push([
                i,
                Type,
                val.length,
                ...val
            ]);
        }
        entries.sort($e4b50d36b79545e2$var$sortByKey);
        this.values = entries.reduce((last, curr)=>last.concat(curr), []);
        return this;
    }
    toArray() {
        return this.values;
    }
    valueOf() {
        const obj = {};
        const arr = this.values; // for (var i = 0, len = arr.length; i < len; i += 2) {
        while(arr.length){
            const key = arr.shift();
            const Type = arr.shift();
            const num = arr.shift();
            const values = arr.splice(0, num);
            obj[key] = new Type(values); // .valueOf()
        }
        return obj;
    }
}
const $e4b50d36b79545e2$var$morphableTypes = [
    $e4b50d36b79545e2$export$886991c84a4f013a,
    $e4b50d36b79545e2$export$9c52af6a49a79065,
    $e4b50d36b79545e2$export$2b088fc80407dd4c
];
function $e4b50d36b79545e2$export$60837f2ca821f102(type = []) {
    $e4b50d36b79545e2$var$morphableTypes.push(...[].concat(type));
}
function $e4b50d36b79545e2$export$a4089364a070cb60() {
    $e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$var$morphableTypes, {
        to (val) {
            return new $e4b50d36b79545e2$export$c8711ee424a4a619().type(this.constructor).from(this.toArray()) // this.valueOf())
            .to(val);
        },
        fromArray (arr) {
            this.init(arr);
            return this;
        },
        toConsumable () {
            return this.toArray();
        },
        morph (from, to, pos, stepper, context) {
            const mapper = function(i, index) {
                return stepper.step(i, to[index], pos, context[index], context);
            };
            return this.fromArray(from.map(mapper));
        }
    });
}
class $e4b50d36b79545e2$export$4b2950bdac9b6ee9 extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("path", node), attrs);
    }
    array() {
        return this._array || (this._array = new $e4b50d36b79545e2$export$dbd6a88fc4ee1d79(this.attr("d")));
    }
    clear() {
        delete this._array;
        return this;
    }
    height(height) {
        return height == null ? this.bbox().height : this.size(this.bbox().width, height);
    }
    move(x, y) {
        return this.attr("d", this.array().move(x, y));
    }
    plot(d) {
        return d == null ? this.array() : this.clear().attr("d", typeof d === "string" ? d : this._array = new $e4b50d36b79545e2$export$dbd6a88fc4ee1d79(d));
    }
    size(width, height) {
        const p = $e4b50d36b79545e2$var$proportionalSize(this, width, height);
        return this.attr("d", this.array().size(p.width, p.height));
    }
    width(width) {
        return width == null ? this.bbox().width : this.size(width, this.bbox().height);
    }
    x(x) {
        return x == null ? this.bbox().x : this.move(x, this.bbox().y);
    }
    y(y) {
        return y == null ? this.bbox().y : this.move(this.bbox().x, y);
    }
} // Define morphable array
$e4b50d36b79545e2$export$4b2950bdac9b6ee9.prototype.MorphArray = $e4b50d36b79545e2$export$dbd6a88fc4ee1d79; // Add parent method
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a wrapped path element
        path: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(d) {
            // make sure plot is called as a setter
            return this.put(new $e4b50d36b79545e2$export$4b2950bdac9b6ee9()).plot(d || new $e4b50d36b79545e2$export$dbd6a88fc4ee1d79());
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$4b2950bdac9b6ee9, "Path");
function $e4b50d36b79545e2$var$array() {
    return this._array || (this._array = new $e4b50d36b79545e2$export$e834181a854d3988(this.attr("points")));
} // Clear array cache
function $e4b50d36b79545e2$var$clear() {
    delete this._array;
    return this;
} // Move by left top corner
function $e4b50d36b79545e2$var$move$2(x, y) {
    return this.attr("points", this.array().move(x, y));
} // Plot new path
function $e4b50d36b79545e2$var$plot(p) {
    return p == null ? this.array() : this.clear().attr("points", typeof p === "string" ? p : this._array = new $e4b50d36b79545e2$export$e834181a854d3988(p));
} // Set element size to given width and height
function $e4b50d36b79545e2$var$size$1(width, height) {
    const p = $e4b50d36b79545e2$var$proportionalSize(this, width, height);
    return this.attr("points", this.array().size(p.width, p.height));
}
var $e4b50d36b79545e2$var$poly = {
    __proto__: null,
    array: $e4b50d36b79545e2$var$array,
    clear: $e4b50d36b79545e2$var$clear,
    move: $e4b50d36b79545e2$var$move$2,
    plot: $e4b50d36b79545e2$var$plot,
    size: $e4b50d36b79545e2$var$size$1
};
class $e4b50d36b79545e2$export$7d31b617c820d435 extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("polygon", node), attrs);
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a wrapped polygon element
        polygon: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(p) {
            // make sure plot is called as a setter
            return this.put(new $e4b50d36b79545e2$export$7d31b617c820d435()).plot(p || new $e4b50d36b79545e2$export$e834181a854d3988());
        })
    }
});
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$7d31b617c820d435, $e4b50d36b79545e2$var$pointed);
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$7d31b617c820d435, $e4b50d36b79545e2$var$poly);
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$7d31b617c820d435, "Polygon");
class $e4b50d36b79545e2$export$79f3ee03e63e7073 extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("polyline", node), attrs);
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a wrapped polygon element
        polyline: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(p) {
            // make sure plot is called as a setter
            return this.put(new $e4b50d36b79545e2$export$79f3ee03e63e7073()).plot(p || new $e4b50d36b79545e2$export$e834181a854d3988());
        })
    }
});
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$79f3ee03e63e7073, $e4b50d36b79545e2$var$pointed);
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$79f3ee03e63e7073, $e4b50d36b79545e2$var$poly);
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$79f3ee03e63e7073, "Polyline");
class $e4b50d36b79545e2$export$c79fc6492f3af13d extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("rect", node), attrs);
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$c79fc6492f3af13d, {
    rx: $e4b50d36b79545e2$var$rx,
    ry: $e4b50d36b79545e2$var$ry
});
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a rect element
        rect: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(width, height) {
            return this.put(new $e4b50d36b79545e2$export$c79fc6492f3af13d()).size(width, height);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$c79fc6492f3af13d, "Rect");
class $e4b50d36b79545e2$export$3dc07afe418952bc {
    constructor(){
        this._first = null;
        this._last = null;
    }
    first() {
        return this._first && this._first.value;
    }
    last() {
        return this._last && this._last.value;
    }
    push(value) {
        // An item stores an id and the provided value
        const item = typeof value.next !== "undefined" ? value : {
            value: value,
            next: null,
            prev: null
        }; // Deal with the queue being empty or populated
        if (this._last) {
            item.prev = this._last;
            this._last.next = item;
            this._last = item;
        } else {
            this._last = item;
            this._first = item;
        } // Return the current item
        return item;
    }
    remove(item) {
        // Relink the previous item
        if (item.prev) item.prev.next = item.next;
        if (item.next) item.next.prev = item.prev;
        if (item === this._last) this._last = item.prev;
        if (item === this._first) this._first = item.next; // Invalidate item
        item.prev = null;
        item.next = null;
    }
    shift() {
        // Check if we have a value
        const remove = this._first;
        if (!remove) return null; // If we do, remove it and relink things
        this._first = remove.next;
        if (this._first) this._first.prev = null;
        this._last = this._first ? this._last : null;
        return remove.value;
    }
}
const $e4b50d36b79545e2$export$c774d8c9d4e9e234 = {
    nextDraw: null,
    frames: new $e4b50d36b79545e2$export$3dc07afe418952bc(),
    timeouts: new $e4b50d36b79545e2$export$3dc07afe418952bc(),
    immediates: new $e4b50d36b79545e2$export$3dc07afe418952bc(),
    timer: ()=>$e4b50d36b79545e2$var$globals.window.performance || $e4b50d36b79545e2$var$globals.window.Date,
    transforms: [],
    frame (fn) {
        // Store the node
        const node = $e4b50d36b79545e2$export$c774d8c9d4e9e234.frames.push({
            run: fn
        }); // Request an animation frame if we don't have one
        if ($e4b50d36b79545e2$export$c774d8c9d4e9e234.nextDraw === null) $e4b50d36b79545e2$export$c774d8c9d4e9e234.nextDraw = $e4b50d36b79545e2$var$globals.window.requestAnimationFrame($e4b50d36b79545e2$export$c774d8c9d4e9e234._draw);
         // Return the node so we can remove it easily
        return node;
    },
    timeout (fn, delay) {
        delay = delay || 0; // Work out when the event should fire
        const time = $e4b50d36b79545e2$export$c774d8c9d4e9e234.timer().now() + delay; // Add the timeout to the end of the queue
        const node = $e4b50d36b79545e2$export$c774d8c9d4e9e234.timeouts.push({
            run: fn,
            time: time
        }); // Request another animation frame if we need one
        if ($e4b50d36b79545e2$export$c774d8c9d4e9e234.nextDraw === null) $e4b50d36b79545e2$export$c774d8c9d4e9e234.nextDraw = $e4b50d36b79545e2$var$globals.window.requestAnimationFrame($e4b50d36b79545e2$export$c774d8c9d4e9e234._draw);
        return node;
    },
    immediate (fn) {
        // Add the immediate fn to the end of the queue
        const node = $e4b50d36b79545e2$export$c774d8c9d4e9e234.immediates.push(fn); // Request another animation frame if we need one
        if ($e4b50d36b79545e2$export$c774d8c9d4e9e234.nextDraw === null) $e4b50d36b79545e2$export$c774d8c9d4e9e234.nextDraw = $e4b50d36b79545e2$var$globals.window.requestAnimationFrame($e4b50d36b79545e2$export$c774d8c9d4e9e234._draw);
        return node;
    },
    cancelFrame (node) {
        node != null && $e4b50d36b79545e2$export$c774d8c9d4e9e234.frames.remove(node);
    },
    clearTimeout (node) {
        node != null && $e4b50d36b79545e2$export$c774d8c9d4e9e234.timeouts.remove(node);
    },
    cancelImmediate (node) {
        node != null && $e4b50d36b79545e2$export$c774d8c9d4e9e234.immediates.remove(node);
    },
    _draw (now) {
        // Run all the timeouts we can run, if they are not ready yet, add them
        // to the end of the queue immediately! (bad timeouts!!! [sarcasm])
        let nextTimeout = null;
        const lastTimeout = $e4b50d36b79545e2$export$c774d8c9d4e9e234.timeouts.last();
        while(nextTimeout = $e4b50d36b79545e2$export$c774d8c9d4e9e234.timeouts.shift()){
            // Run the timeout if its time, or push it to the end
            if (now >= nextTimeout.time) nextTimeout.run();
            else $e4b50d36b79545e2$export$c774d8c9d4e9e234.timeouts.push(nextTimeout);
             // If we hit the last item, we should stop shifting out more items
            if (nextTimeout === lastTimeout) break;
        } // Run all of the animation frames
        let nextFrame = null;
        const lastFrame = $e4b50d36b79545e2$export$c774d8c9d4e9e234.frames.last();
        while(nextFrame !== lastFrame && (nextFrame = $e4b50d36b79545e2$export$c774d8c9d4e9e234.frames.shift()))nextFrame.run(now);
        let nextImmediate = null;
        while(nextImmediate = $e4b50d36b79545e2$export$c774d8c9d4e9e234.immediates.shift())nextImmediate();
         // If we have remaining timeouts or frames, draw until we don't anymore
        $e4b50d36b79545e2$export$c774d8c9d4e9e234.nextDraw = $e4b50d36b79545e2$export$c774d8c9d4e9e234.timeouts.first() || $e4b50d36b79545e2$export$c774d8c9d4e9e234.frames.first() ? $e4b50d36b79545e2$var$globals.window.requestAnimationFrame($e4b50d36b79545e2$export$c774d8c9d4e9e234._draw) : null;
    }
};
const $e4b50d36b79545e2$var$makeSchedule = function(runnerInfo) {
    const start = runnerInfo.start;
    const duration = runnerInfo.runner.duration();
    const end = start + duration;
    return {
        start: start,
        duration: duration,
        end: end,
        runner: runnerInfo.runner
    };
};
const $e4b50d36b79545e2$var$defaultSource = function() {
    const w = $e4b50d36b79545e2$var$globals.window;
    return (w.performance || w.Date).now();
};
class $e4b50d36b79545e2$export$e6a97ba2cae5bb94 extends $e4b50d36b79545e2$export$648eec84020a2b10 {
    // Construct a new timeline on the given element
    constructor(timeSource = $e4b50d36b79545e2$var$defaultSource){
        super();
        this._timeSource = timeSource; // Store the timing variables
        this._startTime = 0;
        this._speed = 1.0; // Determines how long a runner is hold in memory. Can be a dt or true/false
        this._persist = 0; // Keep track of the running animations and their starting parameters
        this._nextFrame = null;
        this._paused = true;
        this._runners = [];
        this._runnerIds = [];
        this._lastRunnerId = -1;
        this._time = 0;
        this._lastSourceTime = 0;
        this._lastStepTime = 0; // Make sure that step is always called in class context
        this._step = this._stepFn.bind(this, false);
        this._stepImmediate = this._stepFn.bind(this, true);
    }
    active() {
        return !!this._nextFrame;
    }
    finish() {
        // Go to end and pause
        this.time(this.getEndTimeOfTimeline() + 1);
        return this.pause();
    }
    getEndTime() {
        const lastRunnerInfo = this.getLastRunnerInfo();
        const lastDuration = lastRunnerInfo ? lastRunnerInfo.runner.duration() : 0;
        const lastStartTime = lastRunnerInfo ? lastRunnerInfo.start : this._time;
        return lastStartTime + lastDuration;
    }
    getEndTimeOfTimeline() {
        const endTimes = this._runners.map((i)=>i.start + i.runner.duration());
        return Math.max(0, ...endTimes);
    }
    getLastRunnerInfo() {
        return this.getRunnerInfoById(this._lastRunnerId);
    }
    getRunnerInfoById(id) {
        return this._runners[this._runnerIds.indexOf(id)] || null;
    }
    pause() {
        this._paused = true;
        return this._continue();
    }
    persist(dtOrForever) {
        if (dtOrForever == null) return this._persist;
        this._persist = dtOrForever;
        return this;
    }
    play() {
        // Now make sure we are not paused and continue the animation
        this._paused = false;
        return this.updateTime()._continue();
    }
    reverse(yes) {
        const currentSpeed = this.speed();
        if (yes == null) return this.speed(-currentSpeed);
        const positive = Math.abs(currentSpeed);
        return this.speed(yes ? -positive : positive);
    }
    schedule(runner, delay, when) {
        if (runner == null) return this._runners.map($e4b50d36b79545e2$var$makeSchedule);
         // The start time for the next animation can either be given explicitly,
        // derived from the current timeline time or it can be relative to the
        // last start time to chain animations directly
        let absoluteStartTime = 0;
        const endTime = this.getEndTime();
        delay = delay || 0; // Work out when to start the animation
        if (when == null || when === "last" || when === "after") // Take the last time and increment
        absoluteStartTime = endTime;
        else if (when === "absolute" || when === "start") {
            absoluteStartTime = delay;
            delay = 0;
        } else if (when === "now") absoluteStartTime = this._time;
        else if (when === "relative") {
            const runnerInfo = this.getRunnerInfoById(runner.id);
            if (runnerInfo) {
                absoluteStartTime = runnerInfo.start + delay;
                delay = 0;
            }
        } else if (when === "with-last") {
            const lastRunnerInfo = this.getLastRunnerInfo();
            const lastStartTime = lastRunnerInfo ? lastRunnerInfo.start : this._time;
            absoluteStartTime = lastStartTime;
        } else throw new Error('Invalid value for the "when" parameter');
         // Manage runner
        runner.unschedule();
        runner.timeline(this);
        const persist = runner.persist();
        const runnerInfo = {
            persist: persist === null ? this._persist : persist,
            start: absoluteStartTime + delay,
            runner: runner
        };
        this._lastRunnerId = runner.id;
        this._runners.push(runnerInfo);
        this._runners.sort((a, b)=>a.start - b.start);
        this._runnerIds = this._runners.map((info)=>info.runner.id);
        this.updateTime()._continue();
        return this;
    }
    seek(dt) {
        return this.time(this._time + dt);
    }
    source(fn) {
        if (fn == null) return this._timeSource;
        this._timeSource = fn;
        return this;
    }
    speed(speed) {
        if (speed == null) return this._speed;
        this._speed = speed;
        return this;
    }
    stop() {
        // Go to start and pause
        this.time(0);
        return this.pause();
    }
    time(time) {
        if (time == null) return this._time;
        this._time = time;
        return this._continue(true);
    }
    unschedule(runner) {
        const index = this._runnerIds.indexOf(runner.id);
        if (index < 0) return this;
        this._runners.splice(index, 1);
        this._runnerIds.splice(index, 1);
        runner.timeline(null);
        return this;
    }
    updateTime() {
        if (!this.active()) this._lastSourceTime = this._timeSource();
        return this;
    }
    _continue(immediateStep = false) {
        $e4b50d36b79545e2$export$c774d8c9d4e9e234.cancelFrame(this._nextFrame);
        this._nextFrame = null;
        if (immediateStep) return this._stepImmediate();
        if (this._paused) return this;
        this._nextFrame = $e4b50d36b79545e2$export$c774d8c9d4e9e234.frame(this._step);
        return this;
    }
    _stepFn(immediateStep = false) {
        // Get the time delta from the last time and update the time
        const time = this._timeSource();
        let dtSource = time - this._lastSourceTime;
        if (immediateStep) dtSource = 0;
        const dtTime = this._speed * dtSource + (this._time - this._lastStepTime);
        this._lastSourceTime = time; // Only update the time if we use the timeSource.
        // Otherwise use the current time
        if (!immediateStep) {
            // Update the time
            this._time += dtTime;
            this._time = this._time < 0 ? 0 : this._time;
        }
        this._lastStepTime = this._time;
        this.fire("time", this._time); // This is for the case that the timeline was seeked so that the time
        // is now before the startTime of the runner. That is why we need to set
        // the runner to position 0
        // FIXME:
        // However, resetting in insertion order leads to bugs. Considering the case,
        // where 2 runners change the same attribute but in different times,
        // resetting both of them will lead to the case where the later defined
        // runner always wins the reset even if the other runner started earlier
        // and therefore should win the attribute battle
        // this can be solved by resetting them backwards
        for(let k = this._runners.length; k--;){
            // Get and run the current runner and ignore it if its inactive
            const runnerInfo = this._runners[k];
            const runner = runnerInfo.runner; // Make sure that we give the actual difference
            // between runner start time and now
            const dtToStart = this._time - runnerInfo.start; // Dont run runner if not started yet
            // and try to reset it
            if (dtToStart <= 0) runner.reset();
        } // Run all of the runners directly
        let runnersLeft = false;
        for(let i = 0, len = this._runners.length; i < len; i++){
            // Get and run the current runner and ignore it if its inactive
            const runnerInfo = this._runners[i];
            const runner = runnerInfo.runner;
            let dt = dtTime; // Make sure that we give the actual difference
            // between runner start time and now
            const dtToStart = this._time - runnerInfo.start; // Dont run runner if not started yet
            if (dtToStart <= 0) {
                runnersLeft = true;
                continue;
            } else if (dtToStart < dt) // Adjust dt to make sure that animation is on point
            dt = dtToStart;
            if (!runner.active()) continue; // If this runner is still going, signal that we need another animation
            // frame, otherwise, remove the completed runner
            const finished = runner.step(dt).done;
            if (!finished) runnersLeft = true; // continue
            else if (runnerInfo.persist !== true) {
                // runner is finished. And runner might get removed
                const endTime = runner.duration() - runner.time() + this._time;
                if (endTime + runnerInfo.persist < this._time) {
                    // Delete runner and correct index
                    runner.unschedule();
                    --i;
                    --len;
                }
            }
        } // Basically: we continue when there are runners right from us in time
        // when -->, and when runners are left from us when <--
        if (runnersLeft && !(this._speed < 0 && this._time === 0) || this._runnerIds.length && this._speed < 0 && this._time > 0) this._continue();
        else {
            this.pause();
            this.fire("finished");
        }
        return this;
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Element: {
        timeline: function(timeline) {
            if (timeline == null) {
                this._timeline = this._timeline || new $e4b50d36b79545e2$export$e6a97ba2cae5bb94();
                return this._timeline;
            } else {
                this._timeline = timeline;
                return this;
            }
        }
    }
});
class $e4b50d36b79545e2$export$571ad3bcba5a0c45 extends $e4b50d36b79545e2$export$648eec84020a2b10 {
    constructor(options){
        super(); // Store a unique id on the runner, so that we can identify it later
        this.id = $e4b50d36b79545e2$export$571ad3bcba5a0c45.id++; // Ensure a default value
        options = options == null ? $e4b50d36b79545e2$var$timeline.duration : options; // Ensure that we get a controller
        options = typeof options === "function" ? new $e4b50d36b79545e2$export$bd0bf19f25da8474(options) : options; // Declare all of the variables
        this._element = null;
        this._timeline = null;
        this.done = false;
        this._queue = []; // Work out the stepper and the duration
        this._duration = typeof options === "number" && options;
        this._isDeclarative = options instanceof $e4b50d36b79545e2$export$bd0bf19f25da8474;
        this._stepper = this._isDeclarative ? options : new $e4b50d36b79545e2$export$e60daad661aebae6(); // We copy the current values from the timeline because they can change
        this._history = {}; // Store the state of the runner
        this.enabled = true;
        this._time = 0;
        this._lastTime = 0; // At creation, the runner is in reset state
        this._reseted = true; // Save transforms applied to this runner
        this.transforms = new $e4b50d36b79545e2$export$5b12bf1653c0dd85();
        this.transformId = 1; // Looping variables
        this._haveReversed = false;
        this._reverse = false;
        this._loopsDone = 0;
        this._swing = false;
        this._wait = 0;
        this._times = 1;
        this._frameId = null; // Stores how long a runner is stored after being done
        this._persist = this._isDeclarative ? true : null;
    }
    static sanitise(duration, delay, when) {
        // Initialise the default parameters
        let times = 1;
        let swing = false;
        let wait = 0;
        duration = duration || $e4b50d36b79545e2$var$timeline.duration;
        delay = delay || $e4b50d36b79545e2$var$timeline.delay;
        when = when || "last"; // If we have an object, unpack the values
        if (typeof duration === "object" && !(duration instanceof $e4b50d36b79545e2$var$Stepper)) {
            delay = duration.delay || delay;
            when = duration.when || when;
            swing = duration.swing || swing;
            times = duration.times || times;
            wait = duration.wait || wait;
            duration = duration.duration || $e4b50d36b79545e2$var$timeline.duration;
        }
        return {
            duration: duration,
            delay: delay,
            swing: swing,
            times: times,
            wait: wait,
            when: when
        };
    }
    active(enabled) {
        if (enabled == null) return this.enabled;
        this.enabled = enabled;
        return this;
    }
    /*
  Private Methods
  ===============
  Methods that shouldn't be used externally
  */ addTransform(transform, index) {
        this.transforms.lmultiplyO(transform);
        return this;
    }
    after(fn) {
        return this.on("finished", fn);
    }
    animate(duration, delay, when) {
        const o = $e4b50d36b79545e2$export$571ad3bcba5a0c45.sanitise(duration, delay, when);
        const runner = new $e4b50d36b79545e2$export$571ad3bcba5a0c45(o.duration);
        if (this._timeline) runner.timeline(this._timeline);
        if (this._element) runner.element(this._element);
        return runner.loop(o).schedule(o.delay, o.when);
    }
    clearTransform() {
        this.transforms = new $e4b50d36b79545e2$export$5b12bf1653c0dd85();
        return this;
    }
    clearTransformsFromQueue() {
        if (!this.done || !this._timeline || !this._timeline._runnerIds.includes(this.id)) this._queue = this._queue.filter((item)=>{
            return !item.isTransform;
        });
    }
    delay(delay) {
        return this.animate(0, delay);
    }
    duration() {
        return this._times * (this._wait + this._duration) - this._wait;
    }
    during(fn) {
        return this.queue(null, fn);
    }
    ease(fn) {
        this._stepper = new $e4b50d36b79545e2$export$e60daad661aebae6(fn);
        return this;
    }
    /*
  Runner Definitions
  ==================
  These methods help us define the runtime behaviour of the Runner or they
  help us make new runners from the current runner
  */ element(element) {
        if (element == null) return this._element;
        this._element = element;
        element._prepareRunner();
        return this;
    }
    finish() {
        return this.step(Infinity);
    }
    loop(times, swing, wait) {
        // Deal with the user passing in an object
        if (typeof times === "object") {
            swing = times.swing;
            wait = times.wait;
            times = times.times;
        } // Sanitise the values and store them
        this._times = times || Infinity;
        this._swing = swing || false;
        this._wait = wait || 0; // Allow true to be passed
        if (this._times === true) this._times = Infinity;
        return this;
    }
    loops(p) {
        const loopDuration = this._duration + this._wait;
        if (p == null) {
            const loopsDone = Math.floor(this._time / loopDuration);
            const relativeTime = this._time - loopsDone * loopDuration;
            const position = relativeTime / this._duration;
            return Math.min(loopsDone + position, this._times);
        }
        const whole = Math.floor(p);
        const partial = p % 1;
        const time = loopDuration * whole + this._duration * partial;
        return this.time(time);
    }
    persist(dtOrForever) {
        if (dtOrForever == null) return this._persist;
        this._persist = dtOrForever;
        return this;
    }
    position(p) {
        // Get all of the variables we need
        const x = this._time;
        const d = this._duration;
        const w = this._wait;
        const t = this._times;
        const s = this._swing;
        const r = this._reverse;
        let position;
        if (p == null) {
            /*
      This function converts a time to a position in the range [0, 1]
      The full explanation can be found in this desmos demonstration
        https://www.desmos.com/calculator/u4fbavgche
      The logic is slightly simplified here because we can use booleans
      */ // Figure out the value without thinking about the start or end time
            const f = function(x) {
                const swinging = s * Math.floor(x % (2 * (w + d)) / (w + d));
                const backwards = swinging && !r || !swinging && r;
                const uncliped = Math.pow(-1, backwards) * (x % (w + d)) / d + backwards;
                const clipped = Math.max(Math.min(uncliped, 1), 0);
                return clipped;
            }; // Figure out the value by incorporating the start time
            const endTime = t * (w + d) - w;
            position = x <= 0 ? Math.round(f(1e-5)) : x < endTime ? f(x) : Math.round(f(endTime - 1e-5));
            return position;
        } // Work out the loops done and add the position to the loops done
        const loopsDone = Math.floor(this.loops());
        const swingForward = s && loopsDone % 2 === 0;
        const forwards = swingForward && !r || r && swingForward;
        position = loopsDone + (forwards ? p : 1 - p);
        return this.loops(position);
    }
    progress(p) {
        if (p == null) return Math.min(1, this._time / this.duration());
        return this.time(p * this.duration());
    }
    /*
  Basic Functionality
  ===================
  These methods allow us to attach basic functions to the runner directly
  */ queue(initFn, runFn, retargetFn, isTransform) {
        this._queue.push({
            initialiser: initFn || $e4b50d36b79545e2$var$noop,
            runner: runFn || $e4b50d36b79545e2$var$noop,
            retarget: retargetFn,
            isTransform: isTransform,
            initialised: false,
            finished: false
        });
        const timeline = this.timeline();
        timeline && this.timeline()._continue();
        return this;
    }
    reset() {
        if (this._reseted) return this;
        this.time(0);
        this._reseted = true;
        return this;
    }
    reverse(reverse) {
        this._reverse = reverse == null ? !this._reverse : reverse;
        return this;
    }
    schedule(timeline, delay, when) {
        // The user doesn't need to pass a timeline if we already have one
        if (!(timeline instanceof $e4b50d36b79545e2$export$e6a97ba2cae5bb94)) {
            when = delay;
            delay = timeline;
            timeline = this.timeline();
        } // If there is no timeline, yell at the user...
        if (!timeline) throw Error("Runner cannot be scheduled without timeline");
         // Schedule the runner on the timeline provided
        timeline.schedule(this, delay, when);
        return this;
    }
    step(dt) {
        // If we are inactive, this stepper just gets skipped
        if (!this.enabled) return this; // Update the time and get the new position
        dt = dt == null ? 16 : dt;
        this._time += dt;
        const position = this.position(); // Figure out if we need to run the stepper in this frame
        const running = this._lastPosition !== position && this._time >= 0;
        this._lastPosition = position; // Figure out if we just started
        const duration = this.duration();
        const justStarted = this._lastTime <= 0 && this._time > 0;
        const justFinished = this._lastTime < duration && this._time >= duration;
        this._lastTime = this._time;
        if (justStarted) this.fire("start", this);
         // Work out if the runner is finished set the done flag here so animations
        // know, that they are running in the last step (this is good for
        // transformations which can be merged)
        const declarative = this._isDeclarative;
        this.done = !declarative && !justFinished && this._time >= duration; // Runner is running. So its not in reset state anymore
        this._reseted = false;
        let converged = false; // Call initialise and the run function
        if (running || declarative) {
            this._initialise(running); // clear the transforms on this runner so they dont get added again and again
            this.transforms = new $e4b50d36b79545e2$export$5b12bf1653c0dd85();
            converged = this._run(declarative ? dt : position);
            this.fire("step", this);
        } // correct the done flag here
        // declarative animations itself know when they converged
        this.done = this.done || converged && declarative;
        if (justFinished) this.fire("finished", this);
        return this;
    }
    /*
  Runner animation methods
  ========================
  Control how the animation plays
  */ time(time) {
        if (time == null) return this._time;
        const dt = time - this._time;
        this.step(dt);
        return this;
    }
    timeline(timeline) {
        // check explicitly for undefined so we can set the timeline to null
        if (typeof timeline === "undefined") return this._timeline;
        this._timeline = timeline;
        return this;
    }
    unschedule() {
        const timeline = this.timeline();
        timeline && timeline.unschedule(this);
        return this;
    }
    _initialise(running) {
        // If we aren't running, we shouldn't initialise when not declarative
        if (!running && !this._isDeclarative) return; // Loop through all of the initialisers
        for(let i = 0, len = this._queue.length; i < len; ++i){
            // Get the current initialiser
            const current = this._queue[i]; // Determine whether we need to initialise
            const needsIt = this._isDeclarative || !current.initialised && running;
            running = !current.finished; // Call the initialiser if we need to
            if (needsIt && running) {
                current.initialiser.call(this);
                current.initialised = true;
            }
        }
    }
    _rememberMorpher(method, morpher) {
        this._history[method] = {
            morpher: morpher,
            caller: this._queue[this._queue.length - 1]
        }; // We have to resume the timeline in case a controller
        // is already done without being ever run
        // This can happen when e.g. this is done:
        //    anim = el.animate(new SVG.Spring)
        // and later
        //    anim.move(...)
        if (this._isDeclarative) {
            const timeline = this.timeline();
            timeline && timeline.play();
        }
    }
    // Run each run function for the position or dt given
    _run(positionOrDt) {
        // Run all of the _queue directly
        let allfinished = true;
        for(let i = 0, len = this._queue.length; i < len; ++i){
            // Get the current function to run
            const current = this._queue[i]; // Run the function if its not finished, we keep track of the finished
            // flag for the sake of declarative _queue
            const converged = current.runner.call(this, positionOrDt);
            current.finished = current.finished || converged === true;
            allfinished = allfinished && current.finished;
        } // We report when all of the constructors are finished
        return allfinished;
    }
    _tryRetarget(method, target, extra) {
        if (this._history[method]) {
            // if the last method wasn't even initialised, throw it away
            if (!this._history[method].caller.initialised) {
                const index = this._queue.indexOf(this._history[method].caller);
                this._queue.splice(index, 1);
                return false;
            } // for the case of transformations, we use the special retarget function
            // which has access to the outer scope
            if (this._history[method].caller.retarget) this._history[method].caller.retarget.call(this, target, extra); // for everything else a simple morpher change is sufficient
            else this._history[method].morpher.to(target);
            this._history[method].caller.finished = false;
            const timeline = this.timeline();
            timeline && timeline.play();
            return true;
        }
        return false;
    }
}
$e4b50d36b79545e2$export$571ad3bcba5a0c45.id = 0;
class $e4b50d36b79545e2$var$FakeRunner {
    constructor(transforms = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(), id = -1, done = true){
        this.transforms = transforms;
        this.id = id;
        this.done = done;
    }
    clearTransformsFromQueue() {}
}
$e4b50d36b79545e2$export$8b58be045bf06082([
    $e4b50d36b79545e2$export$571ad3bcba5a0c45,
    $e4b50d36b79545e2$var$FakeRunner
], {
    mergeWith (runner) {
        return new $e4b50d36b79545e2$var$FakeRunner(runner.transforms.lmultiply(this.transforms), runner.id);
    }
}); // FakeRunner.emptyRunner = new FakeRunner()
const $e4b50d36b79545e2$var$lmultiply = (last, curr)=>last.lmultiplyO(curr);
const $e4b50d36b79545e2$var$getRunnerTransform = (runner)=>runner.transforms;
function $e4b50d36b79545e2$var$mergeTransforms() {
    // Find the matrix to apply to the element and apply it
    const runners = this._transformationRunners.runners;
    const netTransform = runners.map($e4b50d36b79545e2$var$getRunnerTransform).reduce($e4b50d36b79545e2$var$lmultiply, new $e4b50d36b79545e2$export$5b12bf1653c0dd85());
    this.transform(netTransform);
    this._transformationRunners.merge();
    if (this._transformationRunners.length() === 1) this._frameId = null;
}
class $e4b50d36b79545e2$var$RunnerArray {
    constructor(){
        this.runners = [];
        this.ids = [];
    }
    add(runner) {
        if (this.runners.includes(runner)) return;
        const id = runner.id + 1;
        this.runners.push(runner);
        this.ids.push(id);
        return this;
    }
    clearBefore(id) {
        const deleteCnt = this.ids.indexOf(id + 1) || 1;
        this.ids.splice(0, deleteCnt, 0);
        this.runners.splice(0, deleteCnt, new $e4b50d36b79545e2$var$FakeRunner()).forEach((r)=>r.clearTransformsFromQueue());
        return this;
    }
    edit(id, newRunner) {
        const index = this.ids.indexOf(id + 1);
        this.ids.splice(index, 1, id + 1);
        this.runners.splice(index, 1, newRunner);
        return this;
    }
    getByID(id) {
        return this.runners[this.ids.indexOf(id + 1)];
    }
    length() {
        return this.ids.length;
    }
    merge() {
        let lastRunner = null;
        for(let i = 0; i < this.runners.length; ++i){
            const runner = this.runners[i];
            const condition = lastRunner && runner.done && lastRunner.done // don't merge runner when persisted on timeline
             && (!runner._timeline || !runner._timeline._runnerIds.includes(runner.id)) && (!lastRunner._timeline || !lastRunner._timeline._runnerIds.includes(lastRunner.id));
            if (condition) {
                // the +1 happens in the function
                this.remove(runner.id);
                const newRunner = runner.mergeWith(lastRunner);
                this.edit(lastRunner.id, newRunner);
                lastRunner = newRunner;
                --i;
            } else lastRunner = runner;
        }
        return this;
    }
    remove(id) {
        const index = this.ids.indexOf(id + 1);
        this.ids.splice(index, 1);
        this.runners.splice(index, 1);
        return this;
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Element: {
        animate (duration, delay, when) {
            const o = $e4b50d36b79545e2$export$571ad3bcba5a0c45.sanitise(duration, delay, when);
            const timeline = this.timeline();
            return new $e4b50d36b79545e2$export$571ad3bcba5a0c45(o.duration).loop(o).element(this).timeline(timeline.play()).schedule(o.delay, o.when);
        },
        delay (by, when) {
            return this.animate(0, by, when);
        },
        // this function searches for all runners on the element and deletes the ones
        // which run before the current one. This is because absolute transformations
        // overwrite anything anyway so there is no need to waste time computing
        // other runners
        _clearTransformRunnersBefore (currentRunner) {
            this._transformationRunners.clearBefore(currentRunner.id);
        },
        _currentTransform (current) {
            return this._transformationRunners.runners // we need the equal sign here to make sure, that also transformations
            // on the same runner which execute before the current transformation are
            // taken into account
            .filter((runner)=>runner.id <= current.id).map($e4b50d36b79545e2$var$getRunnerTransform).reduce($e4b50d36b79545e2$var$lmultiply, new $e4b50d36b79545e2$export$5b12bf1653c0dd85());
        },
        _addRunner (runner) {
            this._transformationRunners.add(runner); // Make sure that the runner merge is executed at the very end of
            // all Animator functions. That is why we use immediate here to execute
            // the merge right after all frames are run
            $e4b50d36b79545e2$export$c774d8c9d4e9e234.cancelImmediate(this._frameId);
            this._frameId = $e4b50d36b79545e2$export$c774d8c9d4e9e234.immediate($e4b50d36b79545e2$var$mergeTransforms.bind(this));
        },
        _prepareRunner () {
            if (this._frameId == null) this._transformationRunners = new $e4b50d36b79545e2$var$RunnerArray().add(new $e4b50d36b79545e2$var$FakeRunner(new $e4b50d36b79545e2$export$5b12bf1653c0dd85(this)));
        }
    }
}); // Will output the elements from array A that are not in the array B
const $e4b50d36b79545e2$var$difference = (a, b)=>a.filter((x)=>!b.includes(x));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$571ad3bcba5a0c45, {
    attr (a, v) {
        return this.styleAttr("attr", a, v);
    },
    // Add animatable styles
    css (s, v) {
        return this.styleAttr("css", s, v);
    },
    styleAttr (type, nameOrAttrs, val) {
        if (typeof nameOrAttrs === "string") return this.styleAttr(type, {
            [nameOrAttrs]: val
        });
        let attrs = nameOrAttrs;
        if (this._tryRetarget(type, attrs)) return this;
        let morpher = new $e4b50d36b79545e2$export$c8711ee424a4a619(this._stepper).to(attrs);
        let keys = Object.keys(attrs);
        this.queue(function() {
            morpher = morpher.from(this.element()[type](keys));
        }, function(pos) {
            this.element()[type](morpher.at(pos).valueOf());
            return morpher.done();
        }, function(newToAttrs) {
            // Check if any new keys were added
            const newKeys = Object.keys(newToAttrs);
            const differences = $e4b50d36b79545e2$var$difference(newKeys, keys); // If their are new keys, initialize them and add them to morpher
            if (differences.length) {
                // Get the values
                const addedFromAttrs = this.element()[type](differences); // Get the already initialized values
                const oldFromAttrs = new $e4b50d36b79545e2$export$2b088fc80407dd4c(morpher.from()).valueOf(); // Merge old and new
                Object.assign(oldFromAttrs, addedFromAttrs);
                morpher.from(oldFromAttrs);
            } // Get the object from the morpher
            const oldToAttrs = new $e4b50d36b79545e2$export$2b088fc80407dd4c(morpher.to()).valueOf(); // Merge in new attributes
            Object.assign(oldToAttrs, newToAttrs); // Change morpher target
            morpher.to(oldToAttrs); // Make sure that we save the work we did so we don't need it to do again
            keys = newKeys;
            attrs = newToAttrs;
        });
        this._rememberMorpher(type, morpher);
        return this;
    },
    zoom (level, point) {
        if (this._tryRetarget("zoom", level, point)) return this;
        let morpher = new $e4b50d36b79545e2$export$c8711ee424a4a619(this._stepper).to(new $e4b50d36b79545e2$export$fffa67e515d04022(level));
        this.queue(function() {
            morpher = morpher.from(this.element().zoom());
        }, function(pos) {
            this.element().zoom(morpher.at(pos), point);
            return morpher.done();
        }, function(newLevel, newPoint) {
            point = newPoint;
            morpher.to(newLevel);
        });
        this._rememberMorpher("zoom", morpher);
        return this;
    },
    /**
   ** absolute transformations
   **/ //
    // M v -----|-----(D M v = F v)------|----->  T v
    //
    // 1. define the final state (T) and decompose it (once)
    //    t = [tx, ty, the, lam, sy, sx]
    // 2. on every frame: pull the current state of all previous transforms
    //    (M - m can change)
    //   and then write this as m = [tx0, ty0, the0, lam0, sy0, sx0]
    // 3. Find the interpolated matrix F(pos) = m + pos * (t - m)
    //   - Note F(0) = M
    //   - Note F(1) = T
    // 4. Now you get the delta matrix as a result: D = F * inv(M)
    transform (transforms, relative, affine) {
        // If we have a declarative function, we should retarget it if possible
        relative = transforms.relative || relative;
        if (this._isDeclarative && !relative && this._tryRetarget("transform", transforms)) return this;
         // Parse the parameters
        const isMatrix = $e4b50d36b79545e2$export$5b12bf1653c0dd85.isMatrixLike(transforms);
        affine = transforms.affine != null ? transforms.affine : affine != null ? affine : !isMatrix; // Create a morpher and set its type
        const morpher = new $e4b50d36b79545e2$export$c8711ee424a4a619(this._stepper).type(affine ? $e4b50d36b79545e2$export$9c52af6a49a79065 : $e4b50d36b79545e2$export$5b12bf1653c0dd85);
        let origin;
        let element;
        let current;
        let currentAngle;
        let startTransform;
        function setup() {
            // make sure element and origin is defined
            element = element || this.element();
            origin = origin || $e4b50d36b79545e2$var$getOrigin(transforms, element);
            startTransform = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(relative ? undefined : element); // add the runner to the element so it can merge transformations
            element._addRunner(this); // Deactivate all transforms that have run so far if we are absolute
            if (!relative) element._clearTransformRunnersBefore(this);
        }
        function run(pos) {
            // clear all other transforms before this in case something is saved
            // on this runner. We are absolute. We dont need these!
            if (!relative) this.clearTransform();
            const { x: x, y: y } = new $e4b50d36b79545e2$export$baf26146a414f24a(origin).transform(element._currentTransform(this));
            let target = new $e4b50d36b79545e2$export$5b12bf1653c0dd85({
                ...transforms,
                origin: [
                    x,
                    y
                ]
            });
            let start = this._isDeclarative && current ? current : startTransform;
            if (affine) {
                target = target.decompose(x, y);
                start = start.decompose(x, y); // Get the current and target angle as it was set
                const rTarget = target.rotate;
                const rCurrent = start.rotate; // Figure out the shortest path to rotate directly
                const possibilities = [
                    rTarget - 360,
                    rTarget,
                    rTarget + 360
                ];
                const distances = possibilities.map((a)=>Math.abs(a - rCurrent));
                const shortest = Math.min(...distances);
                const index = distances.indexOf(shortest);
                target.rotate = possibilities[index];
            }
            if (relative) {
                // we have to be careful here not to overwrite the rotation
                // with the rotate method of Matrix
                if (!isMatrix) target.rotate = transforms.rotate || 0;
                if (this._isDeclarative && currentAngle) start.rotate = currentAngle;
            }
            morpher.from(start);
            morpher.to(target);
            const affineParameters = morpher.at(pos);
            currentAngle = affineParameters.rotate;
            current = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(affineParameters);
            this.addTransform(current);
            element._addRunner(this);
            return morpher.done();
        }
        function retarget(newTransforms) {
            // only get a new origin if it changed since the last call
            if ((newTransforms.origin || "center").toString() !== (transforms.origin || "center").toString()) origin = $e4b50d36b79545e2$var$getOrigin(newTransforms, element);
             // overwrite the old transformations with the new ones
            transforms = {
                ...newTransforms,
                origin: origin
            };
        }
        this.queue(setup, run, retarget, true);
        this._isDeclarative && this._rememberMorpher("transform", morpher);
        return this;
    },
    // Animatable x-axis
    x (x, relative) {
        return this._queueNumber("x", x);
    },
    // Animatable y-axis
    y (y) {
        return this._queueNumber("y", y);
    },
    dx (x = 0) {
        return this._queueNumberDelta("x", x);
    },
    dy (y = 0) {
        return this._queueNumberDelta("y", y);
    },
    dmove (x, y) {
        return this.dx(x).dy(y);
    },
    _queueNumberDelta (method, to) {
        to = new $e4b50d36b79545e2$export$fffa67e515d04022(to); // Try to change the target if we have this method already registered
        if (this._tryRetarget(method, to)) return this; // Make a morpher and queue the animation
        const morpher = new $e4b50d36b79545e2$export$c8711ee424a4a619(this._stepper).to(to);
        let from = null;
        this.queue(function() {
            from = this.element()[method]();
            morpher.from(from);
            morpher.to(from + to);
        }, function(pos) {
            this.element()[method](morpher.at(pos));
            return morpher.done();
        }, function(newTo) {
            morpher.to(from + new $e4b50d36b79545e2$export$fffa67e515d04022(newTo));
        }); // Register the morpher so that if it is changed again, we can retarget it
        this._rememberMorpher(method, morpher);
        return this;
    },
    _queueObject (method, to) {
        // Try to change the target if we have this method already registered
        if (this._tryRetarget(method, to)) return this; // Make a morpher and queue the animation
        const morpher = new $e4b50d36b79545e2$export$c8711ee424a4a619(this._stepper).to(to);
        this.queue(function() {
            morpher.from(this.element()[method]());
        }, function(pos) {
            this.element()[method](morpher.at(pos));
            return morpher.done();
        }); // Register the morpher so that if it is changed again, we can retarget it
        this._rememberMorpher(method, morpher);
        return this;
    },
    _queueNumber (method, value) {
        return this._queueObject(method, new $e4b50d36b79545e2$export$fffa67e515d04022(value));
    },
    // Animatable center x-axis
    cx (x) {
        return this._queueNumber("cx", x);
    },
    // Animatable center y-axis
    cy (y) {
        return this._queueNumber("cy", y);
    },
    // Add animatable move
    move (x, y) {
        return this.x(x).y(y);
    },
    // Add animatable center
    center (x, y) {
        return this.cx(x).cy(y);
    },
    // Add animatable size
    size (width, height) {
        // animate bbox based size for all other elements
        let box;
        if (!width || !height) box = this._element.bbox();
        if (!width) width = box.width / box.height * height;
        if (!height) height = box.height / box.width * width;
        return this.width(width).height(height);
    },
    // Add animatable width
    width (width) {
        return this._queueNumber("width", width);
    },
    // Add animatable height
    height (height) {
        return this._queueNumber("height", height);
    },
    // Add animatable plot
    plot (a, b, c, d) {
        // Lines can be plotted with 4 arguments
        if (arguments.length === 4) return this.plot([
            a,
            b,
            c,
            d
        ]);
        if (this._tryRetarget("plot", a)) return this;
        const morpher = new $e4b50d36b79545e2$export$c8711ee424a4a619(this._stepper).type(this._element.MorphArray).to(a);
        this.queue(function() {
            morpher.from(this._element.array());
        }, function(pos) {
            this._element.plot(morpher.at(pos));
            return morpher.done();
        });
        this._rememberMorpher("plot", morpher);
        return this;
    },
    // Add leading method
    leading (value) {
        return this._queueNumber("leading", value);
    },
    // Add animatable viewbox
    viewbox (x, y, width, height) {
        return this._queueObject("viewbox", new $e4b50d36b79545e2$export$e71c4d32a2263218(x, y, width, height));
    },
    update (o) {
        if (typeof o !== "object") return this.update({
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        });
        if (o.opacity != null) this.attr("stop-opacity", o.opacity);
        if (o.color != null) this.attr("stop-color", o.color);
        if (o.offset != null) this.attr("offset", o.offset);
        return this;
    }
});
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$571ad3bcba5a0c45, {
    rx: $e4b50d36b79545e2$var$rx,
    ry: $e4b50d36b79545e2$var$ry,
    from: $e4b50d36b79545e2$var$from,
    to: $e4b50d36b79545e2$var$to
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$571ad3bcba5a0c45, "Runner");
class $e4b50d36b79545e2$export$e17b9c1182212c96 extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("svg", node), attrs);
        this.namespace();
    }
    defs() {
        if (!this.isRoot()) return this.root().defs();
        return $e4b50d36b79545e2$export$62c9251e71806cd(this.node.querySelector("defs")) || this.put(new $e4b50d36b79545e2$export$b2bdceae9588b42d());
    }
    isRoot() {
        return !this.node.parentNode || !(this.node.parentNode instanceof $e4b50d36b79545e2$var$globals.window.SVGElement) && this.node.parentNode.nodeName !== "#document-fragment";
    }
    namespace() {
        if (!this.isRoot()) return this.root().namespace();
        return this.attr({
            xmlns: $e4b50d36b79545e2$var$svg,
            version: "1.1"
        }).attr("xmlns:xlink", $e4b50d36b79545e2$var$xlink, $e4b50d36b79545e2$var$xmlns).attr("xmlns:svgjs", $e4b50d36b79545e2$var$svgjs, $e4b50d36b79545e2$var$xmlns);
    }
    removeNamespace() {
        return this.attr({
            xmlns: null,
            version: null
        }).attr("xmlns:xlink", null, $e4b50d36b79545e2$var$xmlns).attr("xmlns:svgjs", null, $e4b50d36b79545e2$var$xmlns);
    }
    // If not, call root() from this element
    root() {
        if (this.isRoot()) return this;
        return super.root();
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create nested svg document
        nested: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function() {
            return this.put(new $e4b50d36b79545e2$export$e17b9c1182212c96());
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$e17b9c1182212c96, "Svg", true);
class $e4b50d36b79545e2$export$3e25e887b7a5b37b extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("symbol", node), attrs);
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        symbol: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function() {
            return this.put(new $e4b50d36b79545e2$export$3e25e887b7a5b37b());
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$3e25e887b7a5b37b, "Symbol");
function $e4b50d36b79545e2$var$plain(text) {
    // clear if build mode is disabled
    if (this._build === false) this.clear();
     // create text node
    this.node.appendChild($e4b50d36b79545e2$var$globals.document.createTextNode(text));
    return this;
} // Get length of text element
function $e4b50d36b79545e2$var$length() {
    return this.node.getComputedTextLength();
} // Move over x-axis
// Text is moved by its bounding box
// text-anchor does NOT matter
function $e4b50d36b79545e2$var$x$1(x, box = this.bbox()) {
    if (x == null) return box.x;
    return this.attr("x", this.attr("x") + x - box.x);
} // Move over y-axis
function $e4b50d36b79545e2$var$y$1(y, box = this.bbox()) {
    if (y == null) return box.y;
    return this.attr("y", this.attr("y") + y - box.y);
}
function $e4b50d36b79545e2$var$move$1(x, y, box = this.bbox()) {
    return this.x(x, box).y(y, box);
} // Move center over x-axis
function $e4b50d36b79545e2$var$cx(x, box = this.bbox()) {
    if (x == null) return box.cx;
    return this.attr("x", this.attr("x") + x - box.cx);
} // Move center over y-axis
function $e4b50d36b79545e2$var$cy(y, box = this.bbox()) {
    if (y == null) return box.cy;
    return this.attr("y", this.attr("y") + y - box.cy);
}
function $e4b50d36b79545e2$var$center(x, y, box = this.bbox()) {
    return this.cx(x, box).cy(y, box);
}
function $e4b50d36b79545e2$var$ax(x) {
    return this.attr("x", x);
}
function $e4b50d36b79545e2$var$ay(y) {
    return this.attr("y", y);
}
function $e4b50d36b79545e2$var$amove(x, y) {
    return this.ax(x).ay(y);
} // Enable / disable build mode
function $e4b50d36b79545e2$var$build(build) {
    this._build = !!build;
    return this;
}
var $e4b50d36b79545e2$var$textable = {
    __proto__: null,
    plain: $e4b50d36b79545e2$var$plain,
    length: $e4b50d36b79545e2$var$length,
    x: $e4b50d36b79545e2$var$x$1,
    y: $e4b50d36b79545e2$var$y$1,
    move: $e4b50d36b79545e2$var$move$1,
    cx: $e4b50d36b79545e2$var$cx,
    cy: $e4b50d36b79545e2$var$cy,
    center: $e4b50d36b79545e2$var$center,
    ax: $e4b50d36b79545e2$var$ax,
    ay: $e4b50d36b79545e2$var$ay,
    amove: $e4b50d36b79545e2$var$amove,
    build: $e4b50d36b79545e2$var$build
};
class $e4b50d36b79545e2$export$5f1af8db9871e1d6 extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("text", node), attrs);
        this.dom.leading = new $e4b50d36b79545e2$export$fffa67e515d04022(1.3); // store leading value for rebuilding
        this._rebuild = true; // enable automatic updating of dy values
        this._build = false; // disable build mode for adding multiple lines
    }
    leading(value) {
        // act as getter
        if (value == null) return this.dom.leading;
         // act as setter
        this.dom.leading = new $e4b50d36b79545e2$export$fffa67e515d04022(value);
        return this.rebuild();
    }
    rebuild(rebuild) {
        // store new rebuild flag if given
        if (typeof rebuild === "boolean") this._rebuild = rebuild;
         // define position of all lines
        if (this._rebuild) {
            const self = this;
            let blankLineOffset = 0;
            const leading = this.dom.leading;
            this.each(function(i) {
                const fontSize = $e4b50d36b79545e2$var$globals.window.getComputedStyle(this.node).getPropertyValue("font-size");
                const dy = leading * new $e4b50d36b79545e2$export$fffa67e515d04022(fontSize);
                if (this.dom.newLined) {
                    this.attr("x", self.attr("x"));
                    if (this.text() === "\n") blankLineOffset += dy;
                    else {
                        this.attr("dy", i ? dy + blankLineOffset : 0);
                        blankLineOffset = 0;
                    }
                }
            });
            this.fire("rebuild");
        }
        return this;
    }
    setData(o) {
        this.dom = o;
        this.dom.leading = new $e4b50d36b79545e2$export$fffa67e515d04022(o.leading || 1.3);
        return this;
    }
    text(text) {
        // act as getter
        if (text === undefined) {
            const children = this.node.childNodes;
            let firstLine = 0;
            text = "";
            for(let i = 0, len = children.length; i < len; ++i){
                // skip textPaths - they are no lines
                if (children[i].nodeName === "textPath") {
                    if (i === 0) firstLine = 1;
                    continue;
                } // add newline if its not the first child and newLined is set to true
                if (i !== firstLine && children[i].nodeType !== 3 && $e4b50d36b79545e2$export$62c9251e71806cd(children[i]).dom.newLined === true) text += "\n";
                 // add content of this node
                text += children[i].textContent;
            }
            return text;
        } // remove existing content
        this.clear().build(true);
        if (typeof text === "function") // call block
        text.call(this, this);
        else {
            // store text and make sure text is not blank
            text = (text + "").split("\n"); // build new lines
            for(let j = 0, jl = text.length; j < jl; j++)this.newLine(text[j]);
        } // disable build mode and rebuild lines
        return this.build(false).rebuild();
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$5f1af8db9871e1d6, $e4b50d36b79545e2$var$textable);
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create text element
        text: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(text = "") {
            return this.put(new $e4b50d36b79545e2$export$5f1af8db9871e1d6()).text(text);
        }),
        // Create plain text element
        plain: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(text = "") {
            return this.put(new $e4b50d36b79545e2$export$5f1af8db9871e1d6()).plain(text);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$5f1af8db9871e1d6, "Text");
class $e4b50d36b79545e2$export$3f943b6ddddb1a7d extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("tspan", node), attrs);
        this._build = false; // disable build mode for adding multiple lines
    }
    dx(dx) {
        return this.attr("dx", dx);
    }
    dy(dy) {
        return this.attr("dy", dy);
    }
    newLine() {
        // mark new line
        this.dom.newLined = true; // fetch parent
        const text = this.parent(); // early return in case we are not in a text element
        if (!(text instanceof $e4b50d36b79545e2$export$5f1af8db9871e1d6)) return this;
        const i = text.index(this);
        const fontSize = $e4b50d36b79545e2$var$globals.window.getComputedStyle(this.node).getPropertyValue("font-size");
        const dy = text.dom.leading * new $e4b50d36b79545e2$export$fffa67e515d04022(fontSize); // apply new position
        return this.dy(i ? dy : 0).attr("x", text.x());
    }
    text(text) {
        if (text == null) return this.node.textContent + (this.dom.newLined ? "\n" : "");
        if (typeof text === "function") {
            this.clear().build(true);
            text.call(this, this);
            this.build(false);
        } else this.plain(text);
        return this;
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$3f943b6ddddb1a7d, $e4b50d36b79545e2$var$textable);
$e4b50d36b79545e2$var$registerMethods({
    Tspan: {
        tspan: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(text = "") {
            const tspan = new $e4b50d36b79545e2$export$3f943b6ddddb1a7d(); // clear if build mode is disabled
            if (!this._build) this.clear();
             // add new tspan
            return this.put(tspan).text(text);
        })
    },
    Text: {
        newLine: function(text = "") {
            return this.tspan(text).newLine();
        }
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$3f943b6ddddb1a7d, "Tspan");
class $e4b50d36b79545e2$export$c89a927ffc67e6fa extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("circle", node), attrs);
    }
    radius(r) {
        return this.attr("r", r);
    }
    rx(rx) {
        return this.attr("r", rx);
    }
    ry(ry) {
        return this.rx(ry);
    }
    size(size) {
        return this.radius(new $e4b50d36b79545e2$export$fffa67e515d04022(size).divide(2));
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$c89a927ffc67e6fa, {
    x: $e4b50d36b79545e2$var$x$3,
    y: $e4b50d36b79545e2$var$y$3,
    cx: $e4b50d36b79545e2$var$cx$1,
    cy: $e4b50d36b79545e2$var$cy$1,
    width: $e4b50d36b79545e2$var$width$2,
    height: $e4b50d36b79545e2$var$height$2
});
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create circle element
        circle: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(size = 0) {
            return this.put(new $e4b50d36b79545e2$export$c89a927ffc67e6fa()).size(size).move(0, 0);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$c89a927ffc67e6fa, "Circle");
class $e4b50d36b79545e2$export$407988c5e190497b extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("clipPath", node), attrs);
    }
    remove() {
        // unclip all targets
        this.targets().forEach(function(el) {
            el.unclip();
        }); // remove clipPath from parent
        return super.remove();
    }
    targets() {
        return $e4b50d36b79545e2$export$71aa6c912b956294("svg [clip-path*=" + this.id() + "]");
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create clipping element
        clip: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function() {
            return this.defs().put(new $e4b50d36b79545e2$export$407988c5e190497b());
        })
    },
    Element: {
        // Distribute clipPath to svg element
        clipper () {
            return this.reference("clip-path");
        },
        clipWith (element) {
            // use given clip or create a new one
            const clipper = element instanceof $e4b50d36b79545e2$export$407988c5e190497b ? element : this.parent().clip().add(element); // apply mask
            return this.attr("clip-path", "url(#" + clipper.id() + ")");
        },
        // Unclip element
        unclip () {
            return this.attr("clip-path", null);
        }
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$407988c5e190497b, "ClipPath");
class $e4b50d36b79545e2$export$86f236f5872f181 extends $e4b50d36b79545e2$export$db77ccec0bb4ccac {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("foreignObject", node), attrs);
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        foreignObject: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(width, height) {
            return this.put(new $e4b50d36b79545e2$export$86f236f5872f181()).size(width, height);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$86f236f5872f181, "ForeignObject");
function $e4b50d36b79545e2$var$dmove(dx, dy) {
    this.children().forEach((child, i)=>{
        let bbox; // We have to wrap this for elements that dont have a bbox
        // e.g. title and other descriptive elements
        try {
            // Get the childs bbox
            bbox = child.bbox();
        } catch (e) {
            return;
        } // Get childs matrix
        const m = new $e4b50d36b79545e2$export$5b12bf1653c0dd85(child); // Translate childs matrix by amount and
        // transform it back into parents space
        const matrix = m.translate(dx, dy).transform(m.inverse()); // Calculate new x and y from old box
        const p = new $e4b50d36b79545e2$export$baf26146a414f24a(bbox.x, bbox.y).transform(matrix); // Move element
        child.move(p.x, p.y);
    });
    return this;
}
function $e4b50d36b79545e2$var$dx(dx) {
    return this.dmove(dx, 0);
}
function $e4b50d36b79545e2$var$dy(dy) {
    return this.dmove(0, dy);
}
function $e4b50d36b79545e2$var$height(height, box = this.bbox()) {
    if (height == null) return box.height;
    return this.size(box.width, height, box);
}
function $e4b50d36b79545e2$var$move(x = 0, y = 0, box = this.bbox()) {
    const dx = x - box.x;
    const dy = y - box.y;
    return this.dmove(dx, dy);
}
function $e4b50d36b79545e2$var$size(width, height, box = this.bbox()) {
    const p = $e4b50d36b79545e2$var$proportionalSize(this, width, height, box);
    const scaleX = p.width / box.width;
    const scaleY = p.height / box.height;
    this.children().forEach((child, i)=>{
        const o = new $e4b50d36b79545e2$export$baf26146a414f24a(box).transform(new $e4b50d36b79545e2$export$5b12bf1653c0dd85(child).inverse());
        child.scale(scaleX, scaleY, o.x, o.y);
    });
    return this;
}
function $e4b50d36b79545e2$var$width(width, box = this.bbox()) {
    if (width == null) return box.width;
    return this.size(width, box.height, box);
}
function $e4b50d36b79545e2$var$x(x, box = this.bbox()) {
    if (x == null) return box.x;
    return this.move(x, box.y, box);
}
function $e4b50d36b79545e2$var$y(y, box = this.bbox()) {
    if (y == null) return box.y;
    return this.move(box.x, y, box);
}
var $e4b50d36b79545e2$var$containerGeometry = {
    __proto__: null,
    dmove: $e4b50d36b79545e2$var$dmove,
    dx: $e4b50d36b79545e2$var$dx,
    dy: $e4b50d36b79545e2$var$dy,
    height: $e4b50d36b79545e2$var$height,
    move: $e4b50d36b79545e2$var$move,
    size: $e4b50d36b79545e2$var$size,
    width: $e4b50d36b79545e2$var$width,
    x: $e4b50d36b79545e2$var$x,
    y: $e4b50d36b79545e2$var$y
};
class $e4b50d36b79545e2$export$2329c99376c9d0a4 extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("g", node), attrs);
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$2329c99376c9d0a4, $e4b50d36b79545e2$var$containerGeometry);
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a group element
        group: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function() {
            return this.put(new $e4b50d36b79545e2$export$2329c99376c9d0a4());
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$2329c99376c9d0a4, "G");
class $e4b50d36b79545e2$export$ebd11618f299a286 extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("a", node), attrs);
    }
    target(target) {
        return this.attr("target", target);
    }
    to(url) {
        return this.attr("href", url, $e4b50d36b79545e2$var$xlink);
    }
}
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$ebd11618f299a286, $e4b50d36b79545e2$var$containerGeometry);
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a hyperlink element
        link: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(url) {
            return this.put(new $e4b50d36b79545e2$export$ebd11618f299a286()).to(url);
        })
    },
    Element: {
        unlink () {
            const link = this.linker();
            if (!link) return this;
            const parent = link.parent();
            if (!parent) return this.remove();
            const index = parent.index(link);
            parent.add(this, index);
            link.remove();
            return this;
        },
        linkTo (url) {
            // reuse old link if possible
            let link = this.linker();
            if (!link) {
                link = new $e4b50d36b79545e2$export$ebd11618f299a286();
                this.wrap(link);
            }
            if (typeof url === "function") url.call(link, link);
            else link.to(url);
            return this;
        },
        linker () {
            const link = this.parent();
            if (link && link.node.nodeName.toLowerCase() === "a") return link;
            return null;
        }
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$ebd11618f299a286, "A");
class $e4b50d36b79545e2$export$991dcf7284de63d extends $e4b50d36b79545e2$export$42a852a2b6b56249 {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("mask", node), attrs);
    }
    remove() {
        // unmask all targets
        this.targets().forEach(function(el) {
            el.unmask();
        }); // remove mask from parent
        return super.remove();
    }
    targets() {
        return $e4b50d36b79545e2$export$71aa6c912b956294("svg [mask*=" + this.id() + "]");
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        mask: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function() {
            return this.defs().put(new $e4b50d36b79545e2$export$991dcf7284de63d());
        })
    },
    Element: {
        // Distribute mask to svg element
        masker () {
            return this.reference("mask");
        },
        maskWith (element) {
            // use given mask or create a new one
            const masker = element instanceof $e4b50d36b79545e2$export$991dcf7284de63d ? element : this.parent().mask().add(element); // apply mask
            return this.attr("mask", "url(#" + masker.id() + ")");
        },
        // Unmask element
        unmask () {
            return this.attr("mask", null);
        }
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$991dcf7284de63d, "Mask");
class $e4b50d36b79545e2$export$ac4156b3386a7c70 extends $e4b50d36b79545e2$export$db77ccec0bb4ccac {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("stop", node), attrs);
    }
    update(o) {
        if (typeof o === "number" || o instanceof $e4b50d36b79545e2$export$fffa67e515d04022) o = {
            offset: arguments[0],
            color: arguments[1],
            opacity: arguments[2]
        };
         // set attributes
        if (o.opacity != null) this.attr("stop-opacity", o.opacity);
        if (o.color != null) this.attr("stop-color", o.color);
        if (o.offset != null) this.attr("offset", new $e4b50d36b79545e2$export$fffa67e515d04022(o.offset));
        return this;
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Gradient: {
        // Add a color stop
        stop: function(offset, color, opacity) {
            return this.put(new $e4b50d36b79545e2$export$ac4156b3386a7c70()).update(offset, color, opacity);
        }
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$ac4156b3386a7c70, "Stop");
function $e4b50d36b79545e2$var$cssRule(selector, rule) {
    if (!selector) return "";
    if (!rule) return selector;
    let ret = selector + "{";
    for(const i in rule)ret += $e4b50d36b79545e2$var$unCamelCase(i) + ":" + rule[i] + ";";
    ret += "}";
    return ret;
}
class $e4b50d36b79545e2$export$d9e45bc13d335801 extends $e4b50d36b79545e2$export$db77ccec0bb4ccac {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("style", node), attrs);
    }
    addText(w = "") {
        this.node.textContent += w;
        return this;
    }
    font(name, src, params = {}) {
        return this.rule("@font-face", {
            fontFamily: name,
            src: src,
            ...params
        });
    }
    rule(selector, obj) {
        return this.addText($e4b50d36b79545e2$var$cssRule(selector, obj));
    }
}
$e4b50d36b79545e2$var$registerMethods("Dom", {
    style (selector, obj) {
        return this.put(new $e4b50d36b79545e2$export$d9e45bc13d335801()).rule(selector, obj);
    },
    fontface (name, src, params) {
        return this.put(new $e4b50d36b79545e2$export$d9e45bc13d335801()).font(name, src, params);
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$d9e45bc13d335801, "Style");
class $e4b50d36b79545e2$export$f7e34a95cc06fac7 extends $e4b50d36b79545e2$export$5f1af8db9871e1d6 {
    // Initialize node
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("textPath", node), attrs);
    }
    array() {
        const track = this.track();
        return track ? track.array() : null;
    }
    plot(d) {
        const track = this.track();
        let pathArray = null;
        if (track) pathArray = track.plot(d);
        return d == null ? pathArray : this;
    }
    track() {
        return this.reference("href");
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        textPath: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(text, path) {
            // Convert text to instance if needed
            if (!(text instanceof $e4b50d36b79545e2$export$5f1af8db9871e1d6)) text = this.text(text);
            return text.path(path);
        })
    },
    Text: {
        // Create path for text to run on
        path: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(track, importNodes = true) {
            const textPath = new $e4b50d36b79545e2$export$f7e34a95cc06fac7(); // if track is a path, reuse it
            if (!(track instanceof $e4b50d36b79545e2$export$4b2950bdac9b6ee9)) // create path element
            track = this.defs().path(track);
             // link textPath to path and add content
            textPath.attr("href", "#" + track, $e4b50d36b79545e2$var$xlink); // Transplant all nodes from text to textPath
            let node;
            if (importNodes) while(node = this.node.firstChild)textPath.node.appendChild(node);
             // add textPath element as child node and return textPath
            return this.put(textPath);
        }),
        // Get the textPath children
        textPath () {
            return this.findOne("textPath");
        }
    },
    Path: {
        // creates a textPath from this path
        text: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(text) {
            // Convert text to instance if needed
            if (!(text instanceof $e4b50d36b79545e2$export$5f1af8db9871e1d6)) text = new $e4b50d36b79545e2$export$5f1af8db9871e1d6().addTo(this.parent()).text(text);
             // Create textPath from text and path and return
            return text.path(this);
        }),
        targets () {
            return $e4b50d36b79545e2$export$71aa6c912b956294("svg textPath").filter((node)=>{
                return (node.attr("href") || "").includes(this.id());
            }); // Does not work in IE11. Use when IE support is dropped
        // return baseFind('svg textPath[*|href*=' + this.id() + ']')
        }
    }
});
$e4b50d36b79545e2$export$f7e34a95cc06fac7.prototype.MorphArray = $e4b50d36b79545e2$export$dbd6a88fc4ee1d79;
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$f7e34a95cc06fac7, "TextPath");
class $e4b50d36b79545e2$export$2973c9696e76e472 extends $e4b50d36b79545e2$export$6428a7f2611ef1fa {
    constructor(node, attrs = node){
        super($e4b50d36b79545e2$export$5b825b8c91fb12a7("use", node), attrs);
    }
    use(element, file) {
        // Set lined element
        return this.attr("href", (file || "") + "#" + element, $e4b50d36b79545e2$var$xlink);
    }
}
$e4b50d36b79545e2$var$registerMethods({
    Container: {
        // Create a use element
        use: $e4b50d36b79545e2$export$26f3b51f2e19e8f9(function(element, file) {
            return this.put(new $e4b50d36b79545e2$export$2973c9696e76e472()).use(element, file);
        })
    }
});
$e4b50d36b79545e2$export$6503ec6e8aabbaf($e4b50d36b79545e2$export$2973c9696e76e472, "Use");
/* Optional Modules */ const $e4b50d36b79545e2$export$13f4b12aafeba5d6 = $e4b50d36b79545e2$export$60fbc25e7b928117;
$e4b50d36b79545e2$export$8b58be045bf06082([
    $e4b50d36b79545e2$export$e17b9c1182212c96,
    $e4b50d36b79545e2$export$3e25e887b7a5b37b,
    $e4b50d36b79545e2$export$3e431a229df88919,
    $e4b50d36b79545e2$export$47606a6ae3eaed8e,
    $e4b50d36b79545e2$export$e98856a975cab58e
], $e4b50d36b79545e2$var$getMethodsFor("viewbox"));
$e4b50d36b79545e2$export$8b58be045bf06082([
    $e4b50d36b79545e2$export$17d680238e50603e,
    $e4b50d36b79545e2$export$79f3ee03e63e7073,
    $e4b50d36b79545e2$export$7d31b617c820d435,
    $e4b50d36b79545e2$export$4b2950bdac9b6ee9
], $e4b50d36b79545e2$var$getMethodsFor("marker"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$5f1af8db9871e1d6, $e4b50d36b79545e2$var$getMethodsFor("Text"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$4b2950bdac9b6ee9, $e4b50d36b79545e2$var$getMethodsFor("Path"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$b2bdceae9588b42d, $e4b50d36b79545e2$var$getMethodsFor("Defs"));
$e4b50d36b79545e2$export$8b58be045bf06082([
    $e4b50d36b79545e2$export$5f1af8db9871e1d6,
    $e4b50d36b79545e2$export$3f943b6ddddb1a7d
], $e4b50d36b79545e2$var$getMethodsFor("Tspan"));
$e4b50d36b79545e2$export$8b58be045bf06082([
    $e4b50d36b79545e2$export$c79fc6492f3af13d,
    $e4b50d36b79545e2$export$80b0269ab108fa11,
    $e4b50d36b79545e2$export$3d3dd8f63ff0f876,
    $e4b50d36b79545e2$export$571ad3bcba5a0c45
], $e4b50d36b79545e2$var$getMethodsFor("radius"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$648eec84020a2b10, $e4b50d36b79545e2$var$getMethodsFor("EventTarget"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$1e2eb70c93855705, $e4b50d36b79545e2$var$getMethodsFor("Dom"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$db77ccec0bb4ccac, $e4b50d36b79545e2$var$getMethodsFor("Element"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$6428a7f2611ef1fa, $e4b50d36b79545e2$var$getMethodsFor("Shape"));
$e4b50d36b79545e2$export$8b58be045bf06082([
    $e4b50d36b79545e2$export$42a852a2b6b56249,
    $e4b50d36b79545e2$export$ffb0004e005737fa
], $e4b50d36b79545e2$var$getMethodsFor("Container"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$3d3dd8f63ff0f876, $e4b50d36b79545e2$var$getMethodsFor("Gradient"));
$e4b50d36b79545e2$export$8b58be045bf06082($e4b50d36b79545e2$export$571ad3bcba5a0c45, $e4b50d36b79545e2$var$getMethodsFor("Runner"));
$e4b50d36b79545e2$export$54c2e3dc7acea9f5.extend($e4b50d36b79545e2$var$getMethodNames());
$e4b50d36b79545e2$export$60837f2ca821f102([
    $e4b50d36b79545e2$export$fffa67e515d04022,
    $e4b50d36b79545e2$export$892596cec99bc70e,
    $e4b50d36b79545e2$export$e71c4d32a2263218,
    $e4b50d36b79545e2$export$5b12bf1653c0dd85,
    $e4b50d36b79545e2$export$c4be6576ca6fe4aa,
    $e4b50d36b79545e2$export$e834181a854d3988,
    $e4b50d36b79545e2$export$dbd6a88fc4ee1d79,
    $e4b50d36b79545e2$export$baf26146a414f24a
]);
$e4b50d36b79545e2$export$a4089364a070cb60();


var $63618293c58b5f80$exports = {};
"use strict";
Object.defineProperty($63618293c58b5f80$exports, "__esModule", {
    value: true
});
function $63618293c58b5f80$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $63618293c58b5f80$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $63618293c58b5f80$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $63618293c58b5f80$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $63618293c58b5f80$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $63618293c58b5f80$var$_extends() {
    $63618293c58b5f80$var$_extends = Object.assign ? Object.assign.bind() : function(target) {
        for(var i = 1; i < arguments.length; i++){
            var source = arguments[i];
            for(var key in source)if (Object.prototype.hasOwnProperty.call(source, key)) target[key] = source[key];
        }
        return target;
    };
    return $63618293c58b5f80$var$_extends.apply(this, arguments);
}
function $63618293c58b5f80$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    $63618293c58b5f80$var$_setPrototypeOf(subClass, superClass);
}
function $63618293c58b5f80$var$_getPrototypeOf(o) {
    $63618293c58b5f80$var$_getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
        return o.__proto__ || Object.getPrototypeOf(o);
    };
    return $63618293c58b5f80$var$_getPrototypeOf(o);
}
function $63618293c58b5f80$var$_setPrototypeOf(o, p) {
    $63618293c58b5f80$var$_setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
        o.__proto__ = p;
        return o;
    };
    return $63618293c58b5f80$var$_setPrototypeOf(o, p);
}
function $63618293c58b5f80$var$_isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;
    try {
        Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function() {}));
        return true;
    } catch (e) {
        return false;
    }
}
function $63618293c58b5f80$var$_construct(Parent, args, Class) {
    if ($63618293c58b5f80$var$_isNativeReflectConstruct()) $63618293c58b5f80$var$_construct = Reflect.construct.bind();
    else $63618293c58b5f80$var$_construct = function _construct(Parent, args, Class) {
        var a = [
            null
        ];
        a.push.apply(a, args);
        var Constructor = Function.bind.apply(Parent, a);
        var instance = new Constructor();
        if (Class) $63618293c58b5f80$var$_setPrototypeOf(instance, Class.prototype);
        return instance;
    };
    return $63618293c58b5f80$var$_construct.apply(null, arguments);
}
function $63618293c58b5f80$var$_isNativeFunction(fn) {
    return Function.toString.call(fn).indexOf("[native code]") !== -1;
}
function $63618293c58b5f80$var$_wrapNativeSuper(Class) {
    var _cache = typeof Map === "function" ? new Map() : undefined;
    $63618293c58b5f80$var$_wrapNativeSuper = function _wrapNativeSuper(Class) {
        if (Class === null || !$63618293c58b5f80$var$_isNativeFunction(Class)) return Class;
        if (typeof Class !== "function") throw new TypeError("Super expression must either be null or a function");
        if (typeof _cache !== "undefined") {
            if (_cache.has(Class)) return _cache.get(Class);
            _cache.set(Class, Wrapper);
        }
        function Wrapper() {
            return $63618293c58b5f80$var$_construct(Class, arguments, $63618293c58b5f80$var$_getPrototypeOf(this).constructor);
        }
        Wrapper.prototype = Object.create(Class.prototype, {
            constructor: {
                value: Wrapper,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
        return $63618293c58b5f80$var$_setPrototypeOf(Wrapper, Class);
    };
    return $63618293c58b5f80$var$_wrapNativeSuper(Class);
}
function $63618293c58b5f80$var$_objectWithoutPropertiesLoose(source, excluded) {
    if (source == null) return {};
    var target = {};
    var sourceKeys = Object.keys(source);
    var key, i;
    for(i = 0; i < sourceKeys.length; i++){
        key = sourceKeys[i];
        if (excluded.indexOf(key) >= 0) continue;
        target[key] = source[key];
    }
    return target;
}
function $63618293c58b5f80$var$_unsupportedIterableToArray(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(o);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return $63618293c58b5f80$var$_arrayLikeToArray(o, minLen);
}
function $63618293c58b5f80$var$_arrayLikeToArray(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function $63618293c58b5f80$var$_createForOfIteratorHelperLoose(o, allowArrayLike) {
    var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"];
    if (it) return (it = it.call(o)).next.bind(it);
    if (Array.isArray(o) || (it = $63618293c58b5f80$var$_unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") {
        if (it) o = it;
        var i = 0;
        return function() {
            if (i >= o.length) return {
                done: true
            };
            return {
                done: false,
                value: o[i++]
            };
        };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function $63618293c58b5f80$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}
function $63618293c58b5f80$var$_toPropertyKey(arg) {
    var key = $63618293c58b5f80$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
// these aren't really private, but nor are they really useful to document
/**
 * @private
 */ var $63618293c58b5f80$var$LuxonError = /*#__PURE__*/ function(_Error) {
    $63618293c58b5f80$var$_inheritsLoose(LuxonError, _Error);
    function LuxonError() {
        return _Error.apply(this, arguments) || this;
    }
    return LuxonError;
}(/*#__PURE__*/ $63618293c58b5f80$var$_wrapNativeSuper(Error));
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDateTimeError = /*#__PURE__*/ function(_LuxonError) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDateTimeError, _LuxonError);
    function InvalidDateTimeError(reason) {
        return _LuxonError.call(this, "Invalid DateTime: " + reason.toMessage()) || this;
    }
    return InvalidDateTimeError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidIntervalError = /*#__PURE__*/ function(_LuxonError2) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidIntervalError, _LuxonError2);
    function InvalidIntervalError(reason) {
        return _LuxonError2.call(this, "Invalid Interval: " + reason.toMessage()) || this;
    }
    return InvalidIntervalError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidDurationError = /*#__PURE__*/ function(_LuxonError3) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidDurationError, _LuxonError3);
    function InvalidDurationError(reason) {
        return _LuxonError3.call(this, "Invalid Duration: " + reason.toMessage()) || this;
    }
    return InvalidDurationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ConflictingSpecificationError = /*#__PURE__*/ function(_LuxonError4) {
    $63618293c58b5f80$var$_inheritsLoose(ConflictingSpecificationError, _LuxonError4);
    function ConflictingSpecificationError() {
        return _LuxonError4.apply(this, arguments) || this;
    }
    return ConflictingSpecificationError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidUnitError = /*#__PURE__*/ function(_LuxonError5) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidUnitError, _LuxonError5);
    function InvalidUnitError(unit) {
        return _LuxonError5.call(this, "Invalid unit " + unit) || this;
    }
    return InvalidUnitError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$InvalidArgumentError = /*#__PURE__*/ function(_LuxonError6) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidArgumentError, _LuxonError6);
    function InvalidArgumentError() {
        return _LuxonError6.apply(this, arguments) || this;
    }
    return InvalidArgumentError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$ZoneIsAbstractError = /*#__PURE__*/ function(_LuxonError7) {
    $63618293c58b5f80$var$_inheritsLoose(ZoneIsAbstractError, _LuxonError7);
    function ZoneIsAbstractError() {
        return _LuxonError7.call(this, "Zone is an abstract class") || this;
    }
    return ZoneIsAbstractError;
}($63618293c58b5f80$var$LuxonError);
/**
 * @private
 */ var $63618293c58b5f80$var$n = "numeric", $63618293c58b5f80$var$s = "short", $63618293c58b5f80$var$l = "long";
var $63618293c58b5f80$var$DATE_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATE_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATE_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$TIME_24_SIMPLE = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SECONDS = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23"
};
var $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET = {
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    hourCycle: "h23",
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_SHORT = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$n,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$s,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$s,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n
};
var $63618293c58b5f80$var$DATETIME_FULL = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$s
};
var $63618293c58b5f80$var$DATETIME_HUGE = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
var $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS = {
    year: $63618293c58b5f80$var$n,
    month: $63618293c58b5f80$var$l,
    day: $63618293c58b5f80$var$n,
    weekday: $63618293c58b5f80$var$l,
    hour: $63618293c58b5f80$var$n,
    minute: $63618293c58b5f80$var$n,
    second: $63618293c58b5f80$var$n,
    timeZoneName: $63618293c58b5f80$var$l
};
/**
 * @interface
 */ var $63618293c58b5f80$var$Zone = /*#__PURE__*/ function() {
    function Zone() {}
    var _proto = Zone.prototype;
    /**
   * Returns the offset's common name (such as EST) at the specified timestamp
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the name
   * @param {Object} opts - Options to affect the format
   * @param {string} opts.format - What style of offset to return. Accepts 'long' or 'short'.
   * @param {string} opts.locale - What locale to return the offset name in.
   * @return {string}
   */ _proto.offsetName = function offsetName(ts, opts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Returns the offset's value as a string
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to get the offset
   * @param {string} format - What style of offset to return.
   *                          Accepts 'narrow', 'short', or 'techie'. Returning '+6', '+06:00', or '+0600' respectively
   * @return {string}
   */ ;
    _proto.formatOffset = function formatOffset(ts, format) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return the offset in minutes for this zone at the specified timestamp.
   * @abstract
   * @param {number} ts - Epoch milliseconds for which to compute the offset
   * @return {number}
   */ ;
    _proto.offset = function offset(ts) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is equal to another zone
   * @abstract
   * @param {Zone} otherZone - the zone to compare
   * @return {boolean}
   */ ;
    _proto.equals = function equals(otherZone) {
        throw new $63618293c58b5f80$var$ZoneIsAbstractError();
    } /**
   * Return whether this Zone is valid.
   * @abstract
   * @type {boolean}
   */ ;
    $63618293c58b5f80$var$_createClass(Zone, [
        {
            key: "type",
            get: /**
     * The type of zone
     * @abstract
     * @type {string}
     */ function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "name",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "ianaName",
            get: function get() {
                return this.name;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        },
        {
            key: "isValid",
            get: function get() {
                throw new $63618293c58b5f80$var$ZoneIsAbstractError();
            }
        }
    ]);
    return Zone;
}();
var $63618293c58b5f80$var$singleton$1 = null;
/**
 * Represents the local zone for this JavaScript environment.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$SystemZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(SystemZone, _Zone);
    function SystemZone() {
        return _Zone.apply(this, arguments) || this;
    }
    var _proto = SystemZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        return -new Date(ts).getTimezoneOffset();
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "system";
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(SystemZone, [
        {
            key: "type",
            get: /** @override **/ function get() {
                return "system";
            }
        },
        {
            key: "name",
            get: function get() {
                return new Intl.DateTimeFormat().resolvedOptions().timeZone;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "instance",
            get: /**
     * Get a singleton instance of the local zone
     * @return {SystemZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton$1 === null) $63618293c58b5f80$var$singleton$1 = new SystemZone();
                return $63618293c58b5f80$var$singleton$1;
            }
        }
    ]);
    return SystemZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$dtfCache = {};
function $63618293c58b5f80$var$makeDTF(zone) {
    if (!$63618293c58b5f80$var$dtfCache[zone]) $63618293c58b5f80$var$dtfCache[zone] = new Intl.DateTimeFormat("en-US", {
        hour12: false,
        timeZone: zone,
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit",
        second: "2-digit",
        era: "short"
    });
    return $63618293c58b5f80$var$dtfCache[zone];
}
var $63618293c58b5f80$var$typeToPos = {
    year: 0,
    month: 1,
    day: 2,
    era: 3,
    hour: 4,
    minute: 5,
    second: 6
};
function $63618293c58b5f80$var$hackyOffset(dtf, date) {
    var formatted = dtf.format(date).replace(/\u200E/g, ""), parsed = /(\d+)\/(\d+)\/(\d+) (AD|BC),? (\d+):(\d+):(\d+)/.exec(formatted), fMonth = parsed[1], fDay = parsed[2], fYear = parsed[3], fadOrBc = parsed[4], fHour = parsed[5], fMinute = parsed[6], fSecond = parsed[7];
    return [
        fYear,
        fMonth,
        fDay,
        fadOrBc,
        fHour,
        fMinute,
        fSecond
    ];
}
function $63618293c58b5f80$var$partsOffset(dtf, date) {
    var formatted = dtf.formatToParts(date);
    var filled = [];
    for(var i = 0; i < formatted.length; i++){
        var _formatted$i = formatted[i], type = _formatted$i.type, value = _formatted$i.value;
        var pos = $63618293c58b5f80$var$typeToPos[type];
        if (type === "era") filled[pos] = value;
        else if (!$63618293c58b5f80$var$isUndefined(pos)) filled[pos] = parseInt(value, 10);
    }
    return filled;
}
var $63618293c58b5f80$var$ianaZoneCache = {};
/**
 * A zone identified by an IANA identifier, like America/New_York
 * @implements {Zone}
 */ var $63618293c58b5f80$var$IANAZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(IANAZone, _Zone);
    /**
   * @param {string} name - Zone name
   * @return {IANAZone}
   */ IANAZone.create = function create(name) {
        if (!$63618293c58b5f80$var$ianaZoneCache[name]) $63618293c58b5f80$var$ianaZoneCache[name] = new IANAZone(name);
        return $63618293c58b5f80$var$ianaZoneCache[name];
    } /**
   * Reset local caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ ;
    IANAZone.resetCache = function resetCache() {
        $63618293c58b5f80$var$ianaZoneCache = {};
        $63618293c58b5f80$var$dtfCache = {};
    } /**
   * Returns whether the provided string is a valid specifier. This only checks the string's format, not that the specifier identifies a known zone; see isValidZone for that.
   * @param {string} s - The string to check validity on
   * @example IANAZone.isValidSpecifier("America/New_York") //=> true
   * @example IANAZone.isValidSpecifier("Sport~~blorp") //=> false
   * @deprecated This method returns false for some valid IANA names. Use isValidZone instead.
   * @return {boolean}
   */ ;
    IANAZone.isValidSpecifier = function isValidSpecifier(s) {
        return this.isValidZone(s);
    } /**
   * Returns whether the provided string identifies a real zone
   * @param {string} zone - The string to check
   * @example IANAZone.isValidZone("America/New_York") //=> true
   * @example IANAZone.isValidZone("Fantasia/Castle") //=> false
   * @example IANAZone.isValidZone("Sport~~blorp") //=> false
   * @return {boolean}
   */ ;
    IANAZone.isValidZone = function isValidZone(zone) {
        if (!zone) return false;
        try {
            new Intl.DateTimeFormat("en-US", {
                timeZone: zone
            }).format();
            return true;
        } catch (e) {
            return false;
        }
    };
    function IANAZone(name) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.zoneName = name;
        /** @private **/ _this.valid = IANAZone.isValidZone(name);
        return _this;
    }
    /** @override **/ var _proto = IANAZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName(ts, _ref) {
        var format = _ref.format, locale = _ref.locale;
        return $63618293c58b5f80$var$parseZoneInfo(ts, format, locale, this.name);
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.offset(ts), format);
    } /** @override **/ ;
    _proto.offset = function offset(ts) {
        var date = new Date(ts);
        if (isNaN(date)) return NaN;
        var dtf = $63618293c58b5f80$var$makeDTF(this.name);
        var _ref2 = dtf.formatToParts ? $63618293c58b5f80$var$partsOffset(dtf, date) : $63618293c58b5f80$var$hackyOffset(dtf, date), year = _ref2[0], month = _ref2[1], day = _ref2[2], adOrBc = _ref2[3], hour = _ref2[4], minute = _ref2[5], second = _ref2[6];
        if (adOrBc === "BC") year = -Math.abs(year) + 1;
        // because we're using hour12 and https://bugs.chromium.org/p/chromium/issues/detail?id=1025564&can=2&q=%2224%3A00%22%20datetimeformat
        var adjustedHour = hour === 24 ? 0 : hour;
        var asUTC = $63618293c58b5f80$var$objToLocalTS({
            year: year,
            month: month,
            day: day,
            hour: adjustedHour,
            minute: minute,
            second: second,
            millisecond: 0
        });
        var asTS = +date;
        var over = asTS % 1000;
        asTS -= over >= 0 ? over : 1000 + over;
        return (asUTC - asTS) / 60000;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "iana" && otherZone.name === this.name;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(IANAZone, [
        {
            key: "type",
            get: function get() {
                return "iana";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.valid;
            }
        }
    ]);
    return IANAZone;
}($63618293c58b5f80$var$Zone);
var $63618293c58b5f80$var$_excluded = [
    "base"
], $63618293c58b5f80$var$_excluded2 = [
    "padTo",
    "floor"
];
// todo - remap caching
var $63618293c58b5f80$var$intlLFCache = {};
function $63618293c58b5f80$var$getCachedLF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlLFCache[key];
    if (!dtf) {
        dtf = new Intl.ListFormat(locString, opts);
        $63618293c58b5f80$var$intlLFCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlDTCache = {};
function $63618293c58b5f80$var$getCachedDTF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var dtf = $63618293c58b5f80$var$intlDTCache[key];
    if (!dtf) {
        dtf = new Intl.DateTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlDTCache[key] = dtf;
    }
    return dtf;
}
var $63618293c58b5f80$var$intlNumCache = {};
function $63618293c58b5f80$var$getCachedINF(locString, opts) {
    if (opts === void 0) opts = {};
    var key = JSON.stringify([
        locString,
        opts
    ]);
    var inf = $63618293c58b5f80$var$intlNumCache[key];
    if (!inf) {
        inf = new Intl.NumberFormat(locString, opts);
        $63618293c58b5f80$var$intlNumCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$intlRelCache = {};
function $63618293c58b5f80$var$getCachedRTF(locString, opts) {
    if (opts === void 0) opts = {};
    var _opts = opts;
    _opts.base;
    var cacheKeyOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(_opts, $63618293c58b5f80$var$_excluded); // exclude `base` from the options
    var key = JSON.stringify([
        locString,
        cacheKeyOpts
    ]);
    var inf = $63618293c58b5f80$var$intlRelCache[key];
    if (!inf) {
        inf = new Intl.RelativeTimeFormat(locString, opts);
        $63618293c58b5f80$var$intlRelCache[key] = inf;
    }
    return inf;
}
var $63618293c58b5f80$var$sysLocaleCache = null;
function $63618293c58b5f80$var$systemLocale() {
    if ($63618293c58b5f80$var$sysLocaleCache) return $63618293c58b5f80$var$sysLocaleCache;
    else {
        $63618293c58b5f80$var$sysLocaleCache = new Intl.DateTimeFormat().resolvedOptions().locale;
        return $63618293c58b5f80$var$sysLocaleCache;
    }
}
function $63618293c58b5f80$var$parseLocaleString(localeStr) {
    // I really want to avoid writing a BCP 47 parser
    // see, e.g. https://github.com/wooorm/bcp-47
    // Instead, we'll do this:
    // a) if the string has no -u extensions, just leave it alone
    // b) if it does, use Intl to resolve everything
    // c) if Intl fails, try again without the -u
    // private subtags and unicode subtags have ordering requirements,
    // and we're not properly parsing this, so just strip out the
    // private ones if they exist.
    var xIndex = localeStr.indexOf("-x-");
    if (xIndex !== -1) localeStr = localeStr.substring(0, xIndex);
    var uIndex = localeStr.indexOf("-u-");
    if (uIndex === -1) return [
        localeStr
    ];
    else {
        var options;
        var selectedStr;
        try {
            options = $63618293c58b5f80$var$getCachedDTF(localeStr).resolvedOptions();
            selectedStr = localeStr;
        } catch (e) {
            var smaller = localeStr.substring(0, uIndex);
            options = $63618293c58b5f80$var$getCachedDTF(smaller).resolvedOptions();
            selectedStr = smaller;
        }
        var _options = options, numberingSystem = _options.numberingSystem, calendar = _options.calendar;
        return [
            selectedStr,
            numberingSystem,
            calendar
        ];
    }
}
function $63618293c58b5f80$var$intlConfigString(localeStr, numberingSystem, outputCalendar) {
    if (outputCalendar || numberingSystem) {
        if (!localeStr.includes("-u-")) localeStr += "-u";
        if (outputCalendar) localeStr += "-ca-" + outputCalendar;
        if (numberingSystem) localeStr += "-nu-" + numberingSystem;
        return localeStr;
    } else return localeStr;
}
function $63618293c58b5f80$var$mapMonths(f) {
    var ms = [];
    for(var i = 1; i <= 12; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2009, i, 1);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$mapWeekdays(f) {
    var ms = [];
    for(var i = 1; i <= 7; i++){
        var dt = $63618293c58b5f80$var$DateTime.utc(2016, 11, 13 + i);
        ms.push(f(dt));
    }
    return ms;
}
function $63618293c58b5f80$var$listStuff(loc, length, englishFn, intlFn) {
    var mode = loc.listingMode();
    if (mode === "error") return null;
    else if (mode === "en") return englishFn(length);
    else return intlFn(length);
}
function $63618293c58b5f80$var$supportsFastNumbers(loc) {
    if (loc.numberingSystem && loc.numberingSystem !== "latn") return false;
    else return loc.numberingSystem === "latn" || !loc.locale || loc.locale.startsWith("en") || new Intl.DateTimeFormat(loc.intl).resolvedOptions().numberingSystem === "latn";
}
/**
 * @private
 */ var $63618293c58b5f80$var$PolyNumberFormatter = /*#__PURE__*/ function() {
    function PolyNumberFormatter(intl, forceSimple, opts) {
        this.padTo = opts.padTo || 0;
        this.floor = opts.floor || false;
        opts.padTo;
        opts.floor;
        var otherOpts = $63618293c58b5f80$var$_objectWithoutPropertiesLoose(opts, $63618293c58b5f80$var$_excluded2);
        if (!forceSimple || Object.keys(otherOpts).length > 0) {
            var intlOpts = $63618293c58b5f80$var$_extends({
                useGrouping: false
            }, opts);
            if (opts.padTo > 0) intlOpts.minimumIntegerDigits = opts.padTo;
            this.inf = $63618293c58b5f80$var$getCachedINF(intl, intlOpts);
        }
    }
    var _proto = PolyNumberFormatter.prototype;
    _proto.format = function format(i) {
        if (this.inf) {
            var fixed = this.floor ? Math.floor(i) : i;
            return this.inf.format(fixed);
        } else {
            // to match the browser's numberformatter defaults
            var _fixed = this.floor ? Math.floor(i) : $63618293c58b5f80$var$roundTo(i, 3);
            return $63618293c58b5f80$var$padStart(_fixed, this.padTo);
        }
    };
    return PolyNumberFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyDateFormatter = /*#__PURE__*/ function() {
    function PolyDateFormatter(dt, intl, opts) {
        this.opts = opts;
        this.originalZone = undefined;
        var z = undefined;
        if (this.opts.timeZone) // Don't apply any workarounds if a timeZone is explicitly provided in opts
        this.dt = dt;
        else if (dt.zone.type === "fixed") {
            // UTC-8 or Etc/UTC-8 are not part of tzdata, only Etc/GMT+8 and the like.
            // That is why fixed-offset TZ is set to that unless it is:
            // 1. Representing offset 0 when UTC is used to maintain previous behavior and does not become GMT.
            // 2. Unsupported by the browser:
            //    - some do not support Etc/
            //    - < Etc/GMT-14, > Etc/GMT+12, and 30-minute or 45-minute offsets are not part of tzdata
            var gmtOffset = -1 * (dt.offset / 60);
            var offsetZ = gmtOffset >= 0 ? "Etc/GMT+" + gmtOffset : "Etc/GMT" + gmtOffset;
            if (dt.offset !== 0 && $63618293c58b5f80$var$IANAZone.create(offsetZ).valid) {
                z = offsetZ;
                this.dt = dt;
            } else {
                // Not all fixed-offset zones like Etc/+4:30 are present in tzdata so
                // we manually apply the offset and substitute the zone as needed.
                z = "UTC";
                this.dt = dt.offset === 0 ? dt : dt.setZone("UTC").plus({
                    minutes: dt.offset
                });
                this.originalZone = dt.zone;
            }
        } else if (dt.zone.type === "system") this.dt = dt;
        else if (dt.zone.type === "iana") {
            this.dt = dt;
            z = dt.zone.name;
        } else {
            // Custom zones can have any offset / offsetName so we just manually
            // apply the offset and substitute the zone as needed.
            z = "UTC";
            this.dt = dt.setZone("UTC").plus({
                minutes: dt.offset
            });
            this.originalZone = dt.zone;
        }
        var intlOpts = $63618293c58b5f80$var$_extends({}, this.opts);
        intlOpts.timeZone = intlOpts.timeZone || z;
        this.dtf = $63618293c58b5f80$var$getCachedDTF(intl, intlOpts);
    }
    var _proto2 = PolyDateFormatter.prototype;
    _proto2.format = function format() {
        if (this.originalZone) // If we have to substitute in the actual zone name, we have to use
        // formatToParts so that the timezone can be replaced.
        return this.formatToParts().map(function(_ref) {
            var value = _ref.value;
            return value;
        }).join("");
        return this.dtf.format(this.dt.toJSDate());
    };
    _proto2.formatToParts = function formatToParts() {
        var _this = this;
        var parts = this.dtf.formatToParts(this.dt.toJSDate());
        if (this.originalZone) return parts.map(function(part) {
            if (part.type === "timeZoneName") {
                var offsetName = _this.originalZone.offsetName(_this.dt.ts, {
                    locale: _this.dt.locale,
                    format: _this.opts.timeZoneName
                });
                return $63618293c58b5f80$var$_extends({}, part, {
                    value: offsetName
                });
            } else return part;
        });
        return parts;
    };
    _proto2.resolvedOptions = function resolvedOptions() {
        return this.dtf.resolvedOptions();
    };
    return PolyDateFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$PolyRelFormatter = /*#__PURE__*/ function() {
    function PolyRelFormatter(intl, isEnglish, opts) {
        this.opts = $63618293c58b5f80$var$_extends({
            style: "long"
        }, opts);
        if (!isEnglish && $63618293c58b5f80$var$hasRelative()) this.rtf = $63618293c58b5f80$var$getCachedRTF(intl, opts);
    }
    var _proto3 = PolyRelFormatter.prototype;
    _proto3.format = function format(count, unit) {
        if (this.rtf) return this.rtf.format(count, unit);
        else return $63618293c58b5f80$var$formatRelativeTime(unit, count, this.opts.numeric, this.opts.style !== "long");
    };
    _proto3.formatToParts = function formatToParts(count, unit) {
        if (this.rtf) return this.rtf.formatToParts(count, unit);
        else return [];
    };
    return PolyRelFormatter;
}();
/**
 * @private
 */ var $63618293c58b5f80$var$Locale = /*#__PURE__*/ function() {
    Locale.fromOpts = function fromOpts(opts) {
        return Locale.create(opts.locale, opts.numberingSystem, opts.outputCalendar, opts.defaultToEN);
    };
    Locale.create = function create(locale, numberingSystem, outputCalendar, defaultToEN) {
        if (defaultToEN === void 0) defaultToEN = false;
        var specifiedLocale = locale || $63618293c58b5f80$var$Settings.defaultLocale;
        // the system locale is useful for human readable strings but annoying for parsing/formatting known formats
        var localeR = specifiedLocale || (defaultToEN ? "en-US" : $63618293c58b5f80$var$systemLocale());
        var numberingSystemR = numberingSystem || $63618293c58b5f80$var$Settings.defaultNumberingSystem;
        var outputCalendarR = outputCalendar || $63618293c58b5f80$var$Settings.defaultOutputCalendar;
        return new Locale(localeR, numberingSystemR, outputCalendarR, specifiedLocale);
    };
    Locale.resetCache = function resetCache() {
        $63618293c58b5f80$var$sysLocaleCache = null;
        $63618293c58b5f80$var$intlDTCache = {};
        $63618293c58b5f80$var$intlNumCache = {};
        $63618293c58b5f80$var$intlRelCache = {};
    };
    Locale.fromObject = function fromObject(_temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, locale = _ref2.locale, numberingSystem = _ref2.numberingSystem, outputCalendar = _ref2.outputCalendar;
        return Locale.create(locale, numberingSystem, outputCalendar);
    };
    function Locale(locale, numbering, outputCalendar, specifiedLocale) {
        var _parseLocaleString = $63618293c58b5f80$var$parseLocaleString(locale), parsedLocale = _parseLocaleString[0], parsedNumberingSystem = _parseLocaleString[1], parsedOutputCalendar = _parseLocaleString[2];
        this.locale = parsedLocale;
        this.numberingSystem = numbering || parsedNumberingSystem || null;
        this.outputCalendar = outputCalendar || parsedOutputCalendar || null;
        this.intl = $63618293c58b5f80$var$intlConfigString(this.locale, this.numberingSystem, this.outputCalendar);
        this.weekdaysCache = {
            format: {},
            standalone: {}
        };
        this.monthsCache = {
            format: {},
            standalone: {}
        };
        this.meridiemCache = null;
        this.eraCache = {};
        this.specifiedLocale = specifiedLocale;
        this.fastNumbersCached = null;
    }
    var _proto4 = Locale.prototype;
    _proto4.listingMode = function listingMode() {
        var isActuallyEn = this.isEnglish();
        var hasNoWeirdness = (this.numberingSystem === null || this.numberingSystem === "latn") && (this.outputCalendar === null || this.outputCalendar === "gregory");
        return isActuallyEn && hasNoWeirdness ? "en" : "intl";
    };
    _proto4.clone = function clone(alts) {
        if (!alts || Object.getOwnPropertyNames(alts).length === 0) return this;
        else return Locale.create(alts.locale || this.specifiedLocale, alts.numberingSystem || this.numberingSystem, alts.outputCalendar || this.outputCalendar, alts.defaultToEN || false);
    };
    _proto4.redefaultToEN = function redefaultToEN(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: true
        }));
    };
    _proto4.redefaultToSystem = function redefaultToSystem(alts) {
        if (alts === void 0) alts = {};
        return this.clone($63618293c58b5f80$var$_extends({}, alts, {
            defaultToEN: false
        }));
    };
    _proto4.months = function months$1(length, format) {
        var _this2 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$months, function() {
            var intl = format ? {
                month: length,
                day: "numeric"
            } : {
                month: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this2.monthsCache[formatStr][length]) _this2.monthsCache[formatStr][length] = $63618293c58b5f80$var$mapMonths(function(dt) {
                return _this2.extract(dt, intl, "month");
            });
            return _this2.monthsCache[formatStr][length];
        });
    };
    _proto4.weekdays = function weekdays$1(length, format) {
        var _this3 = this;
        if (format === void 0) format = false;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$weekdays, function() {
            var intl = format ? {
                weekday: length,
                year: "numeric",
                month: "long",
                day: "numeric"
            } : {
                weekday: length
            }, formatStr = format ? "format" : "standalone";
            if (!_this3.weekdaysCache[formatStr][length]) _this3.weekdaysCache[formatStr][length] = $63618293c58b5f80$var$mapWeekdays(function(dt) {
                return _this3.extract(dt, intl, "weekday");
            });
            return _this3.weekdaysCache[formatStr][length];
        });
    };
    _proto4.meridiems = function meridiems$1() {
        var _this4 = this;
        return $63618293c58b5f80$var$listStuff(this, undefined, function() {
            return $63618293c58b5f80$var$meridiems;
        }, function() {
            // In theory there could be aribitrary day periods. We're gonna assume there are exactly two
            // for AM and PM. This is probably wrong, but it's makes parsing way easier.
            if (!_this4.meridiemCache) {
                var intl = {
                    hour: "numeric",
                    hourCycle: "h12"
                };
                _this4.meridiemCache = [
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 9),
                    $63618293c58b5f80$var$DateTime.utc(2016, 11, 13, 19)
                ].map(function(dt) {
                    return _this4.extract(dt, intl, "dayperiod");
                });
            }
            return _this4.meridiemCache;
        });
    };
    _proto4.eras = function eras$1(length) {
        var _this5 = this;
        return $63618293c58b5f80$var$listStuff(this, length, $63618293c58b5f80$var$eras, function() {
            var intl = {
                era: length
            };
            // This is problematic. Different calendars are going to define eras totally differently. What I need is the minimum set of dates
            // to definitely enumerate them.
            if (!_this5.eraCache[length]) _this5.eraCache[length] = [
                $63618293c58b5f80$var$DateTime.utc(-40, 1, 1),
                $63618293c58b5f80$var$DateTime.utc(2017, 1, 1)
            ].map(function(dt) {
                return _this5.extract(dt, intl, "era");
            });
            return _this5.eraCache[length];
        });
    };
    _proto4.extract = function extract(dt, intlOpts, field) {
        var df = this.dtFormatter(dt, intlOpts), results = df.formatToParts(), matching = results.find(function(m) {
            return m.type.toLowerCase() === field;
        });
        return matching ? matching.value : null;
    };
    _proto4.numberFormatter = function numberFormatter(opts) {
        if (opts === void 0) opts = {};
        // this forcesimple option is never used (the only caller short-circuits on it, but it seems safer to leave)
        // (in contrast, the rest of the condition is used heavily)
        return new $63618293c58b5f80$var$PolyNumberFormatter(this.intl, opts.forceSimple || this.fastNumbers, opts);
    };
    _proto4.dtFormatter = function dtFormatter(dt, intlOpts) {
        if (intlOpts === void 0) intlOpts = {};
        return new $63618293c58b5f80$var$PolyDateFormatter(dt, this.intl, intlOpts);
    };
    _proto4.relFormatter = function relFormatter(opts) {
        if (opts === void 0) opts = {};
        return new $63618293c58b5f80$var$PolyRelFormatter(this.intl, this.isEnglish(), opts);
    };
    _proto4.listFormatter = function listFormatter(opts) {
        if (opts === void 0) opts = {};
        return $63618293c58b5f80$var$getCachedLF(this.intl, opts);
    };
    _proto4.isEnglish = function isEnglish() {
        return this.locale === "en" || this.locale.toLowerCase() === "en-us" || new Intl.DateTimeFormat(this.intl).resolvedOptions().locale.startsWith("en-us");
    };
    _proto4.equals = function equals(other) {
        return this.locale === other.locale && this.numberingSystem === other.numberingSystem && this.outputCalendar === other.outputCalendar;
    };
    $63618293c58b5f80$var$_createClass(Locale, [
        {
            key: "fastNumbers",
            get: function get() {
                if (this.fastNumbersCached == null) this.fastNumbersCached = $63618293c58b5f80$var$supportsFastNumbers(this);
                return this.fastNumbersCached;
            }
        }
    ]);
    return Locale;
}();
var $63618293c58b5f80$var$singleton = null;
/**
 * A zone with a fixed offset (meaning no DST)
 * @implements {Zone}
 */ var $63618293c58b5f80$var$FixedOffsetZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(FixedOffsetZone, _Zone);
    /**
   * Get an instance with a specified offset
   * @param {number} offset - The offset in minutes
   * @return {FixedOffsetZone}
   */ FixedOffsetZone.instance = function instance(offset) {
        return offset === 0 ? FixedOffsetZone.utcInstance : new FixedOffsetZone(offset);
    } /**
   * Get an instance of FixedOffsetZone from a UTC offset string, like "UTC+6"
   * @param {string} s - The offset string to parse
   * @example FixedOffsetZone.parseSpecifier("UTC+6")
   * @example FixedOffsetZone.parseSpecifier("UTC+06")
   * @example FixedOffsetZone.parseSpecifier("UTC-6:00")
   * @return {FixedOffsetZone}
   */ ;
    FixedOffsetZone.parseSpecifier = function parseSpecifier(s) {
        if (s) {
            var r = s.match(/^utc(?:([+-]\d{1,2})(?::(\d{2}))?)?$/i);
            if (r) return new FixedOffsetZone($63618293c58b5f80$var$signedOffset(r[1], r[2]));
        }
        return null;
    };
    function FixedOffsetZone(offset) {
        var _this;
        _this = _Zone.call(this) || this;
        /** @private **/ _this.fixed = offset;
        return _this;
    }
    /** @override **/ var _proto = FixedOffsetZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return this.name;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset$1(ts, format) {
        return $63618293c58b5f80$var$formatOffset(this.fixed, format);
    } /** @override **/ ;
    /** @override **/ _proto.offset = function offset() {
        return this.fixed;
    } /** @override **/ ;
    _proto.equals = function equals(otherZone) {
        return otherZone.type === "fixed" && otherZone.fixed === this.fixed;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(FixedOffsetZone, [
        {
            key: "type",
            get: function get() {
                return "fixed";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.fixed === 0 ? "UTC" : "UTC" + $63618293c58b5f80$var$formatOffset(this.fixed, "narrow");
            }
        },
        {
            key: "ianaName",
            get: function get() {
                if (this.fixed === 0) return "Etc/UTC";
                else return "Etc/GMT" + $63618293c58b5f80$var$formatOffset(-this.fixed, "narrow");
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return true;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return true;
            }
        }
    ], [
        {
            key: "utcInstance",
            get: /**
     * Get a singleton instance of UTC
     * @return {FixedOffsetZone}
     */ function get() {
                if ($63618293c58b5f80$var$singleton === null) $63618293c58b5f80$var$singleton = new FixedOffsetZone(0);
                return $63618293c58b5f80$var$singleton;
            }
        }
    ]);
    return FixedOffsetZone;
}($63618293c58b5f80$var$Zone);
/**
 * A zone that failed to parse. You should never need to instantiate this.
 * @implements {Zone}
 */ var $63618293c58b5f80$var$InvalidZone = /*#__PURE__*/ function(_Zone) {
    $63618293c58b5f80$var$_inheritsLoose(InvalidZone, _Zone);
    function InvalidZone(zoneName) {
        var _this;
        _this = _Zone.call(this) || this;
        /**  @private */ _this.zoneName = zoneName;
        return _this;
    }
    /** @override **/ var _proto = InvalidZone.prototype;
    /** @override **/ _proto.offsetName = function offsetName() {
        return null;
    } /** @override **/ ;
    _proto.formatOffset = function formatOffset() {
        return "";
    } /** @override **/ ;
    _proto.offset = function offset() {
        return NaN;
    } /** @override **/ ;
    _proto.equals = function equals() {
        return false;
    } /** @override **/ ;
    $63618293c58b5f80$var$_createClass(InvalidZone, [
        {
            key: "type",
            get: function get() {
                return "invalid";
            }
        },
        {
            key: "name",
            get: function get() {
                return this.zoneName;
            }
        },
        {
            key: "isUniversal",
            get: function get() {
                return false;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return false;
            }
        }
    ]);
    return InvalidZone;
}($63618293c58b5f80$var$Zone);
/**
 * @private
 */ function $63618293c58b5f80$var$normalizeZone(input, defaultZone) {
    if ($63618293c58b5f80$var$isUndefined(input) || input === null) return defaultZone;
    else if (input instanceof $63618293c58b5f80$var$Zone) return input;
    else if ($63618293c58b5f80$var$isString(input)) {
        var lowered = input.toLowerCase();
        if (lowered === "default") return defaultZone;
        else if (lowered === "local" || lowered === "system") return $63618293c58b5f80$var$SystemZone.instance;
        else if (lowered === "utc" || lowered === "gmt") return $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        else return $63618293c58b5f80$var$FixedOffsetZone.parseSpecifier(lowered) || $63618293c58b5f80$var$IANAZone.create(input);
    } else if ($63618293c58b5f80$var$isNumber(input)) return $63618293c58b5f80$var$FixedOffsetZone.instance(input);
    else if (typeof input === "object" && "offset" in input && typeof input.offset === "function") // This is dumb, but the instanceof check above doesn't seem to really work
    // so we're duck checking it
    return input;
    else return new $63618293c58b5f80$var$InvalidZone(input);
}
var $63618293c58b5f80$var$now = function now() {
    return Date.now();
}, $63618293c58b5f80$var$defaultZone = "system", $63618293c58b5f80$var$defaultLocale = null, $63618293c58b5f80$var$defaultNumberingSystem = null, $63618293c58b5f80$var$defaultOutputCalendar = null, $63618293c58b5f80$var$twoDigitCutoffYear = 60, $63618293c58b5f80$var$throwOnInvalid;
/**
 * Settings contains static getters and setters that control Luxon's overall behavior. Luxon is a simple library with few options, but the ones it does have live here.
 */ var $63618293c58b5f80$var$Settings = /*#__PURE__*/ function() {
    function Settings() {}
    /**
   * Reset Luxon's global caches. Should only be necessary in testing scenarios.
   * @return {void}
   */ Settings.resetCaches = function resetCaches() {
        $63618293c58b5f80$var$Locale.resetCache();
        $63618293c58b5f80$var$IANAZone.resetCache();
    };
    $63618293c58b5f80$var$_createClass(Settings, null, [
        {
            key: "now",
            get: /**
     * Get the callback for returning the current timestamp.
     * @type {function}
     */ function get() {
                return $63618293c58b5f80$var$now;
            },
            set: function set(n) {
                $63618293c58b5f80$var$now = n;
            }
        },
        {
            key: "defaultZone",
            get: /**
     * Get the default time zone object currently used to create DateTimes. Does not affect existing instances.
     * The default value is the system's time zone (the one set on the machine that runs this code).
     * @type {Zone}
     */ function get() {
                return $63618293c58b5f80$var$normalizeZone($63618293c58b5f80$var$defaultZone, $63618293c58b5f80$var$SystemZone.instance);
            },
            set: function set(zone) {
                $63618293c58b5f80$var$defaultZone = zone;
            }
        },
        {
            key: "defaultLocale",
            get: function get() {
                return $63618293c58b5f80$var$defaultLocale;
            },
            set: function set(locale) {
                $63618293c58b5f80$var$defaultLocale = locale;
            }
        },
        {
            key: "defaultNumberingSystem",
            get: function get() {
                return $63618293c58b5f80$var$defaultNumberingSystem;
            },
            set: function set(numberingSystem) {
                $63618293c58b5f80$var$defaultNumberingSystem = numberingSystem;
            }
        },
        {
            key: "defaultOutputCalendar",
            get: function get() {
                return $63618293c58b5f80$var$defaultOutputCalendar;
            },
            set: function set(outputCalendar) {
                $63618293c58b5f80$var$defaultOutputCalendar = outputCalendar;
            }
        },
        {
            key: "twoDigitCutoffYear",
            get: function get() {
                return $63618293c58b5f80$var$twoDigitCutoffYear;
            },
            set: function set(cutoffYear) {
                $63618293c58b5f80$var$twoDigitCutoffYear = cutoffYear % 100;
            }
        },
        {
            key: "throwOnInvalid",
            get: function get() {
                return $63618293c58b5f80$var$throwOnInvalid;
            },
            set: function set(t) {
                $63618293c58b5f80$var$throwOnInvalid = t;
            }
        }
    ]);
    return Settings;
}();
/**
 * @private
 */ // TYPES
function $63618293c58b5f80$var$isUndefined(o) {
    return typeof o === "undefined";
}
function $63618293c58b5f80$var$isNumber(o) {
    return typeof o === "number";
}
function $63618293c58b5f80$var$isInteger(o) {
    return typeof o === "number" && o % 1 === 0;
}
function $63618293c58b5f80$var$isString(o) {
    return typeof o === "string";
}
function $63618293c58b5f80$var$isDate(o) {
    return Object.prototype.toString.call(o) === "[object Date]";
}
// CAPABILITIES
function $63618293c58b5f80$var$hasRelative() {
    try {
        return typeof Intl !== "undefined" && !!Intl.RelativeTimeFormat;
    } catch (e) {
        return false;
    }
}
// OBJECTS AND ARRAYS
function $63618293c58b5f80$var$maybeArray(thing) {
    return Array.isArray(thing) ? thing : [
        thing
    ];
}
function $63618293c58b5f80$var$bestBy(arr, by, compare) {
    if (arr.length === 0) return undefined;
    return arr.reduce(function(best, next) {
        var pair = [
            by(next),
            next
        ];
        if (!best) return pair;
        else if (compare(best[0], pair[0]) === best[0]) return best;
        else return pair;
    }, null)[1];
}
function $63618293c58b5f80$var$pick(obj, keys) {
    return keys.reduce(function(a, k) {
        a[k] = obj[k];
        return a;
    }, {});
}
function $63618293c58b5f80$var$hasOwnProperty(obj, prop) {
    return Object.prototype.hasOwnProperty.call(obj, prop);
}
// NUMBERS AND STRINGS
function $63618293c58b5f80$var$integerBetween(thing, bottom, top) {
    return $63618293c58b5f80$var$isInteger(thing) && thing >= bottom && thing <= top;
}
// x % n but takes the sign of n instead of x
function $63618293c58b5f80$var$floorMod(x, n) {
    return x - n * Math.floor(x / n);
}
function $63618293c58b5f80$var$padStart(input, n) {
    if (n === void 0) n = 2;
    var isNeg = input < 0;
    var padded;
    if (isNeg) padded = "-" + ("" + -input).padStart(n, "0");
    else padded = ("" + input).padStart(n, "0");
    return padded;
}
function $63618293c58b5f80$var$parseInteger(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseInt(string, 10);
}
function $63618293c58b5f80$var$parseFloating(string) {
    if ($63618293c58b5f80$var$isUndefined(string) || string === null || string === "") return undefined;
    else return parseFloat(string);
}
function $63618293c58b5f80$var$parseMillis(fraction) {
    // Return undefined (instead of 0) in these cases, where fraction is not set
    if ($63618293c58b5f80$var$isUndefined(fraction) || fraction === null || fraction === "") return undefined;
    else {
        var f = parseFloat("0." + fraction) * 1000;
        return Math.floor(f);
    }
}
function $63618293c58b5f80$var$roundTo(number, digits, towardZero) {
    if (towardZero === void 0) towardZero = false;
    var factor = Math.pow(10, digits), rounder = towardZero ? Math.trunc : Math.round;
    return rounder(number * factor) / factor;
}
// DATE BASICS
function $63618293c58b5f80$var$isLeapYear(year) {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
}
function $63618293c58b5f80$var$daysInYear(year) {
    return $63618293c58b5f80$var$isLeapYear(year) ? 366 : 365;
}
function $63618293c58b5f80$var$daysInMonth(year, month) {
    var modMonth = $63618293c58b5f80$var$floorMod(month - 1, 12) + 1, modYear = year + (month - modMonth) / 12;
    if (modMonth === 2) return $63618293c58b5f80$var$isLeapYear(modYear) ? 29 : 28;
    else return [
        31,
        null,
        31,
        30,
        31,
        30,
        31,
        31,
        30,
        31,
        30,
        31
    ][modMonth - 1];
}
// convert a calendar object to a local timestamp (epoch, but with the offset baked in)
function $63618293c58b5f80$var$objToLocalTS(obj) {
    var d = Date.UTC(obj.year, obj.month - 1, obj.day, obj.hour, obj.minute, obj.second, obj.millisecond);
    // for legacy reasons, years between 0 and 99 are interpreted as 19XX; revert that
    if (obj.year < 100 && obj.year >= 0) {
        d = new Date(d);
        // set the month and day again, this is necessary because year 2000 is a leap year, but year 100 is not
        // so if obj.year is in 99, but obj.day makes it roll over into year 100,
        // the calculations done by Date.UTC are using year 2000 - which is incorrect
        d.setUTCFullYear(obj.year, obj.month - 1, obj.day);
    }
    return +d;
}
function $63618293c58b5f80$var$weeksInWeekYear(weekYear) {
    var p1 = (weekYear + Math.floor(weekYear / 4) - Math.floor(weekYear / 100) + Math.floor(weekYear / 400)) % 7, last = weekYear - 1, p2 = (last + Math.floor(last / 4) - Math.floor(last / 100) + Math.floor(last / 400)) % 7;
    return p1 === 4 || p2 === 3 ? 53 : 52;
}
function $63618293c58b5f80$var$untruncateYear(year) {
    if (year > 99) return year;
    else return year > $63618293c58b5f80$var$Settings.twoDigitCutoffYear ? 1900 + year : 2000 + year;
}
// PARSING
function $63618293c58b5f80$var$parseZoneInfo(ts, offsetFormat, locale, timeZone) {
    if (timeZone === void 0) timeZone = null;
    var date = new Date(ts), intlOpts = {
        hourCycle: "h23",
        year: "numeric",
        month: "2-digit",
        day: "2-digit",
        hour: "2-digit",
        minute: "2-digit"
    };
    if (timeZone) intlOpts.timeZone = timeZone;
    var modified = $63618293c58b5f80$var$_extends({
        timeZoneName: offsetFormat
    }, intlOpts);
    var parsed = new Intl.DateTimeFormat(locale, modified).formatToParts(date).find(function(m) {
        return m.type.toLowerCase() === "timezonename";
    });
    return parsed ? parsed.value : null;
}
// signedOffset('-5', '30') -> -330
function $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr) {
    var offHour = parseInt(offHourStr, 10);
    // don't || this because we want to preserve -0
    if (Number.isNaN(offHour)) offHour = 0;
    var offMin = parseInt(offMinuteStr, 10) || 0, offMinSigned = offHour < 0 || Object.is(offHour, -0) ? -offMin : offMin;
    return offHour * 60 + offMinSigned;
}
// COERCION
function $63618293c58b5f80$var$asNumber(value) {
    var numericValue = Number(value);
    if (typeof value === "boolean" || value === "" || Number.isNaN(numericValue)) throw new $63618293c58b5f80$var$InvalidArgumentError("Invalid unit value " + value);
    return numericValue;
}
function $63618293c58b5f80$var$normalizeObject(obj, normalizer) {
    var normalized = {};
    for(var u in obj)if ($63618293c58b5f80$var$hasOwnProperty(obj, u)) {
        var v = obj[u];
        if (v === undefined || v === null) continue;
        normalized[normalizer(u)] = $63618293c58b5f80$var$asNumber(v);
    }
    return normalized;
}
function $63618293c58b5f80$var$formatOffset(offset, format) {
    var hours = Math.trunc(Math.abs(offset / 60)), minutes = Math.trunc(Math.abs(offset % 60)), sign = offset >= 0 ? "+" : "-";
    switch(format){
        case "short":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + ":" + $63618293c58b5f80$var$padStart(minutes, 2);
        case "narrow":
            return "" + sign + hours + (minutes > 0 ? ":" + minutes : "");
        case "techie":
            return "" + sign + $63618293c58b5f80$var$padStart(hours, 2) + $63618293c58b5f80$var$padStart(minutes, 2);
        default:
            throw new RangeError("Value format " + format + " is out of range for property format");
    }
}
function $63618293c58b5f80$var$timeObject(obj) {
    return $63618293c58b5f80$var$pick(obj, [
        "hour",
        "minute",
        "second",
        "millisecond"
    ]);
}
/**
 * @private
 */ var $63618293c58b5f80$var$monthsLong = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
];
var $63618293c58b5f80$var$monthsShort = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec"
];
var $63618293c58b5f80$var$monthsNarrow = [
    "J",
    "F",
    "M",
    "A",
    "M",
    "J",
    "J",
    "A",
    "S",
    "O",
    "N",
    "D"
];
function $63618293c58b5f80$var$months(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$monthsNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$monthsShort);
        case "long":
            return [].concat($63618293c58b5f80$var$monthsLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7",
                "8",
                "9",
                "10",
                "11",
                "12"
            ];
        case "2-digit":
            return [
                "01",
                "02",
                "03",
                "04",
                "05",
                "06",
                "07",
                "08",
                "09",
                "10",
                "11",
                "12"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$weekdaysLong = [
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
    "Sunday"
];
var $63618293c58b5f80$var$weekdaysShort = [
    "Mon",
    "Tue",
    "Wed",
    "Thu",
    "Fri",
    "Sat",
    "Sun"
];
var $63618293c58b5f80$var$weekdaysNarrow = [
    "M",
    "T",
    "W",
    "T",
    "F",
    "S",
    "S"
];
function $63618293c58b5f80$var$weekdays(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$weekdaysNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$weekdaysShort);
        case "long":
            return [].concat($63618293c58b5f80$var$weekdaysLong);
        case "numeric":
            return [
                "1",
                "2",
                "3",
                "4",
                "5",
                "6",
                "7"
            ];
        default:
            return null;
    }
}
var $63618293c58b5f80$var$meridiems = [
    "AM",
    "PM"
];
var $63618293c58b5f80$var$erasLong = [
    "Before Christ",
    "Anno Domini"
];
var $63618293c58b5f80$var$erasShort = [
    "BC",
    "AD"
];
var $63618293c58b5f80$var$erasNarrow = [
    "B",
    "A"
];
function $63618293c58b5f80$var$eras(length) {
    switch(length){
        case "narrow":
            return [].concat($63618293c58b5f80$var$erasNarrow);
        case "short":
            return [].concat($63618293c58b5f80$var$erasShort);
        case "long":
            return [].concat($63618293c58b5f80$var$erasLong);
        default:
            return null;
    }
}
function $63618293c58b5f80$var$meridiemForDateTime(dt) {
    return $63618293c58b5f80$var$meridiems[dt.hour < 12 ? 0 : 1];
}
function $63618293c58b5f80$var$weekdayForDateTime(dt, length) {
    return $63618293c58b5f80$var$weekdays(length)[dt.weekday - 1];
}
function $63618293c58b5f80$var$monthForDateTime(dt, length) {
    return $63618293c58b5f80$var$months(length)[dt.month - 1];
}
function $63618293c58b5f80$var$eraForDateTime(dt, length) {
    return $63618293c58b5f80$var$eras(length)[dt.year < 0 ? 0 : 1];
}
function $63618293c58b5f80$var$formatRelativeTime(unit, count, numeric, narrow) {
    if (numeric === void 0) numeric = "always";
    if (narrow === void 0) narrow = false;
    var units = {
        years: [
            "year",
            "yr."
        ],
        quarters: [
            "quarter",
            "qtr."
        ],
        months: [
            "month",
            "mo."
        ],
        weeks: [
            "week",
            "wk."
        ],
        days: [
            "day",
            "day",
            "days"
        ],
        hours: [
            "hour",
            "hr."
        ],
        minutes: [
            "minute",
            "min."
        ],
        seconds: [
            "second",
            "sec."
        ]
    };
    var lastable = [
        "hours",
        "minutes",
        "seconds"
    ].indexOf(unit) === -1;
    if (numeric === "auto" && lastable) {
        var isDay = unit === "days";
        switch(count){
            case 1:
                return isDay ? "tomorrow" : "next " + units[unit][0];
            case -1:
                return isDay ? "yesterday" : "last " + units[unit][0];
            case 0:
                return isDay ? "today" : "this " + units[unit][0];
        }
    }
    var isInPast = Object.is(count, -0) || count < 0, fmtValue = Math.abs(count), singular = fmtValue === 1, lilUnits = units[unit], fmtUnit = narrow ? singular ? lilUnits[1] : lilUnits[2] || lilUnits[1] : singular ? units[unit][0] : unit;
    return isInPast ? fmtValue + " " + fmtUnit + " ago" : "in " + fmtValue + " " + fmtUnit;
}
function $63618293c58b5f80$var$stringifyTokens(splits, tokenToString) {
    var s = "";
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(splits), _step; !(_step = _iterator()).done;){
        var token = _step.value;
        if (token.literal) s += token.val;
        else s += tokenToString(token.val);
    }
    return s;
}
var $63618293c58b5f80$var$_macroTokenToFormatOpts = {
    D: $63618293c58b5f80$var$DATE_SHORT,
    DD: $63618293c58b5f80$var$DATE_MED,
    DDD: $63618293c58b5f80$var$DATE_FULL,
    DDDD: $63618293c58b5f80$var$DATE_HUGE,
    t: $63618293c58b5f80$var$TIME_SIMPLE,
    tt: $63618293c58b5f80$var$TIME_WITH_SECONDS,
    ttt: $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET,
    tttt: $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET,
    T: $63618293c58b5f80$var$TIME_24_SIMPLE,
    TT: $63618293c58b5f80$var$TIME_24_WITH_SECONDS,
    TTT: $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET,
    TTTT: $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET,
    f: $63618293c58b5f80$var$DATETIME_SHORT,
    ff: $63618293c58b5f80$var$DATETIME_MED,
    fff: $63618293c58b5f80$var$DATETIME_FULL,
    ffff: $63618293c58b5f80$var$DATETIME_HUGE,
    F: $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS,
    FF: $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS,
    FFF: $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS,
    FFFF: $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS
};
/**
 * @private
 */ var $63618293c58b5f80$var$Formatter = /*#__PURE__*/ function() {
    Formatter.create = function create(locale, opts) {
        if (opts === void 0) opts = {};
        return new Formatter(locale, opts);
    };
    Formatter.parseFormat = function parseFormat(fmt) {
        // white-space is always considered a literal in user-provided formats
        // the " " token has a special meaning (see unitForToken)
        var current = null, currentFull = "", bracketed = false;
        var splits = [];
        for(var i = 0; i < fmt.length; i++){
            var c = fmt.charAt(i);
            if (c === "'") {
                if (currentFull.length > 0) splits.push({
                    literal: bracketed || /^\s+$/.test(currentFull),
                    val: currentFull
                });
                current = null;
                currentFull = "";
                bracketed = !bracketed;
            } else if (bracketed) currentFull += c;
            else if (c === current) currentFull += c;
            else {
                if (currentFull.length > 0) splits.push({
                    literal: /^\s+$/.test(currentFull),
                    val: currentFull
                });
                currentFull = c;
                current = c;
            }
        }
        if (currentFull.length > 0) splits.push({
            literal: bracketed || /^\s+$/.test(currentFull),
            val: currentFull
        });
        return splits;
    };
    Formatter.macroTokenToFormatOpts = function macroTokenToFormatOpts(token) {
        return $63618293c58b5f80$var$_macroTokenToFormatOpts[token];
    };
    function Formatter(locale, formatOpts) {
        this.opts = formatOpts;
        this.loc = locale;
        this.systemLoc = null;
    }
    var _proto = Formatter.prototype;
    _proto.formatWithSystemDefault = function formatWithSystemDefault(dt, opts) {
        if (this.systemLoc === null) this.systemLoc = this.loc.redefaultToSystem();
        var df = this.systemLoc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
        return df.format();
    };
    _proto.dtFormatter = function dtFormatter(dt, opts) {
        if (opts === void 0) opts = {};
        return this.loc.dtFormatter(dt, $63618293c58b5f80$var$_extends({}, this.opts, opts));
    };
    _proto.formatDateTime = function formatDateTime(dt, opts) {
        return this.dtFormatter(dt, opts).format();
    };
    _proto.formatDateTimeParts = function formatDateTimeParts(dt, opts) {
        return this.dtFormatter(dt, opts).formatToParts();
    };
    _proto.formatInterval = function formatInterval(interval, opts) {
        var df = this.dtFormatter(interval.start, opts);
        return df.dtf.formatRange(interval.start.toJSDate(), interval.end.toJSDate());
    };
    _proto.resolvedOptions = function resolvedOptions(dt, opts) {
        return this.dtFormatter(dt, opts).resolvedOptions();
    };
    _proto.num = function num(n, p) {
        if (p === void 0) p = 0;
        // we get some perf out of doing this here, annoyingly
        if (this.opts.forceSimple) return $63618293c58b5f80$var$padStart(n, p);
        var opts = $63618293c58b5f80$var$_extends({}, this.opts);
        if (p > 0) opts.padTo = p;
        return this.loc.numberFormatter(opts).format(n);
    };
    _proto.formatDateTimeFromString = function formatDateTimeFromString(dt, fmt) {
        var _this = this;
        var knownEnglish = this.loc.listingMode() === "en", useDateTimeFormatter = this.loc.outputCalendar && this.loc.outputCalendar !== "gregory", string = function string(opts, extract) {
            return _this.loc.extract(dt, opts, extract);
        }, formatOffset = function formatOffset(opts) {
            if (dt.isOffsetFixed && dt.offset === 0 && opts.allowZ) return "Z";
            return dt.isValid ? dt.zone.formatOffset(dt.ts, opts.format) : "";
        }, meridiem = function meridiem() {
            return knownEnglish ? $63618293c58b5f80$var$meridiemForDateTime(dt) : string({
                hour: "numeric",
                hourCycle: "h12"
            }, "dayperiod");
        }, month = function month(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$monthForDateTime(dt, length) : string(standalone ? {
                month: length
            } : {
                month: length,
                day: "numeric"
            }, "month");
        }, weekday = function weekday(length, standalone) {
            return knownEnglish ? $63618293c58b5f80$var$weekdayForDateTime(dt, length) : string(standalone ? {
                weekday: length
            } : {
                weekday: length,
                month: "long",
                day: "numeric"
            }, "weekday");
        }, maybeMacro = function maybeMacro(token) {
            var formatOpts = Formatter.macroTokenToFormatOpts(token);
            if (formatOpts) return _this.formatWithSystemDefault(dt, formatOpts);
            else return token;
        }, era = function era(length) {
            return knownEnglish ? $63618293c58b5f80$var$eraForDateTime(dt, length) : string({
                era: length
            }, "era");
        }, tokenToString = function tokenToString(token) {
            // Where possible: https://cldr.unicode.org/translation/date-time/date-time-symbols
            switch(token){
                // ms
                case "S":
                    return _this.num(dt.millisecond);
                case "u":
                // falls through
                case "SSS":
                    return _this.num(dt.millisecond, 3);
                // seconds
                case "s":
                    return _this.num(dt.second);
                case "ss":
                    return _this.num(dt.second, 2);
                // fractional seconds
                case "uu":
                    return _this.num(Math.floor(dt.millisecond / 10), 2);
                case "uuu":
                    return _this.num(Math.floor(dt.millisecond / 100));
                // minutes
                case "m":
                    return _this.num(dt.minute);
                case "mm":
                    return _this.num(dt.minute, 2);
                // hours
                case "h":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12);
                case "hh":
                    return _this.num(dt.hour % 12 === 0 ? 12 : dt.hour % 12, 2);
                case "H":
                    return _this.num(dt.hour);
                case "HH":
                    return _this.num(dt.hour, 2);
                // offset
                case "Z":
                    // like +6
                    return formatOffset({
                        format: "narrow",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZ":
                    // like +06:00
                    return formatOffset({
                        format: "short",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZ":
                    // like +0600
                    return formatOffset({
                        format: "techie",
                        allowZ: _this.opts.allowZ
                    });
                case "ZZZZ":
                    // like EST
                    return dt.zone.offsetName(dt.ts, {
                        format: "short",
                        locale: _this.loc.locale
                    });
                case "ZZZZZ":
                    // like Eastern Standard Time
                    return dt.zone.offsetName(dt.ts, {
                        format: "long",
                        locale: _this.loc.locale
                    });
                // zone
                case "z":
                    // like America/New_York
                    return dt.zoneName;
                // meridiems
                case "a":
                    return meridiem();
                // dates
                case "d":
                    return useDateTimeFormatter ? string({
                        day: "numeric"
                    }, "day") : _this.num(dt.day);
                case "dd":
                    return useDateTimeFormatter ? string({
                        day: "2-digit"
                    }, "day") : _this.num(dt.day, 2);
                // weekdays - standalone
                case "c":
                    // like 1
                    return _this.num(dt.weekday);
                case "ccc":
                    // like 'Tues'
                    return weekday("short", true);
                case "cccc":
                    // like 'Tuesday'
                    return weekday("long", true);
                case "ccccc":
                    // like 'T'
                    return weekday("narrow", true);
                // weekdays - format
                case "E":
                    // like 1
                    return _this.num(dt.weekday);
                case "EEE":
                    // like 'Tues'
                    return weekday("short", false);
                case "EEEE":
                    // like 'Tuesday'
                    return weekday("long", false);
                case "EEEEE":
                    // like 'T'
                    return weekday("narrow", false);
                // months - standalone
                case "L":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric",
                        day: "numeric"
                    }, "month") : _this.num(dt.month);
                case "LL":
                    // like 01, doesn't seem to work
                    return useDateTimeFormatter ? string({
                        month: "2-digit",
                        day: "numeric"
                    }, "month") : _this.num(dt.month, 2);
                case "LLL":
                    // like Jan
                    return month("short", true);
                case "LLLL":
                    // like January
                    return month("long", true);
                case "LLLLL":
                    // like J
                    return month("narrow", true);
                // months - format
                case "M":
                    // like 1
                    return useDateTimeFormatter ? string({
                        month: "numeric"
                    }, "month") : _this.num(dt.month);
                case "MM":
                    // like 01
                    return useDateTimeFormatter ? string({
                        month: "2-digit"
                    }, "month") : _this.num(dt.month, 2);
                case "MMM":
                    // like Jan
                    return month("short", false);
                case "MMMM":
                    // like January
                    return month("long", false);
                case "MMMMM":
                    // like J
                    return month("narrow", false);
                // years
                case "y":
                    // like 2014
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year);
                case "yy":
                    // like 14
                    return useDateTimeFormatter ? string({
                        year: "2-digit"
                    }, "year") : _this.num(dt.year.toString().slice(-2), 2);
                case "yyyy":
                    // like 0012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 4);
                case "yyyyyy":
                    // like 000012
                    return useDateTimeFormatter ? string({
                        year: "numeric"
                    }, "year") : _this.num(dt.year, 6);
                // eras
                case "G":
                    // like AD
                    return era("short");
                case "GG":
                    // like Anno Domini
                    return era("long");
                case "GGGGG":
                    return era("narrow");
                case "kk":
                    return _this.num(dt.weekYear.toString().slice(-2), 2);
                case "kkkk":
                    return _this.num(dt.weekYear, 4);
                case "W":
                    return _this.num(dt.weekNumber);
                case "WW":
                    return _this.num(dt.weekNumber, 2);
                case "o":
                    return _this.num(dt.ordinal);
                case "ooo":
                    return _this.num(dt.ordinal, 3);
                case "q":
                    // like 1
                    return _this.num(dt.quarter);
                case "qq":
                    // like 01
                    return _this.num(dt.quarter, 2);
                case "X":
                    return _this.num(Math.floor(dt.ts / 1000));
                case "x":
                    return _this.num(dt.ts);
                default:
                    return maybeMacro(token);
            }
        };
        return $63618293c58b5f80$var$stringifyTokens(Formatter.parseFormat(fmt), tokenToString);
    };
    _proto.formatDurationFromString = function formatDurationFromString(dur, fmt) {
        var _this2 = this;
        var tokenToField = function tokenToField(token) {
            switch(token[0]){
                case "S":
                    return "millisecond";
                case "s":
                    return "second";
                case "m":
                    return "minute";
                case "h":
                    return "hour";
                case "d":
                    return "day";
                case "w":
                    return "week";
                case "M":
                    return "month";
                case "y":
                    return "year";
                default:
                    return null;
            }
        }, tokenToString = function tokenToString(lildur) {
            return function(token) {
                var mapped = tokenToField(token);
                if (mapped) return _this2.num(lildur.get(mapped), token.length);
                else return token;
            };
        }, tokens = Formatter.parseFormat(fmt), realTokens = tokens.reduce(function(found, _ref) {
            var literal = _ref.literal, val = _ref.val;
            return literal ? found : found.concat(val);
        }, []), collapsed = dur.shiftTo.apply(dur, realTokens.map(tokenToField).filter(function(t) {
            return t;
        }));
        return $63618293c58b5f80$var$stringifyTokens(tokens, tokenToString(collapsed));
    };
    return Formatter;
}();
var $63618293c58b5f80$var$Invalid = /*#__PURE__*/ function() {
    function Invalid(reason, explanation) {
        this.reason = reason;
        this.explanation = explanation;
    }
    var _proto = Invalid.prototype;
    _proto.toMessage = function toMessage() {
        if (this.explanation) return this.reason + ": " + this.explanation;
        else return this.reason;
    };
    return Invalid;
}();
/*
 * This file handles parsing for well-specified formats. Here's how it works:
 * Two things go into parsing: a regex to match with and an extractor to take apart the groups in the match.
 * An extractor is just a function that takes a regex match array and returns a { year: ..., month: ... } object
 * parse() does the work of executing the regex and applying the extractor. It takes multiple regex/extractor pairs to try in sequence.
 * Extractors can take a "cursor" representing the offset in the match to look at. This makes it easy to combine extractors.
 * combineExtractors() does the work of combining them, keeping track of the cursor through multiple extractions.
 * Some extractions are super dumb and simpleParse and fromStrings help DRY them.
 */ var $63618293c58b5f80$var$ianaRegex = /[A-Za-z_+-]{1,256}(?::?\/[A-Za-z0-9_+-]{1,256}(?:\/[A-Za-z0-9_+-]{1,256})?)?/;
function $63618293c58b5f80$var$combineRegexes() {
    for(var _len = arguments.length, regexes = new Array(_len), _key = 0; _key < _len; _key++)regexes[_key] = arguments[_key];
    var full = regexes.reduce(function(f, r) {
        return f + r.source;
    }, "");
    return RegExp("^" + full + "$");
}
function $63618293c58b5f80$var$combineExtractors() {
    for(var _len2 = arguments.length, extractors = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)extractors[_key2] = arguments[_key2];
    return function(m) {
        return extractors.reduce(function(_ref, ex) {
            var mergedVals = _ref[0], mergedZone = _ref[1], cursor = _ref[2];
            var _ex = ex(m, cursor), val = _ex[0], zone = _ex[1], next = _ex[2];
            return [
                $63618293c58b5f80$var$_extends({}, mergedVals, val),
                zone || mergedZone,
                next
            ];
        }, [
            {},
            null,
            1
        ]).slice(0, 2);
    };
}
function $63618293c58b5f80$var$parse(s) {
    if (s == null) return [
        null,
        null
    ];
    for(var _len3 = arguments.length, patterns = new Array(_len3 > 1 ? _len3 - 1 : 0), _key3 = 1; _key3 < _len3; _key3++)patterns[_key3 - 1] = arguments[_key3];
    for(var _i = 0, _patterns = patterns; _i < _patterns.length; _i++){
        var _patterns$_i = _patterns[_i], regex = _patterns$_i[0], extractor = _patterns$_i[1];
        var m = regex.exec(s);
        if (m) return extractor(m);
    }
    return [
        null,
        null
    ];
}
function $63618293c58b5f80$var$simpleParse() {
    for(var _len4 = arguments.length, keys = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++)keys[_key4] = arguments[_key4];
    return function(match, cursor) {
        var ret = {};
        var i;
        for(i = 0; i < keys.length; i++)ret[keys[i]] = $63618293c58b5f80$var$parseInteger(match[cursor + i]);
        return [
            ret,
            null,
            cursor + i
        ];
    };
}
// ISO and SQL parsing
var $63618293c58b5f80$var$offsetRegex = /(?:(Z)|([+-]\d\d)(?::?(\d\d))?)/;
var $63618293c58b5f80$var$isoExtendedZone = "(?:" + $63618293c58b5f80$var$offsetRegex.source + "?(?:\\[(" + $63618293c58b5f80$var$ianaRegex.source + ")\\])?)?";
var $63618293c58b5f80$var$isoTimeBaseRegex = /(\d\d)(?::?(\d\d)(?::?(\d\d)(?:[.,](\d{1,30}))?)?)?/;
var $63618293c58b5f80$var$isoTimeRegex = RegExp("" + $63618293c58b5f80$var$isoTimeBaseRegex.source + $63618293c58b5f80$var$isoExtendedZone);
var $63618293c58b5f80$var$isoTimeExtensionRegex = RegExp("(?:T" + $63618293c58b5f80$var$isoTimeRegex.source + ")?");
var $63618293c58b5f80$var$isoYmdRegex = /([+-]\d{6}|\d{4})(?:-?(\d\d)(?:-?(\d\d))?)?/;
var $63618293c58b5f80$var$isoWeekRegex = /(\d{4})-?W(\d\d)(?:-?(\d))?/;
var $63618293c58b5f80$var$isoOrdinalRegex = /(\d{4})-?(\d{3})/;
var $63618293c58b5f80$var$extractISOWeekData = $63618293c58b5f80$var$simpleParse("weekYear", "weekNumber", "weekDay");
var $63618293c58b5f80$var$extractISOOrdinalData = $63618293c58b5f80$var$simpleParse("year", "ordinal");
var $63618293c58b5f80$var$sqlYmdRegex = /(\d{4})-(\d\d)-(\d\d)/; // dumbed-down version of the ISO one
var $63618293c58b5f80$var$sqlTimeRegex = RegExp($63618293c58b5f80$var$isoTimeBaseRegex.source + " ?(?:" + $63618293c58b5f80$var$offsetRegex.source + "|(" + $63618293c58b5f80$var$ianaRegex.source + "))?");
var $63618293c58b5f80$var$sqlTimeExtensionRegex = RegExp("(?: " + $63618293c58b5f80$var$sqlTimeRegex.source + ")?");
function $63618293c58b5f80$var$int(match, pos, fallback) {
    var m = match[pos];
    return $63618293c58b5f80$var$isUndefined(m) ? fallback : $63618293c58b5f80$var$parseInteger(m);
}
function $63618293c58b5f80$var$extractISOYmd(match, cursor) {
    var item = {
        year: $63618293c58b5f80$var$int(match, cursor),
        month: $63618293c58b5f80$var$int(match, cursor + 1, 1),
        day: $63618293c58b5f80$var$int(match, cursor + 2, 1)
    };
    return [
        item,
        null,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractISOTime(match, cursor) {
    var item = {
        hours: $63618293c58b5f80$var$int(match, cursor, 0),
        minutes: $63618293c58b5f80$var$int(match, cursor + 1, 0),
        seconds: $63618293c58b5f80$var$int(match, cursor + 2, 0),
        milliseconds: $63618293c58b5f80$var$parseMillis(match[cursor + 3])
    };
    return [
        item,
        null,
        cursor + 4
    ];
}
function $63618293c58b5f80$var$extractISOOffset(match, cursor) {
    var local = !match[cursor] && !match[cursor + 1], fullOffset = $63618293c58b5f80$var$signedOffset(match[cursor + 1], match[cursor + 2]), zone = local ? null : $63618293c58b5f80$var$FixedOffsetZone.instance(fullOffset);
    return [
        {},
        zone,
        cursor + 3
    ];
}
function $63618293c58b5f80$var$extractIANAZone(match, cursor) {
    var zone = match[cursor] ? $63618293c58b5f80$var$IANAZone.create(match[cursor]) : null;
    return [
        {},
        zone,
        cursor + 1
    ];
}
// ISO time parsing
var $63618293c58b5f80$var$isoTimeOnly = RegExp("^T?" + $63618293c58b5f80$var$isoTimeBaseRegex.source + "$");
// ISO duration parsing
var $63618293c58b5f80$var$isoDuration = /^-?P(?:(?:(-?\d{1,20}(?:\.\d{1,20})?)Y)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20}(?:\.\d{1,20})?)W)?(?:(-?\d{1,20}(?:\.\d{1,20})?)D)?(?:T(?:(-?\d{1,20}(?:\.\d{1,20})?)H)?(?:(-?\d{1,20}(?:\.\d{1,20})?)M)?(?:(-?\d{1,20})(?:[.,](-?\d{1,20}))?S)?)?)$/;
function $63618293c58b5f80$var$extractISODuration(match) {
    var s = match[0], yearStr = match[1], monthStr = match[2], weekStr = match[3], dayStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], millisecondsStr = match[8];
    var hasNegativePrefix = s[0] === "-";
    var negativeSeconds = secondStr && secondStr[0] === "-";
    var maybeNegate = function maybeNegate(num, force) {
        if (force === void 0) force = false;
        return num !== undefined && (force || num && hasNegativePrefix) ? -num : num;
    };
    return [
        {
            years: maybeNegate($63618293c58b5f80$var$parseFloating(yearStr)),
            months: maybeNegate($63618293c58b5f80$var$parseFloating(monthStr)),
            weeks: maybeNegate($63618293c58b5f80$var$parseFloating(weekStr)),
            days: maybeNegate($63618293c58b5f80$var$parseFloating(dayStr)),
            hours: maybeNegate($63618293c58b5f80$var$parseFloating(hourStr)),
            minutes: maybeNegate($63618293c58b5f80$var$parseFloating(minuteStr)),
            seconds: maybeNegate($63618293c58b5f80$var$parseFloating(secondStr), secondStr === "-0"),
            milliseconds: maybeNegate($63618293c58b5f80$var$parseMillis(millisecondsStr), negativeSeconds)
        }
    ];
}
// These are a little braindead. EDT *should* tell us that we're in, say, America/New_York
// and not just that we're in -240 *right now*. But since I don't think these are used that often
// I'm just going to ignore that
var $63618293c58b5f80$var$obsOffsets = {
    GMT: 0,
    EDT: -240,
    EST: -300,
    CDT: -300,
    CST: -360,
    MDT: -360,
    MST: -420,
    PDT: -420,
    PST: -480
};
function $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = {
        year: yearStr.length === 2 ? $63618293c58b5f80$var$untruncateYear($63618293c58b5f80$var$parseInteger(yearStr)) : $63618293c58b5f80$var$parseInteger(yearStr),
        month: $63618293c58b5f80$var$monthsShort.indexOf(monthStr) + 1,
        day: $63618293c58b5f80$var$parseInteger(dayStr),
        hour: $63618293c58b5f80$var$parseInteger(hourStr),
        minute: $63618293c58b5f80$var$parseInteger(minuteStr)
    };
    if (secondStr) result.second = $63618293c58b5f80$var$parseInteger(secondStr);
    if (weekdayStr) result.weekday = weekdayStr.length > 3 ? $63618293c58b5f80$var$weekdaysLong.indexOf(weekdayStr) + 1 : $63618293c58b5f80$var$weekdaysShort.indexOf(weekdayStr) + 1;
    return result;
}
// RFC 2822/5322
var $63618293c58b5f80$var$rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|(?:([+-]\d\d)(\d\d)))$/;
function $63618293c58b5f80$var$extractRFC2822(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], obsOffset = match[8], milOffset = match[9], offHourStr = match[10], offMinuteStr = match[11], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    var offset;
    if (obsOffset) offset = $63618293c58b5f80$var$obsOffsets[obsOffset];
    else if (milOffset) offset = 0;
    else offset = $63618293c58b5f80$var$signedOffset(offHourStr, offMinuteStr);
    return [
        result,
        new $63618293c58b5f80$var$FixedOffsetZone(offset)
    ];
}
function $63618293c58b5f80$var$preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, " ").replace(/(\s\s+)/g, " ").trim();
}
// http date
var $63618293c58b5f80$var$rfc1123 = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun), (\d\d) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) (\d{4}) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$rfc850 = /^(Monday|Tuesday|Wednesday|Thursday|Friday|Saturday|Sunday), (\d\d)-(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)-(\d\d) (\d\d):(\d\d):(\d\d) GMT$/, $63618293c58b5f80$var$ascii = /^(Mon|Tue|Wed|Thu|Fri|Sat|Sun) (Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec) ( \d|\d\d) (\d\d):(\d\d):(\d\d) (\d{4})$/;
function $63618293c58b5f80$var$extractRFC1123Or850(match) {
    var weekdayStr = match[1], dayStr = match[2], monthStr = match[3], yearStr = match[4], hourStr = match[5], minuteStr = match[6], secondStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
function $63618293c58b5f80$var$extractASCII(match) {
    var weekdayStr = match[1], monthStr = match[2], dayStr = match[3], hourStr = match[4], minuteStr = match[5], secondStr = match[6], yearStr = match[7], result = $63618293c58b5f80$var$fromStrings(weekdayStr, yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr);
    return [
        result,
        $63618293c58b5f80$var$FixedOffsetZone.utcInstance
    ];
}
var $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoYmdRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoWeekRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoOrdinalRegex, $63618293c58b5f80$var$isoTimeExtensionRegex);
var $63618293c58b5f80$var$isoTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$isoTimeRegex);
var $63618293c58b5f80$var$extractISOYmdTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOYmd, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOWeekTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOWeekData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOOrdinalDateAndTime = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOOrdinalData, $63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
var $63618293c58b5f80$var$extractISOTimeAndOffset = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
/*
 * @private
 */ function $63618293c58b5f80$var$parseISODate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoWeekWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOWeekTimeAndOffset
    ], [
        $63618293c58b5f80$var$isoOrdinalWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOOrdinalDateAndTime
    ], [
        $63618293c58b5f80$var$isoTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeAndOffset
    ]);
}
function $63618293c58b5f80$var$parseRFC2822Date(s) {
    return $63618293c58b5f80$var$parse($63618293c58b5f80$var$preprocessRFC2822(s), [
        $63618293c58b5f80$var$rfc2822,
        $63618293c58b5f80$var$extractRFC2822
    ]);
}
function $63618293c58b5f80$var$parseHTTPDate(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$rfc1123,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$rfc850,
        $63618293c58b5f80$var$extractRFC1123Or850
    ], [
        $63618293c58b5f80$var$ascii,
        $63618293c58b5f80$var$extractASCII
    ]);
}
function $63618293c58b5f80$var$parseISODuration(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoDuration,
        $63618293c58b5f80$var$extractISODuration
    ]);
}
var $63618293c58b5f80$var$extractISOTimeOnly = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime);
function $63618293c58b5f80$var$parseISOTimeOnly(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$isoTimeOnly,
        $63618293c58b5f80$var$extractISOTimeOnly
    ]);
}
var $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlYmdRegex, $63618293c58b5f80$var$sqlTimeExtensionRegex);
var $63618293c58b5f80$var$sqlTimeCombinedRegex = $63618293c58b5f80$var$combineRegexes($63618293c58b5f80$var$sqlTimeRegex);
var $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone = $63618293c58b5f80$var$combineExtractors($63618293c58b5f80$var$extractISOTime, $63618293c58b5f80$var$extractISOOffset, $63618293c58b5f80$var$extractIANAZone);
function $63618293c58b5f80$var$parseSQL(s) {
    return $63618293c58b5f80$var$parse(s, [
        $63618293c58b5f80$var$sqlYmdWithTimeExtensionRegex,
        $63618293c58b5f80$var$extractISOYmdTimeAndOffset
    ], [
        $63618293c58b5f80$var$sqlTimeCombinedRegex,
        $63618293c58b5f80$var$extractISOTimeOffsetAndIANAZone
    ]);
}
var $63618293c58b5f80$var$INVALID$2 = "Invalid Duration";
// unit conversion constants
var $63618293c58b5f80$var$lowOrderMatrix = {
    weeks: {
        days: 7,
        hours: 168,
        minutes: 10080,
        seconds: 604800,
        milliseconds: 604800000
    },
    days: {
        hours: 24,
        minutes: 1440,
        seconds: 86400,
        milliseconds: 86400000
    },
    hours: {
        minutes: 60,
        seconds: 3600,
        milliseconds: 3600000
    },
    minutes: {
        seconds: 60,
        milliseconds: 60000
    },
    seconds: {
        milliseconds: 1000
    }
}, $63618293c58b5f80$var$casualMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: 52,
        days: 365,
        hours: 8760,
        minutes: 525600,
        seconds: 31536000,
        milliseconds: 31536000000
    },
    quarters: {
        months: 3,
        weeks: 13,
        days: 91,
        hours: 2184,
        minutes: 131040,
        seconds: 7862400,
        milliseconds: 7862400000
    },
    months: {
        weeks: 4,
        days: 30,
        hours: 720,
        minutes: 43200,
        seconds: 2592000,
        milliseconds: 2592000000
    }
}, $63618293c58b5f80$var$lowOrderMatrix), $63618293c58b5f80$var$daysInYearAccurate = 365.2425, $63618293c58b5f80$var$daysInMonthAccurate = 30.436875, $63618293c58b5f80$var$accurateMatrix = $63618293c58b5f80$var$_extends({
    years: {
        quarters: 4,
        months: 12,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 7,
        days: $63618293c58b5f80$var$daysInYearAccurate,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000
    },
    quarters: {
        months: 3,
        weeks: $63618293c58b5f80$var$daysInYearAccurate / 28,
        days: $63618293c58b5f80$var$daysInYearAccurate / 4,
        hours: $63618293c58b5f80$var$daysInYearAccurate * 24 / 4,
        minutes: $63618293c58b5f80$var$daysInYearAccurate * 1440 / 4,
        seconds: $63618293c58b5f80$var$daysInYearAccurate * 86400 / 4,
        milliseconds: $63618293c58b5f80$var$daysInYearAccurate * 86400000 / 4
    },
    months: {
        weeks: $63618293c58b5f80$var$daysInMonthAccurate / 7,
        days: $63618293c58b5f80$var$daysInMonthAccurate,
        hours: $63618293c58b5f80$var$daysInMonthAccurate * 24,
        minutes: $63618293c58b5f80$var$daysInMonthAccurate * 1440,
        seconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400,
        milliseconds: $63618293c58b5f80$var$daysInMonthAccurate * 86400000
    }
}, $63618293c58b5f80$var$lowOrderMatrix);
// units ordered by size
var $63618293c58b5f80$var$orderedUnits$1 = [
    "years",
    "quarters",
    "months",
    "weeks",
    "days",
    "hours",
    "minutes",
    "seconds",
    "milliseconds"
];
var $63618293c58b5f80$var$reverseUnits = $63618293c58b5f80$var$orderedUnits$1.slice(0).reverse();
// clone really means "create another instance just like this one, but with these changes"
function $63618293c58b5f80$var$clone$1(dur, alts, clear) {
    if (clear === void 0) clear = false;
    // deep merge for vals
    var conf = {
        values: clear ? alts.values : $63618293c58b5f80$var$_extends({}, dur.values, alts.values || {}),
        loc: dur.loc.clone(alts.loc),
        conversionAccuracy: alts.conversionAccuracy || dur.conversionAccuracy,
        matrix: alts.matrix || dur.matrix
    };
    return new $63618293c58b5f80$var$Duration(conf);
}
function $63618293c58b5f80$var$durationToMillis(matrix, vals) {
    var _vals$milliseconds;
    var sum = (_vals$milliseconds = vals.milliseconds) != null ? _vals$milliseconds : 0;
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose($63618293c58b5f80$var$reverseUnits.slice(1)), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        if (vals[unit]) sum += vals[unit] * matrix[unit]["milliseconds"];
    }
    return sum;
}
// NB: mutates parameters
function $63618293c58b5f80$var$normalizeValues(matrix, vals) {
    // the logic below assumes the overall value of the duration is positive
    // if this is not the case, factor is used to make it so
    var factor = $63618293c58b5f80$var$durationToMillis(matrix, vals) < 0 ? -1 : 1;
    $63618293c58b5f80$var$orderedUnits$1.reduceRight(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var previousVal = vals[previous] * factor;
                var conv = matrix[current][previous];
                // if (previousVal < 0):
                // lower order unit is negative (e.g. { years: 2, days: -2 })
                // normalize this by reducing the higher order unit by the appropriate amount
                // and increasing the lower order unit
                // this can never make the higher order unit negative, because this function only operates
                // on positive durations, so the amount of time represented by the lower order unit cannot
                // be larger than the higher order unit
                // else:
                // lower order unit is positive (e.g. { years: 2, days: 450 } or { years: -2, days: 450 })
                // in this case we attempt to convert as much as possible from the lower order unit into
                // the higher order one
                //
                // Math.floor takes care of both of these cases, rounding away from 0
                // if previousVal < 0 it makes the absolute value larger
                // if previousVal >= it makes the absolute value smaller
                var rollUp = Math.floor(previousVal / conv);
                vals[current] += rollUp * factor;
                vals[previous] -= rollUp * conv * factor;
            }
            return current;
        } else return previous;
    }, null);
    // try to convert any decimals into smaller units if possible
    // for example for { years: 2.5, days: 0, seconds: 0 } we want to get { years: 2, days: 182, hours: 12 }
    $63618293c58b5f80$var$orderedUnits$1.reduce(function(previous, current) {
        if (!$63618293c58b5f80$var$isUndefined(vals[current])) {
            if (previous) {
                var fraction = vals[previous] % 1;
                vals[previous] -= fraction;
                vals[current] += fraction * matrix[previous][current];
            }
            return current;
        } else return previous;
    }, null);
}
// Remove all properties with a value of 0 from an object
function $63618293c58b5f80$var$removeZeroes(vals) {
    var newVals = {};
    for(var _i = 0, _Object$entries = Object.entries(vals); _i < _Object$entries.length; _i++){
        var _Object$entries$_i = _Object$entries[_i], key = _Object$entries$_i[0], value = _Object$entries$_i[1];
        if (value !== 0) newVals[key] = value;
    }
    return newVals;
}
/**
 * A Duration object represents a period of time, like "2 months" or "1 day, 1 hour". Conceptually, it's just a map of units to their quantities, accompanied by some additional configuration and methods for creating, parsing, interrogating, transforming, and formatting them. They can be used on their own or in conjunction with other Luxon types; for example, you can use {@link DateTime#plus} to add a Duration object to a DateTime, producing another DateTime.
 *
 * Here is a brief overview of commonly used methods and getters in Duration:
 *
 * * **Creation** To create a Duration, use {@link Duration.fromMillis}, {@link Duration.fromObject}, or {@link Duration.fromISO}.
 * * **Unit values** See the {@link Duration#years}, {@link Duration#months}, {@link Duration#weeks}, {@link Duration#days}, {@link Duration#hours}, {@link Duration#minutes}, {@link Duration#seconds}, {@link Duration#milliseconds} accessors.
 * * **Configuration** See  {@link Duration#locale} and {@link Duration#numberingSystem} accessors.
 * * **Transformation** To create new Durations out of old ones use {@link Duration#plus}, {@link Duration#minus}, {@link Duration#normalize}, {@link Duration#set}, {@link Duration#reconfigure}, {@link Duration#shiftTo}, and {@link Duration#negate}.
 * * **Output** To convert the Duration into other representations, see {@link Duration#as}, {@link Duration#toISO}, {@link Duration#toFormat}, and {@link Duration#toJSON}
 *
 * There's are more methods documented below. In addition, for more information on subtler topics like internationalization and validity, see the external documentation.
 */ var $63618293c58b5f80$var$Duration = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Duration(config) {
        var accurate = config.conversionAccuracy === "longterm" || false;
        var matrix = accurate ? $63618293c58b5f80$var$accurateMatrix : $63618293c58b5f80$var$casualMatrix;
        if (config.matrix) matrix = config.matrix;
        /**
     * @access private
     */ this.values = config.values;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.conversionAccuracy = accurate ? "longterm" : "casual";
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.matrix = matrix;
        /**
     * @access private
     */ this.isLuxonDuration = true;
    }
    /**
   * Create Duration from a number of milliseconds.
   * @param {number} count of milliseconds
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ Duration.fromMillis = function fromMillis(count, opts) {
        return Duration.fromObject({
            milliseconds: count
        }, opts);
    } /**
   * Create a Duration from a JavaScript object with keys like 'years' and 'hours'.
   * If this object is empty then a zero milliseconds duration is returned.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.years
   * @param {number} obj.quarters
   * @param {number} obj.months
   * @param {number} obj.weeks
   * @param {number} obj.days
   * @param {number} obj.hours
   * @param {number} obj.minutes
   * @param {number} obj.seconds
   * @param {number} obj.milliseconds
   * @param {Object} [opts=[]] - options for creating this Duration
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the custom conversion system to use
   * @return {Duration}
   */ ;
    Duration.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        if (obj == null || typeof obj !== "object") throw new $63618293c58b5f80$var$InvalidArgumentError("Duration.fromObject: argument expected to be an object, got " + (obj === null ? "null" : typeof obj));
        return new Duration({
            values: $63618293c58b5f80$var$normalizeObject(obj, Duration.normalizeUnit),
            loc: $63618293c58b5f80$var$Locale.fromObject(opts),
            conversionAccuracy: opts.conversionAccuracy,
            matrix: opts.matrix
        });
    } /**
   * Create a Duration from DurationLike.
   *
   * @param {Object | number | Duration} durationLike
   * One of:
   * - object with keys like 'years' and 'hours'.
   * - number representing milliseconds
   * - Duration instance
   * @return {Duration}
   */ ;
    Duration.fromDurationLike = function fromDurationLike(durationLike) {
        if ($63618293c58b5f80$var$isNumber(durationLike)) return Duration.fromMillis(durationLike);
        else if (Duration.isDuration(durationLike)) return durationLike;
        else if (typeof durationLike === "object") return Duration.fromObject(durationLike);
        else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown duration argument " + durationLike + " of type " + typeof durationLike);
    } /**
   * Create a Duration from an ISO 8601 duration string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the preset conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromISO('P3Y6M1W4DT12H30M5S').toObject() //=> { years: 3, months: 6, weeks: 1, days: 4, hours: 12, minutes: 30, seconds: 5 }
   * @example Duration.fromISO('PT23H').toObject() //=> { hours: 23 }
   * @example Duration.fromISO('P5Y3M').toObject() //=> { years: 5, months: 3 }
   * @return {Duration}
   */ ;
    Duration.fromISO = function fromISO(text, opts) {
        var _parseISODuration = $63618293c58b5f80$var$parseISODuration(text), parsed = _parseISODuration[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create a Duration from an ISO 8601 time string.
   * @param {string} text - text to parse
   * @param {Object} opts - options for parsing
   * @param {string} [opts.locale='en-US'] - the locale to use
   * @param {string} opts.numberingSystem - the numbering system to use
   * @param {string} [opts.conversionAccuracy='casual'] - the preset conversion system to use
   * @param {string} [opts.matrix=Object] - the conversion system to use
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @example Duration.fromISOTime('11:22:33.444').toObject() //=> { hours: 11, minutes: 22, seconds: 33, milliseconds: 444 }
   * @example Duration.fromISOTime('11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T11:00').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @example Duration.fromISOTime('T1100').toObject() //=> { hours: 11, minutes: 0, seconds: 0 }
   * @return {Duration}
   */ ;
    Duration.fromISOTime = function fromISOTime(text, opts) {
        var _parseISOTimeOnly = $63618293c58b5f80$var$parseISOTimeOnly(text), parsed = _parseISOTimeOnly[0];
        if (parsed) return Duration.fromObject(parsed, opts);
        else return Duration.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Create an invalid Duration.
   * @param {string} reason - simple string of why this datetime is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Duration}
   */ ;
    Duration.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Duration is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDurationError(invalid);
        else return new Duration({
            invalid: invalid
        });
    } /**
   * @private
   */ ;
    Duration.normalizeUnit = function normalizeUnit(unit) {
        var normalized = {
            year: "years",
            years: "years",
            quarter: "quarters",
            quarters: "quarters",
            month: "months",
            months: "months",
            week: "weeks",
            weeks: "weeks",
            day: "days",
            days: "days",
            hour: "hours",
            hours: "hours",
            minute: "minutes",
            minutes: "minutes",
            second: "seconds",
            seconds: "seconds",
            millisecond: "milliseconds",
            milliseconds: "milliseconds"
        }[unit ? unit.toLowerCase() : unit];
        if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
        return normalized;
    } /**
   * Check if an object is a Duration. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Duration.isDuration = function isDuration(o) {
        return o && o.isLuxonDuration || false;
    } /**
   * Get  the locale of a Duration, such 'en-GB'
   * @type {string}
   */ ;
    var _proto = Duration.prototype;
    /**
   * Returns a string representation of this Duration formatted according to the specified format string. You may use these tokens:
   * * `S` for milliseconds
   * * `s` for seconds
   * * `m` for minutes
   * * `h` for hours
   * * `d` for days
   * * `w` for weeks
   * * `M` for months
   * * `y` for years
   * Notes:
   * * Add padding by repeating the token, e.g. "yy" pads the years to two digits, "hhhh" pads the hours out to four digits
   * * Tokens can be escaped by wrapping with single quotes.
   * * The duration will be converted to the set of units in the format string using {@link Duration#shiftTo} and the Durations's conversion accuracy setting.
   * @param {string} fmt - the format string
   * @param {Object} opts - options
   * @param {boolean} [opts.floor=true] - floor numerical values
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("y d s") //=> "1 6 2"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("yy dd sss") //=> "01 06 002"
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toFormat("M S") //=> "12 518402000"
   * @return {string}
   */ _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        // reverse-compat since 1.2; we always round down now, never up, and we do it by default
        var fmtOpts = $63618293c58b5f80$var$_extends({}, opts, {
            floor: opts.round !== false && opts.floor !== false
        });
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc, fmtOpts).formatDurationFromString(this, fmt) : $63618293c58b5f80$var$INVALID$2;
    } /**
   * Returns a string representation of a Duration with all units included.
   * To modify its behavior use the `listStyle` and any Intl.NumberFormat option, though `unitDisplay` is especially relevant.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Intl/NumberFormat
   * @param opts - On option object to override the formatting. Accepts the same keys as the options parameter of the native `Int.NumberFormat` constructor, as well as `listStyle`.
   * @example
   * ```js
   * var dur = Duration.fromObject({ days: 1, hours: 5, minutes: 6 })
   * dur.toHuman() //=> '1 day, 5 hours, 6 minutes'
   * dur.toHuman({ listStyle: "long" }) //=> '1 day, 5 hours, and 6 minutes'
   * dur.toHuman({ unitDisplay: "short" }) //=> '1 day, 5 hr, 6 min'
   * ```
   */ ;
    _proto.toHuman = function toHuman(opts) {
        var _this = this;
        if (opts === void 0) opts = {};
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$2;
        var l = $63618293c58b5f80$var$orderedUnits$1.map(function(unit) {
            var val = _this.values[unit];
            if ($63618293c58b5f80$var$isUndefined(val)) return null;
            return _this.loc.numberFormatter($63618293c58b5f80$var$_extends({
                style: "unit",
                unitDisplay: "long"
            }, opts, {
                unit: unit.slice(0, -1)
            })).format(val);
        }).filter(function(n) {
            return n;
        });
        return this.loc.listFormatter($63618293c58b5f80$var$_extends({
            type: "conjunction",
            style: opts.listStyle || "narrow"
        }, opts)).format(l);
    } /**
   * Returns a JavaScript object with this Duration's values.
   * @example Duration.fromObject({ years: 1, days: 6, seconds: 2 }).toObject() //=> { years: 1, days: 6, seconds: 2 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject() {
        if (!this.isValid) return {};
        return $63618293c58b5f80$var$_extends({}, this.values);
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Durations
   * @example Duration.fromObject({ years: 3, seconds: 45 }).toISO() //=> 'P3YT45S'
   * @example Duration.fromObject({ months: 4, seconds: 45 }).toISO() //=> 'P4MT45S'
   * @example Duration.fromObject({ months: 5 }).toISO() //=> 'P5M'
   * @example Duration.fromObject({ minutes: 5 }).toISO() //=> 'PT5M'
   * @example Duration.fromObject({ milliseconds: 6 }).toISO() //=> 'PT0.006S'
   * @return {string}
   */ ;
    _proto.toISO = function toISO() {
        // we could use the formatter, but this is an easier way to get the minimum string
        if (!this.isValid) return null;
        var s = "P";
        if (this.years !== 0) s += this.years + "Y";
        if (this.months !== 0 || this.quarters !== 0) s += this.months + this.quarters * 3 + "M";
        if (this.weeks !== 0) s += this.weeks + "W";
        if (this.days !== 0) s += this.days + "D";
        if (this.hours !== 0 || this.minutes !== 0 || this.seconds !== 0 || this.milliseconds !== 0) s += "T";
        if (this.hours !== 0) s += this.hours + "H";
        if (this.minutes !== 0) s += this.minutes + "M";
        if (this.seconds !== 0 || this.milliseconds !== 0) // this will handle "floating point madness" by removing extra decimal places
        // https://stackoverflow.com/questions/588004/is-floating-point-math-broken
        s += $63618293c58b5f80$var$roundTo(this.seconds + this.milliseconds / 1000, 3) + "S";
        if (s === "P") s += "T0S";
        return s;
    } /**
   * Returns an ISO 8601-compliant string representation of this Duration, formatted as a time of day.
   * Note that this will return null if the duration is invalid, negative, or equal to or greater than 24 hours.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Times
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example Duration.fromObject({ hours: 11 }).toISOTime() //=> '11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressMilliseconds: true }) //=> '11:00:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ suppressSeconds: true }) //=> '11:00'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ includePrefix: true }) //=> 'T11:00:00.000'
   * @example Duration.fromObject({ hours: 11 }).toISOTime({ format: 'basic' }) //=> '110000.000'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        var millis = this.toMillis();
        if (millis < 0 || millis >= 86400000) return null;
        opts = $63618293c58b5f80$var$_extends({
            suppressMilliseconds: false,
            suppressSeconds: false,
            includePrefix: false,
            format: "extended"
        }, opts, {
            includeOffset: false
        });
        var dateTime = $63618293c58b5f80$var$DateTime.fromMillis(millis, {
            zone: "UTC"
        });
        return dateTime.toISOTime(opts);
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns an ISO 8601 representation of this Duration appropriate for use in debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.toISO();
    } /**
   * Returns an milliseconds value of this Duration.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        if (!this.isValid) return NaN;
        return $63618293c58b5f80$var$durationToMillis(this.matrix, this.values);
    } /**
   * Returns an milliseconds value of this Duration. Alias of {@link toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Make this Duration longer by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration), result = {};
        for(var _i2 = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits$1; _i2 < _orderedUnits.length; _i2++){
            var k = _orderedUnits[_i2];
            if ($63618293c58b5f80$var$hasOwnProperty(dur.values, k) || $63618293c58b5f80$var$hasOwnProperty(this.values, k)) result[k] = dur.get(k) + this.get(k);
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Make this Duration shorter by the specified amount. Return a newly-constructed Duration.
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @return {Duration}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = Duration.fromDurationLike(duration);
        return this.plus(dur.negate());
    } /**
   * Scale this Duration by the specified amount. Return a newly-constructed Duration.
   * @param {function} fn - The function to apply to each unit. Arity is 1 or 2: the value of the unit and, optionally, the unit name. Must return a number.
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits(x => x * 2) //=> { hours: 2, minutes: 60 }
   * @example Duration.fromObject({ hours: 1, minutes: 30 }).mapUnits((x, u) => u === "hours" ? x * 2 : x) //=> { hours: 2, minutes: 30 }
   * @return {Duration}
   */ ;
    _proto.mapUnits = function mapUnits(fn) {
        if (!this.isValid) return this;
        var result = {};
        for(var _i3 = 0, _Object$keys = Object.keys(this.values); _i3 < _Object$keys.length; _i3++){
            var k = _Object$keys[_i3];
            result[k] = $63618293c58b5f80$var$asNumber(fn(this.values[k], k));
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: result
        }, true);
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example Duration.fromObject({years: 2, days: 3}).get('years') //=> 2
   * @example Duration.fromObject({years: 2, days: 3}).get('months') //=> 0
   * @example Duration.fromObject({years: 2, days: 3}).get('days') //=> 3
   * @return {number}
   */ ;
    _proto.get = function get(unit) {
        return this[Duration.normalizeUnit(unit)];
    } /**
   * "Set" the values of specified units. Return a newly-constructed Duration.
   * @param {Object} values - a mapping of units to numbers
   * @example dur.set({ years: 2017 })
   * @example dur.set({ hours: 8, minutes: 30 })
   * @return {Duration}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var mixed = $63618293c58b5f80$var$_extends({}, this.values, $63618293c58b5f80$var$normalizeObject(values, Duration.normalizeUnit));
        return $63618293c58b5f80$var$clone$1(this, {
            values: mixed
        });
    } /**
   * "Set" the locale and/or numberingSystem.  Returns a newly-constructed Duration.
   * @example dur.reconfigure({ locale: 'en-GB' })
   * @return {Duration}
   */ ;
    _proto.reconfigure = function reconfigure(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, locale = _ref.locale, numberingSystem = _ref.numberingSystem, conversionAccuracy = _ref.conversionAccuracy, matrix = _ref.matrix;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem
        });
        var opts = {
            loc: loc,
            matrix: matrix,
            conversionAccuracy: conversionAccuracy
        };
        return $63618293c58b5f80$var$clone$1(this, opts);
    } /**
   * Return the length of the duration in the specified unit.
   * @param {string} unit - a unit such as 'minutes' or 'days'
   * @example Duration.fromObject({years: 1}).as('days') //=> 365
   * @example Duration.fromObject({years: 1}).as('months') //=> 12
   * @example Duration.fromObject({hours: 60}).as('days') //=> 2.5
   * @return {number}
   */ ;
    _proto.as = function as(unit) {
        return this.isValid ? this.shiftTo(unit).get(unit) : NaN;
    } /**
   * Reduce this Duration to its canonical representation in its current units.
   * Assuming the overall value of the Duration is positive, this means:
   * - excessive values for lower-order units are converted to higher-order units (if possible, see first and second example)
   * - negative lower-order units are converted to higher order units (there must be such a higher order unit, otherwise
   *   the overall value would be negative, see second example)
   * - fractional values for higher-order units are converted to lower-order units (if possible, see fourth example)
   *
   * If the overall value is negative, the result of this method is equivalent to `this.negate().normalize().negate()`.
   * @example Duration.fromObject({ years: 2, days: 5000 }).normalize().toObject() //=> { years: 15, days: 255 }
   * @example Duration.fromObject({ days: 5000 }).normalize().toObject() //=> { days: 5000 }
   * @example Duration.fromObject({ hours: 12, minutes: -45 }).normalize().toObject() //=> { hours: 11, minutes: 15 }
   * @example Duration.fromObject({ years: 2.5, days: 0, hours: 0 }).normalize().toObject() //=> { years: 2, days: 182, hours: 12 }
   * @return {Duration}
   */ ;
    _proto.normalize = function normalize() {
        if (!this.isValid) return this;
        var vals = this.toObject();
        $63618293c58b5f80$var$normalizeValues(this.matrix, vals);
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Rescale units to its largest representation
   * @example Duration.fromObject({ milliseconds: 90000 }).rescale().toObject() //=> { minutes: 1, seconds: 30 }
   * @return {Duration}
   */ ;
    _proto.rescale = function rescale() {
        if (!this.isValid) return this;
        var vals = $63618293c58b5f80$var$removeZeroes(this.normalize().shiftToAll().toObject());
        return $63618293c58b5f80$var$clone$1(this, {
            values: vals
        }, true);
    } /**
   * Convert this Duration into its representation in a different set of units.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).shiftTo('minutes', 'milliseconds').toObject() //=> { minutes: 60, milliseconds: 30000 }
   * @return {Duration}
   */ ;
    _proto.shiftTo = function shiftTo() {
        for(var _len = arguments.length, units = new Array(_len), _key = 0; _key < _len; _key++)units[_key] = arguments[_key];
        if (!this.isValid) return this;
        if (units.length === 0) return this;
        units = units.map(function(u) {
            return Duration.normalizeUnit(u);
        });
        var built = {}, accumulated = {}, vals = this.toObject();
        var lastUnit;
        for(var _i4 = 0, _orderedUnits2 = $63618293c58b5f80$var$orderedUnits$1; _i4 < _orderedUnits2.length; _i4++){
            var k = _orderedUnits2[_i4];
            if (units.indexOf(k) >= 0) {
                lastUnit = k;
                var own = 0;
                // anything we haven't boiled down yet should get boiled to this unit
                for(var ak in accumulated){
                    own += this.matrix[ak][k] * accumulated[ak];
                    accumulated[ak] = 0;
                }
                // plus anything that's already in this unit
                if ($63618293c58b5f80$var$isNumber(vals[k])) own += vals[k];
                // only keep the integer part for now in the hopes of putting any decimal part
                // into a smaller unit later
                var i = Math.trunc(own);
                built[k] = i;
                accumulated[k] = (own * 1000 - i * 1000) / 1000;
            // otherwise, keep it in the wings to boil it later
            } else if ($63618293c58b5f80$var$isNumber(vals[k])) accumulated[k] = vals[k];
        }
        // anything leftover becomes the decimal for the last unit
        // lastUnit must be defined since units is not empty
        for(var key in accumulated)if (accumulated[key] !== 0) built[lastUnit] += key === lastUnit ? accumulated[key] : accumulated[key] / this.matrix[lastUnit][key];
        $63618293c58b5f80$var$normalizeValues(this.matrix, built);
        return $63618293c58b5f80$var$clone$1(this, {
            values: built
        }, true);
    } /**
   * Shift this Duration to all available units.
   * Same as shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds")
   * @return {Duration}
   */ ;
    _proto.shiftToAll = function shiftToAll() {
        if (!this.isValid) return this;
        return this.shiftTo("years", "months", "weeks", "days", "hours", "minutes", "seconds", "milliseconds");
    } /**
   * Return the negative of this Duration.
   * @example Duration.fromObject({ hours: 1, seconds: 30 }).negate().toObject() //=> { hours: -1, seconds: -30 }
   * @return {Duration}
   */ ;
    _proto.negate = function negate() {
        if (!this.isValid) return this;
        var negated = {};
        for(var _i5 = 0, _Object$keys2 = Object.keys(this.values); _i5 < _Object$keys2.length; _i5++){
            var k = _Object$keys2[_i5];
            negated[k] = this.values[k] === 0 ? 0 : -this.values[k];
        }
        return $63618293c58b5f80$var$clone$1(this, {
            values: negated
        }, true);
    } /**
   * Get the years.
   * @type {number}
   */ ;
    /**
   * Equality check
   * Two Durations are equal iff they have the same units and the same values for each unit.
   * @param {Duration} other
   * @return {boolean}
   */ _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        if (!this.loc.equals(other.loc)) return false;
        function eq(v1, v2) {
            // Consider 0 and undefined as equal
            if (v1 === undefined || v1 === 0) return v2 === undefined || v2 === 0;
            return v1 === v2;
        }
        for(var _i6 = 0, _orderedUnits3 = $63618293c58b5f80$var$orderedUnits$1; _i6 < _orderedUnits3.length; _i6++){
            var u = _orderedUnits3[_i6];
            if (!eq(this.values[u], other.values[u])) return false;
        }
        return true;
    };
    $63618293c58b5f80$var$_createClass(Duration, [
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "years",
            get: function get() {
                return this.isValid ? this.values.years || 0 : NaN;
            }
        },
        {
            key: "quarters",
            get: function get() {
                return this.isValid ? this.values.quarters || 0 : NaN;
            }
        },
        {
            key: "months",
            get: function get() {
                return this.isValid ? this.values.months || 0 : NaN;
            }
        },
        {
            key: "weeks",
            get: function get() {
                return this.isValid ? this.values.weeks || 0 : NaN;
            }
        },
        {
            key: "days",
            get: function get() {
                return this.isValid ? this.values.days || 0 : NaN;
            }
        },
        {
            key: "hours",
            get: function get() {
                return this.isValid ? this.values.hours || 0 : NaN;
            }
        },
        {
            key: "minutes",
            get: function get() {
                return this.isValid ? this.values.minutes || 0 : NaN;
            }
        },
        {
            key: "seconds",
            get: function get() {
                return this.isValid ? this.values.seconds || 0 : NaN;
            }
        },
        {
            key: "milliseconds",
            get: function get() {
                return this.isValid ? this.values.milliseconds || 0 : NaN;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Duration;
}();
var $63618293c58b5f80$var$INVALID$1 = "Invalid Interval";
// checks if the start is equal to or before the end
function $63618293c58b5f80$var$validateStartEnd(start, end) {
    if (!start || !start.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid start");
    else if (!end || !end.isValid) return $63618293c58b5f80$var$Interval.invalid("missing or invalid end");
    else if (end < start) return $63618293c58b5f80$var$Interval.invalid("end before start", "The end of an interval must be after its start, but you had start=" + start.toISO() + " and end=" + end.toISO());
    else return null;
}
/**
 * An Interval object represents a half-open interval of time, where each endpoint is a {@link DateTime}. Conceptually, it's a container for those two endpoints, accompanied by methods for creating, parsing, interrogating, comparing, transforming, and formatting them.
 *
 * Here is a brief overview of the most commonly used methods and getters in Interval:
 *
 * * **Creation** To create an Interval, use {@link Interval.fromDateTimes}, {@link Interval.after}, {@link Interval.before}, or {@link Interval.fromISO}.
 * * **Accessors** Use {@link Interval#start} and {@link Interval#end} to get the start and end.
 * * **Interrogation** To analyze the Interval, use {@link Interval#count}, {@link Interval#length}, {@link Interval#hasSame}, {@link Interval#contains}, {@link Interval#isAfter}, or {@link Interval#isBefore}.
 * * **Transformation** To create other Intervals out of this one, use {@link Interval#set}, {@link Interval#splitAt}, {@link Interval#splitBy}, {@link Interval#divideEqually}, {@link Interval.merge}, {@link Interval.xor}, {@link Interval#union}, {@link Interval#intersection}, or {@link Interval#difference}.
 * * **Comparison** To compare this Interval to another one, use {@link Interval#equals}, {@link Interval#overlaps}, {@link Interval#abutsStart}, {@link Interval#abutsEnd}, {@link Interval#engulfs}
 * * **Output** To convert the Interval into other representations, see {@link Interval#toString}, {@link Interval#toLocaleString}, {@link Interval#toISO}, {@link Interval#toISODate}, {@link Interval#toISOTime}, {@link Interval#toFormat}, and {@link Interval#toDuration}.
 */ var $63618293c58b5f80$var$Interval = /*#__PURE__*/ function() {
    /**
   * @private
   */ function Interval(config) {
        /**
     * @access private
     */ this.s = config.start;
        /**
     * @access private
     */ this.e = config.end;
        /**
     * @access private
     */ this.invalid = config.invalid || null;
        /**
     * @access private
     */ this.isLuxonInterval = true;
    }
    /**
   * Create an invalid Interval.
   * @param {string} reason - simple string of why this Interval is invalid. Should not contain parameters or anything else data-dependent
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {Interval}
   */ Interval.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the Interval is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidIntervalError(invalid);
        else return new Interval({
            invalid: invalid
        });
    } /**
   * Create an Interval from a start DateTime and an end DateTime. Inclusive of the start but not the end.
   * @param {DateTime|Date|Object} start
   * @param {DateTime|Date|Object} end
   * @return {Interval}
   */ ;
    Interval.fromDateTimes = function fromDateTimes(start, end) {
        var builtStart = $63618293c58b5f80$var$friendlyDateTime(start), builtEnd = $63618293c58b5f80$var$friendlyDateTime(end);
        var validateError = $63618293c58b5f80$var$validateStartEnd(builtStart, builtEnd);
        if (validateError == null) return new Interval({
            start: builtStart,
            end: builtEnd
        });
        else return validateError;
    } /**
   * Create an Interval from a start DateTime and a Duration to extend to.
   * @param {DateTime|Date|Object} start
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.after = function after(start, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(start);
        return Interval.fromDateTimes(dt, dt.plus(dur));
    } /**
   * Create an Interval from an end DateTime and a Duration to extend backwards to.
   * @param {DateTime|Date|Object} end
   * @param {Duration|Object|number} duration - the length of the Interval.
   * @return {Interval}
   */ ;
    Interval.before = function before(end, duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration), dt = $63618293c58b5f80$var$friendlyDateTime(end);
        return Interval.fromDateTimes(dt.minus(dur), dt);
    } /**
   * Create an Interval from an ISO 8601 string.
   * Accepts `<start>/<end>`, `<start>/<duration>`, and `<duration>/<end>` formats.
   * @param {string} text - the ISO string to parse
   * @param {Object} [opts] - options to pass {@link DateTime#fromISO} and optionally {@link Duration#fromISO}
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {Interval}
   */ ;
    Interval.fromISO = function fromISO(text, opts) {
        var _split = (text || "").split("/", 2), s = _split[0], e = _split[1];
        if (s && e) {
            var start, startIsValid;
            try {
                start = $63618293c58b5f80$var$DateTime.fromISO(s, opts);
                startIsValid = start.isValid;
            } catch (e) {
                startIsValid = false;
            }
            var end, endIsValid;
            try {
                end = $63618293c58b5f80$var$DateTime.fromISO(e, opts);
                endIsValid = end.isValid;
            } catch (e) {
                endIsValid = false;
            }
            if (startIsValid && endIsValid) return Interval.fromDateTimes(start, end);
            if (startIsValid) {
                var dur = $63618293c58b5f80$var$Duration.fromISO(e, opts);
                if (dur.isValid) return Interval.after(start, dur);
            } else if (endIsValid) {
                var _dur = $63618293c58b5f80$var$Duration.fromISO(s, opts);
                if (_dur.isValid) return Interval.before(end, _dur);
            }
        }
        return Interval.invalid("unparsable", 'the input "' + text + "\" can't be parsed as ISO 8601");
    } /**
   * Check if an object is an Interval. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    Interval.isInterval = function isInterval(o) {
        return o && o.isLuxonInterval || false;
    } /**
   * Returns the start of the Interval
   * @type {DateTime}
   */ ;
    var _proto = Interval.prototype;
    /**
   * Returns the length of the Interval in the specified unit.
   * @param {string} unit - the unit (such as 'hours' or 'days') to return the length in.
   * @return {number}
   */ _proto.length = function length(unit) {
        if (unit === void 0) unit = "milliseconds";
        return this.isValid ? this.toDuration.apply(this, [
            unit
        ]).get(unit) : NaN;
    } /**
   * Returns the count of minutes, hours, days, months, or years included in the Interval, even in part.
   * Unlike {@link Interval#length} this counts sections of the calendar, not periods of time, e.g. specifying 'day'
   * asks 'what dates are included in this interval?', not 'how many days long is this interval?'
   * @param {string} [unit='milliseconds'] - the unit of time to count.
   * @return {number}
   */ ;
    _proto.count = function count(unit) {
        if (unit === void 0) unit = "milliseconds";
        if (!this.isValid) return NaN;
        var start = this.start.startOf(unit), end = this.end.startOf(unit);
        return Math.floor(end.diff(start, unit).get(unit)) + (end.valueOf() !== this.end.valueOf());
    } /**
   * Returns whether this Interval's start and end are both in the same unit of time
   * @param {string} unit - the unit of time to check sameness on
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(unit) {
        return this.isValid ? this.isEmpty() || this.e.minus(1).hasSame(this.s, unit) : false;
    } /**
   * Return whether this Interval has the same start and end DateTimes.
   * @return {boolean}
   */ ;
    _proto.isEmpty = function isEmpty() {
        return this.s.valueOf() === this.e.valueOf();
    } /**
   * Return whether this Interval's start is after the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isAfter = function isAfter(dateTime) {
        if (!this.isValid) return false;
        return this.s > dateTime;
    } /**
   * Return whether this Interval's end is before the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.isBefore = function isBefore(dateTime) {
        if (!this.isValid) return false;
        return this.e <= dateTime;
    } /**
   * Return whether this Interval contains the specified DateTime.
   * @param {DateTime} dateTime
   * @return {boolean}
   */ ;
    _proto.contains = function contains(dateTime) {
        if (!this.isValid) return false;
        return this.s <= dateTime && this.e > dateTime;
    } /**
   * "Sets" the start and/or end dates. Returns a newly-constructed Interval.
   * @param {Object} values - the values to set
   * @param {DateTime} values.start - the starting DateTime
   * @param {DateTime} values.end - the ending DateTime
   * @return {Interval}
   */ ;
    _proto.set = function set(_temp) {
        var _ref = _temp === void 0 ? {} : _temp, start = _ref.start, end = _ref.end;
        if (!this.isValid) return this;
        return Interval.fromDateTimes(start || this.s, end || this.e);
    } /**
   * Split this Interval at each of the specified DateTimes
   * @param {...DateTime} dateTimes - the unit of time to count.
   * @return {Array}
   */ ;
    _proto.splitAt = function splitAt() {
        var _this = this;
        if (!this.isValid) return [];
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        var sorted = dateTimes.map($63618293c58b5f80$var$friendlyDateTime).filter(function(d) {
            return _this.contains(d);
        }).sort(), results = [];
        var s = this.s, i = 0;
        while(s < this.e){
            var added = sorted[i] || this.e, next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            i += 1;
        }
        return results;
    } /**
   * Split this Interval into smaller Intervals, each of the specified length.
   * Left over time is grouped into a smaller interval
   * @param {Duration|Object|number} duration - The length of each resulting interval.
   * @return {Array}
   */ ;
    _proto.splitBy = function splitBy(duration) {
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        if (!this.isValid || !dur.isValid || dur.as("milliseconds") === 0) return [];
        var s = this.s, idx = 1, next;
        var results = [];
        while(s < this.e){
            var added = this.start.plus(dur.mapUnits(function(x) {
                return x * idx;
            }));
            next = +added > +this.e ? this.e : added;
            results.push(Interval.fromDateTimes(s, next));
            s = next;
            idx += 1;
        }
        return results;
    } /**
   * Split this Interval into the specified number of smaller intervals.
   * @param {number} numberOfParts - The number of Intervals to divide the Interval into.
   * @return {Array}
   */ ;
    _proto.divideEqually = function divideEqually(numberOfParts) {
        if (!this.isValid) return [];
        return this.splitBy(this.length() / numberOfParts).slice(0, numberOfParts);
    } /**
   * Return whether this Interval overlaps with the specified Interval
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.overlaps = function overlaps(other) {
        return this.e > other.s && this.s < other.e;
    } /**
   * Return whether this Interval's end is adjacent to the specified Interval's start.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsStart = function abutsStart(other) {
        if (!this.isValid) return false;
        return +this.e === +other.s;
    } /**
   * Return whether this Interval's start is adjacent to the specified Interval's end.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.abutsEnd = function abutsEnd(other) {
        if (!this.isValid) return false;
        return +other.e === +this.s;
    } /**
   * Return whether this Interval engulfs the start and end of the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.engulfs = function engulfs(other) {
        if (!this.isValid) return false;
        return this.s <= other.s && this.e >= other.e;
    } /**
   * Return whether this Interval has the same start and end as the specified Interval.
   * @param {Interval} other
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        if (!this.isValid || !other.isValid) return false;
        return this.s.equals(other.s) && this.e.equals(other.e);
    } /**
   * Return an Interval representing the intersection of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the maximum start time and the minimum end time of the two Intervals.
   * Returns null if the intersection is empty, meaning, the intervals don't intersect.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.intersection = function intersection(other) {
        if (!this.isValid) return this;
        var s = this.s > other.s ? this.s : other.s, e = this.e < other.e ? this.e : other.e;
        if (s >= e) return null;
        else return Interval.fromDateTimes(s, e);
    } /**
   * Return an Interval representing the union of this Interval and the specified Interval.
   * Specifically, the resulting Interval has the minimum start time and the maximum end time of the two Intervals.
   * @param {Interval} other
   * @return {Interval}
   */ ;
    _proto.union = function union(other) {
        if (!this.isValid) return this;
        var s = this.s < other.s ? this.s : other.s, e = this.e > other.e ? this.e : other.e;
        return Interval.fromDateTimes(s, e);
    } /**
   * Merge an array of Intervals into a equivalent minimal set of Intervals.
   * Combines overlapping and adjacent Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.merge = function merge(intervals) {
        var _intervals$sort$reduc = intervals.sort(function(a, b) {
            return a.s - b.s;
        }).reduce(function(_ref2, item) {
            var sofar = _ref2[0], current = _ref2[1];
            if (!current) return [
                sofar,
                item
            ];
            else if (current.overlaps(item) || current.abutsStart(item)) return [
                sofar,
                current.union(item)
            ];
            else return [
                sofar.concat([
                    current
                ]),
                item
            ];
        }, [
            [],
            null
        ]), found = _intervals$sort$reduc[0], final = _intervals$sort$reduc[1];
        if (final) found.push(final);
        return found;
    } /**
   * Return an array of Intervals representing the spans of time that only appear in one of the specified Intervals.
   * @param {Array} intervals
   * @return {Array}
   */ ;
    Interval.xor = function xor(intervals) {
        var _Array$prototype;
        var start = null, currentCount = 0;
        var results = [], ends = intervals.map(function(i) {
            return [
                {
                    time: i.s,
                    type: "s"
                },
                {
                    time: i.e,
                    type: "e"
                }
            ];
        }), flattened = (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, ends), arr = flattened.sort(function(a, b) {
            return a.time - b.time;
        });
        for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(arr), _step; !(_step = _iterator()).done;){
            var i = _step.value;
            currentCount += i.type === "s" ? 1 : -1;
            if (currentCount === 1) start = i.time;
            else {
                if (start && +start !== +i.time) results.push(Interval.fromDateTimes(start, i.time));
                start = null;
            }
        }
        return Interval.merge(results);
    } /**
   * Return an Interval representing the span of time in this Interval that doesn't overlap with any of the specified Intervals.
   * @param {...Interval} intervals
   * @return {Array}
   */ ;
    _proto.difference = function difference() {
        var _this2 = this;
        for(var _len2 = arguments.length, intervals = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)intervals[_key2] = arguments[_key2];
        return Interval.xor([
            this
        ].concat(intervals)).map(function(i) {
            return _this2.intersection(i);
        }).filter(function(i) {
            return i && !i.isEmpty();
        });
    } /**
   * Returns a string representation of this Interval appropriate for debugging.
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "[" + this.s.toISO() + " – " + this.e.toISO() + ")";
    } /**
   * Returns a localized string representing this Interval. Accepts the same options as the
   * Intl.DateTimeFormat constructor and any presets defined by Luxon, such as
   * {@link DateTime.DATE_FULL} or {@link DateTime.TIME_SIMPLE}. The exact behavior of this method
   * is browser-specific, but in general it will return an appropriate representation of the
   * Interval in the assigned locale. Defaults to the system's locale if no locale has been
   * specified.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {Object} [formatOpts=DateTime.DATE_SHORT] - Either a DateTime preset or
   * Intl.DateTimeFormat constructor options.
   * @param {Object} opts - Options to override the configuration of the start DateTime.
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(); //=> 11/7/2022 – 11/8/2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL); //=> November 7 – 8, 2022
   * @example Interval.fromISO('2022-11-07T09:00Z/2022-11-08T09:00Z').toLocaleString(DateTime.DATE_FULL, { locale: 'fr-FR' }); //=> 7–8 novembre 2022
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString(DateTime.TIME_SIMPLE); //=> 6:00 – 8:00 PM
   * @example Interval.fromISO('2022-11-07T17:00Z/2022-11-07T19:00Z').toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> Mon, Nov 07, 6:00 – 8:00 p
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.s.loc.clone(opts), formatOpts).formatInterval(this) : $63618293c58b5f80$var$INVALID$1;
    } /**
   * Returns an ISO 8601-compliant string representation of this Interval.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISO = function toISO(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISO(opts) + "/" + this.e.toISO(opts);
    } /**
   * Returns an ISO 8601-compliant string representation of date of this Interval.
   * The time components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate() {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISODate() + "/" + this.e.toISODate();
    } /**
   * Returns an ISO 8601-compliant string representation of time of this Interval.
   * The date components are ignored.
   * @see https://en.wikipedia.org/wiki/ISO_8601#Time_intervals
   * @param {Object} opts - The same options as {@link DateTime#toISO}
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(opts) {
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return this.s.toISOTime(opts) + "/" + this.e.toISOTime(opts);
    } /**
   * Returns a string representation of this Interval formatted according to the specified format
   * string. **You may not want this.** See {@link Interval#toLocaleString} for a more flexible
   * formatting tool.
   * @param {string} dateFormat - The format string. This string formats the start and end time.
   * See {@link DateTime#toFormat} for details.
   * @param {Object} opts - Options.
   * @param {string} [opts.separator =  ' – '] - A separator to place between the start and end
   * representations.
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(dateFormat, _temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, _ref3$separator = _ref3.separator, separator = _ref3$separator === void 0 ? " – " : _ref3$separator;
        if (!this.isValid) return $63618293c58b5f80$var$INVALID$1;
        return "" + this.s.toFormat(dateFormat) + separator + this.e.toFormat(dateFormat);
    } /**
   * Return a Duration representing the time spanned by this interval.
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example Interval.fromDateTimes(dt1, dt2).toDuration().toObject() //=> { milliseconds: 88489257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('days').toObject() //=> { days: 1.0241812152777778 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes']).toObject() //=> { hours: 24, minutes: 34.82095 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration(['hours', 'minutes', 'seconds']).toObject() //=> { hours: 24, minutes: 34, seconds: 49.257 }
   * @example Interval.fromDateTimes(dt1, dt2).toDuration('seconds').toObject() //=> { seconds: 88489.257 }
   * @return {Duration}
   */ ;
    _proto.toDuration = function toDuration(unit, opts) {
        if (!this.isValid) return $63618293c58b5f80$var$Duration.invalid(this.invalidReason);
        return this.e.diff(this.s, unit, opts);
    } /**
   * Run mapFn on the interval start and end, returning a new Interval from the resulting DateTimes
   * @param {function} mapFn
   * @return {Interval}
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.toUTC())
   * @example Interval.fromDateTimes(dt1, dt2).mapEndpoints(endpoint => endpoint.plus({ hours: 2 }))
   */ ;
    _proto.mapEndpoints = function mapEndpoints(mapFn) {
        return Interval.fromDateTimes(mapFn(this.s), mapFn(this.e));
    };
    $63618293c58b5f80$var$_createClass(Interval, [
        {
            key: "start",
            get: function get() {
                return this.isValid ? this.s : null;
            }
        },
        {
            key: "end",
            get: function get() {
                return this.isValid ? this.e : null;
            }
        },
        {
            key: "isValid",
            get: function get() {
                return this.invalidReason === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        }
    ]);
    return Interval;
}();
/**
 * The Info class contains static methods for retrieving general time and date related data. For example, it has methods for finding out if a time zone has a DST, for listing the months in any supported locale, and for discovering which of Luxon features are available in the current environment.
 */ var $63618293c58b5f80$var$Info = /*#__PURE__*/ function() {
    function Info() {}
    /**
   * Return whether the specified zone contains a DST.
   * @param {string|Zone} [zone='local'] - Zone to check. Defaults to the environment's local zone.
   * @return {boolean}
   */ Info.hasDST = function hasDST(zone) {
        if (zone === void 0) zone = $63618293c58b5f80$var$Settings.defaultZone;
        var proto = $63618293c58b5f80$var$DateTime.now().setZone(zone).set({
            month: 12
        });
        return !zone.isUniversal && proto.offset !== proto.set({
            month: 6
        }).offset;
    } /**
   * Return whether the specified zone is a valid IANA specifier.
   * @param {string} zone - Zone to check
   * @return {boolean}
   */ ;
    Info.isValidIANAZone = function isValidIANAZone(zone) {
        return $63618293c58b5f80$var$IANAZone.isValidZone(zone);
    } /**
   * Converts the input into a {@link Zone} instance.
   *
   * * If `input` is already a Zone instance, it is returned unchanged.
   * * If `input` is a string containing a valid time zone name, a Zone instance
   *   with that name is returned.
   * * If `input` is a string that doesn't refer to a known time zone, a Zone
   *   instance with {@link Zone#isValid} == false is returned.
   * * If `input is a number, a Zone instance with the specified fixed offset
   *   in minutes is returned.
   * * If `input` is `null` or `undefined`, the default zone is returned.
   * @param {string|Zone|number} [input] - the value to be converted
   * @return {Zone}
   */ ;
    Info.normalizeZone = function normalizeZone$1(input) {
        return $63618293c58b5f80$var$normalizeZone(input, $63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * Return an array of standalone month names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @example Info.months()[0] //=> 'January'
   * @example Info.months('short')[0] //=> 'Jan'
   * @example Info.months('numeric')[0] //=> '1'
   * @example Info.months('short', { locale: 'fr-CA' } )[0] //=> 'janv.'
   * @example Info.months('numeric', { locale: 'ar' })[0] //=> '١'
   * @example Info.months('long', { outputCalendar: 'islamic' })[0] //=> 'Rabiʻ I'
   * @return {Array}
   */ ;
    Info.months = function months(length, _temp) {
        if (length === void 0) length = "long";
        var _ref = _temp === void 0 ? {} : _temp, _ref$locale = _ref.locale, locale = _ref$locale === void 0 ? null : _ref$locale, _ref$numberingSystem = _ref.numberingSystem, numberingSystem = _ref$numberingSystem === void 0 ? null : _ref$numberingSystem, _ref$locObj = _ref.locObj, locObj = _ref$locObj === void 0 ? null : _ref$locObj, _ref$outputCalendar = _ref.outputCalendar, outputCalendar = _ref$outputCalendar === void 0 ? "gregory" : _ref$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length);
    } /**
   * Return an array of format month names.
   * Format months differ from standalone months in that they're meant to appear next to the day of the month. In some languages, that
   * changes the string.
   * See {@link Info#months}
   * @param {string} [length='long'] - the length of the month representation, such as "numeric", "2-digit", "narrow", "short", "long"
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @param {string} [opts.outputCalendar='gregory'] - the calendar
   * @return {Array}
   */ ;
    Info.monthsFormat = function monthsFormat(length, _temp2) {
        if (length === void 0) length = "long";
        var _ref2 = _temp2 === void 0 ? {} : _temp2, _ref2$locale = _ref2.locale, locale = _ref2$locale === void 0 ? null : _ref2$locale, _ref2$numberingSystem = _ref2.numberingSystem, numberingSystem = _ref2$numberingSystem === void 0 ? null : _ref2$numberingSystem, _ref2$locObj = _ref2.locObj, locObj = _ref2$locObj === void 0 ? null : _ref2$locObj, _ref2$outputCalendar = _ref2.outputCalendar, outputCalendar = _ref2$outputCalendar === void 0 ? "gregory" : _ref2$outputCalendar;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, outputCalendar)).months(length, true);
    } /**
   * Return an array of standalone week names.
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param {string} [length='long'] - the length of the weekday representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @example Info.weekdays()[0] //=> 'Monday'
   * @example Info.weekdays('short')[0] //=> 'Mon'
   * @example Info.weekdays('short', { locale: 'fr-CA' })[0] //=> 'lun.'
   * @example Info.weekdays('short', { locale: 'ar' })[0] //=> 'الاثنين'
   * @return {Array}
   */ ;
    Info.weekdays = function weekdays(length, _temp3) {
        if (length === void 0) length = "long";
        var _ref3 = _temp3 === void 0 ? {} : _temp3, _ref3$locale = _ref3.locale, locale = _ref3$locale === void 0 ? null : _ref3$locale, _ref3$numberingSystem = _ref3.numberingSystem, numberingSystem = _ref3$numberingSystem === void 0 ? null : _ref3$numberingSystem, _ref3$locObj = _ref3.locObj, locObj = _ref3$locObj === void 0 ? null : _ref3$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length);
    } /**
   * Return an array of format week names.
   * Format weekdays differ from standalone weekdays in that they're meant to appear next to more date information. In some languages, that
   * changes the string.
   * See {@link Info#weekdays}
   * @param {string} [length='long'] - the length of the month representation, such as "narrow", "short", "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale=null] - the locale code
   * @param {string} [opts.numberingSystem=null] - the numbering system
   * @param {string} [opts.locObj=null] - an existing locale object to use
   * @return {Array}
   */ ;
    Info.weekdaysFormat = function weekdaysFormat(length, _temp4) {
        if (length === void 0) length = "long";
        var _ref4 = _temp4 === void 0 ? {} : _temp4, _ref4$locale = _ref4.locale, locale = _ref4$locale === void 0 ? null : _ref4$locale, _ref4$numberingSystem = _ref4.numberingSystem, numberingSystem = _ref4$numberingSystem === void 0 ? null : _ref4$numberingSystem, _ref4$locObj = _ref4.locObj, locObj = _ref4$locObj === void 0 ? null : _ref4$locObj;
        return (locObj || $63618293c58b5f80$var$Locale.create(locale, numberingSystem, null)).weekdays(length, true);
    } /**
   * Return an array of meridiems.
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.meridiems() //=> [ 'AM', 'PM' ]
   * @example Info.meridiems({ locale: 'my' }) //=> [ 'နံနက်', 'ညနေ' ]
   * @return {Array}
   */ ;
    Info.meridiems = function meridiems(_temp5) {
        var _ref5 = _temp5 === void 0 ? {} : _temp5, _ref5$locale = _ref5.locale, locale = _ref5$locale === void 0 ? null : _ref5$locale;
        return $63618293c58b5f80$var$Locale.create(locale).meridiems();
    } /**
   * Return an array of eras, such as ['BC', 'AD']. The locale can be specified, but the calendar system is always Gregorian.
   * @param {string} [length='short'] - the length of the era representation, such as "short" or "long".
   * @param {Object} opts - options
   * @param {string} [opts.locale] - the locale code
   * @example Info.eras() //=> [ 'BC', 'AD' ]
   * @example Info.eras('long') //=> [ 'Before Christ', 'Anno Domini' ]
   * @example Info.eras('long', { locale: 'fr' }) //=> [ 'avant Jésus-Christ', 'après Jésus-Christ' ]
   * @return {Array}
   */ ;
    Info.eras = function eras(length, _temp6) {
        if (length === void 0) length = "short";
        var _ref6 = _temp6 === void 0 ? {} : _temp6, _ref6$locale = _ref6.locale, locale = _ref6$locale === void 0 ? null : _ref6$locale;
        return $63618293c58b5f80$var$Locale.create(locale, null, "gregory").eras(length);
    } /**
   * Return the set of available features in this environment.
   * Some features of Luxon are not available in all environments. For example, on older browsers, relative time formatting support is not available. Use this function to figure out if that's the case.
   * Keys:
   * * `relative`: whether this environment supports relative time formatting
   * @example Info.features() //=> { relative: false }
   * @return {Object}
   */ ;
    Info.features = function features() {
        return {
            relative: $63618293c58b5f80$var$hasRelative()
        };
    };
    return Info;
}();
function $63618293c58b5f80$var$dayDiff(earlier, later) {
    var utcDayStart = function utcDayStart(dt) {
        return dt.toUTC(0, {
            keepLocalTime: true
        }).startOf("day").valueOf();
    }, ms = utcDayStart(later) - utcDayStart(earlier);
    return Math.floor($63618293c58b5f80$var$Duration.fromMillis(ms).as("days"));
}
function $63618293c58b5f80$var$highOrderDiffs(cursor, later, units) {
    var differs = [
        [
            "years",
            function(a, b) {
                return b.year - a.year;
            }
        ],
        [
            "quarters",
            function(a, b) {
                return b.quarter - a.quarter + (b.year - a.year) * 4;
            }
        ],
        [
            "months",
            function(a, b) {
                return b.month - a.month + (b.year - a.year) * 12;
            }
        ],
        [
            "weeks",
            function(a, b) {
                var days = $63618293c58b5f80$var$dayDiff(a, b);
                return (days - days % 7) / 7;
            }
        ],
        [
            "days",
            $63618293c58b5f80$var$dayDiff
        ]
    ];
    var results = {};
    var earlier = cursor;
    var lowestOrder, highWater;
    /* This loop tries to diff using larger units first.
     If we overshoot, we backtrack and try the next smaller unit.
     "cursor" starts out at the earlier timestamp and moves closer and closer to "later"
     as we use smaller and smaller units.
     highWater keeps track of where we would be if we added one more of the smallest unit,
     this is used later to potentially convert any difference smaller than the smallest higher order unit
     into a fraction of that smallest higher order unit
  */ for(var _i = 0, _differs = differs; _i < _differs.length; _i++){
        var _differs$_i = _differs[_i], unit = _differs$_i[0], differ = _differs$_i[1];
        if (units.indexOf(unit) >= 0) {
            lowestOrder = unit;
            results[unit] = differ(cursor, later);
            highWater = earlier.plus(results);
            if (highWater > later) {
                // we overshot the end point, backtrack cursor by 1
                results[unit]--;
                cursor = earlier.plus(results);
                // if we are still overshooting now, we need to backtrack again
                // this happens in certain situations when diffing times in different zones,
                // because this calculation ignores time zones
                if (cursor > later) {
                    // keep the "overshot by 1" around as highWater
                    highWater = cursor;
                    // backtrack cursor by 1
                    results[unit]--;
                    cursor = earlier.plus(results);
                }
            } else cursor = highWater;
        }
    }
    return [
        cursor,
        results,
        highWater,
        lowestOrder
    ];
}
function $63618293c58b5f80$var$_diff(earlier, later, units, opts) {
    var _highOrderDiffs = $63618293c58b5f80$var$highOrderDiffs(earlier, later, units), cursor = _highOrderDiffs[0], results = _highOrderDiffs[1], highWater = _highOrderDiffs[2], lowestOrder = _highOrderDiffs[3];
    var remainingMillis = later - cursor;
    var lowerOrderUnits = units.filter(function(u) {
        return [
            "hours",
            "minutes",
            "seconds",
            "milliseconds"
        ].indexOf(u) >= 0;
    });
    if (lowerOrderUnits.length === 0) {
        if (highWater < later) {
            var _cursor$plus;
            highWater = cursor.plus((_cursor$plus = {}, _cursor$plus[lowestOrder] = 1, _cursor$plus));
        }
        if (highWater !== cursor) results[lowestOrder] = (results[lowestOrder] || 0) + remainingMillis / (highWater - cursor);
    }
    var duration = $63618293c58b5f80$var$Duration.fromObject(results, opts);
    if (lowerOrderUnits.length > 0) {
        var _Duration$fromMillis;
        return (_Duration$fromMillis = $63618293c58b5f80$var$Duration.fromMillis(remainingMillis, opts)).shiftTo.apply(_Duration$fromMillis, lowerOrderUnits).plus(duration);
    } else return duration;
}
var $63618293c58b5f80$var$numberingSystems = {
    arab: "[٠-٩]",
    arabext: "[۰-۹]",
    bali: "[᭐-᭙]",
    beng: "[০-৯]",
    deva: "[०-९]",
    fullwide: "[０-９]",
    gujr: "[૦-૯]",
    hanidec: "[〇|一|二|三|四|五|六|七|八|九]",
    khmr: "[០-៩]",
    knda: "[೦-೯]",
    laoo: "[໐-໙]",
    limb: "[᥆-᥏]",
    mlym: "[൦-൯]",
    mong: "[᠐-᠙]",
    mymr: "[၀-၉]",
    orya: "[୦-୯]",
    tamldec: "[௦-௯]",
    telu: "[౦-౯]",
    thai: "[๐-๙]",
    tibt: "[༠-༩]",
    latn: "\\d"
};
var $63618293c58b5f80$var$numberingSystemsUTF16 = {
    arab: [
        1632,
        1641
    ],
    arabext: [
        1776,
        1785
    ],
    bali: [
        6992,
        7001
    ],
    beng: [
        2534,
        2543
    ],
    deva: [
        2406,
        2415
    ],
    fullwide: [
        65296,
        65303
    ],
    gujr: [
        2790,
        2799
    ],
    khmr: [
        6112,
        6121
    ],
    knda: [
        3302,
        3311
    ],
    laoo: [
        3792,
        3801
    ],
    limb: [
        6470,
        6479
    ],
    mlym: [
        3430,
        3439
    ],
    mong: [
        6160,
        6169
    ],
    mymr: [
        4160,
        4169
    ],
    orya: [
        2918,
        2927
    ],
    tamldec: [
        3046,
        3055
    ],
    telu: [
        3174,
        3183
    ],
    thai: [
        3664,
        3673
    ],
    tibt: [
        3872,
        3881
    ]
};
var $63618293c58b5f80$var$hanidecChars = $63618293c58b5f80$var$numberingSystems.hanidec.replace(/[\[|\]]/g, "").split("");
function $63618293c58b5f80$var$parseDigits(str) {
    var value = parseInt(str, 10);
    if (isNaN(value)) {
        value = "";
        for(var i = 0; i < str.length; i++){
            var code = str.charCodeAt(i);
            if (str[i].search($63618293c58b5f80$var$numberingSystems.hanidec) !== -1) value += $63618293c58b5f80$var$hanidecChars.indexOf(str[i]);
            else for(var key in $63618293c58b5f80$var$numberingSystemsUTF16){
                var _numberingSystemsUTF = $63618293c58b5f80$var$numberingSystemsUTF16[key], min = _numberingSystemsUTF[0], max = _numberingSystemsUTF[1];
                if (code >= min && code <= max) value += code - min;
            }
        }
        return parseInt(value, 10);
    } else return value;
}
function $63618293c58b5f80$var$digitRegex(_ref, append) {
    var numberingSystem = _ref.numberingSystem;
    if (append === void 0) append = "";
    return new RegExp("" + $63618293c58b5f80$var$numberingSystems[numberingSystem || "latn"] + append);
}
var $63618293c58b5f80$var$MISSING_FTP = "missing Intl.DateTimeFormat.formatToParts support";
function $63618293c58b5f80$var$intUnit(regex, post) {
    if (post === void 0) post = function post(i) {
        return i;
    };
    return {
        regex: regex,
        deser: function deser(_ref) {
            var s = _ref[0];
            return post($63618293c58b5f80$var$parseDigits(s));
        }
    };
}
var $63618293c58b5f80$var$NBSP = String.fromCharCode(160);
var $63618293c58b5f80$var$spaceOrNBSP = "[ " + $63618293c58b5f80$var$NBSP + "]";
var $63618293c58b5f80$var$spaceOrNBSPRegExp = new RegExp($63618293c58b5f80$var$spaceOrNBSP, "g");
function $63618293c58b5f80$var$fixListRegex(s) {
    // make dots optional and also make them literal
    // make space and non breakable space characters interchangeable
    return s.replace(/\./g, "\\.?").replace($63618293c58b5f80$var$spaceOrNBSPRegExp, $63618293c58b5f80$var$spaceOrNBSP);
}
function $63618293c58b5f80$var$stripInsensitivities(s) {
    return s.replace(/\./g, "") // ignore dots that were made optional
    .replace($63618293c58b5f80$var$spaceOrNBSPRegExp, " ") // interchange space and nbsp
    .toLowerCase();
}
function $63618293c58b5f80$var$oneOf(strings, startIndex) {
    if (strings === null) return null;
    else return {
        regex: RegExp(strings.map($63618293c58b5f80$var$fixListRegex).join("|")),
        deser: function deser(_ref2) {
            var s = _ref2[0];
            return strings.findIndex(function(i) {
                return $63618293c58b5f80$var$stripInsensitivities(s) === $63618293c58b5f80$var$stripInsensitivities(i);
            }) + startIndex;
        }
    };
}
function $63618293c58b5f80$var$offset(regex, groups) {
    return {
        regex: regex,
        deser: function deser(_ref3) {
            var h = _ref3[1], m = _ref3[2];
            return $63618293c58b5f80$var$signedOffset(h, m);
        },
        groups: groups
    };
}
function $63618293c58b5f80$var$simple(regex) {
    return {
        regex: regex,
        deser: function deser(_ref4) {
            var s = _ref4[0];
            return s;
        }
    };
}
function $63618293c58b5f80$var$escapeToken(value) {
    return value.replace(/[\-\[\]{}()*+?.,\\\^$|#\s]/g, "\\$&");
}
/**
 * @param token
 * @param {Locale} loc
 */ function $63618293c58b5f80$var$unitForToken(token, loc) {
    var one = $63618293c58b5f80$var$digitRegex(loc), two = $63618293c58b5f80$var$digitRegex(loc, "{2}"), three = $63618293c58b5f80$var$digitRegex(loc, "{3}"), four = $63618293c58b5f80$var$digitRegex(loc, "{4}"), six = $63618293c58b5f80$var$digitRegex(loc, "{6}"), oneOrTwo = $63618293c58b5f80$var$digitRegex(loc, "{1,2}"), oneToThree = $63618293c58b5f80$var$digitRegex(loc, "{1,3}"), oneToSix = $63618293c58b5f80$var$digitRegex(loc, "{1,6}"), oneToNine = $63618293c58b5f80$var$digitRegex(loc, "{1,9}"), twoToFour = $63618293c58b5f80$var$digitRegex(loc, "{2,4}"), fourToSix = $63618293c58b5f80$var$digitRegex(loc, "{4,6}"), literal = function literal(t) {
        return {
            regex: RegExp($63618293c58b5f80$var$escapeToken(t.val)),
            deser: function deser(_ref5) {
                var s = _ref5[0];
                return s;
            },
            literal: true
        };
    }, unitate = function unitate(t) {
        if (token.literal) return literal(t);
        switch(t.val){
            // era
            case "G":
                return $63618293c58b5f80$var$oneOf(loc.eras("short"), 0);
            case "GG":
                return $63618293c58b5f80$var$oneOf(loc.eras("long"), 0);
            // years
            case "y":
                return $63618293c58b5f80$var$intUnit(oneToSix);
            case "yy":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            case "yyyy":
                return $63618293c58b5f80$var$intUnit(four);
            case "yyyyy":
                return $63618293c58b5f80$var$intUnit(fourToSix);
            case "yyyyyy":
                return $63618293c58b5f80$var$intUnit(six);
            // months
            case "M":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "MM":
                return $63618293c58b5f80$var$intUnit(two);
            case "MMM":
                return $63618293c58b5f80$var$oneOf(loc.months("short", true), 1);
            case "MMMM":
                return $63618293c58b5f80$var$oneOf(loc.months("long", true), 1);
            case "L":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "LL":
                return $63618293c58b5f80$var$intUnit(two);
            case "LLL":
                return $63618293c58b5f80$var$oneOf(loc.months("short", false), 1);
            case "LLLL":
                return $63618293c58b5f80$var$oneOf(loc.months("long", false), 1);
            // dates
            case "d":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "dd":
                return $63618293c58b5f80$var$intUnit(two);
            // ordinals
            case "o":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "ooo":
                return $63618293c58b5f80$var$intUnit(three);
            // time
            case "HH":
                return $63618293c58b5f80$var$intUnit(two);
            case "H":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "hh":
                return $63618293c58b5f80$var$intUnit(two);
            case "h":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "mm":
                return $63618293c58b5f80$var$intUnit(two);
            case "m":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "q":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "qq":
                return $63618293c58b5f80$var$intUnit(two);
            case "s":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "ss":
                return $63618293c58b5f80$var$intUnit(two);
            case "S":
                return $63618293c58b5f80$var$intUnit(oneToThree);
            case "SSS":
                return $63618293c58b5f80$var$intUnit(three);
            case "u":
                return $63618293c58b5f80$var$simple(oneToNine);
            case "uu":
                return $63618293c58b5f80$var$simple(oneOrTwo);
            case "uuu":
                return $63618293c58b5f80$var$intUnit(one);
            // meridiem
            case "a":
                return $63618293c58b5f80$var$oneOf(loc.meridiems(), 0);
            // weekYear (k)
            case "kkkk":
                return $63618293c58b5f80$var$intUnit(four);
            case "kk":
                return $63618293c58b5f80$var$intUnit(twoToFour, $63618293c58b5f80$var$untruncateYear);
            // weekNumber (W)
            case "W":
                return $63618293c58b5f80$var$intUnit(oneOrTwo);
            case "WW":
                return $63618293c58b5f80$var$intUnit(two);
            // weekdays
            case "E":
            case "c":
                return $63618293c58b5f80$var$intUnit(one);
            case "EEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", false), 1);
            case "EEEE":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", false), 1);
            case "ccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("short", true), 1);
            case "cccc":
                return $63618293c58b5f80$var$oneOf(loc.weekdays("long", true), 1);
            // offset/zone
            case "Z":
            case "ZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(?::(" + two.source + "))?"), 2);
            case "ZZZ":
                return $63618293c58b5f80$var$offset(new RegExp("([+-]" + oneOrTwo.source + ")(" + two.source + ")?"), 2);
            // we don't support ZZZZ (PST) or ZZZZZ (Pacific Standard Time) in parsing
            // because we don't have any way to figure out what they are
            case "z":
                return $63618293c58b5f80$var$simple(/[a-z_+-/]{1,256}?/i);
            // this special-case "token" represents a place where a macro-token expanded into a white-space literal
            // in this case we accept any non-newline white-space
            case " ":
                return $63618293c58b5f80$var$simple(/[^\S\n\r]/);
            default:
                return literal(t);
        }
    };
    var unit = unitate(token) || {
        invalidReason: $63618293c58b5f80$var$MISSING_FTP
    };
    unit.token = token;
    return unit;
}
var $63618293c58b5f80$var$partTypeStyleToTokenVal = {
    year: {
        "2-digit": "yy",
        numeric: "yyyyy"
    },
    month: {
        numeric: "M",
        "2-digit": "MM",
        short: "MMM",
        long: "MMMM"
    },
    day: {
        numeric: "d",
        "2-digit": "dd"
    },
    weekday: {
        short: "EEE",
        long: "EEEE"
    },
    dayperiod: "a",
    dayPeriod: "a",
    hour12: {
        numeric: "h",
        "2-digit": "hh"
    },
    hour24: {
        numeric: "H",
        "2-digit": "HH"
    },
    minute: {
        numeric: "m",
        "2-digit": "mm"
    },
    second: {
        numeric: "s",
        "2-digit": "ss"
    },
    timeZoneName: {
        long: "ZZZZZ",
        short: "ZZZ"
    }
};
function $63618293c58b5f80$var$tokenForPart(part, formatOpts, resolvedOpts) {
    var type = part.type, value = part.value;
    if (type === "literal") {
        var isSpace = /^\s+$/.test(value);
        return {
            literal: !isSpace,
            val: isSpace ? " " : value
        };
    }
    var style = formatOpts[type];
    // The user might have explicitly specified hour12 or hourCycle
    // if so, respect their decision
    // if not, refer back to the resolvedOpts, which are based on the locale
    var actualType = type;
    if (type === "hour") {
        if (formatOpts.hour12 != null) actualType = formatOpts.hour12 ? "hour12" : "hour24";
        else if (formatOpts.hourCycle != null) {
            if (formatOpts.hourCycle === "h11" || formatOpts.hourCycle === "h12") actualType = "hour12";
            else actualType = "hour24";
        } else // tokens only differentiate between 24 hours or not,
        // so we do not need to check hourCycle here, which is less supported anyways
        actualType = resolvedOpts.hour12 ? "hour12" : "hour24";
    }
    var val = $63618293c58b5f80$var$partTypeStyleToTokenVal[actualType];
    if (typeof val === "object") val = val[style];
    if (val) return {
        literal: false,
        val: val
    };
    return undefined;
}
function $63618293c58b5f80$var$buildRegex(units) {
    var re = units.map(function(u) {
        return u.regex;
    }).reduce(function(f, r) {
        return f + "(" + r.source + ")";
    }, "");
    return [
        "^" + re + "$",
        units
    ];
}
function $63618293c58b5f80$var$match(input, regex, handlers) {
    var matches = input.match(regex);
    if (matches) {
        var all = {};
        var matchIndex = 1;
        for(var i in handlers)if ($63618293c58b5f80$var$hasOwnProperty(handlers, i)) {
            var h = handlers[i], groups = h.groups ? h.groups + 1 : 1;
            if (!h.literal && h.token) all[h.token.val[0]] = h.deser(matches.slice(matchIndex, matchIndex + groups));
            matchIndex += groups;
        }
        return [
            matches,
            all
        ];
    } else return [
        matches,
        {}
    ];
}
function $63618293c58b5f80$var$dateTimeFromMatches(matches) {
    var toField = function toField(token) {
        switch(token){
            case "S":
                return "millisecond";
            case "s":
                return "second";
            case "m":
                return "minute";
            case "h":
            case "H":
                return "hour";
            case "d":
                return "day";
            case "o":
                return "ordinal";
            case "L":
            case "M":
                return "month";
            case "y":
                return "year";
            case "E":
            case "c":
                return "weekday";
            case "W":
                return "weekNumber";
            case "k":
                return "weekYear";
            case "q":
                return "quarter";
            default:
                return null;
        }
    };
    var zone = null;
    var specificOffset;
    if (!$63618293c58b5f80$var$isUndefined(matches.z)) zone = $63618293c58b5f80$var$IANAZone.create(matches.z);
    if (!$63618293c58b5f80$var$isUndefined(matches.Z)) {
        if (!zone) zone = new $63618293c58b5f80$var$FixedOffsetZone(matches.Z);
        specificOffset = matches.Z;
    }
    if (!$63618293c58b5f80$var$isUndefined(matches.q)) matches.M = (matches.q - 1) * 3 + 1;
    if (!$63618293c58b5f80$var$isUndefined(matches.h)) {
        if (matches.h < 12 && matches.a === 1) matches.h += 12;
        else if (matches.h === 12 && matches.a === 0) matches.h = 0;
    }
    if (matches.G === 0 && matches.y) matches.y = -matches.y;
    if (!$63618293c58b5f80$var$isUndefined(matches.u)) matches.S = $63618293c58b5f80$var$parseMillis(matches.u);
    var vals = Object.keys(matches).reduce(function(r, k) {
        var f = toField(k);
        if (f) r[f] = matches[k];
        return r;
    }, {});
    return [
        vals,
        zone,
        specificOffset
    ];
}
var $63618293c58b5f80$var$dummyDateTimeCache = null;
function $63618293c58b5f80$var$getDummyDateTime() {
    if (!$63618293c58b5f80$var$dummyDateTimeCache) $63618293c58b5f80$var$dummyDateTimeCache = $63618293c58b5f80$var$DateTime.fromMillis(1555555555555);
    return $63618293c58b5f80$var$dummyDateTimeCache;
}
function $63618293c58b5f80$var$maybeExpandMacroToken(token, locale) {
    if (token.literal) return token;
    var formatOpts = $63618293c58b5f80$var$Formatter.macroTokenToFormatOpts(token.val);
    var tokens = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale);
    if (tokens == null || tokens.includes(undefined)) return token;
    return tokens;
}
function $63618293c58b5f80$var$expandMacroTokens(tokens, locale) {
    var _Array$prototype;
    return (_Array$prototype = Array.prototype).concat.apply(_Array$prototype, tokens.map(function(t) {
        return $63618293c58b5f80$var$maybeExpandMacroToken(t, locale);
    }));
}
/**
 * @private
 */ function $63618293c58b5f80$var$explainFromTokens(locale, input, format) {
    var tokens = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(format), locale), units = tokens.map(function(t) {
        return $63618293c58b5f80$var$unitForToken(t, locale);
    }), disqualifyingUnit = units.find(function(t) {
        return t.invalidReason;
    });
    if (disqualifyingUnit) return {
        input: input,
        tokens: tokens,
        invalidReason: disqualifyingUnit.invalidReason
    };
    else {
        var _buildRegex = $63618293c58b5f80$var$buildRegex(units), regexString = _buildRegex[0], handlers = _buildRegex[1], regex = RegExp(regexString, "i"), _match = $63618293c58b5f80$var$match(input, regex, handlers), rawMatches = _match[0], matches = _match[1], _ref6 = matches ? $63618293c58b5f80$var$dateTimeFromMatches(matches) : [
            null,
            null,
            undefined
        ], result = _ref6[0], zone = _ref6[1], specificOffset = _ref6[2];
        if ($63618293c58b5f80$var$hasOwnProperty(matches, "a") && $63618293c58b5f80$var$hasOwnProperty(matches, "H")) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't include meridiem when specifying 24-hour format");
        return {
            input: input,
            tokens: tokens,
            regex: regex,
            rawMatches: rawMatches,
            matches: matches,
            result: result,
            zone: zone,
            specificOffset: specificOffset
        };
    }
}
function $63618293c58b5f80$var$parseFromTokens(locale, input, format) {
    var _explainFromTokens = $63618293c58b5f80$var$explainFromTokens(locale, input, format), result = _explainFromTokens.result, zone = _explainFromTokens.zone, specificOffset = _explainFromTokens.specificOffset, invalidReason = _explainFromTokens.invalidReason;
    return [
        result,
        zone,
        specificOffset,
        invalidReason
    ];
}
function $63618293c58b5f80$var$formatOptsToTokens(formatOpts, locale) {
    if (!formatOpts) return null;
    var formatter = $63618293c58b5f80$var$Formatter.create(locale, formatOpts);
    var df = formatter.dtFormatter($63618293c58b5f80$var$getDummyDateTime());
    var parts = df.formatToParts();
    var resolvedOpts = df.resolvedOptions();
    return parts.map(function(p) {
        return $63618293c58b5f80$var$tokenForPart(p, formatOpts, resolvedOpts);
    });
}
var $63618293c58b5f80$var$nonLeapLadder = [
    0,
    31,
    59,
    90,
    120,
    151,
    181,
    212,
    243,
    273,
    304,
    334
], $63618293c58b5f80$var$leapLadder = [
    0,
    31,
    60,
    91,
    121,
    152,
    182,
    213,
    244,
    274,
    305,
    335
];
function $63618293c58b5f80$var$unitOutOfRange(unit, value) {
    return new $63618293c58b5f80$var$Invalid("unit out of range", "you specified " + value + " (of type " + typeof value + ") as a " + unit + ", which is invalid");
}
function $63618293c58b5f80$var$dayOfWeek(year, month, day) {
    var d = new Date(Date.UTC(year, month - 1, day));
    if (year < 100 && year >= 0) d.setUTCFullYear(d.getUTCFullYear() - 1900);
    var js = d.getUTCDay();
    return js === 0 ? 7 : js;
}
function $63618293c58b5f80$var$computeOrdinal(year, month, day) {
    return day + ($63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder)[month - 1];
}
function $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal) {
    var table = $63618293c58b5f80$var$isLeapYear(year) ? $63618293c58b5f80$var$leapLadder : $63618293c58b5f80$var$nonLeapLadder, month0 = table.findIndex(function(i) {
        return i < ordinal;
    }), day = ordinal - table[month0];
    return {
        month: month0 + 1,
        day: day
    };
}
/**
 * @private
 */ function $63618293c58b5f80$var$gregorianToWeek(gregObj) {
    var year = gregObj.year, month = gregObj.month, day = gregObj.day, ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day), weekday = $63618293c58b5f80$var$dayOfWeek(year, month, day);
    var weekNumber = Math.floor((ordinal - weekday + 10) / 7), weekYear;
    if (weekNumber < 1) {
        weekYear = year - 1;
        weekNumber = $63618293c58b5f80$var$weeksInWeekYear(weekYear);
    } else if (weekNumber > $63618293c58b5f80$var$weeksInWeekYear(year)) {
        weekYear = year + 1;
        weekNumber = 1;
    } else weekYear = year;
    return $63618293c58b5f80$var$_extends({
        weekYear: weekYear,
        weekNumber: weekNumber,
        weekday: weekday
    }, $63618293c58b5f80$var$timeObject(gregObj));
}
function $63618293c58b5f80$var$weekToGregorian(weekData) {
    var weekYear = weekData.weekYear, weekNumber = weekData.weekNumber, weekday = weekData.weekday, weekdayOfJan4 = $63618293c58b5f80$var$dayOfWeek(weekYear, 1, 4), yearInDays = $63618293c58b5f80$var$daysInYear(weekYear);
    var ordinal = weekNumber * 7 + weekday - weekdayOfJan4 - 3, year;
    if (ordinal < 1) {
        year = weekYear - 1;
        ordinal += $63618293c58b5f80$var$daysInYear(year);
    } else if (ordinal > yearInDays) {
        year = weekYear + 1;
        ordinal -= $63618293c58b5f80$var$daysInYear(weekYear);
    } else year = weekYear;
    var _uncomputeOrdinal = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal.month, day = _uncomputeOrdinal.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(weekData));
}
function $63618293c58b5f80$var$gregorianToOrdinal(gregData) {
    var year = gregData.year, month = gregData.month, day = gregData.day;
    var ordinal = $63618293c58b5f80$var$computeOrdinal(year, month, day);
    return $63618293c58b5f80$var$_extends({
        year: year,
        ordinal: ordinal
    }, $63618293c58b5f80$var$timeObject(gregData));
}
function $63618293c58b5f80$var$ordinalToGregorian(ordinalData) {
    var year = ordinalData.year, ordinal = ordinalData.ordinal;
    var _uncomputeOrdinal2 = $63618293c58b5f80$var$uncomputeOrdinal(year, ordinal), month = _uncomputeOrdinal2.month, day = _uncomputeOrdinal2.day;
    return $63618293c58b5f80$var$_extends({
        year: year,
        month: month,
        day: day
    }, $63618293c58b5f80$var$timeObject(ordinalData));
}
function $63618293c58b5f80$var$hasInvalidWeekData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.weekYear), validWeek = $63618293c58b5f80$var$integerBetween(obj.weekNumber, 1, $63618293c58b5f80$var$weeksInWeekYear(obj.weekYear)), validWeekday = $63618293c58b5f80$var$integerBetween(obj.weekday, 1, 7);
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("weekYear", obj.weekYear);
    else if (!validWeek) return $63618293c58b5f80$var$unitOutOfRange("week", obj.week);
    else if (!validWeekday) return $63618293c58b5f80$var$unitOutOfRange("weekday", obj.weekday);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidOrdinalData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validOrdinal = $63618293c58b5f80$var$integerBetween(obj.ordinal, 1, $63618293c58b5f80$var$daysInYear(obj.year));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validOrdinal) return $63618293c58b5f80$var$unitOutOfRange("ordinal", obj.ordinal);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidGregorianData(obj) {
    var validYear = $63618293c58b5f80$var$isInteger(obj.year), validMonth = $63618293c58b5f80$var$integerBetween(obj.month, 1, 12), validDay = $63618293c58b5f80$var$integerBetween(obj.day, 1, $63618293c58b5f80$var$daysInMonth(obj.year, obj.month));
    if (!validYear) return $63618293c58b5f80$var$unitOutOfRange("year", obj.year);
    else if (!validMonth) return $63618293c58b5f80$var$unitOutOfRange("month", obj.month);
    else if (!validDay) return $63618293c58b5f80$var$unitOutOfRange("day", obj.day);
    else return false;
}
function $63618293c58b5f80$var$hasInvalidTimeData(obj) {
    var hour = obj.hour, minute = obj.minute, second = obj.second, millisecond = obj.millisecond;
    var validHour = $63618293c58b5f80$var$integerBetween(hour, 0, 23) || hour === 24 && minute === 0 && second === 0 && millisecond === 0, validMinute = $63618293c58b5f80$var$integerBetween(minute, 0, 59), validSecond = $63618293c58b5f80$var$integerBetween(second, 0, 59), validMillisecond = $63618293c58b5f80$var$integerBetween(millisecond, 0, 999);
    if (!validHour) return $63618293c58b5f80$var$unitOutOfRange("hour", hour);
    else if (!validMinute) return $63618293c58b5f80$var$unitOutOfRange("minute", minute);
    else if (!validSecond) return $63618293c58b5f80$var$unitOutOfRange("second", second);
    else if (!validMillisecond) return $63618293c58b5f80$var$unitOutOfRange("millisecond", millisecond);
    else return false;
}
var $63618293c58b5f80$var$INVALID = "Invalid DateTime";
var $63618293c58b5f80$var$MAX_DATE = 8.64e15;
function $63618293c58b5f80$var$unsupportedZone(zone) {
    return new $63618293c58b5f80$var$Invalid("unsupported zone", 'the zone "' + zone.name + '" is not supported');
}
// we cache week data on the DT object and this intermediates the cache
function $63618293c58b5f80$var$possiblyCachedWeekData(dt) {
    if (dt.weekData === null) dt.weekData = $63618293c58b5f80$var$gregorianToWeek(dt.c);
    return dt.weekData;
}
// clone really means, "make a new object with these modifications". all "setters" really use this
// to create a new object while only changing some of the properties
function $63618293c58b5f80$var$clone(inst, alts) {
    var current = {
        ts: inst.ts,
        zone: inst.zone,
        c: inst.c,
        o: inst.o,
        loc: inst.loc,
        invalid: inst.invalid
    };
    return new $63618293c58b5f80$var$DateTime($63618293c58b5f80$var$_extends({}, current, alts, {
        old: current
    }));
}
// find the right offset a given local time. The o input is our guess, which determines which
// offset we'll pick in ambiguous cases (e.g. there are two 3 AMs b/c Fallback DST)
function $63618293c58b5f80$var$fixOffset(localTS, o, tz) {
    // Our UTC time is just a guess because our offset is just a guess
    var utcGuess = localTS - o * 60000;
    // Test whether the zone matches the offset for this ts
    var o2 = tz.offset(utcGuess);
    // If so, offset didn't change and we're done
    if (o === o2) return [
        utcGuess,
        o
    ];
    // If not, change the ts by the difference in the offset
    utcGuess -= (o2 - o) * 60000;
    // If that gives us the local time we want, we're done
    var o3 = tz.offset(utcGuess);
    if (o2 === o3) return [
        utcGuess,
        o2
    ];
    // If it's different, we're in a hole time. The offset has changed, but the we don't adjust the time
    return [
        localTS - Math.min(o2, o3) * 60000,
        Math.max(o2, o3)
    ];
}
// convert an epoch timestamp into a calendar object with the given offset
function $63618293c58b5f80$var$tsToObj(ts, offset) {
    ts += offset * 60000;
    var d = new Date(ts);
    return {
        year: d.getUTCFullYear(),
        month: d.getUTCMonth() + 1,
        day: d.getUTCDate(),
        hour: d.getUTCHours(),
        minute: d.getUTCMinutes(),
        second: d.getUTCSeconds(),
        millisecond: d.getUTCMilliseconds()
    };
}
// convert a calendar object to a epoch timestamp
function $63618293c58b5f80$var$objToTS(obj, offset, zone) {
    return $63618293c58b5f80$var$fixOffset($63618293c58b5f80$var$objToLocalTS(obj), offset, zone);
}
// create a new DT instance by adding a duration, adjusting for DSTs
function $63618293c58b5f80$var$adjustTime(inst, dur) {
    var oPre = inst.o, year = inst.c.year + Math.trunc(dur.years), month = inst.c.month + Math.trunc(dur.months) + Math.trunc(dur.quarters) * 3, c = $63618293c58b5f80$var$_extends({}, inst.c, {
        year: year,
        month: month,
        day: Math.min(inst.c.day, $63618293c58b5f80$var$daysInMonth(year, month)) + Math.trunc(dur.days) + Math.trunc(dur.weeks) * 7
    }), millisToAdd = $63618293c58b5f80$var$Duration.fromObject({
        years: dur.years - Math.trunc(dur.years),
        quarters: dur.quarters - Math.trunc(dur.quarters),
        months: dur.months - Math.trunc(dur.months),
        weeks: dur.weeks - Math.trunc(dur.weeks),
        days: dur.days - Math.trunc(dur.days),
        hours: dur.hours,
        minutes: dur.minutes,
        seconds: dur.seconds,
        milliseconds: dur.milliseconds
    }).as("milliseconds"), localTS = $63618293c58b5f80$var$objToLocalTS(c);
    var _fixOffset = $63618293c58b5f80$var$fixOffset(localTS, oPre, inst.zone), ts = _fixOffset[0], o = _fixOffset[1];
    if (millisToAdd !== 0) {
        ts += millisToAdd;
        // that could have changed the offset by going over a DST, but we want to keep the ts the same
        o = inst.zone.offset(ts);
    }
    return {
        ts: ts,
        o: o
    };
}
// helper useful in turning the results of parsing into real dates
// by handling the zone options
function $63618293c58b5f80$var$parseDataToDateTime(parsed, parsedZone, opts, format, text, specificOffset) {
    var setZone = opts.setZone, zone = opts.zone;
    if (parsed && Object.keys(parsed).length !== 0 || parsedZone) {
        var interpretationZone = parsedZone || zone, inst = $63618293c58b5f80$var$DateTime.fromObject(parsed, $63618293c58b5f80$var$_extends({}, opts, {
            zone: interpretationZone,
            specificOffset: specificOffset
        }));
        return setZone ? inst : inst.setZone(zone);
    } else return $63618293c58b5f80$var$DateTime.invalid(new $63618293c58b5f80$var$Invalid("unparsable", 'the input "' + text + "\" can't be parsed as " + format));
}
// if you want to output a technical format (e.g. RFC 2822), this helper
// helps handle the details
function $63618293c58b5f80$var$toTechFormat(dt, format, allowZ) {
    if (allowZ === void 0) allowZ = true;
    return dt.isValid ? $63618293c58b5f80$var$Formatter.create($63618293c58b5f80$var$Locale.create("en-US"), {
        allowZ: allowZ,
        forceSimple: true
    }).formatDateTimeFromString(dt, format) : null;
}
function $63618293c58b5f80$var$_toISODate(o, extended) {
    var longFormat = o.c.year > 9999 || o.c.year < 0;
    var c = "";
    if (longFormat && o.c.year >= 0) c += "+";
    c += $63618293c58b5f80$var$padStart(o.c.year, longFormat ? 6 : 4);
    if (extended) {
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += "-";
        c += $63618293c58b5f80$var$padStart(o.c.day);
    } else {
        c += $63618293c58b5f80$var$padStart(o.c.month);
        c += $63618293c58b5f80$var$padStart(o.c.day);
    }
    return c;
}
function $63618293c58b5f80$var$_toISOTime(o, extended, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone) {
    var c = $63618293c58b5f80$var$padStart(o.c.hour);
    if (extended) {
        c += ":";
        c += $63618293c58b5f80$var$padStart(o.c.minute);
        if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) c += ":";
    } else c += $63618293c58b5f80$var$padStart(o.c.minute);
    if (o.c.millisecond !== 0 || o.c.second !== 0 || !suppressSeconds) {
        c += $63618293c58b5f80$var$padStart(o.c.second);
        if (o.c.millisecond !== 0 || !suppressMilliseconds) {
            c += ".";
            c += $63618293c58b5f80$var$padStart(o.c.millisecond, 3);
        }
    }
    if (includeOffset) {
        if (o.isOffsetFixed && o.offset === 0 && !extendedZone) c += "Z";
        else if (o.o < 0) {
            c += "-";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(-o.o % 60));
        } else {
            c += "+";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o / 60));
            c += ":";
            c += $63618293c58b5f80$var$padStart(Math.trunc(o.o % 60));
        }
    }
    if (extendedZone) c += "[" + o.zone.ianaName + "]";
    return c;
}
// defaults for unspecified units in the supported calendars
var $63618293c58b5f80$var$defaultUnitValues = {
    month: 1,
    day: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultWeekUnitValues = {
    weekNumber: 1,
    weekday: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
}, $63618293c58b5f80$var$defaultOrdinalUnitValues = {
    ordinal: 1,
    hour: 0,
    minute: 0,
    second: 0,
    millisecond: 0
};
// Units in the supported calendars, sorted by bigness
var $63618293c58b5f80$var$orderedUnits = [
    "year",
    "month",
    "day",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedWeekUnits = [
    "weekYear",
    "weekNumber",
    "weekday",
    "hour",
    "minute",
    "second",
    "millisecond"
], $63618293c58b5f80$var$orderedOrdinalUnits = [
    "year",
    "ordinal",
    "hour",
    "minute",
    "second",
    "millisecond"
];
// standardize case and plurality in units
function $63618293c58b5f80$var$normalizeUnit(unit) {
    var normalized = {
        year: "year",
        years: "year",
        month: "month",
        months: "month",
        day: "day",
        days: "day",
        hour: "hour",
        hours: "hour",
        minute: "minute",
        minutes: "minute",
        quarter: "quarter",
        quarters: "quarter",
        second: "second",
        seconds: "second",
        millisecond: "millisecond",
        milliseconds: "millisecond",
        weekday: "weekday",
        weekdays: "weekday",
        weeknumber: "weekNumber",
        weeksnumber: "weekNumber",
        weeknumbers: "weekNumber",
        weekyear: "weekYear",
        weekyears: "weekYear",
        ordinal: "ordinal"
    }[unit.toLowerCase()];
    if (!normalized) throw new $63618293c58b5f80$var$InvalidUnitError(unit);
    return normalized;
}
// this is a dumbed down version of fromObject() that runs about 60% faster
// but doesn't do any validation, makes a bunch of assumptions about what units
// are present, and so on.
function $63618293c58b5f80$var$quickDT(obj, opts) {
    var zone = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone), loc = $63618293c58b5f80$var$Locale.fromObject(opts), tsNow = $63618293c58b5f80$var$Settings.now();
    var ts, o;
    // assume we have the higher-order units
    if (!$63618293c58b5f80$var$isUndefined(obj.year)) {
        for(var _i = 0, _orderedUnits = $63618293c58b5f80$var$orderedUnits; _i < _orderedUnits.length; _i++){
            var u = _orderedUnits[_i];
            if ($63618293c58b5f80$var$isUndefined(obj[u])) obj[u] = $63618293c58b5f80$var$defaultUnitValues[u];
        }
        var invalid = $63618293c58b5f80$var$hasInvalidGregorianData(obj) || $63618293c58b5f80$var$hasInvalidTimeData(obj);
        if (invalid) return $63618293c58b5f80$var$DateTime.invalid(invalid);
        var offsetProvis = zone.offset(tsNow);
        var _objToTS = $63618293c58b5f80$var$objToTS(obj, offsetProvis, zone);
        ts = _objToTS[0];
        o = _objToTS[1];
    } else ts = tsNow;
    return new $63618293c58b5f80$var$DateTime({
        ts: ts,
        zone: zone,
        loc: loc,
        o: o
    });
}
function $63618293c58b5f80$var$diffRelative(start, end, opts) {
    var round = $63618293c58b5f80$var$isUndefined(opts.round) ? true : opts.round, format = function format(c, unit) {
        c = $63618293c58b5f80$var$roundTo(c, round || opts.calendary ? 0 : 2, true);
        var formatter = end.loc.clone(opts).relFormatter(opts);
        return formatter.format(c, unit);
    }, differ = function differ(unit) {
        if (opts.calendary) {
            if (!end.hasSame(start, unit)) return end.startOf(unit).diff(start.startOf(unit), unit).get(unit);
            else return 0;
        } else return end.diff(start, unit).get(unit);
    };
    if (opts.unit) return format(differ(opts.unit), opts.unit);
    for(var _iterator = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(opts.units), _step; !(_step = _iterator()).done;){
        var unit = _step.value;
        var count = differ(unit);
        if (Math.abs(count) >= 1) return format(count, unit);
    }
    return format(start > end ? -0 : 0, opts.units[opts.units.length - 1]);
}
function $63618293c58b5f80$var$lastOpts(argList) {
    var opts = {}, args;
    if (argList.length > 0 && typeof argList[argList.length - 1] === "object") {
        opts = argList[argList.length - 1];
        args = Array.from(argList).slice(0, argList.length - 1);
    } else args = Array.from(argList);
    return [
        opts,
        args
    ];
}
/**
 * A DateTime is an immutable data structure representing a specific date and time and accompanying methods. It contains class and instance methods for creating, parsing, interrogating, transforming, and formatting them.
 *
 * A DateTime comprises of:
 * * A timestamp. Each DateTime instance refers to a specific millisecond of the Unix epoch.
 * * A time zone. Each instance is considered in the context of a specific zone (by default the local system's zone).
 * * Configuration properties that effect how output strings are formatted, such as `locale`, `numberingSystem`, and `outputCalendar`.
 *
 * Here is a brief overview of the most commonly used functionality it provides:
 *
 * * **Creation**: To create a DateTime from its components, use one of its factory class methods: {@link DateTime.local}, {@link DateTime.utc}, and (most flexibly) {@link DateTime.fromObject}. To create one from a standard string format, use {@link DateTime.fromISO}, {@link DateTime.fromHTTP}, and {@link DateTime.fromRFC2822}. To create one from a custom string format, use {@link DateTime.fromFormat}. To create one from a native JS date, use {@link DateTime.fromJSDate}.
 * * **Gregorian calendar and time**: To examine the Gregorian properties of a DateTime individually (i.e as opposed to collectively through {@link DateTime#toObject}), use the {@link DateTime#year}, {@link DateTime#month},
 * {@link DateTime#day}, {@link DateTime#hour}, {@link DateTime#minute}, {@link DateTime#second}, {@link DateTime#millisecond} accessors.
 * * **Week calendar**: For ISO week calendar attributes, see the {@link DateTime#weekYear}, {@link DateTime#weekNumber}, and {@link DateTime#weekday} accessors.
 * * **Configuration** See the {@link DateTime#locale} and {@link DateTime#numberingSystem} accessors.
 * * **Transformation**: To transform the DateTime into other DateTimes, use {@link DateTime#set}, {@link DateTime#reconfigure}, {@link DateTime#setZone}, {@link DateTime#setLocale}, {@link DateTime.plus}, {@link DateTime#minus}, {@link DateTime#endOf}, {@link DateTime#startOf}, {@link DateTime#toUTC}, and {@link DateTime#toLocal}.
 * * **Output**: To convert the DateTime to other representations, use the {@link DateTime#toRelative}, {@link DateTime#toRelativeCalendar}, {@link DateTime#toJSON}, {@link DateTime#toISO}, {@link DateTime#toHTTP}, {@link DateTime#toObject}, {@link DateTime#toRFC2822}, {@link DateTime#toString}, {@link DateTime#toLocaleString}, {@link DateTime#toFormat}, {@link DateTime#toMillis} and {@link DateTime#toJSDate}.
 *
 * There's plenty others documented below. In addition, for more information on subtler topics like internationalization, time zones, alternative calendars, validity, and so on, see the external documentation.
 */ var $63618293c58b5f80$var$DateTime = /*#__PURE__*/ function() {
    /**
   * @access private
   */ function DateTime(config) {
        var zone = config.zone || $63618293c58b5f80$var$Settings.defaultZone;
        var invalid = config.invalid || (Number.isNaN(config.ts) ? new $63618293c58b5f80$var$Invalid("invalid input") : null) || (!zone.isValid ? $63618293c58b5f80$var$unsupportedZone(zone) : null);
        /**
     * @access private
     */ this.ts = $63618293c58b5f80$var$isUndefined(config.ts) ? $63618293c58b5f80$var$Settings.now() : config.ts;
        var c = null, o = null;
        if (!invalid) {
            var unchanged = config.old && config.old.ts === this.ts && config.old.zone.equals(zone);
            if (unchanged) {
                var _ref = [
                    config.old.c,
                    config.old.o
                ];
                c = _ref[0];
                o = _ref[1];
            } else {
                var ot = zone.offset(this.ts);
                c = $63618293c58b5f80$var$tsToObj(this.ts, ot);
                invalid = Number.isNaN(c.year) ? new $63618293c58b5f80$var$Invalid("invalid input") : null;
                c = invalid ? null : c;
                o = invalid ? null : ot;
            }
        }
        /**
     * @access private
     */ this._zone = zone;
        /**
     * @access private
     */ this.loc = config.loc || $63618293c58b5f80$var$Locale.create();
        /**
     * @access private
     */ this.invalid = invalid;
        /**
     * @access private
     */ this.weekData = null;
        /**
     * @access private
     */ this.c = c;
        /**
     * @access private
     */ this.o = o;
        /**
     * @access private
     */ this.isLuxonDateTime = true;
    }
    // CONSTRUCT
    /**
   * Create a DateTime for the current instant, in the system's time zone.
   *
   * Use Settings to override these default values if needed.
   * @example DateTime.now().toISO() //~> now in the ISO format
   * @return {DateTime}
   */ DateTime.now = function now() {
        return new DateTime({});
    } /**
   * Create a local DateTime
   * @param {number} [year] - The calendar year. If omitted (as in, call `local()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month, 1-indexed
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @example DateTime.local()                                  //~> now
   * @example DateTime.local({ zone: "America/New_York" })      //~> now, in US east coast time
   * @example DateTime.local(2017)                              //~> 2017-01-01T00:00:00
   * @example DateTime.local(2017, 3)                           //~> 2017-03-01T00:00:00
   * @example DateTime.local(2017, 3, 12, { locale: "fr" })     //~> 2017-03-12T00:00:00, with a French locale
   * @example DateTime.local(2017, 3, 12, 5)                    //~> 2017-03-12T05:00:00
   * @example DateTime.local(2017, 3, 12, 5, { zone: "utc" })   //~> 2017-03-12T05:00:00, in UTC
   * @example DateTime.local(2017, 3, 12, 5, 45)                //~> 2017-03-12T05:45:00
   * @example DateTime.local(2017, 3, 12, 5, 45, 10)            //~> 2017-03-12T05:45:10
   * @example DateTime.local(2017, 3, 12, 5, 45, 10, 765)       //~> 2017-03-12T05:45:10.765
   * @return {DateTime}
   */ ;
    DateTime.local = function local() {
        var _lastOpts = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts[0], args = _lastOpts[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime in UTC
   * @param {number} [year] - The calendar year. If omitted (as in, call `utc()` with no arguments), the current time will be used
   * @param {number} [month=1] - The month, 1-indexed
   * @param {number} [day=1] - The day of the month
   * @param {number} [hour=0] - The hour of the day, in 24-hour time
   * @param {number} [minute=0] - The minute of the hour, meaning a number between 0 and 59
   * @param {number} [second=0] - The second of the minute, meaning a number between 0 and 59
   * @param {number} [millisecond=0] - The millisecond of the second, meaning a number between 0 and 999
   * @param {Object} options - configuration options for the DateTime
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} [options.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [options.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.utc()                                              //~> now
   * @example DateTime.utc(2017)                                          //~> 2017-01-01T00:00:00Z
   * @example DateTime.utc(2017, 3)                                       //~> 2017-03-01T00:00:00Z
   * @example DateTime.utc(2017, 3, 12)                                   //~> 2017-03-12T00:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5)                                //~> 2017-03-12T05:00:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45)                            //~> 2017-03-12T05:45:00Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, { locale: "fr" })          //~> 2017-03-12T05:45:00Z with a French locale
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10)                        //~> 2017-03-12T05:45:10Z
   * @example DateTime.utc(2017, 3, 12, 5, 45, 10, 765, { locale: "fr" }) //~> 2017-03-12T05:45:10.765Z with a French locale
   * @return {DateTime}
   */ ;
    DateTime.utc = function utc() {
        var _lastOpts2 = $63618293c58b5f80$var$lastOpts(arguments), opts = _lastOpts2[0], args = _lastOpts2[1], year = args[0], month = args[1], day = args[2], hour = args[3], minute = args[4], second = args[5], millisecond = args[6];
        opts.zone = $63618293c58b5f80$var$FixedOffsetZone.utcInstance;
        return $63618293c58b5f80$var$quickDT({
            year: year,
            month: month,
            day: day,
            hour: hour,
            minute: minute,
            second: second,
            millisecond: millisecond
        }, opts);
    } /**
   * Create a DateTime from a JavaScript Date object. Uses the default zone.
   * @param {Date} date - a JavaScript Date object
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @return {DateTime}
   */ ;
    DateTime.fromJSDate = function fromJSDate(date, options) {
        if (options === void 0) options = {};
        var ts = $63618293c58b5f80$var$isDate(date) ? date.valueOf() : NaN;
        if (Number.isNaN(ts)) return DateTime.invalid("invalid input");
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        return new DateTime({
            ts: ts,
            zone: zoneToUse,
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of milliseconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} milliseconds - a number of milliseconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromMillis = function fromMillis(milliseconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(milliseconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromMillis requires a numerical input, but received a " + typeof milliseconds + " with value " + milliseconds);
        else if (milliseconds < -$63618293c58b5f80$var$MAX_DATE || milliseconds > $63618293c58b5f80$var$MAX_DATE) // this isn't perfect because because we can still end up out of range because of additional shifting, but it's a start
        return DateTime.invalid("Timestamp out of range");
        else return new DateTime({
            ts: milliseconds,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a number of seconds since the epoch (meaning since 1 January 1970 00:00:00 UTC). Uses the default zone.
   * @param {number} seconds - a number of seconds since 1970 UTC
   * @param {Object} options - configuration options for the DateTime
   * @param {string|Zone} [options.zone='local'] - the zone to place the DateTime into
   * @param {string} [options.locale] - a locale to set on the resulting DateTime instance
   * @param {string} options.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} options.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromSeconds = function fromSeconds(seconds, options) {
        if (options === void 0) options = {};
        if (!$63618293c58b5f80$var$isNumber(seconds)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromSeconds requires a numerical input");
        else return new DateTime({
            ts: seconds * 1000,
            zone: $63618293c58b5f80$var$normalizeZone(options.zone, $63618293c58b5f80$var$Settings.defaultZone),
            loc: $63618293c58b5f80$var$Locale.fromObject(options)
        });
    } /**
   * Create a DateTime from a JavaScript object with keys like 'year' and 'hour' with reasonable defaults.
   * @param {Object} obj - the object to create the DateTime from
   * @param {number} obj.year - a year, such as 1987
   * @param {number} obj.month - a month, 1-12
   * @param {number} obj.day - a day of the month, 1-31, depending on the month
   * @param {number} obj.ordinal - day of the year, 1-365 or 366
   * @param {number} obj.weekYear - an ISO week year
   * @param {number} obj.weekNumber - an ISO week number, between 1 and 52 or 53, depending on the year
   * @param {number} obj.weekday - an ISO weekday, 1-7, where 1 is Monday and 7 is Sunday
   * @param {number} obj.hour - hour of the day, 0-23
   * @param {number} obj.minute - minute of the hour, 0-59
   * @param {number} obj.second - second of the minute, 0-59
   * @param {number} obj.millisecond - millisecond of the second, 0-999
   * @param {Object} opts - options for creating this DateTime
   * @param {string|Zone} [opts.zone='local'] - interpret the numbers in the context of a particular zone. Can take any value taken as the first argument to setZone()
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromObject({ year: 1982, month: 5, day: 25}).toISODate() //=> '1982-05-25'
   * @example DateTime.fromObject({ year: 1982 }).toISODate() //=> '1982-01-01'
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }) //~> today at 10:26:06
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'utc' }),
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'local' })
   * @example DateTime.fromObject({ hour: 10, minute: 26, second: 6 }, { zone: 'America/New_York' })
   * @example DateTime.fromObject({ weekYear: 2016, weekNumber: 2, weekday: 3 }).toISODate() //=> '2016-01-13'
   * @return {DateTime}
   */ ;
    DateTime.fromObject = function fromObject(obj, opts) {
        if (opts === void 0) opts = {};
        obj = obj || {};
        var zoneToUse = $63618293c58b5f80$var$normalizeZone(opts.zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (!zoneToUse.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zoneToUse));
        var tsNow = $63618293c58b5f80$var$Settings.now(), offsetProvis = !$63618293c58b5f80$var$isUndefined(opts.specificOffset) ? opts.specificOffset : zoneToUse.offset(tsNow), normalized = $63618293c58b5f80$var$normalizeObject(obj, $63618293c58b5f80$var$normalizeUnit), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber, loc = $63618293c58b5f80$var$Locale.fromObject(opts);
        // cases:
        // just a weekday -> this week's instance of that weekday, no worries
        // (gregorian data or ordinal) + (weekYear or weekNumber) -> error
        // (gregorian month or day) + ordinal -> error
        // otherwise just use weeks or ordinals or gregorian, depending on what's specified
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var useWeekData = definiteWeekDef || normalized.weekday && !containsGregor;
        // configure ourselves to deal with gregorian dates or week stuff
        var units, defaultValues, objNow = $63618293c58b5f80$var$tsToObj(tsNow, offsetProvis);
        if (useWeekData) {
            units = $63618293c58b5f80$var$orderedWeekUnits;
            defaultValues = $63618293c58b5f80$var$defaultWeekUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToWeek(objNow);
        } else if (containsOrdinal) {
            units = $63618293c58b5f80$var$orderedOrdinalUnits;
            defaultValues = $63618293c58b5f80$var$defaultOrdinalUnitValues;
            objNow = $63618293c58b5f80$var$gregorianToOrdinal(objNow);
        } else {
            units = $63618293c58b5f80$var$orderedUnits;
            defaultValues = $63618293c58b5f80$var$defaultUnitValues;
        }
        // set default values for missing stuff
        var foundFirst = false;
        for(var _iterator2 = $63618293c58b5f80$var$_createForOfIteratorHelperLoose(units), _step2; !(_step2 = _iterator2()).done;){
            var u = _step2.value;
            var v = normalized[u];
            if (!$63618293c58b5f80$var$isUndefined(v)) foundFirst = true;
            else if (foundFirst) normalized[u] = defaultValues[u];
            else normalized[u] = objNow[u];
        }
        // make sure the values we have are in range
        var higherOrderInvalid = useWeekData ? $63618293c58b5f80$var$hasInvalidWeekData(normalized) : containsOrdinal ? $63618293c58b5f80$var$hasInvalidOrdinalData(normalized) : $63618293c58b5f80$var$hasInvalidGregorianData(normalized), invalid = higherOrderInvalid || $63618293c58b5f80$var$hasInvalidTimeData(normalized);
        if (invalid) return DateTime.invalid(invalid);
        // compute the actual time
        var gregorian = useWeekData ? $63618293c58b5f80$var$weekToGregorian(normalized) : containsOrdinal ? $63618293c58b5f80$var$ordinalToGregorian(normalized) : normalized, _objToTS2 = $63618293c58b5f80$var$objToTS(gregorian, offsetProvis, zoneToUse), tsFinal = _objToTS2[0], offsetFinal = _objToTS2[1], inst = new DateTime({
            ts: tsFinal,
            zone: zoneToUse,
            o: offsetFinal,
            loc: loc
        });
        // gregorian data + weekday serves only to validate
        if (normalized.weekday && containsGregor && obj.weekday !== inst.weekday) return DateTime.invalid("mismatched weekday", "you can't specify both a weekday of " + normalized.weekday + " and a date of " + inst.toISO());
        return inst;
    } /**
   * Create a DateTime from an ISO 8601 string
   * @param {string} text - the ISO string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the time to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} [opts.outputCalendar] - the output calendar to set on the resulting DateTime instance
   * @param {string} [opts.numberingSystem] - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromISO('2016-05-25T09:08:34.123')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00')
   * @example DateTime.fromISO('2016-05-25T09:08:34.123+06:00', {setZone: true})
   * @example DateTime.fromISO('2016-05-25T09:08:34.123', {zone: 'utc'})
   * @example DateTime.fromISO('2016-W05-4')
   * @return {DateTime}
   */ ;
    DateTime.fromISO = function fromISO(text, opts) {
        if (opts === void 0) opts = {};
        var _parseISODate = $63618293c58b5f80$var$parseISODate(text), vals = _parseISODate[0], parsedZone = _parseISODate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "ISO 8601", text);
    } /**
   * Create a DateTime from an RFC 2822 string
   * @param {string} text - the RFC 2822 string
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since the offset is always specified in the string itself, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with a fixed-offset zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23:12 GMT')
   * @example DateTime.fromRFC2822('Fri, 25 Nov 2016 13:23:12 +0600')
   * @example DateTime.fromRFC2822('25 Nov 2016 13:23 Z')
   * @return {DateTime}
   */ ;
    DateTime.fromRFC2822 = function fromRFC2822(text, opts) {
        if (opts === void 0) opts = {};
        var _parseRFC2822Date = $63618293c58b5f80$var$parseRFC2822Date(text), vals = _parseRFC2822Date[0], parsedZone = _parseRFC2822Date[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "RFC 2822", text);
    } /**
   * Create a DateTime from an HTTP header date
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @param {string} text - the HTTP header date
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - convert the time to this zone. Since HTTP dates are always in UTC, this has no effect on the interpretation of string, merely the zone the resulting DateTime is expressed in.
   * @param {boolean} [opts.setZone=false] - override the zone with the fixed-offset zone specified in the string. For HTTP dates, this is always UTC, so this option is equivalent to setting the `zone` option to 'utc', but this option is included for consistency with similar methods.
   * @param {string} [opts.locale='system's locale'] - a locale to set on the resulting DateTime instance
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @param {string} opts.numberingSystem - the numbering system to set on the resulting DateTime instance
   * @example DateTime.fromHTTP('Sun, 06 Nov 1994 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sunday, 06-Nov-94 08:49:37 GMT')
   * @example DateTime.fromHTTP('Sun Nov  6 08:49:37 1994')
   * @return {DateTime}
   */ ;
    DateTime.fromHTTP = function fromHTTP(text, opts) {
        if (opts === void 0) opts = {};
        var _parseHTTPDate = $63618293c58b5f80$var$parseHTTPDate(text), vals = _parseHTTPDate[0], parsedZone = _parseHTTPDate[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "HTTP", opts);
    } /**
   * Create a DateTime from an input string and format string.
   * Defaults to en-US if no locale has been specified, regardless of the system's locale. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/parsing?id=table-of-tokens).
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see the link below for the formats)
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @return {DateTime}
   */ ;
    DateTime.fromFormat = function fromFormat(text, fmt, opts) {
        if (opts === void 0) opts = {};
        if ($63618293c58b5f80$var$isUndefined(text) || $63618293c58b5f80$var$isUndefined(fmt)) throw new $63618293c58b5f80$var$InvalidArgumentError("fromFormat requires an input string and a format");
        var _opts = opts, _opts$locale = _opts.locale, locale = _opts$locale === void 0 ? null : _opts$locale, _opts$numberingSystem = _opts.numberingSystem, numberingSystem = _opts$numberingSystem === void 0 ? null : _opts$numberingSystem, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        }), _parseFromTokens = $63618293c58b5f80$var$parseFromTokens(localeToUse, text, fmt), vals = _parseFromTokens[0], parsedZone = _parseFromTokens[1], specificOffset = _parseFromTokens[2], invalid = _parseFromTokens[3];
        if (invalid) return DateTime.invalid(invalid);
        else return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "format " + fmt, text, specificOffset);
    } /**
   * @deprecated use fromFormat instead
   */ ;
    DateTime.fromString = function fromString(text, fmt, opts) {
        if (opts === void 0) opts = {};
        return DateTime.fromFormat(text, fmt, opts);
    } /**
   * Create a DateTime from a SQL date, time, or datetime
   * Defaults to en-US if no locale has been specified, regardless of the system's locale
   * @param {string} text - the string to parse
   * @param {Object} opts - options to affect the creation
   * @param {string|Zone} [opts.zone='local'] - use this zone if no offset is specified in the input string itself. Will also convert the DateTime to this zone
   * @param {boolean} [opts.setZone=false] - override the zone with a zone specified in the string itself, if it specifies one
   * @param {string} [opts.locale='en-US'] - a locale string to use when parsing. Will also set the DateTime to this locale
   * @param {string} opts.numberingSystem - the numbering system to use when parsing. Will also set the resulting DateTime to this numbering system
   * @param {string} opts.outputCalendar - the output calendar to set on the resulting DateTime instance
   * @example DateTime.fromSQL('2017-05-15')
   * @example DateTime.fromSQL('2017-05-15 09:12:34')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342+06:00')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles')
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342 America/Los_Angeles', { setZone: true })
   * @example DateTime.fromSQL('2017-05-15 09:12:34.342', { zone: 'America/Los_Angeles' })
   * @example DateTime.fromSQL('09:12:34.342')
   * @return {DateTime}
   */ ;
    DateTime.fromSQL = function fromSQL(text, opts) {
        if (opts === void 0) opts = {};
        var _parseSQL = $63618293c58b5f80$var$parseSQL(text), vals = _parseSQL[0], parsedZone = _parseSQL[1];
        return $63618293c58b5f80$var$parseDataToDateTime(vals, parsedZone, opts, "SQL", text);
    } /**
   * Create an invalid DateTime.
   * @param {string} reason - simple string of why this DateTime is invalid. Should not contain parameters or anything else data-dependent.
   * @param {string} [explanation=null] - longer explanation, may include parameters and other useful debugging information
   * @return {DateTime}
   */ ;
    DateTime.invalid = function invalid(reason, explanation) {
        if (explanation === void 0) explanation = null;
        if (!reason) throw new $63618293c58b5f80$var$InvalidArgumentError("need to specify a reason the DateTime is invalid");
        var invalid = reason instanceof $63618293c58b5f80$var$Invalid ? reason : new $63618293c58b5f80$var$Invalid(reason, explanation);
        if ($63618293c58b5f80$var$Settings.throwOnInvalid) throw new $63618293c58b5f80$var$InvalidDateTimeError(invalid);
        else return new DateTime({
            invalid: invalid
        });
    } /**
   * Check if an object is an instance of DateTime. Works across context boundaries
   * @param {object} o
   * @return {boolean}
   */ ;
    DateTime.isDateTime = function isDateTime(o) {
        return o && o.isLuxonDateTime || false;
    } /**
   * Produce the format string for a set of options
   * @param formatOpts
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.parseFormatForOpts = function parseFormatForOpts(formatOpts, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var tokenList = $63618293c58b5f80$var$formatOptsToTokens(formatOpts, $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return !tokenList ? null : tokenList.map(function(t) {
            return t ? t.val : null;
        }).join("");
    } /**
   * Produce the the fully expanded format token for the locale
   * Does NOT quote characters, so quoted tokens will not round trip correctly
   * @param fmt
   * @param localeOpts
   * @returns {string}
   */ ;
    DateTime.expandFormat = function expandFormat(fmt, localeOpts) {
        if (localeOpts === void 0) localeOpts = {};
        var expanded = $63618293c58b5f80$var$expandMacroTokens($63618293c58b5f80$var$Formatter.parseFormat(fmt), $63618293c58b5f80$var$Locale.fromObject(localeOpts));
        return expanded.map(function(t) {
            return t.val;
        }).join("");
    } /**
   * Get the value of unit.
   * @param {string} unit - a unit such as 'minute' or 'day'
   * @example DateTime.local(2017, 7, 4).get('month'); //=> 7
   * @example DateTime.local(2017, 7, 4).get('day'); //=> 4
   * @return {number}
   */ ;
    var _proto = DateTime.prototype;
    _proto.get = function get(unit) {
        return this[unit];
    } /**
   * Returns whether the DateTime is valid. Invalid DateTimes occur when:
   * * The DateTime was created from invalid calendar information, such as the 13th month or February 30
   * * The DateTime was created by an operation on another invalid date
   * @type {boolean}
   */ ;
    /**
   * Get those DateTimes which have the same local time as this DateTime, but a different offset from UTC
   * in this DateTime's zone. During DST changes local time can be ambiguous, for example
   * `2023-10-29T02:30:00` in `Europe/Berlin` can have offset `+01:00` or `+02:00`.
   * This method will return both possible DateTimes if this DateTime's local time is ambiguous.
   * @returns {DateTime[]}
   */ _proto.getPossibleOffsets = function getPossibleOffsets() {
        if (!this.isValid || this.isOffsetFixed) return [
            this
        ];
        var dayMs = 86400000;
        var minuteMs = 60000;
        var localTS = $63618293c58b5f80$var$objToLocalTS(this.c);
        var oEarlier = this.zone.offset(localTS - dayMs);
        var oLater = this.zone.offset(localTS + dayMs);
        var o1 = this.zone.offset(localTS - oEarlier * minuteMs);
        var o2 = this.zone.offset(localTS - oLater * minuteMs);
        if (o1 === o2) return [
            this
        ];
        var ts1 = localTS - o1 * minuteMs;
        var ts2 = localTS - o2 * minuteMs;
        var c1 = $63618293c58b5f80$var$tsToObj(ts1, o1);
        var c2 = $63618293c58b5f80$var$tsToObj(ts2, o2);
        if (c1.hour === c2.hour && c1.minute === c2.minute && c1.second === c2.second && c1.millisecond === c2.millisecond) return [
            $63618293c58b5f80$var$clone(this, {
                ts: ts1
            }),
            $63618293c58b5f80$var$clone(this, {
                ts: ts2
            })
        ];
        return [
            this
        ];
    } /**
   * Returns true if this DateTime is in a leap year, false otherwise
   * @example DateTime.local(2016).isInLeapYear //=> true
   * @example DateTime.local(2013).isInLeapYear //=> false
   * @type {boolean}
   */ ;
    /**
   * Returns the resolved Intl options for this DateTime.
   * This is useful in understanding the behavior of formatting methods
   * @param {Object} opts - the same options as toLocaleString
   * @return {Object}
   */ _proto.resolvedLocaleOptions = function resolvedLocaleOptions(opts) {
        if (opts === void 0) opts = {};
        var _Formatter$create$res = $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).resolvedOptions(this), locale = _Formatter$create$res.locale, numberingSystem = _Formatter$create$res.numberingSystem, calendar = _Formatter$create$res.calendar;
        return {
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: calendar
        };
    } /**
   * "Set" the DateTime's zone to UTC. Returns a newly-constructed DateTime.
   *
   * Equivalent to {@link DateTime#setZone}('utc')
   * @param {number} [offset=0] - optionally, an offset from UTC in minutes
   * @param {Object} [opts={}] - options to pass to `setZone()`
   * @return {DateTime}
   */ ;
    _proto.toUTC = function toUTC(offset, opts) {
        if (offset === void 0) offset = 0;
        if (opts === void 0) opts = {};
        return this.setZone($63618293c58b5f80$var$FixedOffsetZone.instance(offset), opts);
    } /**
   * "Set" the DateTime's zone to the host's local zone. Returns a newly-constructed DateTime.
   *
   * Equivalent to `setZone('local')`
   * @return {DateTime}
   */ ;
    _proto.toLocal = function toLocal() {
        return this.setZone($63618293c58b5f80$var$Settings.defaultZone);
    } /**
   * "Set" the DateTime's zone to specified zone. Returns a newly-constructed DateTime.
   *
   * By default, the setter keeps the underlying time the same (as in, the same timestamp), but the new instance will report different local times and consider DSTs when making computations, as with {@link DateTime#plus}. You may wish to use {@link DateTime#toLocal} and {@link DateTime#toUTC} which provide simple convenience wrappers for commonly used zones.
   * @param {string|Zone} [zone='local'] - a zone identifier. As a string, that can be any IANA zone supported by the host environment, or a fixed-offset name of the form 'UTC+3', or the strings 'local' or 'utc'. You may also supply an instance of a {@link DateTime#Zone} class.
   * @param {Object} opts - options
   * @param {boolean} [opts.keepLocalTime=false] - If true, adjust the underlying time so that the local time stays the same, but in the target zone. You should rarely need this.
   * @return {DateTime}
   */ ;
    _proto.setZone = function setZone(zone, _temp) {
        var _ref2 = _temp === void 0 ? {} : _temp, _ref2$keepLocalTime = _ref2.keepLocalTime, keepLocalTime = _ref2$keepLocalTime === void 0 ? false : _ref2$keepLocalTime, _ref2$keepCalendarTim = _ref2.keepCalendarTime, keepCalendarTime = _ref2$keepCalendarTim === void 0 ? false : _ref2$keepCalendarTim;
        zone = $63618293c58b5f80$var$normalizeZone(zone, $63618293c58b5f80$var$Settings.defaultZone);
        if (zone.equals(this.zone)) return this;
        else if (!zone.isValid) return DateTime.invalid($63618293c58b5f80$var$unsupportedZone(zone));
        else {
            var newTS = this.ts;
            if (keepLocalTime || keepCalendarTime) {
                var offsetGuess = zone.offset(this.ts);
                var asObj = this.toObject();
                var _objToTS3 = $63618293c58b5f80$var$objToTS(asObj, offsetGuess, zone);
                newTS = _objToTS3[0];
            }
            return $63618293c58b5f80$var$clone(this, {
                ts: newTS,
                zone: zone
            });
        }
    } /**
   * "Set" the locale, numberingSystem, or outputCalendar. Returns a newly-constructed DateTime.
   * @param {Object} properties - the properties to set
   * @example DateTime.local(2017, 5, 25).reconfigure({ locale: 'en-GB' })
   * @return {DateTime}
   */ ;
    _proto.reconfigure = function reconfigure(_temp2) {
        var _ref3 = _temp2 === void 0 ? {} : _temp2, locale = _ref3.locale, numberingSystem = _ref3.numberingSystem, outputCalendar = _ref3.outputCalendar;
        var loc = this.loc.clone({
            locale: locale,
            numberingSystem: numberingSystem,
            outputCalendar: outputCalendar
        });
        return $63618293c58b5f80$var$clone(this, {
            loc: loc
        });
    } /**
   * "Set" the locale. Returns a newly-constructed DateTime.
   * Just a convenient alias for reconfigure({ locale })
   * @example DateTime.local(2017, 5, 25).setLocale('en-GB')
   * @return {DateTime}
   */ ;
    _proto.setLocale = function setLocale(locale) {
        return this.reconfigure({
            locale: locale
        });
    } /**
   * "Set" the values of specified units. Returns a newly-constructed DateTime.
   * You can only set units with this method; for "setting" metadata, see {@link DateTime#reconfigure} and {@link DateTime#setZone}.
   * @param {Object} values - a mapping of units to numbers
   * @example dt.set({ year: 2017 })
   * @example dt.set({ hour: 8, minute: 30 })
   * @example dt.set({ weekday: 5 })
   * @example dt.set({ year: 2005, ordinal: 234 })
   * @return {DateTime}
   */ ;
    _proto.set = function set(values) {
        if (!this.isValid) return this;
        var normalized = $63618293c58b5f80$var$normalizeObject(values, $63618293c58b5f80$var$normalizeUnit), settingWeekStuff = !$63618293c58b5f80$var$isUndefined(normalized.weekYear) || !$63618293c58b5f80$var$isUndefined(normalized.weekNumber) || !$63618293c58b5f80$var$isUndefined(normalized.weekday), containsOrdinal = !$63618293c58b5f80$var$isUndefined(normalized.ordinal), containsGregorYear = !$63618293c58b5f80$var$isUndefined(normalized.year), containsGregorMD = !$63618293c58b5f80$var$isUndefined(normalized.month) || !$63618293c58b5f80$var$isUndefined(normalized.day), containsGregor = containsGregorYear || containsGregorMD, definiteWeekDef = normalized.weekYear || normalized.weekNumber;
        if ((containsGregor || containsOrdinal) && definiteWeekDef) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix weekYear/weekNumber units with year/month/day or ordinals");
        if (containsGregorMD && containsOrdinal) throw new $63618293c58b5f80$var$ConflictingSpecificationError("Can't mix ordinal dates with month/day");
        var mixed;
        if (settingWeekStuff) mixed = $63618293c58b5f80$var$weekToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToWeek(this.c), normalized));
        else if (!$63618293c58b5f80$var$isUndefined(normalized.ordinal)) mixed = $63618293c58b5f80$var$ordinalToGregorian($63618293c58b5f80$var$_extends({}, $63618293c58b5f80$var$gregorianToOrdinal(this.c), normalized));
        else {
            mixed = $63618293c58b5f80$var$_extends({}, this.toObject(), normalized);
            // if we didn't set the day but we ended up on an overflow date,
            // use the last day of the right month
            if ($63618293c58b5f80$var$isUndefined(normalized.day)) mixed.day = Math.min($63618293c58b5f80$var$daysInMonth(mixed.year, mixed.month), mixed.day);
        }
        var _objToTS4 = $63618293c58b5f80$var$objToTS(mixed, this.o, this.zone), ts = _objToTS4[0], o = _objToTS4[1];
        return $63618293c58b5f80$var$clone(this, {
            ts: ts,
            o: o
        });
    } /**
   * Add a period of time to this DateTime and return the resulting DateTime
   *
   * Adding hours, minutes, seconds, or milliseconds increases the timestamp by the right number of milliseconds. Adding days, months, or years shifts the calendar, accounting for DSTs and leap years along the way. Thus, `dt.plus({ hours: 24 })` may result in a different time than `dt.plus({ days: 1 })` if there's a DST shift in between.
   * @param {Duration|Object|number} duration - The amount to add. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   * @example DateTime.now().plus(123) //~> in 123 milliseconds
   * @example DateTime.now().plus({ minutes: 15 }) //~> in 15 minutes
   * @example DateTime.now().plus({ days: 1 }) //~> this time tomorrow
   * @example DateTime.now().plus({ days: -1 }) //~> this time yesterday
   * @example DateTime.now().plus({ hours: 3, minutes: 13 }) //~> in 3 hr, 13 min
   * @example DateTime.now().plus(Duration.fromObject({ hours: 3, minutes: 13 })) //~> in 3 hr, 13 min
   * @return {DateTime}
   */ ;
    _proto.plus = function plus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration);
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * Subtract a period of time to this DateTime and return the resulting DateTime
   * See {@link DateTime#plus}
   * @param {Duration|Object|number} duration - The amount to subtract. Either a Luxon Duration, a number of milliseconds, the object argument to Duration.fromObject()
   @return {DateTime}
   */ ;
    _proto.minus = function minus(duration) {
        if (!this.isValid) return this;
        var dur = $63618293c58b5f80$var$Duration.fromDurationLike(duration).negate();
        return $63618293c58b5f80$var$clone(this, $63618293c58b5f80$var$adjustTime(this, dur));
    } /**
   * "Set" this DateTime to the beginning of a unit of time.
   * @param {string} unit - The unit to go to the beginning of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).startOf('month').toISODate(); //=> '2014-03-01'
   * @example DateTime.local(2014, 3, 3).startOf('year').toISODate(); //=> '2014-01-01'
   * @example DateTime.local(2014, 3, 3).startOf('week').toISODate(); //=> '2014-03-03', weeks always start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('day').toISOTime(); //=> '00:00.000-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).startOf('hour').toISOTime(); //=> '05:00:00.000-05:00'
   * @return {DateTime}
   */ ;
    _proto.startOf = function startOf(unit) {
        if (!this.isValid) return this;
        var o = {}, normalizedUnit = $63618293c58b5f80$var$Duration.normalizeUnit(unit);
        switch(normalizedUnit){
            case "years":
                o.month = 1;
            // falls through
            case "quarters":
            case "months":
                o.day = 1;
            // falls through
            case "weeks":
            case "days":
                o.hour = 0;
            // falls through
            case "hours":
                o.minute = 0;
            // falls through
            case "minutes":
                o.second = 0;
            // falls through
            case "seconds":
                o.millisecond = 0;
                break;
        }
        if (normalizedUnit === "weeks") o.weekday = 1;
        if (normalizedUnit === "quarters") {
            var q = Math.ceil(this.month / 3);
            o.month = (q - 1) * 3 + 1;
        }
        return this.set(o);
    } /**
   * "Set" this DateTime to the end (meaning the last millisecond) of a unit of time
   * @param {string} unit - The unit to go to the end of. Can be 'year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', or 'millisecond'.
   * @example DateTime.local(2014, 3, 3).endOf('month').toISO(); //=> '2014-03-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('year').toISO(); //=> '2014-12-31T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3).endOf('week').toISO(); // => '2014-03-09T23:59:59.999-05:00', weeks start on Mondays
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('day').toISO(); //=> '2014-03-03T23:59:59.999-05:00'
   * @example DateTime.local(2014, 3, 3, 5, 30).endOf('hour').toISO(); //=> '2014-03-03T05:59:59.999-05:00'
   * @return {DateTime}
   */ ;
    _proto.endOf = function endOf(unit) {
        var _this$plus;
        return this.isValid ? this.plus((_this$plus = {}, _this$plus[unit] = 1, _this$plus)).startOf(unit).minus(1) : this;
    } /**
   * Returns a string representation of this DateTime formatted according to the specified format string.
   * **You may not want this.** See {@link DateTime#toLocaleString} for a more flexible formatting tool. For a table of tokens and their interpretations, see [here](https://moment.github.io/luxon/#/formatting?id=table-of-tokens).
   * Defaults to en-US if no locale has been specified, regardless of the system's locale.
   * @param {string} fmt - the format string
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toFormat('yyyy LLL dd') //=> '2017 Apr 22'
   * @example DateTime.now().setLocale('fr').toFormat('yyyy LLL dd') //=> '2017 avr. 22'
   * @example DateTime.now().toFormat('yyyy LLL dd', { locale: "fr" }) //=> '2017 avr. 22'
   * @example DateTime.now().toFormat("HH 'hours and' mm 'minutes'") //=> '20 hours and 55 minutes'
   * @return {string}
   */ ;
    _proto.toFormat = function toFormat(fmt, opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.redefaultToEN(opts)).formatDateTimeFromString(this, fmt) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns a localized string representing this date. Accepts the same options as the Intl.DateTimeFormat constructor and any presets defined by Luxon, such as `DateTime.DATE_FULL` or `DateTime.TIME_SIMPLE`.
   * The exact behavior of this method is browser-specific, but in general it will return an appropriate representation
   * of the DateTime in the assigned locale.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat
   * @param formatOpts {Object} - Intl.DateTimeFormat constructor options and configuration options
   * @param {Object} opts - opts to override the configuration options on this DateTime
   * @example DateTime.now().toLocaleString(); //=> 4/20/2017
   * @example DateTime.now().setLocale('en-gb').toLocaleString(); //=> '20/04/2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL); //=> 'April 20, 2017'
   * @example DateTime.now().toLocaleString(DateTime.DATE_FULL, { locale: 'fr' }); //=> '28 août 2022'
   * @example DateTime.now().toLocaleString(DateTime.TIME_SIMPLE); //=> '11:32 AM'
   * @example DateTime.now().toLocaleString(DateTime.DATETIME_SHORT); //=> '4/20/2017, 11:32 AM'
   * @example DateTime.now().toLocaleString({ weekday: 'long', month: 'long', day: '2-digit' }); //=> 'Thursday, April 20'
   * @example DateTime.now().toLocaleString({ weekday: 'short', month: 'short', day: '2-digit', hour: '2-digit', minute: '2-digit' }); //=> 'Thu, Apr 20, 11:27 AM'
   * @example DateTime.now().toLocaleString({ hour: '2-digit', minute: '2-digit', hourCycle: 'h23' }); //=> '11:32'
   * @return {string}
   */ ;
    _proto.toLocaleString = function toLocaleString(formatOpts, opts) {
        if (formatOpts === void 0) formatOpts = $63618293c58b5f80$var$DATE_SHORT;
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), formatOpts).formatDateTime(this) : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns an array of format "parts", meaning individual tokens along with metadata. This is allows callers to post-process individual sections of the formatted output.
   * Defaults to the system's locale if no locale has been specified
   * @see https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/DateTimeFormat/formatToParts
   * @param opts {Object} - Intl.DateTimeFormat constructor options, same as `toLocaleString`.
   * @example DateTime.now().toLocaleParts(); //=> [
   *                                   //=>   { type: 'day', value: '25' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'month', value: '05' },
   *                                   //=>   { type: 'literal', value: '/' },
   *                                   //=>   { type: 'year', value: '1982' }
   *                                   //=> ]
   */ ;
    _proto.toLocaleParts = function toLocaleParts(opts) {
        if (opts === void 0) opts = {};
        return this.isValid ? $63618293c58b5f80$var$Formatter.create(this.loc.clone(opts), opts).formatDateTimeParts(this) : [];
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=false] - add the time zone format extension
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1983, 5, 25).toISO() //=> '1982-05-25T00:00:00.000Z'
   * @example DateTime.now().toISO() //=> '2017-04-22T20:47:05.335-04:00'
   * @example DateTime.now().toISO({ includeOffset: false }) //=> '2017-04-22T20:47:05.335'
   * @example DateTime.now().toISO({ format: 'basic' }) //=> '20170422T204705.335-0400'
   * @return {string}
   */ ;
    _proto.toISO = function toISO(_temp3) {
        var _ref4 = _temp3 === void 0 ? {} : _temp3, _ref4$format = _ref4.format, format = _ref4$format === void 0 ? "extended" : _ref4$format, _ref4$suppressSeconds = _ref4.suppressSeconds, suppressSeconds = _ref4$suppressSeconds === void 0 ? false : _ref4$suppressSeconds, _ref4$suppressMillise = _ref4.suppressMilliseconds, suppressMilliseconds = _ref4$suppressMillise === void 0 ? false : _ref4$suppressMillise, _ref4$includeOffset = _ref4.includeOffset, includeOffset = _ref4$includeOffset === void 0 ? true : _ref4$includeOffset, _ref4$extendedZone = _ref4.extendedZone, extendedZone = _ref4$extendedZone === void 0 ? false : _ref4$extendedZone;
        if (!this.isValid) return null;
        var ext = format === "extended";
        var c = $63618293c58b5f80$var$_toISODate(this, ext);
        c += "T";
        c += $63618293c58b5f80$var$_toISOTime(this, ext, suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
        return c;
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's date component
   * @param {Object} opts - options
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc(1982, 5, 25).toISODate() //=> '1982-05-25'
   * @example DateTime.utc(1982, 5, 25).toISODate({ format: 'basic' }) //=> '19820525'
   * @return {string}
   */ ;
    _proto.toISODate = function toISODate(_temp4) {
        var _ref5 = _temp4 === void 0 ? {} : _temp4, _ref5$format = _ref5.format, format = _ref5$format === void 0 ? "extended" : _ref5$format;
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, format === "extended");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's week date
   * @example DateTime.utc(1982, 5, 25).toISOWeekDate() //=> '1982-W21-2'
   * @return {string}
   */ ;
    _proto.toISOWeekDate = function toISOWeekDate() {
        return $63618293c58b5f80$var$toTechFormat(this, "kkkk-'W'WW-c");
    } /**
   * Returns an ISO 8601-compliant string representation of this DateTime's time component
   * @param {Object} opts - options
   * @param {boolean} [opts.suppressMilliseconds=false] - exclude milliseconds from the format if they're 0
   * @param {boolean} [opts.suppressSeconds=false] - exclude seconds from the format if they're 0
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.extendedZone=true] - add the time zone format extension
   * @param {boolean} [opts.includePrefix=false] - include the `T` prefix
   * @param {string} [opts.format='extended'] - choose between the basic and extended format
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime() //=> '07:34:19.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34, seconds: 0, milliseconds: 0 }).toISOTime({ suppressSeconds: true }) //=> '07:34Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ format: 'basic' }) //=> '073419.361Z'
   * @example DateTime.utc().set({ hour: 7, minute: 34 }).toISOTime({ includePrefix: true }) //=> 'T07:34:19.361Z'
   * @return {string}
   */ ;
    _proto.toISOTime = function toISOTime(_temp5) {
        var _ref6 = _temp5 === void 0 ? {} : _temp5, _ref6$suppressMillise = _ref6.suppressMilliseconds, suppressMilliseconds = _ref6$suppressMillise === void 0 ? false : _ref6$suppressMillise, _ref6$suppressSeconds = _ref6.suppressSeconds, suppressSeconds = _ref6$suppressSeconds === void 0 ? false : _ref6$suppressSeconds, _ref6$includeOffset = _ref6.includeOffset, includeOffset = _ref6$includeOffset === void 0 ? true : _ref6$includeOffset, _ref6$includePrefix = _ref6.includePrefix, includePrefix = _ref6$includePrefix === void 0 ? false : _ref6$includePrefix, _ref6$extendedZone = _ref6.extendedZone, extendedZone = _ref6$extendedZone === void 0 ? false : _ref6$extendedZone, _ref6$format = _ref6.format, format = _ref6$format === void 0 ? "extended" : _ref6$format;
        if (!this.isValid) return null;
        var c = includePrefix ? "T" : "";
        return c + $63618293c58b5f80$var$_toISOTime(this, format === "extended", suppressSeconds, suppressMilliseconds, includeOffset, extendedZone);
    } /**
   * Returns an RFC 2822-compatible string representation of this DateTime
   * @example DateTime.utc(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 +0000'
   * @example DateTime.local(2014, 7, 13).toRFC2822() //=> 'Sun, 13 Jul 2014 00:00:00 -0400'
   * @return {string}
   */ ;
    _proto.toRFC2822 = function toRFC2822() {
        return $63618293c58b5f80$var$toTechFormat(this, "EEE, dd LLL yyyy HH:mm:ss ZZZ", false);
    } /**
   * Returns a string representation of this DateTime appropriate for use in HTTP headers. The output is always expressed in GMT.
   * Specifically, the string conforms to RFC 1123.
   * @see https://www.w3.org/Protocols/rfc2616/rfc2616-sec3.html#sec3.3.1
   * @example DateTime.utc(2014, 7, 13).toHTTP() //=> 'Sun, 13 Jul 2014 00:00:00 GMT'
   * @example DateTime.utc(2014, 7, 13, 19).toHTTP() //=> 'Sun, 13 Jul 2014 19:00:00 GMT'
   * @return {string}
   */ ;
    _proto.toHTTP = function toHTTP() {
        return $63618293c58b5f80$var$toTechFormat(this.toUTC(), "EEE, dd LLL yyyy HH:mm:ss 'GMT'");
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Date
   * @example DateTime.utc(2014, 7, 13).toSQLDate() //=> '2014-07-13'
   * @return {string}
   */ ;
    _proto.toSQLDate = function toSQLDate() {
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$_toISODate(this, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL Time
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc().toSQL() //=> '05:15:16.345'
   * @example DateTime.now().toSQL() //=> '05:15:16.345 -04:00'
   * @example DateTime.now().toSQL({ includeOffset: false }) //=> '05:15:16.345'
   * @example DateTime.now().toSQL({ includeZone: false }) //=> '05:15:16.345 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQLTime = function toSQLTime(_temp6) {
        var _ref7 = _temp6 === void 0 ? {} : _temp6, _ref7$includeOffset = _ref7.includeOffset, includeOffset = _ref7$includeOffset === void 0 ? true : _ref7$includeOffset, _ref7$includeZone = _ref7.includeZone, includeZone = _ref7$includeZone === void 0 ? false : _ref7$includeZone, _ref7$includeOffsetSp = _ref7.includeOffsetSpace, includeOffsetSpace = _ref7$includeOffsetSp === void 0 ? true : _ref7$includeOffsetSp;
        var fmt = "HH:mm:ss.SSS";
        if (includeZone || includeOffset) {
            if (includeOffsetSpace) fmt += " ";
            if (includeZone) fmt += "z";
            else if (includeOffset) fmt += "ZZ";
        }
        return $63618293c58b5f80$var$toTechFormat(this, fmt, true);
    } /**
   * Returns a string representation of this DateTime appropriate for use in SQL DateTime
   * @param {Object} opts - options
   * @param {boolean} [opts.includeZone=false] - include the zone, such as 'America/New_York'. Overrides includeOffset.
   * @param {boolean} [opts.includeOffset=true] - include the offset, such as 'Z' or '-04:00'
   * @param {boolean} [opts.includeOffsetSpace=true] - include the space between the time and the offset, such as '05:15:16.345 -04:00'
   * @example DateTime.utc(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 Z'
   * @example DateTime.local(2014, 7, 13).toSQL() //=> '2014-07-13 00:00:00.000 -04:00'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeOffset: false }) //=> '2014-07-13 00:00:00.000'
   * @example DateTime.local(2014, 7, 13).toSQL({ includeZone: true }) //=> '2014-07-13 00:00:00.000 America/New_York'
   * @return {string}
   */ ;
    _proto.toSQL = function toSQL(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return null;
        return this.toSQLDate() + " " + this.toSQLTime(opts);
    } /**
   * Returns a string representation of this DateTime appropriate for debugging
   * @return {string}
   */ ;
    _proto.toString = function toString() {
        return this.isValid ? this.toISO() : $63618293c58b5f80$var$INVALID;
    } /**
   * Returns the epoch milliseconds of this DateTime. Alias of {@link DateTime#toMillis}
   * @return {number}
   */ ;
    _proto.valueOf = function valueOf() {
        return this.toMillis();
    } /**
   * Returns the epoch milliseconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toMillis = function toMillis() {
        return this.isValid ? this.ts : NaN;
    } /**
   * Returns the epoch seconds of this DateTime.
   * @return {number}
   */ ;
    _proto.toSeconds = function toSeconds() {
        return this.isValid ? this.ts / 1000 : NaN;
    } /**
   * Returns the epoch seconds (as a whole number) of this DateTime.
   * @return {number}
   */ ;
    _proto.toUnixInteger = function toUnixInteger() {
        return this.isValid ? Math.floor(this.ts / 1000) : NaN;
    } /**
   * Returns an ISO 8601 representation of this DateTime appropriate for use in JSON.
   * @return {string}
   */ ;
    _proto.toJSON = function toJSON() {
        return this.toISO();
    } /**
   * Returns a BSON serializable equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toBSON = function toBSON() {
        return this.toJSDate();
    } /**
   * Returns a JavaScript object with this DateTime's year, month, day, and so on.
   * @param opts - options for generating the object
   * @param {boolean} [opts.includeConfig=false] - include configuration attributes in the output
   * @example DateTime.now().toObject() //=> { year: 2017, month: 4, day: 22, hour: 20, minute: 49, second: 42, millisecond: 268 }
   * @return {Object}
   */ ;
    _proto.toObject = function toObject(opts) {
        if (opts === void 0) opts = {};
        if (!this.isValid) return {};
        var base = $63618293c58b5f80$var$_extends({}, this.c);
        if (opts.includeConfig) {
            base.outputCalendar = this.outputCalendar;
            base.numberingSystem = this.loc.numberingSystem;
            base.locale = this.loc.locale;
        }
        return base;
    } /**
   * Returns a JavaScript Date equivalent to this DateTime.
   * @return {Date}
   */ ;
    _proto.toJSDate = function toJSDate() {
        return new Date(this.isValid ? this.ts : NaN);
    } /**
   * Return the difference between two DateTimes as a Duration.
   * @param {DateTime} otherDateTime - the DateTime to compare this one to
   * @param {string|string[]} [unit=['milliseconds']] - the unit or array of units (such as 'hours' or 'days') to include in the duration.
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @example
   * var i1 = DateTime.fromISO('1982-05-25T09:45'),
   *     i2 = DateTime.fromISO('1983-10-14T10:30');
   * i2.diff(i1).toObject() //=> { milliseconds: 43807500000 }
   * i2.diff(i1, 'hours').toObject() //=> { hours: 12168.75 }
   * i2.diff(i1, ['months', 'days']).toObject() //=> { months: 16, days: 19.03125 }
   * i2.diff(i1, ['months', 'days', 'hours']).toObject() //=> { months: 16, days: 19, hours: 0.75 }
   * @return {Duration}
   */ ;
    _proto.diff = function diff(otherDateTime, unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        if (!this.isValid || !otherDateTime.isValid) return $63618293c58b5f80$var$Duration.invalid("created by diffing an invalid DateTime");
        var durOpts = $63618293c58b5f80$var$_extends({
            locale: this.locale,
            numberingSystem: this.numberingSystem
        }, opts);
        var units = $63618293c58b5f80$var$maybeArray(unit).map($63618293c58b5f80$var$Duration.normalizeUnit), otherIsLater = otherDateTime.valueOf() > this.valueOf(), earlier = otherIsLater ? this : otherDateTime, later = otherIsLater ? otherDateTime : this, diffed = $63618293c58b5f80$var$_diff(earlier, later, units, durOpts);
        return otherIsLater ? diffed.negate() : diffed;
    } /**
   * Return the difference between this DateTime and right now.
   * See {@link DateTime#diff}
   * @param {string|string[]} [unit=['milliseconds']] - the unit or units units (such as 'hours' or 'days') to include in the duration
   * @param {Object} opts - options that affect the creation of the Duration
   * @param {string} [opts.conversionAccuracy='casual'] - the conversion system to use
   * @return {Duration}
   */ ;
    _proto.diffNow = function diffNow(unit, opts) {
        if (unit === void 0) unit = "milliseconds";
        if (opts === void 0) opts = {};
        return this.diff(DateTime.now(), unit, opts);
    } /**
   * Return an Interval spanning between this DateTime and another DateTime
   * @param {DateTime} otherDateTime - the other end point of the Interval
   * @return {Interval}
   */ ;
    _proto.until = function until(otherDateTime) {
        return this.isValid ? $63618293c58b5f80$var$Interval.fromDateTimes(this, otherDateTime) : this;
    } /**
   * Return whether this DateTime is in the same unit of time as another DateTime.
   * Higher-order units must also be identical for this function to return `true`.
   * Note that time zones are **ignored** in this comparison, which compares the **local** calendar time. Use {@link DateTime#setZone} to convert one of the dates if needed.
   * @param {DateTime} otherDateTime - the other DateTime
   * @param {string} unit - the unit of time to check sameness on
   * @example DateTime.now().hasSame(otherDT, 'day'); //~> true if otherDT is in the same current calendar day
   * @return {boolean}
   */ ;
    _proto.hasSame = function hasSame(otherDateTime, unit) {
        if (!this.isValid) return false;
        var inputMs = otherDateTime.valueOf();
        var adjustedToZone = this.setZone(otherDateTime.zone, {
            keepLocalTime: true
        });
        return adjustedToZone.startOf(unit) <= inputMs && inputMs <= adjustedToZone.endOf(unit);
    } /**
   * Equality check
   * Two DateTimes are equal if and only if they represent the same millisecond, have the same zone and location, and are both valid.
   * To compare just the millisecond values, use `+dt1 === +dt2`.
   * @param {DateTime} other - the other DateTime
   * @return {boolean}
   */ ;
    _proto.equals = function equals(other) {
        return this.isValid && other.isValid && this.valueOf() === other.valueOf() && this.zone.equals(other.zone) && this.loc.equals(other.loc);
    } /**
   * Returns a string representation of a this time relative to now, such as "in two days". Can only internationalize if your
   * platform supports Intl.RelativeTimeFormat. Rounds down by default.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} [options.style="long"] - the style of units, must be "long", "short", or "narrow"
   * @param {string|string[]} options.unit - use a specific unit or array of units; if omitted, or an array, the method will pick the best unit. Use an array or one of "years", "quarters", "months", "weeks", "days", "hours", "minutes", or "seconds"
   * @param {boolean} [options.round=true] - whether to round the numbers in the output.
   * @param {number} [options.padding=0] - padding in milliseconds. This allows you to round up the result if it fits inside the threshold. Don't use in combination with {round: false} because the decimal output will include the padding.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelative() //=> "in 1 day"
   * @example DateTime.now().setLocale("es").toRelative({ days: 1 }) //=> "dentro de 1 día"
   * @example DateTime.now().plus({ days: 1 }).toRelative({ locale: "fr" }) //=> "dans 23 heures"
   * @example DateTime.now().minus({ days: 2 }).toRelative() //=> "2 days ago"
   * @example DateTime.now().minus({ days: 2 }).toRelative({ unit: "hours" }) //=> "48 hours ago"
   * @example DateTime.now().minus({ hours: 36 }).toRelative({ round: false }) //=> "1.5 days ago"
   */ ;
    _proto.toRelative = function toRelative(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        var base = options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), padding = options.padding ? this < base ? -options.padding : options.padding : 0;
        var units = [
            "years",
            "months",
            "days",
            "hours",
            "minutes",
            "seconds"
        ];
        var unit = options.unit;
        if (Array.isArray(options.unit)) {
            units = options.unit;
            unit = undefined;
        }
        return $63618293c58b5f80$var$diffRelative(base, this.plus(padding), $63618293c58b5f80$var$_extends({}, options, {
            numeric: "always",
            units: units,
            unit: unit
        }));
    } /**
   * Returns a string representation of this date relative to today, such as "yesterday" or "next month".
   * Only internationalizes on platforms that supports Intl.RelativeTimeFormat.
   * @param {Object} options - options that affect the output
   * @param {DateTime} [options.base=DateTime.now()] - the DateTime to use as the basis to which this time is compared. Defaults to now.
   * @param {string} options.locale - override the locale of this DateTime
   * @param {string} options.unit - use a specific unit; if omitted, the method will pick the unit. Use one of "years", "quarters", "months", "weeks", or "days"
   * @param {string} options.numberingSystem - override the numberingSystem of this DateTime. The Intl system may choose not to honor this
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar() //=> "tomorrow"
   * @example DateTime.now().setLocale("es").plus({ days: 1 }).toRelative() //=> ""mañana"
   * @example DateTime.now().plus({ days: 1 }).toRelativeCalendar({ locale: "fr" }) //=> "demain"
   * @example DateTime.now().minus({ days: 2 }).toRelativeCalendar() //=> "2 days ago"
   */ ;
    _proto.toRelativeCalendar = function toRelativeCalendar(options) {
        if (options === void 0) options = {};
        if (!this.isValid) return null;
        return $63618293c58b5f80$var$diffRelative(options.base || DateTime.fromObject({}, {
            zone: this.zone
        }), this, $63618293c58b5f80$var$_extends({}, options, {
            numeric: "auto",
            units: [
                "years",
                "months",
                "days"
            ],
            calendary: true
        }));
    } /**
   * Return the min of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the minimum
   * @return {DateTime} the min DateTime, or undefined if called with no argument
   */ ;
    DateTime.min = function min() {
        for(var _len = arguments.length, dateTimes = new Array(_len), _key = 0; _key < _len; _key++)dateTimes[_key] = arguments[_key];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("min requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.min);
    } /**
   * Return the max of several date times
   * @param {...DateTime} dateTimes - the DateTimes from which to choose the maximum
   * @return {DateTime} the max DateTime, or undefined if called with no argument
   */ ;
    DateTime.max = function max() {
        for(var _len2 = arguments.length, dateTimes = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++)dateTimes[_key2] = arguments[_key2];
        if (!dateTimes.every(DateTime.isDateTime)) throw new $63618293c58b5f80$var$InvalidArgumentError("max requires all arguments be DateTimes");
        return $63618293c58b5f80$var$bestBy(dateTimes, function(i) {
            return i.valueOf();
        }, Math.max);
    } /**
   * Explain how a string would be parsed by fromFormat()
   * @param {string} text - the string to parse
   * @param {string} fmt - the format the string is expected to be in (see description)
   * @param {Object} options - options taken by fromFormat()
   * @return {Object}
   */ ;
    DateTime.fromFormatExplain = function fromFormatExplain(text, fmt, options) {
        if (options === void 0) options = {};
        var _options = options, _options$locale = _options.locale, locale = _options$locale === void 0 ? null : _options$locale, _options$numberingSys = _options.numberingSystem, numberingSystem = _options$numberingSys === void 0 ? null : _options$numberingSys, localeToUse = $63618293c58b5f80$var$Locale.fromOpts({
            locale: locale,
            numberingSystem: numberingSystem,
            defaultToEN: true
        });
        return $63618293c58b5f80$var$explainFromTokens(localeToUse, text, fmt);
    } /**
   * @deprecated use fromFormatExplain instead
   */ ;
    DateTime.fromStringExplain = function fromStringExplain(text, fmt, options) {
        if (options === void 0) options = {};
        return DateTime.fromFormatExplain(text, fmt, options);
    } /**
   * {@link DateTime#toLocaleString} format like 10/14/1983
   * @type {Object}
   */ ;
    $63618293c58b5f80$var$_createClass(DateTime, [
        {
            key: "isValid",
            get: function get() {
                return this.invalid === null;
            }
        },
        {
            key: "invalidReason",
            get: function get() {
                return this.invalid ? this.invalid.reason : null;
            }
        },
        {
            key: "invalidExplanation",
            get: function get() {
                return this.invalid ? this.invalid.explanation : null;
            }
        },
        {
            key: "locale",
            get: function get() {
                return this.isValid ? this.loc.locale : null;
            }
        },
        {
            key: "numberingSystem",
            get: function get() {
                return this.isValid ? this.loc.numberingSystem : null;
            }
        },
        {
            key: "outputCalendar",
            get: function get() {
                return this.isValid ? this.loc.outputCalendar : null;
            }
        },
        {
            key: "zone",
            get: function get() {
                return this._zone;
            }
        },
        {
            key: "zoneName",
            get: function get() {
                return this.isValid ? this.zone.name : null;
            }
        },
        {
            key: "year",
            get: function get() {
                return this.isValid ? this.c.year : NaN;
            }
        },
        {
            key: "quarter",
            get: function get() {
                return this.isValid ? Math.ceil(this.c.month / 3) : NaN;
            }
        },
        {
            key: "month",
            get: function get() {
                return this.isValid ? this.c.month : NaN;
            }
        },
        {
            key: "day",
            get: function get() {
                return this.isValid ? this.c.day : NaN;
            }
        },
        {
            key: "hour",
            get: function get() {
                return this.isValid ? this.c.hour : NaN;
            }
        },
        {
            key: "minute",
            get: function get() {
                return this.isValid ? this.c.minute : NaN;
            }
        },
        {
            key: "second",
            get: function get() {
                return this.isValid ? this.c.second : NaN;
            }
        },
        {
            key: "millisecond",
            get: function get() {
                return this.isValid ? this.c.millisecond : NaN;
            }
        },
        {
            key: "weekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekYear : NaN;
            }
        },
        {
            key: "weekNumber",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekNumber : NaN;
            }
        },
        {
            key: "weekday",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$possiblyCachedWeekData(this).weekday : NaN;
            }
        },
        {
            key: "ordinal",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$gregorianToOrdinal(this.c).ordinal : NaN;
            }
        },
        {
            key: "monthShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("short", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "monthLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.months("long", {
                    locObj: this.loc
                })[this.month - 1] : null;
            }
        },
        {
            key: "weekdayShort",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("short", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "weekdayLong",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$Info.weekdays("long", {
                    locObj: this.loc
                })[this.weekday - 1] : null;
            }
        },
        {
            key: "offset",
            get: function get() {
                return this.isValid ? +this.o : NaN;
            }
        },
        {
            key: "offsetNameShort",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "short",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "offsetNameLong",
            get: function get() {
                if (this.isValid) return this.zone.offsetName(this.ts, {
                    format: "long",
                    locale: this.locale
                });
                else return null;
            }
        },
        {
            key: "isOffsetFixed",
            get: function get() {
                return this.isValid ? this.zone.isUniversal : null;
            }
        },
        {
            key: "isInDST",
            get: function get() {
                if (this.isOffsetFixed) return false;
                else return this.offset > this.set({
                    month: 1,
                    day: 1
                }).offset || this.offset > this.set({
                    month: 5
                }).offset;
            }
        },
        {
            key: "isInLeapYear",
            get: function get() {
                return $63618293c58b5f80$var$isLeapYear(this.year);
            }
        },
        {
            key: "daysInMonth",
            get: function get() {
                return $63618293c58b5f80$var$daysInMonth(this.year, this.month);
            }
        },
        {
            key: "daysInYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$daysInYear(this.year) : NaN;
            }
        },
        {
            key: "weeksInWeekYear",
            get: function get() {
                return this.isValid ? $63618293c58b5f80$var$weeksInWeekYear(this.weekYear) : NaN;
            }
        }
    ], [
        {
            key: "DATE_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATE_SHORT;
            }
        },
        {
            key: "DATE_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED;
            }
        },
        {
            key: "DATE_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATE_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATE_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATE_FULL;
            }
        },
        {
            key: "DATE_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATE_HUGE;
            }
        },
        {
            key: "TIME_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_SIMPLE;
            }
        },
        {
            key: "TIME_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SECONDS;
            }
        },
        {
            key: "TIME_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_WITH_LONG_OFFSET;
            }
        },
        {
            key: "TIME_24_SIMPLE",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_SIMPLE;
            }
        },
        {
            key: "TIME_24_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SECONDS;
            }
        },
        {
            key: "TIME_24_WITH_SHORT_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_SHORT_OFFSET;
            }
        },
        {
            key: "TIME_24_WITH_LONG_OFFSET",
            get: function get() {
                return $63618293c58b5f80$var$TIME_24_WITH_LONG_OFFSET;
            }
        },
        {
            key: "DATETIME_SHORT",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT;
            }
        },
        {
            key: "DATETIME_SHORT_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_SHORT_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED;
            }
        },
        {
            key: "DATETIME_MED_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_MED_WITH_WEEKDAY",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_MED_WITH_WEEKDAY;
            }
        },
        {
            key: "DATETIME_FULL",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL;
            }
        },
        {
            key: "DATETIME_FULL_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_FULL_WITH_SECONDS;
            }
        },
        {
            key: "DATETIME_HUGE",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE;
            }
        },
        {
            key: "DATETIME_HUGE_WITH_SECONDS",
            get: function get() {
                return $63618293c58b5f80$var$DATETIME_HUGE_WITH_SECONDS;
            }
        }
    ]);
    return DateTime;
}();
function $63618293c58b5f80$var$friendlyDateTime(dateTimeish) {
    if ($63618293c58b5f80$var$DateTime.isDateTime(dateTimeish)) return dateTimeish;
    else if (dateTimeish && dateTimeish.valueOf && $63618293c58b5f80$var$isNumber(dateTimeish.valueOf())) return $63618293c58b5f80$var$DateTime.fromJSDate(dateTimeish);
    else if (dateTimeish && typeof dateTimeish === "object") return $63618293c58b5f80$var$DateTime.fromObject(dateTimeish);
    else throw new $63618293c58b5f80$var$InvalidArgumentError("Unknown datetime argument: " + dateTimeish + ", of type " + typeof dateTimeish);
}
var $63618293c58b5f80$var$VERSION = "3.4.3";
$63618293c58b5f80$exports.DateTime = $63618293c58b5f80$var$DateTime;
$63618293c58b5f80$exports.Duration = $63618293c58b5f80$var$Duration;
$63618293c58b5f80$exports.FixedOffsetZone = $63618293c58b5f80$var$FixedOffsetZone;
$63618293c58b5f80$exports.IANAZone = $63618293c58b5f80$var$IANAZone;
$63618293c58b5f80$exports.Info = $63618293c58b5f80$var$Info;
$63618293c58b5f80$exports.Interval = $63618293c58b5f80$var$Interval;
$63618293c58b5f80$exports.InvalidZone = $63618293c58b5f80$var$InvalidZone;
$63618293c58b5f80$exports.Settings = $63618293c58b5f80$var$Settings;
$63618293c58b5f80$exports.SystemZone = $63618293c58b5f80$var$SystemZone;
$63618293c58b5f80$exports.VERSION = $63618293c58b5f80$var$VERSION;
$63618293c58b5f80$exports.Zone = $63618293c58b5f80$var$Zone;


const $9fab29b0215440cb$export$3fd1b87e602b44a0 = `
<svg width="16px" height="16px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
  <rect x="9" y="9" width="13" height="13" rx="2" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M5 15H4C2.89543 15 2 14.1046 2 13V4C2 2.89543 2.89543 2 4 2H13C14.1046 2 15 2.89543 15 4V5" stroke="#333" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
`;



function $c8405d23c9f3c6d9$var$isMoment(parseFn, text) {
    const a = parseFn(text, {
        zone: "Etc/UTC",
        setZone: true
    });
    const b = parseFn(text, {
        zone: "Etc/UTC+1",
        setZone: true
    });
    return a.toMillis() === b.toMillis();
}
// Matches explicit timezone markers like "UTC", "GMT-0700", "-08:00", or "PDT".
function $c8405d23c9f3c6d9$var$hasExplicitTimezone(text) {
    return /\b(?:UTC|GMT)(?:[+-]\d{1,2}(?::?\d{2})?)?\b|[+-]\d{2}:?\d{2}\b|\b(?!AM\b|PM\b)[A-Z]{2,4}\b/.test(text);
}
function $c8405d23c9f3c6d9$var$fromCustomFormat(text) {
    const formats = [
        "yyyy-MM-dd ha",
        "yyyy-MM-dd h a",
        "ha yyyy-MM-dd",
        "h a yyyy-MM-dd"
    ];
    for (const format of formats){
        const parsed = (0, $63618293c58b5f80$exports.DateTime).fromFormat(text, format);
        if (parsed.isValid) return parsed;
    }
    return undefined;
}
function $c8405d23c9f3c6d9$var$extractComment(raw) {
    const matches = [
        ...raw.matchAll(/(^|\s)(#|\/\/|--|;)(?=\s|$)/g)
    ];
    if (matches.length === 0) return {
        text: raw.trim(),
        comment: undefined
    };
    const match = matches[0];
    const markerIdx = match.index + match[1].length;
    const text = raw.slice(0, markerIdx).trim();
    const comment = raw.slice(markerIdx + match[2].length).trim();
    return {
        text: text,
        comment: comment.length > 0 ? comment : undefined
    };
}
function $c8405d23c9f3c6d9$var$withComment(parsed, comment) {
    return Object.assign(parsed, {
        comment: comment
    });
}
function $c8405d23c9f3c6d9$export$8ceb1d4b31259502(raw, line) {
    const { text: text, comment: comment } = $c8405d23c9f3c6d9$var$extractComment(raw);
    const isNumber = /^\d+([.,]\d*)?$/.test(text);
    // Number
    if (isNumber) {
        const number = parseFloat(text);
        const whole = Math.floor(number);
        // Milliseconds
        if (whole.toString().length >= 13) return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment((0, $63618293c58b5f80$exports.DateTime).fromMillis(number), comment),
            moment: true
        };
        else return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment((0, $63618293c58b5f80$exports.DateTime).fromSeconds(number), comment),
            moment: true
        };
    } else {
        const fromHTTP = (0, $63618293c58b5f80$exports.DateTime).fromHTTP(text);
        const fromISO = (0, $63618293c58b5f80$exports.DateTime).fromISO(text);
        const fromRFC2822 = (0, $63618293c58b5f80$exports.DateTime).fromRFC2822(text);
        const fromSQL = (0, $63618293c58b5f80$exports.DateTime).fromSQL(text);
        const fromCustom = $c8405d23c9f3c6d9$var$fromCustomFormat(text);
        const fromDate = new Date(text);
        if (fromISO.isValid) return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment(fromISO, comment),
            moment: $c8405d23c9f3c6d9$var$isMoment((0, $63618293c58b5f80$exports.DateTime).fromISO, text)
        };
        else if (fromHTTP.isValid) return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment(fromHTTP, comment),
            moment: $c8405d23c9f3c6d9$var$isMoment((0, $63618293c58b5f80$exports.DateTime).fromHTTP, text)
        };
        else if (fromRFC2822.isValid) return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment(fromRFC2822, comment),
            moment: $c8405d23c9f3c6d9$var$isMoment((0, $63618293c58b5f80$exports.DateTime).fromRFC2822, text)
        };
        else if (fromSQL.isValid) return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment(fromSQL, comment),
            moment: $c8405d23c9f3c6d9$var$isMoment((0, $63618293c58b5f80$exports.DateTime).fromSQL, text)
        };
        else if (fromCustom?.isValid) return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment(fromCustom, comment),
            moment: false
        };
        else if (fromDate.toString() !== "Invalid Date") return {
            line: line,
            raw: raw,
            text: text,
            parsed: $c8405d23c9f3c6d9$var$withComment((0, $63618293c58b5f80$exports.DateTime).fromJSDate(fromDate), comment),
            moment: $c8405d23c9f3c6d9$var$hasExplicitTimezone(text)
        };
        else return {
            line: line,
            raw: raw,
            text: text,
            parsed: undefined,
            moment: false
        };
    }
}


const $f43313d21d3fd8e2$var$KEY_TIMEZONES = "timezones";
let $f43313d21d3fd8e2$var$text = "";
let $f43313d21d3fd8e2$var$entries = [];
let $f43313d21d3fd8e2$var$timezones = [];
let $f43313d21d3fd8e2$var$timelineTimezone = "UTC";
let $f43313d21d3fd8e2$var$minMs = Number.MAX_VALUE;
let $f43313d21d3fd8e2$var$maxMs = -Number.MAX_VALUE;
const $f43313d21d3fd8e2$var$textarea = document.getElementById("textarea");
const $f43313d21d3fd8e2$var$statuses = document.getElementById("statuses");
const $f43313d21d3fd8e2$var$rangeLabel = document.getElementById("range-label");
const $f43313d21d3fd8e2$var$formatSelect = document.querySelector("#add-format select");
const $f43313d21d3fd8e2$var$timelineStatuses = document.getElementById("timeline-statuses");
const $f43313d21d3fd8e2$var$timelineTextarea = document.getElementById("timeline-textarea");
const $f43313d21d3fd8e2$var$timelineTimezoneSelect = document.querySelector("#timeline-timezone select");
const $f43313d21d3fd8e2$var$timelines = document.getElementById("timelines");
const $f43313d21d3fd8e2$var$svg = (0, $e4b50d36b79545e2$export$13f4b12aafeba5d6)("svg").size("100%", "100%");
const $f43313d21d3fd8e2$var$l1 = $f43313d21d3fd8e2$var$svg.group(); // Timelines and circles
const $f43313d21d3fd8e2$var$l2 = $f43313d21d3fd8e2$var$svg.group(); // Verticle line and timestamps
const $f43313d21d3fd8e2$var$l3 = $f43313d21d3fd8e2$var$svg.group(); // Timezone background mask
const $f43313d21d3fd8e2$var$l4 = $f43313d21d3fd8e2$var$svg.group(); // Timezone background mask
var $f43313d21d3fd8e2$var$FormatMethods;
(function(FormatMethods) {
    FormatMethods["SECS"] = "toUnixInteger";
    FormatMethods["MILLIS"] = "toMillis";
    FormatMethods["ISO"] = "toISO";
    FormatMethods["HTTP"] = "toHTTP";
    FormatMethods["SQL"] = "toSQL";
    FormatMethods["RFC2822"] = "toRFC2822";
})($f43313d21d3fd8e2$var$FormatMethods || ($f43313d21d3fd8e2$var$FormatMethods = {}));
function $f43313d21d3fd8e2$var$formatName(method) {
    switch(method){
        case $f43313d21d3fd8e2$var$FormatMethods.HTTP:
            return "HTTP";
        case $f43313d21d3fd8e2$var$FormatMethods.ISO:
            return "ISO 8601";
        case $f43313d21d3fd8e2$var$FormatMethods.MILLIS:
            return "Unix (ms)";
        case $f43313d21d3fd8e2$var$FormatMethods.SECS:
            return "Unix (s)";
        case $f43313d21d3fd8e2$var$FormatMethods.RFC2822:
            return "RFC 2822";
        case $f43313d21d3fd8e2$var$FormatMethods.SQL:
            return "SQL";
        default:
            return "UNKNOWN";
    }
}
function $f43313d21d3fd8e2$var$serializeFormat(dt, format) {
    return format === $f43313d21d3fd8e2$var$FormatMethods.ISO ? dt[format]({
        suppressMilliseconds: true
    }).toString() : dt[format]().toString();
}
function $f43313d21d3fd8e2$var$validEntryIndexes() {
    return $f43313d21d3fd8e2$var$entries.flatMap((entry, idx)=>entry.parsed ? [
            idx
        ] : []);
}
function $f43313d21d3fd8e2$var$formatRange(ms) {
    const units = [
        {
            label: "day",
            ms: 86400000
        },
        {
            label: "hour",
            ms: 3600000
        },
        {
            label: "minute",
            ms: 60000
        },
        {
            label: "second",
            ms: 1000
        },
        {
            label: "millisecond",
            ms: 1
        }
    ];
    for (const unit of units)if (ms >= unit.ms || unit.ms === 1) {
        const value = Math.floor(ms / unit.ms);
        return `${value} ${unit.label}${value === 1 ? "" : "s"}`;
    }
    return "0 milliseconds";
}
function $f43313d21d3fd8e2$var$colorSlotForEntry(entryIdx) {
    return $f43313d21d3fd8e2$var$validEntryIndexes().indexOf(entryIdx);
}
function $f43313d21d3fd8e2$var$colorForSlot(colorSlot) {
    const validCount = $f43313d21d3fd8e2$var$validEntryIndexes().length || 1;
    const h = colorSlot * 360 / validCount;
    return new (0, $e4b50d36b79545e2$export$892596cec99bc70e)(h, 80, 65, "hsl");
}
function $f43313d21d3fd8e2$var$fillAndStroke(circle, entryIdx) {
    const colorSlot = $f43313d21d3fd8e2$var$colorSlotForEntry(entryIdx);
    if (colorSlot < 0) return;
    const isMoment = $f43313d21d3fd8e2$var$entries[entryIdx].moment;
    if (isMoment) circle.fill($f43313d21d3fd8e2$var$colorForSlot(colorSlot));
    else circle.fill("none").stroke({
        color: $f43313d21d3fd8e2$var$colorForSlot(colorSlot).toString()
    });
}
function $f43313d21d3fd8e2$var$statusBadge(valid, idx) {
    const container = document.createElement("div");
    container.className = "status-container";
    if (valid) {
        const svg = (0, $e4b50d36b79545e2$export$13f4b12aafeba5d6)().size("100%", "100%").addTo(container);
        const clipCircle = svg.circle("80%").attr("cx", "50%").attr("cy", "50%");
        const clip = svg.clip().add(clipCircle);
        $f43313d21d3fd8e2$var$fillAndStroke(svg.circle("80%").attr("cx", "50%").attr("cy", "50%").stroke({
            width: 6
        }).clipWith(clip), idx);
    } else {
        const span = document.createElement("span");
        span.innerHTML = "!";
        span.title = "Unparseable";
        container.appendChild(span);
    }
    return container;
}
function $f43313d21d3fd8e2$var$statusSpacer() {
    const container = document.createElement("div");
    container.className = "status-container";
    return container;
}
function $f43313d21d3fd8e2$var$updateStatus() {
    $f43313d21d3fd8e2$var$statuses.innerHTML = "";
    $f43313d21d3fd8e2$var$entries.forEach((e, idx)=>{
        $f43313d21d3fd8e2$var$statuses.appendChild($f43313d21d3fd8e2$var$statusBadge(e.parsed?.isValid === true, idx));
    });
}
function $f43313d21d3fd8e2$var$updateRangeLabel() {
    const parsedEntries = $f43313d21d3fd8e2$var$entries.flatMap((entry)=>entry.parsed ? [
            entry.parsed.toMillis()
        ] : []);
    if (parsedEntries.length <= 1) {
        $f43313d21d3fd8e2$var$rangeLabel.innerText = "Range";
        return;
    }
    const minParsed = Math.min(...parsedEntries);
    const maxParsed = Math.max(...parsedEntries);
    $f43313d21d3fd8e2$var$rangeLabel.innerText = `Range: ${$f43313d21d3fd8e2$var$formatRange(maxParsed - minParsed)}`;
}
function $f43313d21d3fd8e2$var$updateTimelineTextarea() {
    const projectedMillis = (entry)=>entry.parsed.setZone($f43313d21d3fd8e2$var$timelineTimezone, {
            keepLocalTime: !entry.moment
        }).toMillis();
    const sortedEntries = $f43313d21d3fd8e2$var$entries.filter((entry)=>entry.parsed).sort((a, b)=>projectedMillis(a) - projectedMillis(b)).map((entry)=>entry);
    const timelineLines = [];
    $f43313d21d3fd8e2$var$timelineStatuses.innerHTML = "";
    for (const [idx, entry] of sortedEntries.entries()){
        timelineLines.push(entry.parsed?.comment ?? entry.raw);
        $f43313d21d3fd8e2$var$timelineStatuses.appendChild($f43313d21d3fd8e2$var$statusBadge(true, entry.line));
        const nextEntry = sortedEntries[idx + 1];
        if (!nextEntry) continue;
        const gapMs = projectedMillis(nextEntry) - projectedMillis(entry);
        timelineLines.push(`  ... ${$f43313d21d3fd8e2$var$formatRange(gapMs)} ...`);
        $f43313d21d3fd8e2$var$timelineStatuses.appendChild($f43313d21d3fd8e2$var$statusSpacer());
    }
    $f43313d21d3fd8e2$var$timelineTextarea.value = timelineLines.join("\n");
}
function $f43313d21d3fd8e2$var$parseTextArea() {
    $f43313d21d3fd8e2$var$text = $f43313d21d3fd8e2$var$textarea.value;
    $f43313d21d3fd8e2$var$entries = $f43313d21d3fd8e2$var$text.split("\n").map((0, $c8405d23c9f3c6d9$export$8ceb1d4b31259502));
    $f43313d21d3fd8e2$var$updateStatus();
    $f43313d21d3fd8e2$var$updateRangeLabel();
    $f43313d21d3fd8e2$var$updateTimelineTextarea();
}
$f43313d21d3fd8e2$var$textarea.addEventListener("input", (ev)=>{
    $f43313d21d3fd8e2$var$refresh();
});
function $f43313d21d3fd8e2$var$drawTimelines() {
    $f43313d21d3fd8e2$var$l1.clear();
    $f43313d21d3fd8e2$var$l2.clear();
    $f43313d21d3fd8e2$var$l3.clear();
    $f43313d21d3fd8e2$var$l4.clear();
    const h = $f43313d21d3fd8e2$var$timelines.clientHeight / $f43313d21d3fd8e2$var$timezones.length;
    const w = $f43313d21d3fd8e2$var$timelines.clientWidth;
    $f43313d21d3fd8e2$var$minMs = Number.MAX_VALUE;
    $f43313d21d3fd8e2$var$maxMs = -Number.MAX_VALUE;
    const timezoneTimes = new Array($f43313d21d3fd8e2$var$timezones.length);
    // Collect stats and create times adjusted to each timezone
    for (const [idx, tz] of $f43313d21d3fd8e2$var$timezones.entries()){
        const y = idx * h + h / 2;
        // Put the timeline lines into a group for organizational purposes
        const tl = $f43313d21d3fd8e2$var$l1.group();
        const insetX = 2;
        const insetY = 8;
        tl.rect(w - insetX * 2, h - insetY).move(insetX, idx * h + 1).fill("white").stroke({
            color: "#d3d3d3",
            width: 2
        });
        // Main horizontal
        tl.line(insetX * 4, y, w - insetX * 4, y).stroke({
            color: "#eee",
            width: 2
        });
        // Arrows
        const arrowLen = 8;
        tl.line(insetX * 4, y, insetX * 4 + arrowLen, y - arrowLen).stroke({
            color: "#eee",
            width: 2
        });
        tl.line(insetX * 4, y, insetX * 4 + arrowLen, y + arrowLen).stroke({
            color: "#eee",
            width: 2
        });
        tl.line(w - insetX * 4, y, w - insetX * 4 - arrowLen, y - arrowLen).stroke({
            color: "#eee",
            width: 2
        });
        tl.line(w - insetX * 4, y, w - insetX * 4 - arrowLen, y + arrowLen).stroke({
            color: "#eee",
            width: 2
        });
        timezoneTimes[idx] = [];
        for (const [entryIdx, e] of $f43313d21d3fd8e2$var$entries.entries()){
            if (!e.parsed) continue;
            const inTz = e.parsed.setZone(tz, {
                keepLocalTime: !e.moment
            });
            timezoneTimes[idx].push({
                entryIdx: entryIdx,
                time: inTz
            });
            $f43313d21d3fd8e2$var$minMs = Math.min($f43313d21d3fd8e2$var$minMs, inTz.toMillis());
            $f43313d21d3fd8e2$var$maxMs = Math.max($f43313d21d3fd8e2$var$maxMs, inTz.toMillis());
        }
    }
    // Add padding
    const range = $f43313d21d3fd8e2$var$maxMs - $f43313d21d3fd8e2$var$minMs;
    $f43313d21d3fd8e2$var$minMs -= range * 0.1;
    $f43313d21d3fd8e2$var$maxMs += range * 0.1;
    // Draw actual circles
    for (const [idx, tzTimes] of timezoneTimes.entries())for (const { entryIdx: entryIdx, time: t } of tzTimes){
        const y = idx * h + h / 2;
        $f43313d21d3fd8e2$var$fillAndStroke($f43313d21d3fd8e2$var$l1.circle(20).center($f43313d21d3fd8e2$var$maxMs - $f43313d21d3fd8e2$var$minMs > 0 ? w * (t.toMillis() - $f43313d21d3fd8e2$var$minMs) / ($f43313d21d3fd8e2$var$maxMs - $f43313d21d3fd8e2$var$minMs) : w / 2, y).stroke({
            width: 4
        }).attr("pointer-events", "all").attr("cursor", "pointer").on("click", (ev)=>{
            ev.stopPropagation();
            $f43313d21d3fd8e2$var$showModal({
                tz: $f43313d21d3fd8e2$var$timezones[idx],
                entry: $f43313d21d3fd8e2$var$entries[entryIdx]
            });
        }), entryIdx);
    }
    // Write timezone labels and center times
    for (const [idx, tz] of $f43313d21d3fd8e2$var$timezones.entries()){
        const y = (idx + 1) * h - 28;
        // const timeStr = DateTime.fromMillis(minMs + range / 2, {
        //   zone: tz,
        // }).toISO();
        const label = $f43313d21d3fd8e2$var$l4.text(tz).x(w / 2).y(y).font({
            anchor: "middle",
            weight: "bold"
        });
        // Place box underneath matching background so crosshair doesn't interfere
        $f43313d21d3fd8e2$var$l3.rect(label.bbox().w + 10, label.bbox().h + 10).center(label.bbox().cx, label.bbox().cy).fill("white");
    }
    // Clear existing buttons
    document.querySelectorAll(".remove-button").forEach((e)=>e.parentNode.removeChild(e));
    // Create buttons to remove timezones
    const buttonInsetX = 7;
    const buttonInsetY = 5;
    for (const [idx, tz] of $f43313d21d3fd8e2$var$timezones.entries()){
        const y = idx * h + buttonInsetY;
        const button = document.createElement("button");
        button.onmousemove = (ev)=>{
            ev.stopPropagation();
        };
        button.innerHTML = `<span>×</span>`;
        button.className = "remove-button";
        button.style.position = "absolute";
        button.style.top = `${y}px`;
        button.style.right = `${buttonInsetX}px`;
        button.onclick = ()=>{
            $f43313d21d3fd8e2$var$removeTimezone(tz);
        };
        $f43313d21d3fd8e2$var$timelines.appendChild(button);
    }
}
function $f43313d21d3fd8e2$var$sortTimezones() {
    const now = (0, $63618293c58b5f80$exports.DateTime).now();
    $f43313d21d3fd8e2$var$timezones.sort((a, b)=>{
        const offseta = now.setZone(a).offset;
        const offsetb = now.setZone(b).offset;
        if (offseta !== offsetb) return offsetb - offseta;
        else return a.localeCompare(b);
    });
}
function $f43313d21d3fd8e2$var$refresh() {
    $f43313d21d3fd8e2$var$sortTimezones();
    $f43313d21d3fd8e2$var$parseTextArea();
    $f43313d21d3fd8e2$var$drawTimelines();
}
function $f43313d21d3fd8e2$var$setDefaultTimelineTimezone() {
    const localTimezone = (0, $63618293c58b5f80$exports.DateTime).now().zoneName;
    $f43313d21d3fd8e2$var$timelineTimezone = $f43313d21d3fd8e2$var$timezones.includes(localTimezone) ? localTimezone : "UTC";
    $f43313d21d3fd8e2$var$timelineTimezoneSelect.value = $f43313d21d3fd8e2$var$timelineTimezone;
    $f43313d21d3fd8e2$var$updateTimelineTextarea();
}
addEventListener("paste", (ev)=>{
    // Allow "normal" paste behaviour to occur if you pasted inside textarea
    // `input` event will handle it
    if (ev.target === $f43313d21d3fd8e2$var$textarea) return;
    // Allow "global" paste behaviour if you pasted outside textarea
    // Prevent 'input' event from also firing
    // if we're pasting inside the input
    ev.preventDefault();
    let text = $f43313d21d3fd8e2$var$textarea.value;
    if (!text.endsWith("\n")) text += "\n";
    text += ev.clipboardData.getData("text");
    $f43313d21d3fd8e2$var$textarea.value = text;
    $f43313d21d3fd8e2$var$refresh();
});
document.querySelector("body").onresize = $f43313d21d3fd8e2$var$refresh;
const $f43313d21d3fd8e2$var$now = (0, $63618293c58b5f80$exports.DateTime).now().startOf("minute");
$f43313d21d3fd8e2$var$textarea.value = [
    `${$f43313d21d3fd8e2$var$now.toISO({
        suppressMilliseconds: true
    })} # page load`,
    `${$f43313d21d3fd8e2$var$now.toISODate()} # midnight today`
].join("\n");
$f43313d21d3fd8e2$var$refresh();
const $f43313d21d3fd8e2$var$select = document.querySelector("#add-timezone select");
for (const format of Object.values($f43313d21d3fd8e2$var$FormatMethods)){
    const option = document.createElement("option");
    option.text = $f43313d21d3fd8e2$var$formatName(format);
    option.value = format;
    $f43313d21d3fd8e2$var$formatSelect.appendChild(option);
}
$f43313d21d3fd8e2$var$formatSelect.value = $f43313d21d3fd8e2$var$FormatMethods.ISO;
for (const tz of Intl.supportedValuesOf("timeZone")){
    const option = document.createElement("option");
    option.text = tz;
    option.value = tz;
    $f43313d21d3fd8e2$var$select.appendChild(option);
    const timelineOption = document.createElement("option");
    timelineOption.text = tz;
    timelineOption.value = tz;
    $f43313d21d3fd8e2$var$timelineTimezoneSelect.appendChild(timelineOption);
}
$f43313d21d3fd8e2$var$select.value = (0, $63618293c58b5f80$exports.DateTime).now().zoneName;
$f43313d21d3fd8e2$var$timelineTimezoneSelect.value = $f43313d21d3fd8e2$var$timelineTimezone;
function $f43313d21d3fd8e2$var$addTimezone(tz) {
    $f43313d21d3fd8e2$var$removeTimezone(tz); // Clear if it's already there
    $f43313d21d3fd8e2$var$timezones.push(tz);
    localStorage.setItem($f43313d21d3fd8e2$var$KEY_TIMEZONES, $f43313d21d3fd8e2$var$timezones.join());
    $f43313d21d3fd8e2$var$refresh();
}
function $f43313d21d3fd8e2$var$removeTimezone(tz) {
    $f43313d21d3fd8e2$var$timezones = $f43313d21d3fd8e2$var$timezones.filter((t)=>t != tz);
    localStorage.setItem($f43313d21d3fd8e2$var$KEY_TIMEZONES, $f43313d21d3fd8e2$var$timezones.join());
    $f43313d21d3fd8e2$var$refresh();
}
document.getElementById("add-button").onclick = ()=>{
    $f43313d21d3fd8e2$var$addTimezone($f43313d21d3fd8e2$var$select.value);
};
$f43313d21d3fd8e2$var$timelineTimezoneSelect.onchange = ()=>{
    $f43313d21d3fd8e2$var$timelineTimezone = $f43313d21d3fd8e2$var$timelineTimezoneSelect.value;
    $f43313d21d3fd8e2$var$updateTimelineTextarea();
};
document.getElementById("add-format-button").onclick = ()=>{
    let text = $f43313d21d3fd8e2$var$textarea.value;
    if (text && !text.endsWith("\n")) text += "\n";
    text += $f43313d21d3fd8e2$var$serializeFormat((0, $63618293c58b5f80$exports.DateTime).now(), $f43313d21d3fd8e2$var$formatSelect.value);
    $f43313d21d3fd8e2$var$textarea.value = text;
    $f43313d21d3fd8e2$var$refresh();
};
// Load previous timezones
if (localStorage.getItem($f43313d21d3fd8e2$var$KEY_TIMEZONES)) {
    $f43313d21d3fd8e2$var$timezones = localStorage.getItem($f43313d21d3fd8e2$var$KEY_TIMEZONES).split(",");
    $f43313d21d3fd8e2$var$setDefaultTimelineTimezone();
    $f43313d21d3fd8e2$var$refresh();
} else {
    $f43313d21d3fd8e2$var$addTimezone("UTC");
    $f43313d21d3fd8e2$var$addTimezone((0, $63618293c58b5f80$exports.DateTime).local().zoneName);
    $f43313d21d3fd8e2$var$setDefaultTimelineTimezone();
}
let $f43313d21d3fd8e2$var$offsetX = undefined;
let $f43313d21d3fd8e2$var$offsetY = undefined;
$f43313d21d3fd8e2$var$timelines.onmouseover = (ev)=>{
    $f43313d21d3fd8e2$var$offsetX = ev.offsetX;
    $f43313d21d3fd8e2$var$offsetY = ev.offsetY;
};
function $f43313d21d3fd8e2$var$snappedTimeAt(offsetX) {
    const w = $f43313d21d3fd8e2$var$timelines.clientWidth;
    // Get all ms values for entries
    const allMs = new Set();
    for (const e of $f43313d21d3fd8e2$var$entries){
        for (const tz of $f43313d21d3fd8e2$var$timezones)if (e.parsed) {
            const inTz = e.parsed.setZone(tz, {
                keepLocalTime: !e.moment
            });
            allMs.add(inTz.toMillis());
        }
    }
    // Get a snapped ms based on physical proximity in px to known ms value
    // Default to a value based on pixel offset
    let snappedMs = offsetX / w * ($f43313d21d3fd8e2$var$maxMs - $f43313d21d3fd8e2$var$minMs) + $f43313d21d3fd8e2$var$minMs;
    let snappedX = offsetX;
    let isSnapped = false;
    for (const ms of allMs){
        const msX = $f43313d21d3fd8e2$var$maxMs > $f43313d21d3fd8e2$var$minMs ? (ms - $f43313d21d3fd8e2$var$minMs) / ($f43313d21d3fd8e2$var$maxMs - $f43313d21d3fd8e2$var$minMs) * w : w / 2;
        if (Math.abs(offsetX - msX) <= 12) {
            snappedMs = ms;
            snappedX = msX;
            isSnapped = true;
        }
    }
    return {
        isSnapped: isSnapped,
        snappedMs: snappedMs,
        snappedX: snappedX
    };
}
function $f43313d21d3fd8e2$var$updateCrosshair() {
    if ($f43313d21d3fd8e2$var$offsetX === undefined || $f43313d21d3fd8e2$var$offsetY === undefined) return;
    const h = $f43313d21d3fd8e2$var$timelines.clientHeight / $f43313d21d3fd8e2$var$timezones.length;
    const { isSnapped: isSnapped, snappedMs: snappedMs, snappedX: snappedX } = $f43313d21d3fd8e2$var$snappedTimeAt($f43313d21d3fd8e2$var$offsetX);
    const hoveredTzIdx = Math.min($f43313d21d3fd8e2$var$timezones.length - 1, Math.max(0, Math.floor($f43313d21d3fd8e2$var$offsetY / h)));
    $f43313d21d3fd8e2$var$l2.clear();
    const crosshairInset = 6;
    $f43313d21d3fd8e2$var$l2.line(snappedX, 0, snappedX, $f43313d21d3fd8e2$var$timelines.clientHeight - crosshairInset).stroke({
        color: "#666"
    });
    $f43313d21d3fd8e2$var$l2.circle(10).center(snappedX, hoveredTzIdx * h + h / 2).fill("#bbb").stroke({
        color: "#666",
        width: 2
    });
    const t = (0, $63618293c58b5f80$exports.DateTime).fromMillis(snappedMs);
    const leftHalf = snappedX <= $f43313d21d3fd8e2$var$timelines.clientWidth / 2;
    // SVG text anchoring is not visually symmetric, so the right-aligned
    // labels need a slightly larger offset to match the left-side gap.
    const labelPadding = leftHalf ? 2 : 4;
    for (const [idx, tz] of $f43313d21d3fd8e2$var$timezones.entries()){
        const rowTop = idx * h;
        const labelY = rowTop + 12;
        // Absolute time
        $f43313d21d3fd8e2$var$l2.text(t.setZone(tz).toISO({
            suppressMilliseconds: true
        })).x(snappedX + (leftHalf ? 1 : -1) * labelPadding).y(labelY).font({
            anchor: leftHalf ? "start" : "end"
        });
        // Relative time
        $f43313d21d3fd8e2$var$l2.text(t.setZone(tz).toRelative() ?? "").x(snappedX + (leftHalf ? 1 : -1) * labelPadding).y(labelY + 19).font({
            anchor: leftHalf ? "start" : "end"
        });
        if (!isSnapped || idx !== hoveredTzIdx) continue;
        const snappedEntry = $f43313d21d3fd8e2$var$entries.find((e)=>{
            if (!e.parsed?.comment) return false;
            const inTz = e.parsed.setZone(tz, {
                keepLocalTime: !e.moment
            });
            return inTz.toMillis() === snappedMs;
        });
        if (snappedEntry?.parsed?.comment) $f43313d21d3fd8e2$var$l2.text(snappedEntry.parsed.comment).x(snappedX + (leftHalf ? 1 : -1) * labelPadding).y(labelY + 38).font({
            anchor: leftHalf ? "start" : "end",
            weight: "bold"
        });
    }
}
$f43313d21d3fd8e2$var$timelines.onmousemove = (ev)=>{
    $f43313d21d3fd8e2$var$offsetX = ev.offsetX;
    $f43313d21d3fd8e2$var$offsetY = ev.offsetY;
    $f43313d21d3fd8e2$var$updateCrosshair();
};
$f43313d21d3fd8e2$var$timelines.onmouseout = ()=>{
    $f43313d21d3fd8e2$var$offsetX = $f43313d21d3fd8e2$var$offsetY = undefined;
    $f43313d21d3fd8e2$var$l2.clear();
};
$f43313d21d3fd8e2$var$timelines.onclick = (ev)=>{
    if ($f43313d21d3fd8e2$var$timezones.length === 0) return;
    const rowHeight = $f43313d21d3fd8e2$var$timelines.clientHeight / $f43313d21d3fd8e2$var$timezones.length;
    const tzIdx = Math.min($f43313d21d3fd8e2$var$timezones.length - 1, Math.max(0, Math.floor(ev.offsetY / rowHeight)));
    const { snappedMs: snappedMs } = $f43313d21d3fd8e2$var$snappedTimeAt(ev.offsetX);
    $f43313d21d3fd8e2$var$showModal({
        tz: $f43313d21d3fd8e2$var$timezones[tzIdx],
        time: (0, $63618293c58b5f80$exports.DateTime).fromMillis(snappedMs)
    });
};
// Modal stuff
const $f43313d21d3fd8e2$var$backdrop = document.querySelector(".modal-backdrop");
const $f43313d21d3fd8e2$var$modal = document.querySelector(".modal");
function $f43313d21d3fd8e2$var$showModal(displayInfo) {
    if (displayInfo) {
        const e = displayInfo.entry;
        const parsed = e?.parsed ?? displayInfo.time;
        const moment = e?.moment ?? false;
        const left = document.createElement("div");
        const badge = e ? $f43313d21d3fd8e2$var$statusBadge(true, e.line) : $f43313d21d3fd8e2$var$statusBadge(true, 0);
        left.appendChild(badge);
        const right = document.createElement("div");
        right.className = "modal-right";
        const title = document.createElement("div");
        title.className = "modal-title";
        title.innerText = e?.text ?? parsed.setZone(displayInfo.tz).toISO({
            suppressMilliseconds: true
        });
        right.appendChild(title);
        const tz = document.createElement("div");
        tz.innerText = displayInfo.tz;
        right.appendChild(tz);
        const subtitle = document.createElement("div");
        subtitle.innerText = parsed?.toRelative() ?? "";
        right.appendChild(subtitle);
        // Output formats
        const table = document.createElement("table");
        for (const format of Object.values($f43313d21d3fd8e2$var$FormatMethods)){
            const row = document.createElement("tr");
            const name = document.createElement("td");
            name.innerText = $f43313d21d3fd8e2$var$formatName(format);
            row.appendChild(name);
            const value = document.createElement("td");
            const inTz = parsed.setZone(displayInfo.tz, {
                keepLocalTime: !moment
            });
            const text = $f43313d21d3fd8e2$var$serializeFormat(inTz, format);
            value.innerText = text;
            row.appendChild(value);
            const copy = document.createElement("td");
            const button = document.createElement("button");
            button.innerHTML = (0, $9fab29b0215440cb$export$3fd1b87e602b44a0);
            button.addEventListener("click", ()=>{
                navigator.clipboard.writeText(text);
            });
            copy.appendChild(button);
            row.appendChild(copy);
            table.appendChild(row);
        }
        right.appendChild(table);
        $f43313d21d3fd8e2$var$modal.replaceChildren(left, right);
    }
    const visibility = displayInfo ? "visible" : "hidden";
    $f43313d21d3fd8e2$var$backdrop.style.visibility = visibility;
    $f43313d21d3fd8e2$var$modal.style.visibility = visibility;
}
// Hide when clicking backdrop
$f43313d21d3fd8e2$var$backdrop.addEventListener("click", ()=>{
    $f43313d21d3fd8e2$var$showModal(undefined);
});
// Allow ESC to quit modal
document.querySelector("body").addEventListener("keydown", (ev)=>{
    if (ev.key === "Escape") $f43313d21d3fd8e2$var$showModal(undefined);
});


//# sourceMappingURL=index.80f83f8c.js.map
